import type { DateTime } from './codegen/date-time';
import type { Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver, StorageAdapter as GraphCacheStorageAdapter } from '@urql/exchange-graphcache';
import type { IntrospectionData } from '@urql/exchange-graphcache/dist/types/ast';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date (isoformat) */
  Date: any;
  /** Date with time (isoformat) */
  DateTime: DateTime;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  UUID: any;
};

export enum AdminUserType {
  EMPLOYEE = 'employee',
  OWNER = 'owner',
  READ_ONLY = 'read_only'
}

export type Approval = {
  __typename: 'Approval';
  admin?: Maybe<User>;
  adminId: Scalars['String'];
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type Artist = {
  __typename: 'Artist';
  adminDetails?: Maybe<Scalars['String']>;
  artistReviews: Array<ArtistReview>;
  avgRating: Scalars['Float'];
  bandConfiguration?: Maybe<BandConfig>;
  billing: ConnectAccountDisplay;
  bio?: Maybe<Scalars['String']>;
  bookings: Array<Booking>;
  category?: Maybe<Category>;
  contactInformation?: Maybe<ContactInformation>;
  coverImage?: Maybe<Image>;
  createdAt: Scalars['DateTime'];
  defaultPriceRange?: Maybe<PriceRange>;
  groupedReviews: Array<ArtistReview>;
  iLiked: Scalars['Boolean'];
  id: Scalars['String'];
  lastUpdated: Scalars['DateTime'];
  likeCount: Scalars['Int'];
  location?: Maybe<Location>;
  media?: Maybe<Media>;
  name: Scalars['String'];
  numberOfReviews: Scalars['Int'];
  pendingUserPhoneNumbers: Array<Scalars['String']>;
  performanceData?: Maybe<ArtistPerformanceData>;
  profileImage?: Maybe<Image>;
  published: Scalars['Boolean'];
  relatedArtists: Array<Artist>;
  sellers: Array<User>;
  slug: Scalars['String'];
  socialMedia?: Maybe<SocialMedia>;
  spotifyId?: Maybe<Scalars['String']>;
  subgenres?: Maybe<Array<Scalars['String']>>;
  topReviews: Array<ArtistReview>;
  transfers: Array<TransferStripe>;
  venueTakePercentages?: Maybe<Scalars['JSON']>;
  viewCount: Scalars['Int'];
};


export type ArtistArtistReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ArtistBillingArgs = {
  redirectUrl: Scalars['String'];
};


export type ArtistBookingsArgs = {
  bookingFlows?: InputMaybe<Array<BookingFlow>>;
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
};


export type ArtistGroupedReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ArtistRelatedArtistsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type ArtistArtistNotFoundResponse = Artist | ArtistNotFoundResponse;

export type ArtistAvailability = {
  __typename: 'ArtistAvailability';
  booking?: Maybe<Booking>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  /** Admin only. */
  checks: Array<ArtistAvailabilityCheck>;
  createdAt: Scalars['DateTime'];
  /** Admin only. */
  createdBy?: Maybe<User>;
  id: Scalars['UUID'];
  lastUpdated: Scalars['DateTime'];
  location: Location;
  performanceLengthMins?: Maybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  status: ArtistAvailabilityStatus;
};

export type ArtistAvailabilityCheck = {
  __typename: 'ArtistAvailabilityCheck';
  artist: Artist;
  artistAvailability: ArtistAvailability;
  /** Admin only. */
  courierMessages: Array<CourierMessage>;
  courierNotificationIds: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Admin only. */
  createdBy?: Maybe<User>;
  id: Scalars['UUID'];
  lastUpdated: Scalars['DateTime'];
  notifiedAt: Scalars['DateTime'];
  respondedAt?: Maybe<Scalars['DateTime']>;
  respondedBy?: Maybe<User>;
  response?: Maybe<ArtistAvailabilityResponse>;
  responseMessage?: Maybe<Scalars['String']>;
};

export type ArtistAvailabilityInput = {
  buyerDisplayName?: InputMaybe<Scalars['String']>;
  location: LocationInput;
  performanceLengthMins?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
};

export enum ArtistAvailabilityResponse {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable'
}

export enum ArtistAvailabilityStatus {
  DONE = 'done',
  PENDING = 'pending'
}

export type ArtistLike = {
  __typename: 'ArtistLike';
  artist: Artist;
  timestamp: Scalars['DateTime'];
  user: User;
};

export type ArtistNotFoundResponse = {
  __typename: 'ArtistNotFoundResponse';
  message: Scalars['String'];
};

export enum ArtistOrderBy {
  CREATED_AT = 'created_at',
  LAST_UPDATED = 'last_updated'
}

export type ArtistPatch = {
  bandConfiguration?: InputMaybe<BandConfigInput>;
  bio?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Category>;
  contactInformation?: InputMaybe<ContactInformationInput>;
  coverImage?: InputMaybe<ImageInput>;
  location?: InputMaybe<LocationInput>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']>;
  profileImage?: InputMaybe<ImageInput>;
  slug?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<SocialMediaInput>;
  subgenres?: InputMaybe<Array<Scalars['String']>>;
};

export type ArtistPerformanceData = {
  __typename: 'ArtistPerformanceData';
  createdAt: Scalars['DateTime'];
  firebaseId: Scalars['String'];
  id: Scalars['UUID'];
  lastUpdated: Scalars['DateTime'];
  songs?: Maybe<Array<Scalars['String']>>;
  songsTxt?: Maybe<Scalars['String']>;
  states?: Maybe<Array<Scalars['String']>>;
};

export type ArtistReview = {
  __typename: 'ArtistReview';
  artist: Artist;
  author?: Maybe<User>;
  authorFirstName?: Maybe<Scalars['String']>;
  authorLocStr?: Maybe<Scalars['String']>;
  authorOrgStr?: Maybe<Scalars['String']>;
  authorProfileImage?: Maybe<SmallImage>;
  avgRating?: Maybe<Scalars['Float']>;
  booking?: Maybe<Booking>;
  comment?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  fromVenue: Scalars['Boolean'];
  id: Scalars['String'];
  published: Scalars['Boolean'];
  rating: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  venue?: Maybe<Venue>;
};

export type ArtistReviewInput = {
  comment?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<ImageInput>>;
  rating: Scalars['Int'];
};

export type ArtistReviewPatch = {
  comment?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<ImageInput>>;
  rating: Scalars['Int'];
};

export type ArtistSpotify = {
  __typename: 'ArtistSpotify';
  externalUrls?: Maybe<ExternalUrls>;
  followers: Followers;
  genres: Array<Scalars['String']>;
  href: Scalars['String'];
  id: Scalars['String'];
  images: Array<ImageSpotify>;
  name: Scalars['String'];
  popularity: Scalars['Int'];
};

export type ArtistStats = {
  __typename: 'ArtistStats';
  cancellationRate?: Maybe<Scalars['Float']>;
  hasVerifiedBadge: Scalars['Boolean'];
  numberOfBookings: Scalars['Int'];
  numberOfCancellations: Scalars['Int'];
  responseRate?: Maybe<Scalars['Float']>;
  responseTimeMins?: Maybe<Scalars['Float']>;
};

export type ArtistTypesense = {
  __typename: 'ArtistTypesense';
  _geoloc?: Maybe<GeoLoc>;
  avgRating: Scalars['Float'];
  bandConfiguration: BandConfig;
  bandConfigurationOptions?: Maybe<Array<Scalars['String']>>;
  category?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Image>;
  createdAt: Scalars['Int'];
  id: Scalars['String'];
  lastTriggeredToTypesenseAt: Scalars['Int'];
  lastUpdated: Scalars['Int'];
  locationGeopoint?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  numberOfReviews: Scalars['Int'];
  objectID: Scalars['String'];
  privateDefaultPriceHigh?: Maybe<Scalars['Int']>;
  privateDefaultPriceLow?: Maybe<Scalars['Int']>;
  privateDuoPriceHigh?: Maybe<Scalars['Int']>;
  privateDuoPriceLow?: Maybe<Scalars['Int']>;
  privateFourPlusPriceHigh?: Maybe<Scalars['Int']>;
  privateFourPlusPriceLow?: Maybe<Scalars['Int']>;
  privateSoloPriceHigh?: Maybe<Scalars['Int']>;
  privateSoloPriceLow?: Maybe<Scalars['Int']>;
  privateTrioPriceHigh?: Maybe<Scalars['Int']>;
  privateTrioPriceLow?: Maybe<Scalars['Int']>;
  profileImage?: Maybe<Image>;
  publicDefaultPriceHigh?: Maybe<Scalars['Int']>;
  publicDefaultPriceLow?: Maybe<Scalars['Int']>;
  publicDuoPriceHigh?: Maybe<Scalars['Int']>;
  publicDuoPriceLow?: Maybe<Scalars['Int']>;
  publicFourPlusPriceHigh?: Maybe<Scalars['Int']>;
  publicFourPlusPriceLow?: Maybe<Scalars['Int']>;
  publicSoloPriceHigh?: Maybe<Scalars['Int']>;
  publicSoloPriceLow?: Maybe<Scalars['Int']>;
  publicTrioPriceHigh?: Maybe<Scalars['Int']>;
  publicTrioPriceLow?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  spotifyPopularity?: Maybe<Scalars['Int']>;
  spotifyPopularityAndReviews: Scalars['Int'];
  subgenres?: Maybe<Array<Scalars['String']>>;
};

export type ArtistTypesensePublic = {
  __typename: 'ArtistTypesensePublic';
  _geoloc?: Maybe<GeoLoc>;
  avgRating: Scalars['Float'];
  category?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Image>;
  createdAt: Scalars['Int'];
  id: Scalars['String'];
  lastTriggeredToTypesenseAt: Scalars['Int'];
  lastUpdated: Scalars['Int'];
  locationGeopoint?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  numberOfReviews: Scalars['Int'];
  objectID: Scalars['String'];
  profileImage?: Maybe<Image>;
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  spotifyPopularity?: Maybe<Scalars['Int']>;
  spotifyPopularityAndReviews: Scalars['Int'];
  subgenres?: Maybe<Array<Scalars['String']>>;
};

export type ArtistVenueApplicationStraw = {
  __typename: 'ArtistVenueApplicationStraw';
  id: Scalars['String'];
  message: Scalars['String'];
};

export type BandConfig = {
  __typename: 'BandConfig';
  bandConfigOptionTypes: BandConfigOptionFrontend;
  duo?: Maybe<ConfigInfo>;
  fallback?: Maybe<ConfigInfo>;
  fourPlus?: Maybe<ConfigInfo>;
  solo?: Maybe<ConfigInfo>;
  trio?: Maybe<ConfigInfo>;
};

export type BandConfigInput = {
  duo?: InputMaybe<ConfigInfoInput>;
  fourPlus?: InputMaybe<ConfigInfoInput>;
  solo?: InputMaybe<ConfigInfoInput>;
  trio?: InputMaybe<ConfigInfoInput>;
  unspecified?: InputMaybe<ConfigInfoInput>;
};

export enum BandConfigOptionFrontend {
  DUO = 'duo',
  FALLBACK = 'fallback',
  FOUR_PLUS = 'four_plus',
  SOLO = 'solo',
  TRIO = 'trio'
}

export enum BandConfigurationOption {
  DUO = 'duo',
  FOUR_PLUS = 'four_plus',
  SOLO = 'solo',
  TRIO = 'trio',
  UNSPECIFIED = 'unspecified'
}

export type BarChart = {
  __typename: 'BarChart';
  data: Array<Scalars['Float']>;
  firstFutureIndex?: Maybe<Scalars['Int']>;
  labels: Array<Scalars['String']>;
};

export type BarChartEdge = {
  __typename: 'BarChartEdge';
  monthly?: Maybe<BarChart>;
  yearly?: Maybe<BarChart>;
};

export type Bid = {
  __typename: 'Bid';
  artist: Artist;
  bandConfiguration?: Maybe<BandConfigurationOption>;
  bookingRequest: BookingRequest;
  buyerHasSeen?: Maybe<Scalars['Boolean']>;
  buyerPrice: Scalars['Float'];
  buyerSawAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  id: Scalars['String'];
  lastUpdated: Scalars['DateTime'];
  notes?: Maybe<Scalars['String']>;
  rejectionMessage?: Maybe<Scalars['String']>;
  sellerPrice: Scalars['Float'];
  status: BidStatus;
  withdrawalMessage?: Maybe<Scalars['String']>;
};

export type BidInput = {
  bandConfiguration?: InputMaybe<BandConfigurationOption>;
  notes?: InputMaybe<Scalars['String']>;
};

export type BidPatch = {
  bandConfiguration?: InputMaybe<BandConfigurationOption>;
  notes?: InputMaybe<Scalars['String']>;
};

export enum BidStatus {
  ACCEPTED = 'accepted',
  ARTIST_UNAVAILABLE = 'artist_unavailable',
  PENDING = 'pending',
  REJECTED = 'rejected',
  WITHDRAWN = 'withdrawn'
}

export enum Billing {
  CO_HEADLINER = 'Co_Headliner',
  HEADLINER = 'Headliner',
  OPENER = 'Opener'
}

export type Booking = {
  __typename: 'Booking';
  accountExec?: Maybe<User>;
  adminCancellationMessage?: Maybe<Scalars['String']>;
  artist: Artist;
  artistAvailability?: Maybe<ArtistAvailability>;
  artistId: Scalars['String'];
  artistName: Scalars['String'];
  artistReviews: Array<ArtistReview>;
  artistSlug: Scalars['String'];
  autoPublishMessage: Scalars['String'];
  bandConfiguration?: Maybe<BandConfigurationOption>;
  billing: Billing;
  bookingBilling?: Maybe<BookingBilling>;
  bookingDispute?: Maybe<BookingDispute>;
  bookingFlow: BookingFlow;
  buyer: User;
  buyerHasReviewed?: Maybe<Scalars['Boolean']>;
  buyerId: Scalars['String'];
  buyerMetadata: Metadata;
  buyerName: Scalars['String'];
  buyerSlug: Scalars['String'];
  canIAdvanceBooking: Scalars['Boolean'];
  canIAutoPublish: Scalars['Boolean'];
  canIEdit: Scalars['Boolean'];
  canIEditEventDescription: Scalars['Boolean'];
  canIPublish: Scalars['Boolean'];
  canSellerSee: Scalars['Boolean'];
  cancellationMessage?: Maybe<Scalars['String']>;
  cancellationRequested?: Maybe<Scalars['Boolean']>;
  cancellationRequests: Array<CancellationRequest>;
  capacity?: Maybe<Scalars['Int']>;
  charge?: Maybe<Charge>;
  comments?: Maybe<Scalars['String']>;
  confirmation?: Maybe<BookingConfirmation>;
  createdAt: Scalars['DateTime'];
  displayPrices: DisplayPrices;
  doINeedToReview: Scalars['Boolean'];
  doINeedToReviewMessage?: Maybe<Scalars['String']>;
  firebaseId: Scalars['String'];
  id: Scalars['String'];
  indoorsOrOutdoors: IndoorsOrOutdoors;
  isPublished: Scalars['Boolean'];
  /** Buyer only. */
  lastOfferAmount: Scalars['Float'];
  /** Seller only. */
  lastSellerOfferAmount: Scalars['Float'];
  lastUpdated: Scalars['DateTime'];
  location: Location;
  negotiationSteps: Array<NegotiationStep>;
  oldStartTime?: Maybe<Scalars['DateTime']>;
  payout?: Maybe<Payout>;
  performanceLengthMins: Scalars['Int'];
  possibleActions: Array<NegotiationAction>;
  productionAndVenueSpecs?: Maybe<Scalars['String']>;
  publicCoverImage?: Maybe<Image>;
  publicEventDescription?: Maybe<Scalars['String']>;
  publicProfileImage?: Maybe<Image>;
  publishedMessage: Scalars['String'];
  refundedInCredits?: Maybe<Scalars['Boolean']>;
  rescheduleMessage?: Maybe<Scalars['String']>;
  shouldAutoPublish?: Maybe<Scalars['Boolean']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  statusInformation?: Maybe<StatusInformation>;
  statusV2: BookingStatusV2;
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  venueSlug?: Maybe<Scalars['String']>;
  whatShouldIDoAlerts?: Maybe<WhatShouldIDoAlerts>;
};

export type BookingBadgesResponse = {
  __typename: 'BookingBadgesResponse';
  badgeCount: Scalars['Int'];
  bookings: Array<Booking>;
};

export type BookingBilling = {
  __typename: 'BookingBilling';
  buyerBilling?: Maybe<BuyerBilling>;
  buyerNeedsBankAccountCard?: Maybe<Card>;
  connectAccount?: Maybe<ConnectAccountDisplay>;
  frontendDirections: FrontendDirections;
  receiptItems?: Maybe<Array<ReceiptItem>>;
  sellerNeedsPayoutMethodCard?: Maybe<Card>;
};

export type BookingByBuyerType = {
  __typename: 'BookingByBuyerType';
  bookingsCount: Scalars['Int'];
  buyerUserType: UserType;
  revenue: Scalars['Float'];
};

export type BookingByCity = {
  __typename: 'BookingByCity';
  bookingsCount: Scalars['Int'];
  cityName: Scalars['String'];
  revenue: Scalars['Float'];
  sampleLocation: Location;
};

export type BookingByVenue = {
  __typename: 'BookingByVenue';
  bookingsCount: Scalars['Int'];
  location: Location;
  revenue: Scalars['Float'];
  venueId?: Maybe<Scalars['String']>;
  venueName: Scalars['String'];
  venueType: VenueType;
};

export type BookingConfirmation = {
  __typename: 'BookingConfirmation';
  booking: Booking;
  confirmedAt: Scalars['DateTime'];
  confirmedBy: User;
  id: Scalars['UUID'];
  response: BookingConfirmationResponse;
};

export enum BookingConfirmationResponse {
  CANCEL = 'cancel',
  CONFIRM = 'confirm'
}

export type BookingDispute = {
  __typename: 'BookingDispute';
  booking: Booking;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  lastUpdated: Scalars['DateTime'];
  message: Scalars['String'];
  resolved: Scalars['Boolean'];
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedBy?: Maybe<User>;
  user: User;
};

export enum BookingFlow {
  PRIVATE = 'private',
  UPB = 'upb',
  VENUE = 'venue'
}

export type BookingInput = {
  bandConfiguration?: InputMaybe<BandConfigurationOption>;
  billing: Billing;
  capacity?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  indoorsOrOutdoors: IndoorsOrOutdoors;
  performanceLengthMins: Scalars['Int'];
  productionAndVenueSpecs?: InputMaybe<Scalars['String']>;
  publicCoverImage?: InputMaybe<ImageInput>;
  publicEventDescription?: InputMaybe<Scalars['String']>;
  publicProfileImage?: InputMaybe<ImageInput>;
  shouldAutoPublish?: InputMaybe<Scalars['Boolean']>;
};

export enum BookingOrderBy {
  CREATED_AT = 'created_at',
  LAST_UPDATED = 'last_updated',
  START_TIME = 'start_time'
}

export type BookingPatch = {
  bandConfiguration?: InputMaybe<BandConfigurationOption>;
  billing?: InputMaybe<Billing>;
  capacity?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  indoorsOrOutdoors?: InputMaybe<IndoorsOrOutdoors>;
  location?: InputMaybe<LocationInput>;
  performanceLengthMins?: InputMaybe<Scalars['Int']>;
  productionAndVenueSpecs?: InputMaybe<Scalars['String']>;
  publicCoverImage?: InputMaybe<ImageInput>;
  publicEventDescription?: InputMaybe<Scalars['String']>;
  publicProfileImage?: InputMaybe<ImageInput>;
  shouldAutoPublish?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type BookingRequest = {
  __typename: 'BookingRequest';
  accountExec?: Maybe<User>;
  adminInstructions?: Maybe<Scalars['String']>;
  adminInstructionsBuyer?: Maybe<Scalars['String']>;
  areAllMyBidsRejected?: Maybe<Scalars['Boolean']>;
  artistInstructions?: Maybe<Scalars['String']>;
  artists: Array<Artist>;
  artistsBuyer: Array<Artist>;
  bandConfigurationOptions?: Maybe<Array<BandConfigurationOption>>;
  bids: Array<Bid>;
  billing?: Maybe<Billing>;
  booking?: Maybe<Booking>;
  budget?: Maybe<PriceRangeOptional>;
  budgetBuyer?: Maybe<PriceRangeOptional>;
  buyerFrontendCopy?: Maybe<FrontendDirections>;
  canIEdit: Scalars['Boolean'];
  capacity?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  declines: Array<BookingRequestDecline>;
  didSomeoneElsesBidGetChosen: Scalars['Boolean'];
  extraArtistInfos: Array<ExtraArtistInfo>;
  firebaseId: Scalars['String'];
  genres?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  indoorsOrOutdoors?: Maybe<IndoorsOrOutdoors>;
  isActionRequired: Scalars['Boolean'];
  isPast: Scalars['Boolean'];
  lastUpdated: Scalars['DateTime'];
  myAcceptedBid?: Maybe<Bid>;
  myArtistsThatCanBid: Array<Artist>;
  otherBookingRequestsInGroup: Array<BookingRequest>;
  performanceLengthMins: Scalars['Int'];
  publicEventDescription?: Maybe<Scalars['String']>;
  shouldAutoPublish?: Maybe<Scalars['Boolean']>;
  startTime: Scalars['DateTime'];
  status: BookingRequestStatus;
  venue: Venue;
  venueId?: Maybe<Scalars['String']>;
  venueLocation: Location;
  venueName?: Maybe<Scalars['String']>;
  venueSlug?: Maybe<Scalars['String']>;
  whatShouldIDoAlerts?: Maybe<WhatShouldIDoAlerts>;
};

export type BookingRequestBadgesResponse = {
  __typename: 'BookingRequestBadgesResponse';
  badgeCount: Scalars['Int'];
  bookingRequests: Array<BookingRequest>;
};

export type BookingRequestDecline = {
  __typename: 'BookingRequestDecline';
  artist: Artist;
  bookingRequest: BookingRequest;
  declinedBy: User;
  id: Scalars['String'];
  reasonForDecline?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

export type BookingRequestInput = {
  adminInstructions?: InputMaybe<Scalars['String']>;
  artistInstructions?: InputMaybe<Scalars['String']>;
  bandConfigurationOptions?: InputMaybe<Array<BandConfigurationOption>>;
  billing?: InputMaybe<Billing>;
  budget?: InputMaybe<PriceRangeOptionalInput>;
  genres?: InputMaybe<Array<Scalars['String']>>;
  indoorsOrOutdoors?: InputMaybe<IndoorsOrOutdoors>;
  performanceLengthMins: Scalars['Int'];
  publicEventDescription?: InputMaybe<Scalars['String']>;
  shouldAutoPublish?: InputMaybe<Scalars['Boolean']>;
};

export enum BookingRequestOrderBy {
  CREATED_AT = 'created_at',
  LAST_UPDATED = 'last_updated',
  START_TIME = 'start_time'
}

export type BookingRequestPatch = {
  adminInstructions?: InputMaybe<Scalars['String']>;
  artistInstructions?: InputMaybe<Scalars['String']>;
  bandConfigurationOptions?: InputMaybe<Array<BandConfigurationOption>>;
  billing?: InputMaybe<Billing>;
  budget?: InputMaybe<PriceRangeOptionalInput>;
  genres?: InputMaybe<Array<Scalars['String']>>;
  indoorsOrOutdoors?: InputMaybe<IndoorsOrOutdoors>;
  performanceLengthMins?: InputMaybe<Scalars['Int']>;
  publicEventDescription?: InputMaybe<Scalars['String']>;
  shouldAutoPublish?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export enum BookingRequestStatus {
  ACCEPTED = 'accepted',
  CANCELLED = 'cancelled',
  PENDING = 'pending'
}

export enum BookingStatus {
  ADVANCING = 'advancing',
  CANCELED = 'canceled',
  CONTRACTING = 'contracting',
  CREATED = 'created',
  DECLINED = 'declined',
  NEGOTIATING = 'negotiating',
  PERFORMANCE = 'performance',
  RESCHEDULING = 'rescheduling'
}

export enum BookingStatusV2 {
  CANCELED = 'canceled',
  CONFIRMED = 'confirmed',
  CONTRACTING = 'contracting',
  CREATED = 'created',
  DECLINED = 'declined',
  NEGOTIATING = 'negotiating',
  RESCHEDULING = 'rescheduling'
}

export type BookingTypesense = {
  __typename: 'BookingTypesense';
  artistCategory?: Maybe<Scalars['String']>;
  artistId: Scalars['String'];
  artistName: Scalars['String'];
  artistProfileImage?: Maybe<Image>;
  artistSubgenres?: Maybe<Array<Scalars['String']>>;
  buyerMetadataLocation?: Maybe<Scalars['String']>;
  buyerMetadataOrganization?: Maybe<Scalars['String']>;
  buyerName: Scalars['String'];
  createdAt: Scalars['Int'];
  firebaseId: Scalars['String'];
  id: Scalars['String'];
  isPublished: Scalars['Boolean'];
  lastTriggeredToTypesenseAt: Scalars['Int'];
  lastUpdated: Scalars['Int'];
  latLngStr: Scalars['String'];
  location: Location;
  locationGeopoint: Array<Scalars['Float']>;
  startTime: Scalars['Int'];
  startTimeQueryableStr: Scalars['String'];
  statusV2: BookingStatusV2;
  venueId?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  venueProfileImage?: Maybe<Image>;
  yearMonthStr: Scalars['String'];
};

export type Button = {
  __typename: 'Button';
  subtext: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type BuyerBilling = {
  __typename: 'BuyerBilling';
  bankAccount?: Maybe<StripeBankAccount>;
  needsBankAccountCard?: Maybe<Card>;
};

export enum BuyerUserType {
  BAR = 'Bar',
  BREWERY = 'Brewery',
  CORPORATE_EVENT = 'Corporate_Event',
  COUNTRY_CLUB = 'Country_Club',
  FRATERNITY_SORORITY = 'Fraternity_Sorority',
  HOTEL_RESORT = 'Hotel_Resort',
  MUNICIPALITY = 'Municipality',
  NIGHTCLUB = 'Nightclub',
  OTHER_BUYER = 'Other_Buyer',
  PROMOTER = 'Promoter',
  RESTAURANT = 'Restaurant',
  THEATER = 'Theater',
  UNIVERSITY_PROGRAM_BOARD = 'University_Program_Board',
  VINEYARD_WINERY = 'Vineyard_Winery',
  WEDDING = 'Wedding'
}

export type CalendarBooking = {
  __typename: 'CalendarBooking';
  artistBio?: Maybe<Scalars['String']>;
  artistCategory?: Maybe<Category>;
  artistCoverImage?: Maybe<Image>;
  artistName: Scalars['String'];
  artistProfileImage?: Maybe<Image>;
  artistSlug?: Maybe<Scalars['String']>;
  bandConfiguration?: Maybe<BandConfigurationOption>;
  beatgigId: Scalars['String'];
  bookingType: CalendarBookingType;
  id: Scalars['String'];
  performanceLengthMins: Scalars['Int'];
  publicCoverImage?: Maybe<Image>;
  publicEventDescription?: Maybe<Scalars['String']>;
  publicProfileImage?: Maybe<Image>;
  startTime: Scalars['DateTime'];
};

export enum CalendarBookingType {
  EXTERNAL = 'external',
  INTERNAL = 'internal'
}

export type CalendarBookingsResponse = {
  __typename: 'CalendarBookingsResponse';
  calendarBookings: Array<CalendarBooking>;
  canFetchMore: Scalars['Boolean'];
  venueId: Scalars['String'];
  venueLocation: Location;
};

export type CancellationRequest = {
  __typename: 'CancellationRequest';
  booking: Booking;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  lastUpdated: Scalars['DateTime'];
  message?: Maybe<Scalars['String']>;
  resolved: Scalars['Boolean'];
  user: User;
};

export type Card = {
  __typename: 'Card';
  buttonText?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  header: Scalars['String'];
  message: Scalars['String'];
};

export enum Category {
  COMEDY = 'Comedy',
  COUNTRY = 'Country',
  DJ = 'DJ',
  HIP_HOP = 'Hip_Hop',
  JAZZ = 'Jazz',
  POP = 'Pop',
  REGGAE = 'Reggae',
  ROCK = 'Rock',
  TRIBUTE = 'Tribute'
}

export type Charge = {
  __typename: 'Charge';
  cancelledInvoiceId?: Maybe<Scalars['String']>;
  chargedBuyer: Scalars['Boolean'];
  invoiceId?: Maybe<Scalars['String']>;
  invoiceItemId?: Maybe<Scalars['String']>;
  manuallyChargedBuyer: Scalars['Boolean'];
  manuallyChargedBuyerBy?: Maybe<Scalars['String']>;
};

export enum Collection {
  ARTISTS = 'ARTISTS',
  BOOKINGS = 'BOOKINGS',
  USERS = 'USERS'
}

export enum ColorMode {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}

export type Colors = {
  __typename: 'Colors';
  colorMode: ColorMode;
  primary: Scalars['String'];
};

export type ColorsInput = {
  colorMode: ColorMode;
  primary: Scalars['String'];
};

export type ConfigInfo = {
  __typename: 'ConfigInfo';
  notes?: Maybe<Scalars['String']>;
  prices: Prices;
};

export type ConfigInfoInput = {
  notes?: InputMaybe<Scalars['String']>;
  prices: PricesInput;
};

export type ConnectAccountDisplay = {
  __typename: 'ConnectAccountDisplay';
  button: Button;
  canTransfer: Scalars['Boolean'];
  dashboardLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  needsToAddInformation: Scalars['Boolean'];
  needsToOnboard: Scalars['Boolean'];
  onboardingLink?: Maybe<Scalars['String']>;
  payoutMethod?: Maybe<PayoutMethod>;
};

export type ContactInformation = {
  __typename: 'ContactInformation';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ContactInformationInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CourierChannel = {
  __typename: 'CourierChannel';
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
};

export type CourierMessage = {
  __typename: 'CourierMessage';
  channel?: Maybe<CourierChannel>;
  clicked?: Maybe<Scalars['DateTime']>;
  courierUrl: Scalars['String'];
  delivered?: Maybe<Scalars['DateTime']>;
  enqueued?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  id: Scalars['String'];
  notification?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['DateTime']>;
  providers?: Maybe<Array<CourierProvider>>;
  reason?: Maybe<Scalars['String']>;
  recipient: Scalars['String'];
  recipientId: Scalars['String'];
  sent?: Maybe<Scalars['DateTime']>;
  status: Status;
};

export type CourierProvider = {
  __typename: 'CourierProvider';
  clicked?: Maybe<Scalars['DateTime']>;
  delivered?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['DateTime']>;
  provider: Scalars['String'];
  sent?: Maybe<Scalars['DateTime']>;
  status: Status;
};

export enum Dir {
  ASC = 'asc',
  DESC = 'desc'
}

export enum DirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type DiscoverArtist = {
  __typename: 'DiscoverArtist';
  avgRating: Scalars['Float'];
  displayPriceRange?: Maybe<PriceRange>;
  id: Scalars['String'];
  name: Scalars['String'];
  numberOfReviews: Scalars['Int'];
  profileImage?: Maybe<Image>;
  slug: Scalars['String'];
};

export type DisplayImages = {
  __typename: 'DisplayImages';
  coverImage?: Maybe<Image>;
  profileImage?: Maybe<Image>;
};

export type DisplayImagesInput = {
  coverImage?: InputMaybe<ImageInput>;
  profileImage?: InputMaybe<ImageInput>;
};

export type DisplayPrices = {
  __typename: 'DisplayPrices';
  buyer: Scalars['Float'];
  seller: Scalars['Float'];
};

export enum EventStatus {
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  TENTATIVE = 'TENTATIVE'
}

export type ExternalBooking = {
  __typename: 'ExternalBooking';
  artistName: Scalars['String'];
  canIEdit: Scalars['Boolean'];
  coverImage?: Maybe<Image>;
  firebaseId: Scalars['String'];
  id: Scalars['String'];
  indoorsOrOutdoors?: Maybe<IndoorsOrOutdoors>;
  isPublished: Scalars['Boolean'];
  performanceLengthMins: Scalars['Int'];
  publicEventDescription?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  venue: Venue;
};

export type ExternalBookingInput = {
  artistName?: InputMaybe<Scalars['String']>;
  coverImage?: InputMaybe<ImageInput>;
  indoorsOrOutdoors?: InputMaybe<IndoorsOrOutdoors>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  performanceLengthMins: Scalars['Int'];
  publicEventDescription?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
};

export enum ExternalBookingOrderBy {
  CREATED_AT = 'created_at',
  LAST_UPDATED = 'last_updated',
  START_TIME = 'start_time'
}

export type ExternalBookingPatch = {
  artistName?: InputMaybe<Scalars['String']>;
  coverImage?: InputMaybe<ImageInput>;
  indoorsOrOutdoors?: InputMaybe<IndoorsOrOutdoors>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  performanceLengthMins?: InputMaybe<Scalars['Int']>;
  publicEventDescription?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type ExternalCalendarEvent = {
  __typename: 'ExternalCalendarEvent';
  busy: Scalars['Boolean'];
  calendarId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  participants: Array<Participant>;
  status: EventStatus;
  title: Scalars['String'];
  when: WhenTimeWhenTimespanWhenDateWhenDatespan;
};

export type ExternalUrls = {
  __typename: 'ExternalUrls';
  spotify?: Maybe<Scalars['String']>;
};

export type ExtraArtistInfo = {
  __typename: 'ExtraArtistInfo';
  artist: Artist;
  artistDetailsForBuyerByAdmin?: Maybe<Scalars['String']>;
  bookingRequest: BookingRequest;
  id: Scalars['String'];
  recommendedBy: User;
  recommendedPrice?: Maybe<Scalars['Float']>;
};

export type ExtraArtistInfoInput = {
  artistDetailsForBuyerByAdmin?: InputMaybe<Scalars['String']>;
  recommendedPrice?: InputMaybe<Scalars['Float']>;
};

export type ExtraArtistInfoPatch = {
  artistDetailsForBuyerByAdmin?: InputMaybe<Scalars['String']>;
  recommendedPrice?: InputMaybe<Scalars['Float']>;
};

export enum Filling {
  FADED = 'faded',
  FILLED = 'filled',
  OUTLINED = 'outlined'
}

export type FilterArtistAvailabilityResponse = {
  eq?: InputMaybe<ArtistAvailabilityResponse>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<ArtistAvailabilityResponse>;
  gte?: InputMaybe<ArtistAvailabilityResponse>;
  in?: InputMaybe<Array<ArtistAvailabilityResponse>>;
  lt?: InputMaybe<ArtistAvailabilityResponse>;
  lte?: InputMaybe<ArtistAvailabilityResponse>;
  neq?: InputMaybe<ArtistAvailabilityResponse>;
};

export type FilterArtistAvailabilityStatus = {
  eq?: InputMaybe<ArtistAvailabilityStatus>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<ArtistAvailabilityStatus>;
  gte?: InputMaybe<ArtistAvailabilityStatus>;
  in?: InputMaybe<Array<ArtistAvailabilityStatus>>;
  lt?: InputMaybe<ArtistAvailabilityStatus>;
  lte?: InputMaybe<ArtistAvailabilityStatus>;
  neq?: InputMaybe<ArtistAvailabilityStatus>;
};

export type FilterBandConfigurationOption = {
  eq?: InputMaybe<BandConfigurationOption>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<BandConfigurationOption>;
  gte?: InputMaybe<BandConfigurationOption>;
  in?: InputMaybe<Array<BandConfigurationOption>>;
  lt?: InputMaybe<BandConfigurationOption>;
  lte?: InputMaybe<BandConfigurationOption>;
  neq?: InputMaybe<BandConfigurationOption>;
};

export type FilterBidStatus = {
  eq?: InputMaybe<BidStatus>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<BidStatus>;
  gte?: InputMaybe<BidStatus>;
  in?: InputMaybe<Array<BidStatus>>;
  lt?: InputMaybe<BidStatus>;
  lte?: InputMaybe<BidStatus>;
  neq?: InputMaybe<BidStatus>;
};

export type FilterBilling = {
  eq?: InputMaybe<Billing>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Billing>;
  gte?: InputMaybe<Billing>;
  in?: InputMaybe<Array<Billing>>;
  lt?: InputMaybe<Billing>;
  lte?: InputMaybe<Billing>;
  neq?: InputMaybe<Billing>;
};

export type FilterBooking = {
  accountExec?: InputMaybe<NestedFilterUser>;
  adminCancellationMessage?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<FilterBooking>>;
  artist?: InputMaybe<NestedFilterArtist>;
  artistAvailability?: InputMaybe<NestedFilterArtistAvailability>;
  artistId?: InputMaybe<FilterId>;
  artistName?: InputMaybe<FilterString>;
  artistSlug?: InputMaybe<FilterString>;
  bandConfiguration?: InputMaybe<FilterBandConfigurationOption>;
  billing?: InputMaybe<FilterBilling>;
  bookingDispute?: InputMaybe<NestedFilterBookingDispute>;
  bookingFlow?: InputMaybe<FilterBookingFlow>;
  bookingGroup?: InputMaybe<FilterString>;
  bookingRequest?: InputMaybe<NestedFilterBookingRequest>;
  buyer?: InputMaybe<NestedFilterUser>;
  buyerHasReviewed?: InputMaybe<FilterBoolean>;
  buyerId?: InputMaybe<FilterId>;
  buyerMetadata?: InputMaybe<FilterString>;
  buyerName?: InputMaybe<FilterString>;
  buyerSlug?: InputMaybe<FilterString>;
  buyersWithAccess?: InputMaybe<FilterString>;
  canSellerSee?: InputMaybe<FilterBoolean>;
  cancellationMessage?: InputMaybe<FilterString>;
  cancellationRequested?: InputMaybe<FilterBoolean>;
  cancellationRequests?: InputMaybe<NestedFilterCancellationRequest>;
  capacity?: InputMaybe<FilterInt16>;
  charge?: InputMaybe<FilterString>;
  chargeLink?: InputMaybe<NestedFilterCharge>;
  chargedBuyer?: InputMaybe<FilterBoolean>;
  comments?: InputMaybe<FilterString>;
  confirmation?: InputMaybe<NestedFilterBookingConfirmation>;
  createdAt?: InputMaybe<FilterDateTime>;
  customerBalanceTransactionId?: InputMaybe<FilterString>;
  deposit?: InputMaybe<FilterString>;
  firebaseId?: InputMaybe<FilterString>;
  hasBookingDispute?: InputMaybe<FilterBoolean>;
  hasCancellationRequest?: InputMaybe<FilterBoolean>;
  hasConfirmation?: InputMaybe<FilterBoolean>;
  hasExtraCharge?: InputMaybe<FilterBoolean>;
  hasExtraPayout?: InputMaybe<FilterBoolean>;
  hasPendingCancellationRequest?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterId>;
  indoorsOrOutdoors?: InputMaybe<FilterIndoorsOrOutdoors>;
  isPublished?: InputMaybe<FilterBoolean>;
  lastAction?: InputMaybe<FilterNegotiationAction>;
  lastCancellationRequest?: InputMaybe<NestedFilterCancellationRequest>;
  lastOfferAmount?: InputMaybe<FilterFloat32>;
  lastOnBehalfOfRole?: InputMaybe<FilterOnBehalfOfRole>;
  lastSellerOfferAmount?: InputMaybe<FilterFloat32>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  legacyId?: InputMaybe<FilterString>;
  location?: InputMaybe<FilterString>;
  negotiationStepModels?: InputMaybe<NestedFilterNegotiationStep>;
  negotiationSteps?: InputMaybe<FilterString>;
  not?: InputMaybe<FilterBooking>;
  oldBooking?: InputMaybe<NestedFilterBooking>;
  oldStartTime?: InputMaybe<FilterDateTime>;
  or?: InputMaybe<Array<FilterBooking>>;
  originalBookingFromReplaceArtist?: InputMaybe<NestedFilterBooking>;
  paidSeller?: InputMaybe<FilterBoolean>;
  payout?: InputMaybe<FilterString>;
  payoutLink?: InputMaybe<NestedFilterPayout>;
  performanceLengthMins?: InputMaybe<FilterInt16>;
  productionAndVenueSpecs?: InputMaybe<FilterString>;
  publicCoverImage?: InputMaybe<FilterString>;
  publicEventDescription?: InputMaybe<FilterString>;
  publicProfileImage?: InputMaybe<FilterString>;
  refundedInCredits?: InputMaybe<FilterBoolean>;
  replaceArtistOnBooking?: InputMaybe<NestedFilterBooking>;
  rescheduleMessage?: InputMaybe<FilterString>;
  revenue?: InputMaybe<FilterFloat32>;
  reviewsOfArtist?: InputMaybe<NestedFilterArtistReview>;
  sellersWithAccess?: InputMaybe<FilterString>;
  shouldAutoPublish?: InputMaybe<FilterBoolean>;
  startTime?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterBookingStatus>;
  statusV2?: InputMaybe<FilterBookingStatusV2>;
  usersWithAccess?: InputMaybe<FilterString>;
  venue?: InputMaybe<NestedFilterVenue>;
  venueId?: InputMaybe<FilterId>;
  venueName?: InputMaybe<FilterString>;
  venueSlug?: InputMaybe<FilterString>;
  version?: InputMaybe<FilterString>;
  weekOutNotification?: InputMaybe<FilterBoolean>;
  weekOutNotificationAt?: InputMaybe<FilterDateTime>;
};

export type FilterBookingConfirmation = {
  and?: InputMaybe<Array<FilterBookingConfirmation>>;
  booking?: InputMaybe<NestedFilterBooking>;
  confirmedAt?: InputMaybe<FilterDateTime>;
  confirmedBy?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterId>;
  not?: InputMaybe<FilterBookingConfirmation>;
  or?: InputMaybe<Array<FilterBookingConfirmation>>;
  response?: InputMaybe<FilterBookingConfirmationResponse>;
  sellersWithAccess?: InputMaybe<FilterString>;
};

export type FilterBookingConfirmationResponse = {
  eq?: InputMaybe<BookingConfirmationResponse>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<BookingConfirmationResponse>;
  gte?: InputMaybe<BookingConfirmationResponse>;
  in?: InputMaybe<Array<BookingConfirmationResponse>>;
  lt?: InputMaybe<BookingConfirmationResponse>;
  lte?: InputMaybe<BookingConfirmationResponse>;
  neq?: InputMaybe<BookingConfirmationResponse>;
};

export type FilterBookingFlow = {
  eq?: InputMaybe<BookingFlow>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<BookingFlow>;
  gte?: InputMaybe<BookingFlow>;
  in?: InputMaybe<Array<BookingFlow>>;
  lt?: InputMaybe<BookingFlow>;
  lte?: InputMaybe<BookingFlow>;
  neq?: InputMaybe<BookingFlow>;
};

export type FilterBookingRequestStatus = {
  eq?: InputMaybe<BookingRequestStatus>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<BookingRequestStatus>;
  gte?: InputMaybe<BookingRequestStatus>;
  in?: InputMaybe<Array<BookingRequestStatus>>;
  lt?: InputMaybe<BookingRequestStatus>;
  lte?: InputMaybe<BookingRequestStatus>;
  neq?: InputMaybe<BookingRequestStatus>;
};

export type FilterBookingStatus = {
  eq?: InputMaybe<BookingStatus>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<BookingStatus>;
  gte?: InputMaybe<BookingStatus>;
  in?: InputMaybe<Array<BookingStatus>>;
  lt?: InputMaybe<BookingStatus>;
  lte?: InputMaybe<BookingStatus>;
  neq?: InputMaybe<BookingStatus>;
};

export type FilterBookingStatusV2 = {
  eq?: InputMaybe<BookingStatusV2>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<BookingStatusV2>;
  gte?: InputMaybe<BookingStatusV2>;
  in?: InputMaybe<Array<BookingStatusV2>>;
  lt?: InputMaybe<BookingStatusV2>;
  lte?: InputMaybe<BookingStatusV2>;
  neq?: InputMaybe<BookingStatusV2>;
};

export type FilterBoolean = {
  eq?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCancellationRequest = {
  and?: InputMaybe<Array<FilterCancellationRequest>>;
  booking?: InputMaybe<NestedFilterBooking>;
  createdAt?: InputMaybe<FilterDateTime>;
  id?: InputMaybe<FilterId>;
  key?: InputMaybe<FilterString>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  message?: InputMaybe<FilterString>;
  not?: InputMaybe<FilterCancellationRequest>;
  or?: InputMaybe<Array<FilterCancellationRequest>>;
  resolved?: InputMaybe<FilterBoolean>;
  user?: InputMaybe<NestedFilterUser>;
};

export type FilterCategory = {
  eq?: InputMaybe<Category>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Category>;
  gte?: InputMaybe<Category>;
  in?: InputMaybe<Array<Category>>;
  lt?: InputMaybe<Category>;
  lte?: InputMaybe<Category>;
  neq?: InputMaybe<Category>;
};

export type FilterDateTime = {
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  ilike?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  like?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
};

export type FilterFloat32 = {
  eq?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
};

export type FilterFloat64 = {
  eq?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
};

export type FilterId = {
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  neq?: InputMaybe<Scalars['String']>;
};

export type FilterIndoorsOrOutdoors = {
  eq?: InputMaybe<IndoorsOrOutdoors>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<IndoorsOrOutdoors>;
  gte?: InputMaybe<IndoorsOrOutdoors>;
  in?: InputMaybe<Array<IndoorsOrOutdoors>>;
  lt?: InputMaybe<IndoorsOrOutdoors>;
  lte?: InputMaybe<IndoorsOrOutdoors>;
  neq?: InputMaybe<IndoorsOrOutdoors>;
};

export type FilterInt16 = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
};

export type FilterInt32 = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
};

export type FilterInt64 = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
};

export type FilterNegotiationAction = {
  eq?: InputMaybe<NegotiationAction>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<NegotiationAction>;
  gte?: InputMaybe<NegotiationAction>;
  in?: InputMaybe<Array<NegotiationAction>>;
  lt?: InputMaybe<NegotiationAction>;
  lte?: InputMaybe<NegotiationAction>;
  neq?: InputMaybe<NegotiationAction>;
};

export type FilterOnBehalfOfRole = {
  eq?: InputMaybe<OnBehalfOfRole>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<OnBehalfOfRole>;
  gte?: InputMaybe<OnBehalfOfRole>;
  in?: InputMaybe<Array<OnBehalfOfRole>>;
  lt?: InputMaybe<OnBehalfOfRole>;
  lte?: InputMaybe<OnBehalfOfRole>;
  neq?: InputMaybe<OnBehalfOfRole>;
};

export type FilterPlaidStatus = {
  eq?: InputMaybe<PlaidStatus>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<PlaidStatus>;
  gte?: InputMaybe<PlaidStatus>;
  in?: InputMaybe<Array<PlaidStatus>>;
  lt?: InputMaybe<PlaidStatus>;
  lte?: InputMaybe<PlaidStatus>;
  neq?: InputMaybe<PlaidStatus>;
};

export type FilterString = {
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  ilike?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  like?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
};

export type FilterUserRole = {
  eq?: InputMaybe<UserRole>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<UserRole>;
  gte?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  lt?: InputMaybe<UserRole>;
  lte?: InputMaybe<UserRole>;
  neq?: InputMaybe<UserRole>;
};

export type FilterUserType = {
  eq?: InputMaybe<UserType>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<UserType>;
  gte?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  lt?: InputMaybe<UserType>;
  lte?: InputMaybe<UserType>;
  neq?: InputMaybe<UserType>;
};

export type FilterVenueType = {
  eq?: InputMaybe<VenueType>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<VenueType>;
  gte?: InputMaybe<VenueType>;
  in?: InputMaybe<Array<VenueType>>;
  lt?: InputMaybe<VenueType>;
  lte?: InputMaybe<VenueType>;
  neq?: InputMaybe<VenueType>;
};

export type Followers = {
  __typename: 'Followers';
  total?: Maybe<Scalars['Int']>;
};

export type FrontendDirections = {
  __typename: 'FrontendDirections';
  notes?: Maybe<Array<Note>>;
  shortMessage?: Maybe<ShortMessage>;
  tooltip?: Maybe<Tooltip>;
};

export type GamificationMetric = {
  __typename: 'GamificationMetric';
  quality: Quality;
  score: Scalars['Int'];
  value: Scalars['Float'];
};

export type GamificationMetrics = {
  __typename: 'GamificationMetrics';
  avgRating: GamificationMetric;
  bookingsCount: GamificationMetric;
  cancellationRate: GamificationMetric;
  cancellationsCount: GamificationMetric;
  likeCount: GamificationMetric;
  numberOfReviews: GamificationMetric;
  responseRate: GamificationMetric;
  responseTimeMins: GamificationMetric;
  viewCount: GamificationMetric;
};

export type GeoLoc = {
  __typename: 'GeoLoc';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type Image = {
  __typename: 'Image';
  height: Scalars['Int'];
  publicCloudinaryId: Scalars['String'];
  url: Scalars['String'];
  verticalAlign?: Maybe<VerticalAlign>;
  width: Scalars['Int'];
};

export type ImageInput = {
  height: Scalars['Int'];
  publicCloudinaryId: Scalars['String'];
  url: Scalars['String'];
  verticalAlign?: InputMaybe<VerticalAlign>;
  width: Scalars['Int'];
};

export type ImageSpotify = {
  __typename: 'ImageSpotify';
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type Images = {
  __typename: 'Images';
  allSources: Array<Image>;
  gallery: Array<Image>;
};

export type ImagesInput = {
  allSources?: Array<ImageInput>;
  gallery?: Array<ImageInput>;
};

export enum IndoorsOrOutdoors {
  INDOORS = 'Indoors',
  OUTDOORS = 'Outdoors'
}

export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  PAID = 'PAID',
  UNCOLLECTIBLE = 'UNCOLLECTIBLE',
  VOID = 'VOID'
}

export type IpResponse = {
  __typename: 'IpResponse';
  countryAbbr: Scalars['String'];
  stateAbbr: Scalars['String'];
};

export type LastMoved = {
  __typename: 'LastMoved';
  buyer?: Maybe<Array<NegotiationAction>>;
  seller?: Maybe<Array<NegotiationAction>>;
};

export type Location = {
  __typename: 'Location';
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  countryName?: Maybe<Scalars['String']>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  placeId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateAbbr?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
};

export type LocationInput = {
  city?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  countryName?: InputMaybe<Scalars['String']>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  stateAbbr?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
};

export type Media = {
  __typename: 'Media';
  images: Images;
  songs: Songs;
  videos: Videos;
};

export type MediaInput = {
  images: ImagesInput;
  songs: SongsInput;
  videos: VideosInput;
};

export type Metadata = {
  __typename: 'Metadata';
  location?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  userType: UserType;
};

export type MetadataInput = {
  location?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  userType: UserType;
};

export type Metric = {
  __typename: 'Metric';
  barCharts: BarChartEdge;
  overview?: Maybe<Overview>;
};

export type Metrics = {
  __typename: 'Metrics';
  bookingsCount: Metric;
  revenue: Metric;
};

export type Mutation = {
  __typename: 'Mutation';
  acceptBidAdmin: Bid;
  acceptBidBuyer: Bid;
  acceptBookingAdmin: Booking;
  acceptBookingBuyer: Booking;
  acceptBookingSeller: Booking;
  addArtistsToBookingRequests: Array<BookingRequest>;
  advanceBooking: Booking;
  /** admin only */
  approve: User;
  assignAccountExecToBooking: Booking;
  assignAccountExecToBookingRequest: BookingRequest;
  cancelBooking: Booking;
  cancelBookingAdmin: Booking;
  cancelBookingRequests: Array<BookingRequest>;
  changePlaceId: Venue;
  /** admin only */
  changeUserRole: User;
  chargeBooking: Booking;
  confirmBooking: BookingConfirmation;
  counterBookingAdmin: Booking;
  counterBookingBuyer: Booking;
  counterBookingSeller: Booking;
  createArtist: Artist;
  createArtistAvailability: ArtistAvailability;
  createArtistAvailabilityCheck: ArtistAvailabilityCheck;
  createArtistReview: ArtistReview;
  createArtistVenueApplication: ArtistVenueApplicationStraw;
  createBidAdmin: Bid;
  createBidSeller: Bid;
  createBookingRequestsAdmin: Array<BookingRequest>;
  createBookingRequestsBuyer: Array<BookingRequest>;
  createBookingsAdmin: Array<Booking>;
  createBookingsBuyer: Array<Booking>;
  createCustomToken: Scalars['String'];
  createExternalBooking: ExternalBooking;
  createExtraArtistInfo: ExtraArtistInfo;
  createLinkToArtist: Artist;
  createLinkToVenue: Venue;
  createUser: User;
  createVenueFromPlaceId: Venue;
  declineBooking: Booking;
  declineBookingAdmin: Booking;
  declineBookingRequest: BookingRequestDecline;
  deleteArtist: Artist;
  deleteArtistReview: ArtistReview;
  deleteBankAccount?: Maybe<StripeBankAccount>;
  deleteExternalBooking: ExternalBooking;
  deleteExtraArtistInfo: ExtraArtistInfo;
  deleteUser: User;
  /** admin only */
  deleteUserAdmin: User;
  deleteUserForTesting: Scalars['Boolean'];
  deleteVenue: Venue;
  disputeBooking: BookingDispute;
  duplicateBooking: Booking;
  exchangeAuthCodeGoogle: Scalars['Boolean'];
  getCodeTestUser: Scalars['Boolean'];
  giveArtistAvailability: ArtistAvailabilityCheck;
  helloMutation: Scalars['String'];
  likeArtist: Scalars['Boolean'];
  linkAccountExec: Venue;
  login: Scalars['Boolean'];
  markBookingAsCharged: Booking;
  markBookingAsPaidOut: Booking;
  payoutBooking: Booking;
  /** queue_only */
  propagateArtist: Scalars['JSON'];
  /** queue_only */
  propagateBooking: Scalars['JSON'];
  /** queue_only */
  propagateUser: Scalars['JSON'];
  /** queue_only */
  propagateVenue: Scalars['JSON'];
  publishArtist: Artist;
  publishArtistReview: ArtistReview;
  publishBooking: Booking;
  refreshDiscoverPage: Scalars['Boolean'];
  rejectBid: Bid;
  removeArtistsFromBookingRequests: Array<BookingRequest>;
  removeCalendar: Scalars['Boolean'];
  replaceArtistOnBooking: Booking;
  replaceVenue: Booking;
  requestArtistAvailabilityForBooking: ArtistAvailability;
  resendCheck: ArtistAvailabilityCheck;
  resolveBookingDispute: BookingDispute;
  resolveCancellationRequest: CancellationRequest;
  sendPromoImageToEmail: SendImageToEmailResponse;
  sendPromoImageToPhone: SendImageToPhoneResponse;
  setArtistAvailabilityStatus: ArtistAvailability;
  setCustomBuyerPriceOnBid: Bid;
  setDefaultBankAccount?: Maybe<StripeBankAccount>;
  setDevice: Scalars['Boolean'];
  setPlaidAccessToken?: Maybe<SetPlaidAccessTokenResponse>;
  switchBuyerToSeller: User;
  switchSellerToBuyer: User;
  textUserLink: Scalars['Boolean'];
  trackPromoExport: Scalars['Boolean'];
  trackPushNotificationEvent: Scalars['Boolean'];
  undoDeclineBookingRequest: BookingRequestDecline;
  unsetDevice: Scalars['Boolean'];
  updateAdminDetails: Artist;
  updateArtist: Artist;
  updateArtistImages: Artist;
  updateArtistPerformanceDataSongs: ArtistPerformanceData;
  updateArtistReview: ArtistReview;
  updateArtistSongs: Artist;
  updateArtistVideos: Artist;
  updateBid: Bid;
  updateBookingPreference: Array<Question>;
  updateBookingPreferences: Array<Question>;
  updateBookingRequests: Array<BookingRequest>;
  updateBookings: Array<Booking>;
  updateBuyerPrice: Booking;
  updateExternalBooking: ExternalBooking;
  updateExtraArtistInfo: ExtraArtistInfo;
  updateLastOfferAmount: Booking;
  updateSellerPrice: Booking;
  updateSellerPriceOnBid: Bid;
  updateSpotifyId: Artist;
  updateUser: User;
  /** admin only */
  updateUserAdmin: User;
  updateVenue: Venue;
  uploadImage: Image;
  viewArtist: Scalars['Int'];
  withdrawBid: Bid;
};


export type MutationAcceptBidAdminArgs = {
  bidId: Scalars['String'];
  buyerFirebaseId: Scalars['String'];
  notifyAcceptedSellers: Scalars['Boolean'];
  notifyRejectedSellers: Scalars['Boolean'];
};


export type MutationAcceptBidBuyerArgs = {
  bidId: Scalars['String'];
};


export type MutationAcceptBookingAdminArgs = {
  bookingId: Scalars['String'];
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  offerAmount?: InputMaybe<Scalars['Float']>;
  onBehalfOfRole: OnBehalfOfRole;
  sellerOfferAmount?: InputMaybe<Scalars['Float']>;
};


export type MutationAcceptBookingBuyerArgs = {
  bookingId: Scalars['String'];
  offerAmount: Scalars['Float'];
};


export type MutationAcceptBookingSellerArgs = {
  bookingId: Scalars['String'];
  sellerOfferAmount: Scalars['Float'];
};


export type MutationAddArtistsToBookingRequestsArgs = {
  artistIds: Array<Scalars['String']>;
  bookingRequestIds: Array<Scalars['String']>;
  extraArtistInfoInputs: Array<InputMaybe<ExtraArtistInfoInput>>;
  notifySellers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAdvanceBookingArgs = {
  bookingId: Scalars['String'];
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
};


export type MutationApproveArgs = {
  disapprove?: Scalars['Boolean'];
  userId: Scalars['String'];
};


export type MutationAssignAccountExecToBookingArgs = {
  accountExecId: Scalars['String'];
  bookingId: Scalars['String'];
};


export type MutationAssignAccountExecToBookingRequestArgs = {
  accountExecId: Scalars['String'];
  bookingRequestId: Scalars['String'];
};


export type MutationCancelBookingArgs = {
  bookingId: Scalars['String'];
  cancellationMessage: Scalars['String'];
};


export type MutationCancelBookingAdminArgs = {
  adminCancellationMessage?: InputMaybe<Scalars['String']>;
  bookingId: Scalars['String'];
  cancellationMessage: Scalars['String'];
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  onBehalfOfRole: OnBehalfOfRole;
};


export type MutationCancelBookingRequestsArgs = {
  bookingRequestIds: Array<Scalars['String']>;
  cancellationMessage: Scalars['String'];
  notifySellers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationChangePlaceIdArgs = {
  newPlaceId: Scalars['String'];
  venueId: Scalars['String'];
};


export type MutationChangeUserRoleArgs = {
  newMetadata: MetadataInput;
  newUserRole: UserRole;
  userId: Scalars['String'];
};


export type MutationChargeBookingArgs = {
  bookingId: Scalars['String'];
};


export type MutationConfirmBookingArgs = {
  bookingId: Scalars['UUID'];
  response: BookingConfirmationResponse;
};


export type MutationCounterBookingAdminArgs = {
  bookingId: Scalars['String'];
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  offerAmount?: InputMaybe<Scalars['Float']>;
  onBehalfOfRole: OnBehalfOfRole;
  sellerOfferAmount?: InputMaybe<Scalars['Float']>;
};


export type MutationCounterBookingBuyerArgs = {
  bookingId: Scalars['String'];
  offerAmount: Scalars['Float'];
};


export type MutationCounterBookingSellerArgs = {
  bookingId: Scalars['String'];
  sellerOfferAmount: Scalars['Float'];
};


export type MutationCreateArtistArgs = {
  name: Scalars['String'];
  spotifyId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateArtistAvailabilityArgs = {
  bookingId?: InputMaybe<Scalars['UUID']>;
  input?: InputMaybe<ArtistAvailabilityInput>;
};


export type MutationCreateArtistAvailabilityCheckArgs = {
  artistAvailabilityId: Scalars['UUID'];
  artistId: Scalars['UUID'];
};


export type MutationCreateArtistReviewArgs = {
  bookingId: Scalars['String'];
  input: ArtistReviewInput;
};


export type MutationCreateArtistVenueApplicationArgs = {
  artistId: Scalars['String'];
  message: Scalars['String'];
  venueId: Scalars['String'];
};


export type MutationCreateBidAdminArgs = {
  artistDetailsForBuyerByAdmin?: InputMaybe<Scalars['String']>;
  artistId: Scalars['String'];
  bookingRequestId: Scalars['String'];
  customBuyerPrice?: InputMaybe<Scalars['Float']>;
  input: BidInput;
  notifyBuyers: Scalars['Boolean'];
  sellerPrice: Scalars['Float'];
};


export type MutationCreateBidSellerArgs = {
  artistId: Scalars['String'];
  bookingRequestId: Scalars['String'];
  input: BidInput;
  sellerPrice: Scalars['Float'];
};


export type MutationCreateBookingRequestsAdminArgs = {
  accountExecId?: InputMaybe<Scalars['String']>;
  artistIds: Array<Scalars['String']>;
  input: BookingRequestInput;
  notifySellers?: InputMaybe<Scalars['Boolean']>;
  startTimes: Array<Scalars['DateTime']>;
  venueId: Scalars['String'];
};


export type MutationCreateBookingRequestsBuyerArgs = {
  artistIds: Array<Scalars['String']>;
  input: BookingRequestInput;
  startTimes: Array<Scalars['DateTime']>;
  venueId: Scalars['String'];
};


export type MutationCreateBookingsAdminArgs = {
  artistId: Scalars['String'];
  bookingFlow: BookingFlow;
  buyerFirebaseId?: InputMaybe<Scalars['String']>;
  ignoreConflictingBookings?: Scalars['Boolean'];
  input: BookingInput;
  notifyBuyers?: Scalars['Boolean'];
  notifySellers?: Scalars['Boolean'];
  offerAmount: Scalars['Float'];
  sellerAutoAccepts?: InputMaybe<Scalars['Boolean']>;
  sellerOfferAmount?: InputMaybe<Scalars['Float']>;
  startTimes: Array<Scalars['DateTime']>;
  venueId?: InputMaybe<Scalars['String']>;
  venueLocationInput?: InputMaybe<LocationInput>;
};


export type MutationCreateBookingsBuyerArgs = {
  artistId: Scalars['String'];
  bookingFlow: BookingFlow;
  input: BookingInput;
  offerAmount: Scalars['Float'];
  startTimes: Array<Scalars['DateTime']>;
  venueId?: InputMaybe<Scalars['String']>;
  venueLocationInput?: InputMaybe<LocationInput>;
};


export type MutationCreateCustomTokenArgs = {
  code: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationCreateExternalBookingArgs = {
  input: ExternalBookingInput;
  venueId: Scalars['String'];
};


export type MutationCreateExtraArtistInfoArgs = {
  artistId: Scalars['String'];
  bookingRequestId: Scalars['String'];
  input: ExtraArtistInfoInput;
};


export type MutationCreateLinkToArtistArgs = {
  artistId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  remove?: Scalars['Boolean'];
  slug?: InputMaybe<Scalars['String']>;
};


export type MutationCreateLinkToVenueArgs = {
  phoneNumber: Scalars['String'];
  remove?: Scalars['Boolean'];
  venueId: Scalars['String'];
};


export type MutationCreateUserArgs = {
  input: UserInput;
  signUpMessage?: InputMaybe<Scalars['String']>;
};


export type MutationCreateVenueFromPlaceIdArgs = {
  accountExecId?: InputMaybe<Scalars['String']>;
  ignoreDuplicatePlaceIds?: InputMaybe<Scalars['Boolean']>;
  placeId: Scalars['String'];
  venueName?: InputMaybe<Scalars['String']>;
  venueType: VenueType;
};


export type MutationDeclineBookingArgs = {
  bookingId: Scalars['String'];
};


export type MutationDeclineBookingAdminArgs = {
  bookingId: Scalars['String'];
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  onBehalfOfRole: OnBehalfOfRole;
};


export type MutationDeclineBookingRequestArgs = {
  artistId: Scalars['String'];
  bookingRequestId: Scalars['String'];
  reasonForDecline: Scalars['String'];
};


export type MutationDeleteArtistArgs = {
  artistId?: InputMaybe<Scalars['String']>;
  artistSlug?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteArtistReviewArgs = {
  artistReviewId: Scalars['String'];
};


export type MutationDeleteBankAccountArgs = {
  bankAccountId: Scalars['String'];
  venueId: Scalars['String'];
};


export type MutationDeleteExternalBookingArgs = {
  externalBookingId: Scalars['String'];
};


export type MutationDeleteExtraArtistInfoArgs = {
  extraArtistInfoId: Scalars['String'];
};


export type MutationDeleteUserAdminArgs = {
  userId?: InputMaybe<Scalars['String']>;
  userSlug?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUserForTestingArgs = {
  key: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationDeleteVenueArgs = {
  venueId?: InputMaybe<Scalars['String']>;
  venueSlug?: InputMaybe<Scalars['String']>;
};


export type MutationDisputeBookingArgs = {
  bookingId: Scalars['String'];
  message: Scalars['String'];
};


export type MutationDuplicateBookingArgs = {
  bookingId: Scalars['String'];
  newArtistBandConfiguration: BandConfigurationOption;
  newArtistId: Scalars['String'];
  newOfferAmount: Scalars['Float'];
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
};


export type MutationExchangeAuthCodeGoogleArgs = {
  authCode: Scalars['String'];
  redirectUri: Scalars['String'];
};


export type MutationGetCodeTestUserArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationGiveArtistAvailabilityArgs = {
  artistAvailabilityCheckId: Scalars['UUID'];
  response: ArtistAvailabilityResponse;
  responseMessage?: InputMaybe<Scalars['String']>;
};


export type MutationLikeArtistArgs = {
  artistId?: InputMaybe<Scalars['String']>;
  artistSlug?: InputMaybe<Scalars['String']>;
  unlike?: Scalars['Boolean'];
};


export type MutationLinkAccountExecArgs = {
  accountExecId: Scalars['String'];
  remove?: Scalars['Boolean'];
  venueId: Scalars['String'];
};


export type MutationMarkBookingAsChargedArgs = {
  bookingId: Scalars['String'];
  undo?: Scalars['Boolean'];
};


export type MutationMarkBookingAsPaidOutArgs = {
  bookingId: Scalars['String'];
  undo?: Scalars['Boolean'];
};


export type MutationPayoutBookingArgs = {
  bookingId: Scalars['String'];
};


export type MutationPropagateArtistArgs = {
  modelId: Scalars['String'];
};


export type MutationPropagateBookingArgs = {
  modelId: Scalars['String'];
};


export type MutationPropagateUserArgs = {
  modelId: Scalars['String'];
};


export type MutationPropagateVenueArgs = {
  modelId: Scalars['String'];
};


export type MutationPublishArtistArgs = {
  artistId?: InputMaybe<Scalars['String']>;
  unpublish?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishArtistReviewArgs = {
  artistReviewId: Scalars['String'];
  unpublish?: Scalars['Boolean'];
};


export type MutationPublishBookingArgs = {
  bookingId: Scalars['String'];
  unpublish?: Scalars['Boolean'];
};


export type MutationRefreshDiscoverPageArgs = {
  key: Scalars['String'];
};


export type MutationRejectBidArgs = {
  bidId: Scalars['String'];
  notifySellers?: InputMaybe<Scalars['Boolean']>;
  rejectionMessage: Scalars['String'];
};


export type MutationRemoveArtistsFromBookingRequestsArgs = {
  artistIds: Array<Scalars['String']>;
  bookingRequestIds: Array<Scalars['String']>;
};


export type MutationReplaceArtistOnBookingArgs = {
  adminCancellationMessage?: InputMaybe<Scalars['String']>;
  bookingId: Scalars['String'];
  cancelOnBehalfOfRole: OnBehalfOfRole;
  cancellationMessage: Scalars['String'];
  newArtistId: Scalars['String'];
  newBandConfiguration?: InputMaybe<BandConfigurationOption>;
  newOfferAmount?: InputMaybe<Scalars['Float']>;
  notifyBuyers: Scalars['Boolean'];
  notifyOldSellers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
};


export type MutationReplaceVenueArgs = {
  bookingId: Scalars['UUID'];
  newBuyerId?: InputMaybe<Scalars['UUID']>;
  newVenueId: Scalars['UUID'];
};


export type MutationRequestArtistAvailabilityForBookingArgs = {
  artistIds: Array<Scalars['UUID']>;
  bookingId: Scalars['UUID'];
};


export type MutationResendCheckArgs = {
  artistAvailabilityCheckId: Scalars['UUID'];
};


export type MutationResolveBookingDisputeArgs = {
  bookingDisputeId: Scalars['String'];
};


export type MutationResolveCancellationRequestArgs = {
  id: Scalars['String'];
};


export type MutationSendPromoImageToEmailArgs = {
  imgUrl: Scalars['String'];
  message: Scalars['String'];
  redirectUrl: Scalars['String'];
  subject: Scalars['String'];
};


export type MutationSendPromoImageToPhoneArgs = {
  imgUrl: Scalars['String'];
  message: Scalars['String'];
  redirectUrl: Scalars['String'];
};


export type MutationSetArtistAvailabilityStatusArgs = {
  artistAvailabilityId: Scalars['UUID'];
  status: ArtistAvailabilityStatus;
};


export type MutationSetCustomBuyerPriceOnBidArgs = {
  bidId: Scalars['String'];
  customBuyerPrice: Scalars['Float'];
};


export type MutationSetDefaultBankAccountArgs = {
  bankAccountId: Scalars['String'];
  venueId: Scalars['String'];
};


export type MutationSetDeviceArgs = {
  deviceName: Scalars['String'];
  notificationToken: Scalars['String'];
};


export type MutationSetPlaidAccessTokenArgs = {
  metadataStringified: Scalars['String'];
  publicToken: Scalars['String'];
  venueId: Scalars['String'];
};


export type MutationSwitchBuyerToSellerArgs = {
  sellerUserType: SellerUserType;
  userId: Scalars['UUID'];
};


export type MutationSwitchSellerToBuyerArgs = {
  buyerUserType: BuyerUserType;
  location?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};


export type MutationTextUserLinkArgs = {
  captchaToken: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationTrackPromoExportArgs = {
  imgUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
  via: Scalars['String'];
};


export type MutationTrackPushNotificationEventArgs = {
  pushTrackingEvent: PushTrackingEvent;
  trackingUrl: Scalars['String'];
};


export type MutationUndoDeclineBookingRequestArgs = {
  declineId: Scalars['String'];
};


export type MutationUnsetDeviceArgs = {
  deviceName: Scalars['String'];
};


export type MutationUpdateAdminDetailsArgs = {
  artistId: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateArtistArgs = {
  artistId: Scalars['String'];
  patch: ArtistPatch;
};


export type MutationUpdateArtistImagesArgs = {
  artistId: Scalars['String'];
  images: Array<ImageInput>;
};


export type MutationUpdateArtistPerformanceDataSongsArgs = {
  artistId: Scalars['String'];
  songsTxt: Scalars['String'];
};


export type MutationUpdateArtistReviewArgs = {
  artistReviewId: Scalars['String'];
  patch: ArtistReviewPatch;
};


export type MutationUpdateArtistSongsArgs = {
  artistId: Scalars['String'];
  songs: SongsInput;
};


export type MutationUpdateArtistVideosArgs = {
  artistId: Scalars['String'];
  videos: VideosInput;
};


export type MutationUpdateBidArgs = {
  bidId: Scalars['String'];
  notifyBuyers?: InputMaybe<Scalars['Boolean']>;
  patch: BidPatch;
};


export type MutationUpdateBookingPreferenceArgs = {
  response: ResponseInput;
};


export type MutationUpdateBookingPreferencesArgs = {
  responses: Array<ResponseInput>;
};


export type MutationUpdateBookingRequestsArgs = {
  bookingRequestIds: Array<Scalars['String']>;
  notifySellers?: InputMaybe<Scalars['Boolean']>;
  patch: BookingRequestPatch;
  startTimeDeltaMins?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateBookingsArgs = {
  bookingIds: Array<Scalars['String']>;
  notifySellers?: Scalars['Boolean'];
  patch: BookingPatch;
  startTimeDeltaMins?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateBuyerPriceArgs = {
  bookingId: Scalars['String'];
  newPrice: Scalars['Float'];
};


export type MutationUpdateExternalBookingArgs = {
  externalBookingId: Scalars['String'];
  patch: ExternalBookingPatch;
};


export type MutationUpdateExtraArtistInfoArgs = {
  extraArtistInfoId: Scalars['String'];
  patch: ExtraArtistInfoPatch;
};


export type MutationUpdateLastOfferAmountArgs = {
  bookingId: Scalars['String'];
  newBuyerPrice: Scalars['Float'];
  takePercentage?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdateSellerPriceArgs = {
  bookingId: Scalars['String'];
  newPrice: Scalars['Float'];
};


export type MutationUpdateSellerPriceOnBidArgs = {
  bidId: Scalars['String'];
  newSellerPrice: Scalars['Float'];
  notifyBuyers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateSpotifyIdArgs = {
  artistId: Scalars['String'];
  newSpotifyId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserArgs = {
  patch: UserPatch;
};


export type MutationUpdateUserAdminArgs = {
  patch: UserPatch;
  userId: Scalars['String'];
};


export type MutationUpdateVenueArgs = {
  patch: VenuePatch;
  venueId: Scalars['String'];
};


export type MutationUploadImageArgs = {
  imageBytes: Scalars['String'];
};


export type MutationViewArtistArgs = {
  artistId: Scalars['String'];
};


export type MutationWithdrawBidArgs = {
  bidId: Scalars['String'];
  notifyBuyers?: InputMaybe<Scalars['Boolean']>;
  withdrawalMessage?: InputMaybe<Scalars['String']>;
};

export type MyBadgeResponse = {
  __typename: 'MyBadgeResponse';
  artistAvailChecks: Scalars['Int'];
  bookingRequests: Scalars['Int'];
  bookings: Scalars['Int'];
  total: Scalars['Int'];
};

export enum MyBookingsFilter {
  ARTIST_BOOKINGS_ONLY = 'ARTIST_BOOKINGS_ONLY',
  BUYER_BOOKINGS_ONLY = 'BUYER_BOOKINGS_ONLY',
  PRIVATE_BUYER_BOOKINGS_ONLY = 'PRIVATE_BUYER_BOOKINGS_ONLY',
  VENUE_BOOKINGS_ONLY = 'VENUE_BOOKINGS_ONLY'
}

export enum NegotiationAction {
  ACCEPT = 'accept',
  CANCEL = 'cancel',
  COUNTER = 'counter',
  DECLINE = 'decline',
  OFFER = 'offer',
  RESCHEDULE = 'reschedule',
  SCHEDULE = 'schedule'
}

export type NegotiationStep = {
  __typename: 'NegotiationStep';
  action: NegotiationAction;
  description: NegotiationStepDescription;
  offerAmount: Scalars['Float'];
  onBehalfOfRole: OnBehalfOfRole;
  sellerOfferAmount: Scalars['Float'];
  timestamp: Scalars['DateTime'];
  userId: Scalars['String'];
  userRole: UserRole;
};

export type NegotiationStepDescription = {
  __typename: 'NegotiationStepDescription';
  admin: Scalars['String'];
  buyer: Scalars['String'];
  seller: Scalars['String'];
};

export type NestedFilterArtist = {
  adminDetails?: InputMaybe<FilterString>;
  artistPerformanceData?: InputMaybe<NestedFilterArtistPerformanceData>;
  artistReviews?: InputMaybe<NestedFilterArtistReview>;
  avgRating?: InputMaybe<FilterFloat64>;
  bandConfiguration?: InputMaybe<FilterString>;
  bio?: InputMaybe<FilterString>;
  bookingRequests?: InputMaybe<NestedFilterBookingRequest>;
  bookings?: InputMaybe<NestedFilterBooking>;
  category?: InputMaybe<FilterCategory>;
  confirmedBookings?: InputMaybe<NestedFilterBooking>;
  connectAccountId?: InputMaybe<FilterString>;
  contactInformation?: InputMaybe<FilterString>;
  coverImage?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterDateTime>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  lastBackendUpdated?: InputMaybe<FilterDateTime>;
  lastRedisRefreshed?: InputMaybe<FilterDateTime>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  likeCount?: InputMaybe<FilterInt64>;
  likes?: InputMaybe<NestedFilterArtistLike>;
  linkedPhoneNumbers?: InputMaybe<NestedFilterPhoneNumberToArtist>;
  location?: InputMaybe<FilterString>;
  media?: InputMaybe<FilterString>;
  migrationVersion?: InputMaybe<FilterInt16>;
  name?: InputMaybe<FilterString>;
  numberOfReviews?: InputMaybe<FilterInt64>;
  payoutsManually?: InputMaybe<FilterBoolean>;
  profileImage?: InputMaybe<FilterString>;
  published?: InputMaybe<FilterBoolean>;
  publishedArtistReviews?: InputMaybe<NestedFilterArtistReview>;
  relatedArtists?: InputMaybe<NestedFilterArtist>;
  sellerFirebaseIds?: InputMaybe<FilterString>;
  sellers?: InputMaybe<NestedFilterUser>;
  slug?: InputMaybe<FilterString>;
  socialMedia?: InputMaybe<FilterString>;
  spotifyData?: InputMaybe<NestedFilterArtistSpotifyData>;
  spotifyFollowers?: InputMaybe<FilterInt32>;
  spotifyId?: InputMaybe<FilterString>;
  spotifyPopularity?: InputMaybe<FilterInt16>;
  topReviews?: InputMaybe<NestedFilterArtistReview>;
  venueTakePercentages?: InputMaybe<FilterString>;
  version?: InputMaybe<FilterInt16>;
  viewCount?: InputMaybe<FilterInt64>;
  views?: InputMaybe<NestedFilterArtistView>;
};

export type NestedFilterArtistAvailability = {
  booking?: InputMaybe<NestedFilterBooking>;
  buyerDisplayName?: InputMaybe<FilterString>;
  checks?: InputMaybe<NestedFilterArtistAvailabilityCheck>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  location?: InputMaybe<FilterString>;
  performanceLengthMins?: InputMaybe<FilterInt16>;
  startTime?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterArtistAvailabilityStatus>;
};

export type NestedFilterArtistAvailabilityCheck = {
  artist?: InputMaybe<NestedFilterArtist>;
  artistAvailability?: InputMaybe<NestedFilterArtistAvailability>;
  artistAvailabilityId?: InputMaybe<FilterId>;
  artistId?: InputMaybe<FilterId>;
  courierNotificationIds?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  notifiedAt?: InputMaybe<FilterDateTime>;
  respondedAt?: InputMaybe<FilterDateTime>;
  respondedBy?: InputMaybe<NestedFilterUser>;
  response?: InputMaybe<FilterArtistAvailabilityResponse>;
  responseMessage?: InputMaybe<FilterString>;
  sellersWithAccess?: InputMaybe<FilterString>;
  startTime?: InputMaybe<FilterDateTime>;
};

export type NestedFilterArtistLike = {
  artist?: InputMaybe<NestedFilterArtist>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  timestamp?: InputMaybe<FilterDateTime>;
  user?: InputMaybe<NestedFilterUser>;
};

export type NestedFilterArtistPerformanceData = {
  artist?: InputMaybe<NestedFilterArtist>;
  createdAt?: InputMaybe<FilterDateTime>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  songsTxt?: InputMaybe<FilterString>;
};

export type NestedFilterArtistReview = {
  artist?: InputMaybe<NestedFilterArtist>;
  author?: InputMaybe<NestedFilterUser>;
  authorLocStr?: InputMaybe<FilterString>;
  authorName?: InputMaybe<FilterString>;
  authorOrgStr?: InputMaybe<FilterString>;
  authorProfileImage?: InputMaybe<FilterString>;
  booking?: InputMaybe<NestedFilterBooking>;
  comment?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  images?: InputMaybe<FilterString>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  legacyId?: InputMaybe<FilterString>;
  published?: InputMaybe<FilterBoolean>;
  rating?: InputMaybe<FilterInt16>;
  timestamp?: InputMaybe<FilterDateTime>;
  venue?: InputMaybe<NestedFilterVenue>;
};

export type NestedFilterArtistSpotifyData = {
  artist?: InputMaybe<NestedFilterArtist>;
  artistId?: InputMaybe<FilterId>;
  exists?: InputMaybe<Scalars['Boolean']>;
  followers?: InputMaybe<FilterInt32>;
  id?: InputMaybe<FilterId>;
  images?: InputMaybe<FilterString>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  popularity?: InputMaybe<FilterInt16>;
  spotifyId?: InputMaybe<FilterString>;
  url?: InputMaybe<FilterString>;
};

export type NestedFilterArtistView = {
  artist?: InputMaybe<NestedFilterArtist>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  timestamp?: InputMaybe<FilterDateTime>;
  totalViews?: InputMaybe<FilterInt32>;
  user?: InputMaybe<NestedFilterUser>;
};

export type NestedFilterBid = {
  artist?: InputMaybe<NestedFilterArtist>;
  artistId?: InputMaybe<FilterId>;
  bandConfiguration?: InputMaybe<FilterBandConfigurationOption>;
  bookingRequest?: InputMaybe<NestedFilterBookingRequest>;
  bookingRequestId?: InputMaybe<FilterId>;
  buyerHasSeen?: InputMaybe<FilterBoolean>;
  buyerPrice?: InputMaybe<FilterFloat32>;
  buyerSawAt?: InputMaybe<FilterDateTime>;
  buyersWithAccess?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  notes?: InputMaybe<FilterString>;
  rejectionMessage?: InputMaybe<FilterString>;
  sellerPrice?: InputMaybe<FilterFloat32>;
  sellersWithAccess?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterBidStatus>;
  usersWithAccess?: InputMaybe<FilterString>;
  withdrawalMessage?: InputMaybe<FilterString>;
};

export type NestedFilterBooking = {
  accountExec?: InputMaybe<NestedFilterUser>;
  adminCancellationMessage?: InputMaybe<FilterString>;
  artist?: InputMaybe<NestedFilterArtist>;
  artistAvailability?: InputMaybe<NestedFilterArtistAvailability>;
  artistId?: InputMaybe<FilterId>;
  artistName?: InputMaybe<FilterString>;
  artistSlug?: InputMaybe<FilterString>;
  bandConfiguration?: InputMaybe<FilterBandConfigurationOption>;
  billing?: InputMaybe<FilterBilling>;
  bookingDispute?: InputMaybe<NestedFilterBookingDispute>;
  bookingFlow?: InputMaybe<FilterBookingFlow>;
  bookingGroup?: InputMaybe<FilterString>;
  bookingRequest?: InputMaybe<NestedFilterBookingRequest>;
  buyer?: InputMaybe<NestedFilterUser>;
  buyerHasReviewed?: InputMaybe<FilterBoolean>;
  buyerId?: InputMaybe<FilterId>;
  buyerMetadata?: InputMaybe<FilterString>;
  buyerName?: InputMaybe<FilterString>;
  buyerSlug?: InputMaybe<FilterString>;
  buyersWithAccess?: InputMaybe<FilterString>;
  canSellerSee?: InputMaybe<FilterBoolean>;
  cancellationMessage?: InputMaybe<FilterString>;
  cancellationRequested?: InputMaybe<FilterBoolean>;
  cancellationRequests?: InputMaybe<NestedFilterCancellationRequest>;
  capacity?: InputMaybe<FilterInt16>;
  charge?: InputMaybe<FilterString>;
  chargeLink?: InputMaybe<NestedFilterCharge>;
  chargedBuyer?: InputMaybe<FilterBoolean>;
  comments?: InputMaybe<FilterString>;
  confirmation?: InputMaybe<NestedFilterBookingConfirmation>;
  createdAt?: InputMaybe<FilterDateTime>;
  customerBalanceTransactionId?: InputMaybe<FilterString>;
  deposit?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  hasBookingDispute?: InputMaybe<FilterBoolean>;
  hasCancellationRequest?: InputMaybe<FilterBoolean>;
  hasConfirmation?: InputMaybe<FilterBoolean>;
  hasExtraCharge?: InputMaybe<FilterBoolean>;
  hasExtraPayout?: InputMaybe<FilterBoolean>;
  hasPendingCancellationRequest?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterId>;
  indoorsOrOutdoors?: InputMaybe<FilterIndoorsOrOutdoors>;
  isPublished?: InputMaybe<FilterBoolean>;
  lastAction?: InputMaybe<FilterNegotiationAction>;
  lastCancellationRequest?: InputMaybe<NestedFilterCancellationRequest>;
  lastOfferAmount?: InputMaybe<FilterFloat32>;
  lastOnBehalfOfRole?: InputMaybe<FilterOnBehalfOfRole>;
  lastSellerOfferAmount?: InputMaybe<FilterFloat32>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  legacyId?: InputMaybe<FilterString>;
  location?: InputMaybe<FilterString>;
  negotiationStepModels?: InputMaybe<NestedFilterNegotiationStep>;
  negotiationSteps?: InputMaybe<FilterString>;
  oldBooking?: InputMaybe<NestedFilterBooking>;
  oldStartTime?: InputMaybe<FilterDateTime>;
  originalBookingFromReplaceArtist?: InputMaybe<NestedFilterBooking>;
  paidSeller?: InputMaybe<FilterBoolean>;
  payout?: InputMaybe<FilterString>;
  payoutLink?: InputMaybe<NestedFilterPayout>;
  performanceLengthMins?: InputMaybe<FilterInt16>;
  productionAndVenueSpecs?: InputMaybe<FilterString>;
  publicCoverImage?: InputMaybe<FilterString>;
  publicEventDescription?: InputMaybe<FilterString>;
  publicProfileImage?: InputMaybe<FilterString>;
  refundedInCredits?: InputMaybe<FilterBoolean>;
  replaceArtistOnBooking?: InputMaybe<NestedFilterBooking>;
  rescheduleMessage?: InputMaybe<FilterString>;
  revenue?: InputMaybe<FilterFloat32>;
  reviewsOfArtist?: InputMaybe<NestedFilterArtistReview>;
  sellersWithAccess?: InputMaybe<FilterString>;
  shouldAutoPublish?: InputMaybe<FilterBoolean>;
  startTime?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterBookingStatus>;
  statusV2?: InputMaybe<FilterBookingStatusV2>;
  usersWithAccess?: InputMaybe<FilterString>;
  venue?: InputMaybe<NestedFilterVenue>;
  venueId?: InputMaybe<FilterId>;
  venueName?: InputMaybe<FilterString>;
  venueSlug?: InputMaybe<FilterString>;
  version?: InputMaybe<FilterString>;
  weekOutNotification?: InputMaybe<FilterBoolean>;
  weekOutNotificationAt?: InputMaybe<FilterDateTime>;
};

export type NestedFilterBookingConfirmation = {
  booking?: InputMaybe<NestedFilterBooking>;
  confirmedAt?: InputMaybe<FilterDateTime>;
  confirmedBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  response?: InputMaybe<FilterBookingConfirmationResponse>;
  sellersWithAccess?: InputMaybe<FilterString>;
};

export type NestedFilterBookingDispute = {
  booking?: InputMaybe<NestedFilterBooking>;
  createdAt?: InputMaybe<FilterDateTime>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  message?: InputMaybe<FilterString>;
  resolved?: InputMaybe<FilterBoolean>;
  resolvedAt?: InputMaybe<FilterDateTime>;
  resolvedBy?: InputMaybe<NestedFilterUser>;
  user?: InputMaybe<NestedFilterUser>;
  usersWithAccess?: InputMaybe<FilterString>;
};

export type NestedFilterBookingPreferenceResponses = {
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  responses?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type NestedFilterBookingRequest = {
  accountExec?: InputMaybe<NestedFilterUser>;
  accountExecId?: InputMaybe<FilterId>;
  adminInstructions?: InputMaybe<FilterString>;
  artistIds?: InputMaybe<FilterId>;
  artistInstructions?: InputMaybe<FilterString>;
  artistSlugs?: InputMaybe<FilterString>;
  artists?: InputMaybe<NestedFilterArtist>;
  artistsWithActiveBidsFirebaseIds?: InputMaybe<FilterString>;
  bids?: InputMaybe<NestedFilterBid>;
  billing?: InputMaybe<FilterBilling>;
  booking?: InputMaybe<NestedFilterBooking>;
  bookingGroup?: InputMaybe<FilterString>;
  budget?: InputMaybe<FilterString>;
  buyersWithAccess?: InputMaybe<FilterString>;
  cancellationMessage?: InputMaybe<FilterString>;
  capacity?: InputMaybe<FilterInt16>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdBy?: InputMaybe<NestedFilterUser>;
  declines?: InputMaybe<NestedFilterDecline>;
  exists?: InputMaybe<Scalars['Boolean']>;
  extraArtistInfos?: InputMaybe<FilterString>;
  extraArtistInfosV2?: InputMaybe<NestedFilterExtraArtistInfo>;
  firebaseId?: InputMaybe<FilterString>;
  hasPendingBids?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterId>;
  indoorsOrOutdoors?: InputMaybe<FilterIndoorsOrOutdoors>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  pendingBids?: InputMaybe<NestedFilterBid>;
  performanceLengthMins?: InputMaybe<FilterInt16>;
  productionAndVenueSpecs?: InputMaybe<FilterString>;
  publicEventDescription?: InputMaybe<FilterString>;
  sellersWithAccess?: InputMaybe<FilterString>;
  shouldAutoPublish?: InputMaybe<FilterBoolean>;
  startTime?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterBookingRequestStatus>;
  usersWithAccess?: InputMaybe<FilterString>;
  venue?: InputMaybe<NestedFilterVenue>;
  venueId?: InputMaybe<FilterId>;
  venueLocation?: InputMaybe<FilterString>;
  venueName?: InputMaybe<FilterString>;
  venueSlug?: InputMaybe<FilterString>;
  version?: InputMaybe<FilterString>;
};

export type NestedFilterCancellationRequest = {
  booking?: InputMaybe<NestedFilterBooking>;
  createdAt?: InputMaybe<FilterDateTime>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  key?: InputMaybe<FilterString>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  message?: InputMaybe<FilterString>;
  resolved?: InputMaybe<FilterBoolean>;
  user?: InputMaybe<NestedFilterUser>;
};

export type NestedFilterCharge = {
  booking?: InputMaybe<NestedFilterBooking>;
  cancelledInvoiceId?: InputMaybe<FilterString>;
  chargedBuyer?: InputMaybe<FilterBoolean>;
  chargedBuyerBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  invoiceId?: InputMaybe<FilterString>;
  invoiceItemId?: InputMaybe<FilterString>;
  manuallyChargedBuyer?: InputMaybe<FilterBoolean>;
};

export type NestedFilterDecline = {
  artist?: InputMaybe<NestedFilterArtist>;
  bookingRequest?: InputMaybe<NestedFilterBookingRequest>;
  buyersWithAccessDecline?: InputMaybe<FilterString>;
  declinedBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  reasonForDecline?: InputMaybe<FilterString>;
  sellersWithAccessDecline?: InputMaybe<FilterString>;
  timestamp?: InputMaybe<FilterDateTime>;
};

export type NestedFilterDevice = {
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  ipAddress?: InputMaybe<FilterString>;
  lastSeenAt?: InputMaybe<FilterDateTime>;
  name?: InputMaybe<FilterString>;
  notificationToken?: InputMaybe<FilterString>;
  uid?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type NestedFilterExternalBooking = {
  artistName?: InputMaybe<FilterString>;
  billing?: InputMaybe<FilterBilling>;
  capacity?: InputMaybe<FilterInt16>;
  coverImage?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterDateTime>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  indoorsOrOutdoors?: InputMaybe<FilterIndoorsOrOutdoors>;
  isPublished?: InputMaybe<FilterBoolean>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  ownerFirebaseIds?: InputMaybe<FilterString>;
  performanceLengthMins?: InputMaybe<FilterInt16>;
  productionAndVenueSpecs?: InputMaybe<FilterString>;
  publicEventDescription?: InputMaybe<FilterString>;
  shouldAutoPublish?: InputMaybe<FilterBoolean>;
  startTime?: InputMaybe<FilterDateTime>;
  venue?: InputMaybe<NestedFilterVenue>;
  venueId?: InputMaybe<FilterId>;
  venueName?: InputMaybe<FilterString>;
  venueSlug?: InputMaybe<FilterString>;
  version?: InputMaybe<FilterString>;
};

export type NestedFilterExtraArtistInfo = {
  artist?: InputMaybe<NestedFilterArtist>;
  artistDetailsForBuyerByAdmin?: InputMaybe<FilterString>;
  bookingRequest?: InputMaybe<NestedFilterBookingRequest>;
  buyersWithAccessExtra?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterDateTime>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  recommendedBy?: InputMaybe<NestedFilterUser>;
  recommendedPrice?: InputMaybe<FilterFloat32>;
  sellersWithAccessExtra?: InputMaybe<FilterString>;
};

export type NestedFilterMetaBooking = {
  billing?: InputMaybe<FilterBilling>;
  capacity?: InputMaybe<FilterInt16>;
  createdAt?: InputMaybe<FilterDateTime>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  indoorsOrOutdoors?: InputMaybe<FilterIndoorsOrOutdoors>;
  isPublished?: InputMaybe<FilterBoolean>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  performanceLengthMins?: InputMaybe<FilterInt16>;
  productionAndVenueSpecs?: InputMaybe<FilterString>;
  publicEventDescription?: InputMaybe<FilterString>;
  shouldAutoPublish?: InputMaybe<FilterBoolean>;
  startTime?: InputMaybe<FilterDateTime>;
  venue?: InputMaybe<NestedFilterVenue>;
  version?: InputMaybe<FilterString>;
};

export type NestedFilterNegotiationStep = {
  action?: InputMaybe<FilterNegotiationAction>;
  booking?: InputMaybe<NestedFilterBooking>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  offerAmount?: InputMaybe<FilterFloat32>;
  onBehalfOfRole?: InputMaybe<FilterOnBehalfOfRole>;
  sellerOfferAmount?: InputMaybe<FilterFloat32>;
  timestamp?: InputMaybe<FilterDateTime>;
  user?: InputMaybe<NestedFilterUser>;
  userRole?: InputMaybe<FilterUserRole>;
};

export type NestedFilterPayout = {
  booking?: InputMaybe<NestedFilterBooking>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  manuallyPaidSeller?: InputMaybe<FilterBoolean>;
  manuallyPaidSellerBy?: InputMaybe<NestedFilterUser>;
  paidSeller?: InputMaybe<FilterBoolean>;
  transferId?: InputMaybe<FilterString>;
};

export type NestedFilterPhoneNumberToArtist = {
  artists?: InputMaybe<NestedFilterArtist>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  isLegacy?: InputMaybe<FilterBoolean>;
  linkedArtistIds?: InputMaybe<FilterId>;
  phoneNumber?: InputMaybe<FilterString>;
};

export type NestedFilterPhoneNumberToVenue = {
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  isLegacy?: InputMaybe<FilterBoolean>;
  phoneNumber?: InputMaybe<FilterString>;
  venueIds?: InputMaybe<FilterId>;
  venues?: InputMaybe<NestedFilterVenue>;
};

export type NestedFilterUser = {
  acceptTermsConditions?: InputMaybe<FilterBoolean>;
  accountExecBookingRequests?: InputMaybe<NestedFilterBookingRequest>;
  accountExecBookings?: InputMaybe<NestedFilterBooking>;
  adminType?: InputMaybe<FilterUserType>;
  allMyVenues?: InputMaybe<NestedFilterVenue>;
  approval?: InputMaybe<FilterString>;
  approved?: InputMaybe<FilterBoolean>;
  approvedBy?: InputMaybe<NestedFilterUser>;
  artistFirebaseIds?: InputMaybe<FilterString>;
  artistIds?: InputMaybe<FilterId>;
  artistNames?: InputMaybe<FilterString>;
  artistReviews?: InputMaybe<NestedFilterArtistReview>;
  artistSlugs?: InputMaybe<FilterString>;
  artists?: InputMaybe<NestedFilterArtist>;
  bookingPreferenceResponses?: InputMaybe<NestedFilterBookingPreferenceResponses>;
  bookings?: InputMaybe<NestedFilterBooking>;
  buyerBookingRequests?: InputMaybe<NestedFilterBookingRequest>;
  buyerBookings?: InputMaybe<NestedFilterBooking>;
  buyerSellerBookingRequests?: InputMaybe<NestedFilterBookingRequest>;
  buyerSellerBookings?: InputMaybe<NestedFilterBooking>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdByEdgedb?: InputMaybe<FilterBoolean>;
  defaultStateAbbr?: InputMaybe<FilterString>;
  deletedAt?: InputMaybe<FilterDateTime>;
  devices?: InputMaybe<NestedFilterDevice>;
  email?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  legacyId?: InputMaybe<FilterString>;
  likeCount?: InputMaybe<FilterInt64>;
  likes?: InputMaybe<NestedFilterArtistLike>;
  metadata?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  notificationTokens?: InputMaybe<FilterString>;
  numberOfArtists?: InputMaybe<FilterInt64>;
  numberOfVenues?: InputMaybe<FilterInt64>;
  nylasAccessToken?: InputMaybe<FilterString>;
  otherStateResponse?: InputMaybe<FilterString>;
  phoneNumber?: InputMaybe<FilterString>;
  profileImage?: InputMaybe<FilterString>;
  referredById?: InputMaybe<FilterString>;
  sellerBookingRequests?: InputMaybe<NestedFilterBookingRequest>;
  sellerBookings?: InputMaybe<NestedFilterBooking>;
  signUpMessage?: InputMaybe<FilterString>;
  slackUserId?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  userRole?: InputMaybe<FilterUserRole>;
  userType?: InputMaybe<FilterUserType>;
  venueBookings?: InputMaybe<NestedFilterBooking>;
  venueIds?: InputMaybe<FilterId>;
  venueNames?: InputMaybe<FilterString>;
  venues?: InputMaybe<NestedFilterVenue>;
  venuesAssignedTo?: InputMaybe<NestedFilterVenue>;
  viewCount?: InputMaybe<FilterInt64>;
  views?: InputMaybe<NestedFilterArtistView>;
};

export type NestedFilterVenue = {
  accountExec?: InputMaybe<NestedFilterUser>;
  accountExecId?: InputMaybe<FilterId>;
  artistReviews?: InputMaybe<NestedFilterArtistReview>;
  bookingRequests?: InputMaybe<NestedFilterBookingRequest>;
  bookings?: InputMaybe<NestedFilterBooking>;
  budget?: InputMaybe<FilterString>;
  capacity?: InputMaybe<FilterInt16>;
  colors?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdBy?: InputMaybe<NestedFilterUser>;
  createdByEdgedb?: InputMaybe<FilterBoolean>;
  customerId?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayImages?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']>;
  externalBookings?: InputMaybe<NestedFilterExternalBooking>;
  firebaseId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterId>;
  images?: InputMaybe<FilterString>;
  lastTriggeredAt?: InputMaybe<FilterDateTime>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  linkedPhoneNumbers?: InputMaybe<NestedFilterPhoneNumberToVenue>;
  location?: InputMaybe<FilterString>;
  logo?: InputMaybe<FilterString>;
  metaBookings?: InputMaybe<NestedFilterMetaBooking>;
  name?: InputMaybe<FilterString>;
  numStages?: InputMaybe<FilterInt16>;
  ownerFirebaseIds?: InputMaybe<FilterString>;
  ownerIds?: InputMaybe<FilterId>;
  owners?: InputMaybe<NestedFilterUser>;
  parkingAndLoadingAccess?: InputMaybe<FilterString>;
  paysManually?: InputMaybe<FilterBoolean>;
  phoneNumber?: InputMaybe<FilterString>;
  placeId?: InputMaybe<FilterString>;
  plaidInfo?: InputMaybe<NestedFilterVenuePlaidInfo>;
  productionAndVenueSpecs?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  socialMedia?: InputMaybe<FilterString>;
  venueType?: InputMaybe<FilterVenueType>;
  website?: InputMaybe<FilterString>;
};

export type NestedFilterVenuePlaidInfo = {
  accessToken?: InputMaybe<FilterString>;
  accountId?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<FilterId>;
  lastUpdated?: InputMaybe<FilterDateTime>;
  setAccessTokenBy?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<FilterPlaidStatus>;
  venue?: InputMaybe<NestedFilterVenue>;
};

export type Note = {
  __typename: 'Note';
  filling?: Maybe<Filling>;
  label?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  size?: Maybe<Size>;
  variant?: Maybe<Variant>;
};

export enum NullsOrderingEnum {
  BIGGEST = 'BIGGEST',
  SMALLEST = 'SMALLEST'
}

export enum OnBehalfOfRole {
  BUYER = 'buyer',
  SELLER = 'seller'
}

export type OrderArtist = {
  adminDetails?: InputMaybe<Ordering>;
  artistPerformanceData?: InputMaybe<OrderArtistPerformanceData>;
  artistReviews?: InputMaybe<OrderArtistReview>;
  avgRating?: InputMaybe<Ordering>;
  bandConfiguration?: InputMaybe<Ordering>;
  bio?: InputMaybe<Ordering>;
  bookingRequests?: InputMaybe<OrderBookingRequest>;
  bookings?: InputMaybe<OrderBooking>;
  category?: InputMaybe<Ordering>;
  confirmedBookings?: InputMaybe<OrderBooking>;
  connectAccountId?: InputMaybe<Ordering>;
  contactInformation?: InputMaybe<Ordering>;
  coverImage?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastBackendUpdated?: InputMaybe<Ordering>;
  lastRedisRefreshed?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  likeCount?: InputMaybe<Ordering>;
  likes?: InputMaybe<OrderArtistLike>;
  linkedPhoneNumbers?: InputMaybe<OrderPhoneNumberToArtist>;
  location?: InputMaybe<Ordering>;
  media?: InputMaybe<Ordering>;
  migrationVersion?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  numberOfReviews?: InputMaybe<Ordering>;
  payoutsManually?: InputMaybe<Ordering>;
  profileImage?: InputMaybe<Ordering>;
  published?: InputMaybe<Ordering>;
  publishedArtistReviews?: InputMaybe<OrderArtistReview>;
  relatedArtists?: InputMaybe<OrderArtist>;
  sellerFirebaseIds?: InputMaybe<Ordering>;
  sellers?: InputMaybe<OrderUser>;
  slug?: InputMaybe<Ordering>;
  socialMedia?: InputMaybe<Ordering>;
  spotifyData?: InputMaybe<OrderArtistSpotifyData>;
  spotifyFollowers?: InputMaybe<Ordering>;
  spotifyId?: InputMaybe<Ordering>;
  spotifyPopularity?: InputMaybe<Ordering>;
  topReviews?: InputMaybe<OrderArtistReview>;
  venueTakePercentages?: InputMaybe<Ordering>;
  version?: InputMaybe<Ordering>;
  viewCount?: InputMaybe<Ordering>;
  views?: InputMaybe<OrderArtistView>;
};

export type OrderArtistAvailability = {
  booking?: InputMaybe<OrderBooking>;
  buyerDisplayName?: InputMaybe<Ordering>;
  checks?: InputMaybe<OrderArtistAvailabilityCheck>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  location?: InputMaybe<Ordering>;
  performanceLengthMins?: InputMaybe<Ordering>;
  startTime?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export type OrderArtistAvailabilityCheck = {
  artist?: InputMaybe<OrderArtist>;
  artistAvailability?: InputMaybe<OrderArtistAvailability>;
  artistAvailabilityId?: InputMaybe<Ordering>;
  artistId?: InputMaybe<Ordering>;
  courierNotificationIds?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  notifiedAt?: InputMaybe<Ordering>;
  respondedAt?: InputMaybe<Ordering>;
  respondedBy?: InputMaybe<OrderUser>;
  response?: InputMaybe<Ordering>;
  responseMessage?: InputMaybe<Ordering>;
  sellersWithAccess?: InputMaybe<Ordering>;
  startTime?: InputMaybe<Ordering>;
};

export type OrderArtistLike = {
  artist?: InputMaybe<OrderArtist>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  timestamp?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type OrderArtistPerformanceData = {
  artist?: InputMaybe<OrderArtist>;
  createdAt?: InputMaybe<Ordering>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  songsTxt?: InputMaybe<Ordering>;
};

export type OrderArtistReview = {
  artist?: InputMaybe<OrderArtist>;
  author?: InputMaybe<OrderUser>;
  authorLocStr?: InputMaybe<Ordering>;
  authorName?: InputMaybe<Ordering>;
  authorOrgStr?: InputMaybe<Ordering>;
  authorProfileImage?: InputMaybe<Ordering>;
  booking?: InputMaybe<OrderBooking>;
  comment?: InputMaybe<Ordering>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  images?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  legacyId?: InputMaybe<Ordering>;
  published?: InputMaybe<Ordering>;
  rating?: InputMaybe<Ordering>;
  timestamp?: InputMaybe<Ordering>;
  venue?: InputMaybe<OrderVenue>;
};

export type OrderArtistSpotifyData = {
  artist?: InputMaybe<OrderArtist>;
  artistId?: InputMaybe<Ordering>;
  followers?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  images?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  popularity?: InputMaybe<Ordering>;
  spotifyId?: InputMaybe<Ordering>;
  url?: InputMaybe<Ordering>;
};

export type OrderArtistView = {
  artist?: InputMaybe<OrderArtist>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  timestamp?: InputMaybe<Ordering>;
  totalViews?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type OrderBid = {
  artist?: InputMaybe<OrderArtist>;
  artistId?: InputMaybe<Ordering>;
  bandConfiguration?: InputMaybe<Ordering>;
  bookingRequest?: InputMaybe<OrderBookingRequest>;
  bookingRequestId?: InputMaybe<Ordering>;
  buyerHasSeen?: InputMaybe<Ordering>;
  buyerPrice?: InputMaybe<Ordering>;
  buyerSawAt?: InputMaybe<Ordering>;
  buyersWithAccess?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  rejectionMessage?: InputMaybe<Ordering>;
  sellerPrice?: InputMaybe<Ordering>;
  sellersWithAccess?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  usersWithAccess?: InputMaybe<Ordering>;
  withdrawalMessage?: InputMaybe<Ordering>;
};

export type OrderBooking = {
  accountExec?: InputMaybe<OrderUser>;
  adminCancellationMessage?: InputMaybe<Ordering>;
  artist?: InputMaybe<OrderArtist>;
  artistAvailability?: InputMaybe<OrderArtistAvailability>;
  artistId?: InputMaybe<Ordering>;
  artistName?: InputMaybe<Ordering>;
  artistSlug?: InputMaybe<Ordering>;
  bandConfiguration?: InputMaybe<Ordering>;
  billing?: InputMaybe<Ordering>;
  bookingDispute?: InputMaybe<OrderBookingDispute>;
  bookingFlow?: InputMaybe<Ordering>;
  bookingGroup?: InputMaybe<Ordering>;
  bookingRequest?: InputMaybe<OrderBookingRequest>;
  buyer?: InputMaybe<OrderUser>;
  buyerHasReviewed?: InputMaybe<Ordering>;
  buyerId?: InputMaybe<Ordering>;
  buyerMetadata?: InputMaybe<Ordering>;
  buyerName?: InputMaybe<Ordering>;
  buyerSlug?: InputMaybe<Ordering>;
  buyersWithAccess?: InputMaybe<Ordering>;
  canSellerSee?: InputMaybe<Ordering>;
  cancellationMessage?: InputMaybe<Ordering>;
  cancellationRequested?: InputMaybe<Ordering>;
  cancellationRequests?: InputMaybe<OrderCancellationRequest>;
  capacity?: InputMaybe<Ordering>;
  charge?: InputMaybe<Ordering>;
  chargeLink?: InputMaybe<OrderCharge>;
  chargedBuyer?: InputMaybe<Ordering>;
  comments?: InputMaybe<Ordering>;
  confirmation?: InputMaybe<OrderBookingConfirmation>;
  createdAt?: InputMaybe<Ordering>;
  customerBalanceTransactionId?: InputMaybe<Ordering>;
  deposit?: InputMaybe<Ordering>;
  firebaseId?: InputMaybe<Ordering>;
  hasBookingDispute?: InputMaybe<Ordering>;
  hasCancellationRequest?: InputMaybe<Ordering>;
  hasConfirmation?: InputMaybe<Ordering>;
  hasExtraCharge?: InputMaybe<Ordering>;
  hasExtraPayout?: InputMaybe<Ordering>;
  hasPendingCancellationRequest?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  indoorsOrOutdoors?: InputMaybe<Ordering>;
  isPublished?: InputMaybe<Ordering>;
  lastAction?: InputMaybe<Ordering>;
  lastCancellationRequest?: InputMaybe<OrderCancellationRequest>;
  lastOfferAmount?: InputMaybe<Ordering>;
  lastOnBehalfOfRole?: InputMaybe<Ordering>;
  lastSellerOfferAmount?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  legacyId?: InputMaybe<Ordering>;
  location?: InputMaybe<Ordering>;
  negotiationStepModels?: InputMaybe<OrderNegotiationStep>;
  negotiationSteps?: InputMaybe<Ordering>;
  oldBooking?: InputMaybe<OrderBooking>;
  oldStartTime?: InputMaybe<Ordering>;
  originalBookingFromReplaceArtist?: InputMaybe<OrderBooking>;
  paidSeller?: InputMaybe<Ordering>;
  payout?: InputMaybe<Ordering>;
  payoutLink?: InputMaybe<OrderPayout>;
  performanceLengthMins?: InputMaybe<Ordering>;
  productionAndVenueSpecs?: InputMaybe<Ordering>;
  publicCoverImage?: InputMaybe<Ordering>;
  publicEventDescription?: InputMaybe<Ordering>;
  publicProfileImage?: InputMaybe<Ordering>;
  refundedInCredits?: InputMaybe<Ordering>;
  replaceArtistOnBooking?: InputMaybe<OrderBooking>;
  rescheduleMessage?: InputMaybe<Ordering>;
  revenue?: InputMaybe<Ordering>;
  reviewsOfArtist?: InputMaybe<OrderArtistReview>;
  sellersWithAccess?: InputMaybe<Ordering>;
  shouldAutoPublish?: InputMaybe<Ordering>;
  startTime?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  statusV2?: InputMaybe<Ordering>;
  usersWithAccess?: InputMaybe<Ordering>;
  venue?: InputMaybe<OrderVenue>;
  venueId?: InputMaybe<Ordering>;
  venueName?: InputMaybe<Ordering>;
  venueSlug?: InputMaybe<Ordering>;
  version?: InputMaybe<Ordering>;
  weekOutNotification?: InputMaybe<Ordering>;
  weekOutNotificationAt?: InputMaybe<Ordering>;
};

export type OrderBookingConfirmation = {
  booking?: InputMaybe<OrderBooking>;
  confirmedAt?: InputMaybe<Ordering>;
  confirmedBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  response?: InputMaybe<Ordering>;
  sellersWithAccess?: InputMaybe<Ordering>;
};

export type OrderBookingDispute = {
  booking?: InputMaybe<OrderBooking>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  message?: InputMaybe<Ordering>;
  resolved?: InputMaybe<Ordering>;
  resolvedAt?: InputMaybe<Ordering>;
  resolvedBy?: InputMaybe<OrderUser>;
  user?: InputMaybe<OrderUser>;
  usersWithAccess?: InputMaybe<Ordering>;
};

export type OrderBookingPreferenceResponses = {
  id?: InputMaybe<Ordering>;
  responses?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type OrderBookingRequest = {
  accountExec?: InputMaybe<OrderUser>;
  accountExecId?: InputMaybe<Ordering>;
  adminInstructions?: InputMaybe<Ordering>;
  artistIds?: InputMaybe<Ordering>;
  artistInstructions?: InputMaybe<Ordering>;
  artistSlugs?: InputMaybe<Ordering>;
  artists?: InputMaybe<OrderArtist>;
  artistsWithActiveBidsFirebaseIds?: InputMaybe<Ordering>;
  bids?: InputMaybe<OrderBid>;
  billing?: InputMaybe<Ordering>;
  booking?: InputMaybe<OrderBooking>;
  bookingGroup?: InputMaybe<Ordering>;
  budget?: InputMaybe<Ordering>;
  buyersWithAccess?: InputMaybe<Ordering>;
  cancellationMessage?: InputMaybe<Ordering>;
  capacity?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  declines?: InputMaybe<OrderDecline>;
  extraArtistInfos?: InputMaybe<Ordering>;
  extraArtistInfosV2?: InputMaybe<OrderExtraArtistInfo>;
  firebaseId?: InputMaybe<Ordering>;
  hasPendingBids?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  indoorsOrOutdoors?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  pendingBids?: InputMaybe<OrderBid>;
  performanceLengthMins?: InputMaybe<Ordering>;
  productionAndVenueSpecs?: InputMaybe<Ordering>;
  publicEventDescription?: InputMaybe<Ordering>;
  sellersWithAccess?: InputMaybe<Ordering>;
  shouldAutoPublish?: InputMaybe<Ordering>;
  startTime?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  usersWithAccess?: InputMaybe<Ordering>;
  venue?: InputMaybe<OrderVenue>;
  venueId?: InputMaybe<Ordering>;
  venueLocation?: InputMaybe<Ordering>;
  venueName?: InputMaybe<Ordering>;
  venueSlug?: InputMaybe<Ordering>;
  version?: InputMaybe<Ordering>;
};

export type OrderCancellationRequest = {
  booking?: InputMaybe<OrderBooking>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  message?: InputMaybe<Ordering>;
  resolved?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type OrderCharge = {
  booking?: InputMaybe<OrderBooking>;
  cancelledInvoiceId?: InputMaybe<Ordering>;
  chargedBuyer?: InputMaybe<Ordering>;
  chargedBuyerBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  invoiceId?: InputMaybe<Ordering>;
  invoiceItemId?: InputMaybe<Ordering>;
  manuallyChargedBuyer?: InputMaybe<Ordering>;
};

export type OrderDecline = {
  artist?: InputMaybe<OrderArtist>;
  bookingRequest?: InputMaybe<OrderBookingRequest>;
  buyersWithAccessDecline?: InputMaybe<Ordering>;
  declinedBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  reasonForDecline?: InputMaybe<Ordering>;
  sellersWithAccessDecline?: InputMaybe<Ordering>;
  timestamp?: InputMaybe<Ordering>;
};

export type OrderDevice = {
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ipAddress?: InputMaybe<Ordering>;
  lastSeenAt?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  notificationToken?: InputMaybe<Ordering>;
  uid?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type OrderExternalBooking = {
  artistName?: InputMaybe<Ordering>;
  billing?: InputMaybe<Ordering>;
  capacity?: InputMaybe<Ordering>;
  coverImage?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  indoorsOrOutdoors?: InputMaybe<Ordering>;
  isPublished?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  ownerFirebaseIds?: InputMaybe<Ordering>;
  performanceLengthMins?: InputMaybe<Ordering>;
  productionAndVenueSpecs?: InputMaybe<Ordering>;
  publicEventDescription?: InputMaybe<Ordering>;
  shouldAutoPublish?: InputMaybe<Ordering>;
  startTime?: InputMaybe<Ordering>;
  venue?: InputMaybe<OrderVenue>;
  venueId?: InputMaybe<Ordering>;
  venueName?: InputMaybe<Ordering>;
  venueSlug?: InputMaybe<Ordering>;
  version?: InputMaybe<Ordering>;
};

export type OrderExtraArtistInfo = {
  artist?: InputMaybe<OrderArtist>;
  artistDetailsForBuyerByAdmin?: InputMaybe<Ordering>;
  bookingRequest?: InputMaybe<OrderBookingRequest>;
  buyersWithAccessExtra?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  recommendedBy?: InputMaybe<OrderUser>;
  recommendedPrice?: InputMaybe<Ordering>;
  sellersWithAccessExtra?: InputMaybe<Ordering>;
};

export type OrderMetaBooking = {
  billing?: InputMaybe<Ordering>;
  capacity?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  indoorsOrOutdoors?: InputMaybe<Ordering>;
  isPublished?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  performanceLengthMins?: InputMaybe<Ordering>;
  productionAndVenueSpecs?: InputMaybe<Ordering>;
  publicEventDescription?: InputMaybe<Ordering>;
  shouldAutoPublish?: InputMaybe<Ordering>;
  startTime?: InputMaybe<Ordering>;
  venue?: InputMaybe<OrderVenue>;
  version?: InputMaybe<Ordering>;
};

export type OrderNegotiationStep = {
  action?: InputMaybe<Ordering>;
  booking?: InputMaybe<OrderBooking>;
  id?: InputMaybe<Ordering>;
  offerAmount?: InputMaybe<Ordering>;
  onBehalfOfRole?: InputMaybe<Ordering>;
  sellerOfferAmount?: InputMaybe<Ordering>;
  timestamp?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
  userRole?: InputMaybe<Ordering>;
};

export type OrderPayout = {
  booking?: InputMaybe<OrderBooking>;
  id?: InputMaybe<Ordering>;
  manuallyPaidSeller?: InputMaybe<Ordering>;
  manuallyPaidSellerBy?: InputMaybe<OrderUser>;
  paidSeller?: InputMaybe<Ordering>;
  transferId?: InputMaybe<Ordering>;
};

export type OrderPhoneNumberToArtist = {
  artists?: InputMaybe<OrderArtist>;
  id?: InputMaybe<Ordering>;
  isLegacy?: InputMaybe<Ordering>;
  linkedArtistIds?: InputMaybe<Ordering>;
  phoneNumber?: InputMaybe<Ordering>;
};

export type OrderPhoneNumberToVenue = {
  id?: InputMaybe<Ordering>;
  isLegacy?: InputMaybe<Ordering>;
  phoneNumber?: InputMaybe<Ordering>;
  venueIds?: InputMaybe<Ordering>;
  venues?: InputMaybe<OrderVenue>;
};

export type OrderUser = {
  acceptTermsConditions?: InputMaybe<Ordering>;
  accountExecBookingRequests?: InputMaybe<OrderBookingRequest>;
  accountExecBookings?: InputMaybe<OrderBooking>;
  adminType?: InputMaybe<Ordering>;
  allMyVenues?: InputMaybe<OrderVenue>;
  approval?: InputMaybe<Ordering>;
  approved?: InputMaybe<Ordering>;
  approvedBy?: InputMaybe<OrderUser>;
  artistFirebaseIds?: InputMaybe<Ordering>;
  artistIds?: InputMaybe<Ordering>;
  artistNames?: InputMaybe<Ordering>;
  artistReviews?: InputMaybe<OrderArtistReview>;
  artistSlugs?: InputMaybe<Ordering>;
  artists?: InputMaybe<OrderArtist>;
  bookingPreferenceResponses?: InputMaybe<OrderBookingPreferenceResponses>;
  bookings?: InputMaybe<OrderBooking>;
  buyerBookingRequests?: InputMaybe<OrderBookingRequest>;
  buyerBookings?: InputMaybe<OrderBooking>;
  buyerSellerBookingRequests?: InputMaybe<OrderBookingRequest>;
  buyerSellerBookings?: InputMaybe<OrderBooking>;
  createdAt?: InputMaybe<Ordering>;
  createdByEdgedb?: InputMaybe<Ordering>;
  defaultStateAbbr?: InputMaybe<Ordering>;
  deletedAt?: InputMaybe<Ordering>;
  devices?: InputMaybe<OrderDevice>;
  email?: InputMaybe<Ordering>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  legacyId?: InputMaybe<Ordering>;
  likeCount?: InputMaybe<Ordering>;
  likes?: InputMaybe<OrderArtistLike>;
  metadata?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  notificationTokens?: InputMaybe<Ordering>;
  numberOfArtists?: InputMaybe<Ordering>;
  numberOfVenues?: InputMaybe<Ordering>;
  nylasAccessToken?: InputMaybe<Ordering>;
  otherStateResponse?: InputMaybe<Ordering>;
  phoneNumber?: InputMaybe<Ordering>;
  profileImage?: InputMaybe<Ordering>;
  referredById?: InputMaybe<Ordering>;
  sellerBookingRequests?: InputMaybe<OrderBookingRequest>;
  sellerBookings?: InputMaybe<OrderBooking>;
  signUpMessage?: InputMaybe<Ordering>;
  slackUserId?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  userRole?: InputMaybe<Ordering>;
  userType?: InputMaybe<Ordering>;
  venueBookings?: InputMaybe<OrderBooking>;
  venueIds?: InputMaybe<Ordering>;
  venueNames?: InputMaybe<Ordering>;
  venues?: InputMaybe<OrderVenue>;
  venuesAssignedTo?: InputMaybe<OrderVenue>;
  viewCount?: InputMaybe<Ordering>;
  views?: InputMaybe<OrderArtistView>;
};

export type OrderVenue = {
  accountExec?: InputMaybe<OrderUser>;
  accountExecId?: InputMaybe<Ordering>;
  artistReviews?: InputMaybe<OrderArtistReview>;
  bookingRequests?: InputMaybe<OrderBookingRequest>;
  bookings?: InputMaybe<OrderBooking>;
  budget?: InputMaybe<Ordering>;
  capacity?: InputMaybe<Ordering>;
  colors?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  createdByEdgedb?: InputMaybe<Ordering>;
  customerId?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  displayImages?: InputMaybe<Ordering>;
  externalBookings?: InputMaybe<OrderExternalBooking>;
  firebaseId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  images?: InputMaybe<Ordering>;
  lastTriggeredAt?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  linkedPhoneNumbers?: InputMaybe<OrderPhoneNumberToVenue>;
  location?: InputMaybe<Ordering>;
  logo?: InputMaybe<Ordering>;
  metaBookings?: InputMaybe<OrderMetaBooking>;
  name?: InputMaybe<Ordering>;
  numStages?: InputMaybe<Ordering>;
  ownerFirebaseIds?: InputMaybe<Ordering>;
  ownerIds?: InputMaybe<Ordering>;
  owners?: InputMaybe<OrderUser>;
  parkingAndLoadingAccess?: InputMaybe<Ordering>;
  paysManually?: InputMaybe<Ordering>;
  phoneNumber?: InputMaybe<Ordering>;
  placeId?: InputMaybe<Ordering>;
  plaidInfo?: InputMaybe<OrderVenuePlaidInfo>;
  productionAndVenueSpecs?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  socialMedia?: InputMaybe<Ordering>;
  venueType?: InputMaybe<Ordering>;
  website?: InputMaybe<Ordering>;
};

export type OrderVenuePlaidInfo = {
  accessToken?: InputMaybe<Ordering>;
  accountId?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  lastUpdated?: InputMaybe<Ordering>;
  setAccessTokenBy?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  venue?: InputMaybe<OrderVenue>;
};

export type Ordering = {
  dir: DirectionEnum;
  nulls?: InputMaybe<NullsOrderingEnum>;
};

export type Overview = {
  __typename: 'Overview';
  allTimeValue: Scalars['Float'];
  growth?: Maybe<Scalars['Float']>;
};

export type Participant = {
  __typename: 'Participant';
  comment?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status: ParticipantStatus;
};

export enum ParticipantStatus {
  MAYBE = 'MAYBE',
  NO = 'NO',
  NOREPLY = 'NOREPLY',
  YES = 'YES'
}

export type Payout = {
  __typename: 'Payout';
  manuallyPaidSeller: Scalars['Boolean'];
  manuallyPaidSellerBy?: Maybe<Scalars['String']>;
  paidSeller: Scalars['Boolean'];
  transferId?: Maybe<Scalars['String']>;
};

export type PayoutMethod = {
  __typename: 'PayoutMethod';
  availablePayoutMethods?: Maybe<Array<Scalars['String']>>;
  bankName?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  funding?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

export type Pipeline = {
  __typename: 'Pipeline';
  confirmed: PipelineMetrics;
  pending: PipelineMetrics;
};

export type PipelineMetrics = {
  __typename: 'PipelineMetrics';
  bookingsCount: Scalars['Int'];
  revenue: Scalars['Float'];
};

export enum PlaidStatus {
  ERRORED = 'errored',
  PENDING = 'pending',
  SUCCESS = 'success',
  WAITING_FOR_MICRO_DEPOSITS = 'waiting_for_micro_deposits'
}

export type PossibleActions = {
  __typename: 'PossibleActions';
  buyer: LastMoved;
  seller: LastMoved;
};

export enum PreferenceType {
  ARTISTS = 'Artists',
  BUDGET = 'Budget',
  DATES = 'Dates',
  GENRES = 'Genres',
  LOCATION = 'Location',
  TEXT = 'Text',
  VENUE = 'Venue'
}

export type PriceRange = {
  __typename: 'PriceRange';
  high: Scalars['Float'];
  low: Scalars['Float'];
};

export type PriceRangeInput = {
  high: Scalars['Float'];
  low: Scalars['Float'];
};

export type PriceRangeOptional = {
  __typename: 'PriceRangeOptional';
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
};

export type PriceRangeOptionalInput = {
  high?: InputMaybe<Scalars['Float']>;
  low?: InputMaybe<Scalars['Float']>;
};

export type Prices = {
  __typename: 'Prices';
  private?: Maybe<PriceRange>;
  public?: Maybe<PriceRange>;
};

export type PricesInput = {
  private: PriceRangeInput;
  public: PriceRangeInput;
};

export type PublicInvoice = {
  __typename: 'PublicInvoice';
  amountDue: Scalars['Int'];
  created: Scalars['DateTime'];
  customerName: Scalars['String'];
  hostedInvoiceUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoicePdf?: Maybe<Scalars['String']>;
  paid: Scalars['Boolean'];
  status: InvoiceStatus;
};

export enum PublicOrPrivate {
  PRIVATE = 'private',
  PUBLIC = 'public'
}

export type PublicUser = {
  __typename: 'PublicUser';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type PublicUserUserDoesNotExist = PublicUser | UserDoesNotExist;

export enum PushTrackingEvent {
  CLICKED = 'CLICKED',
  DELIVERED = 'DELIVERED',
  OPENED = 'OPENED',
  READ = 'READ'
}

export enum Quality {
  BAD = 'bad',
  GOOD = 'good'
}

export type Query = {
  __typename: 'Query';
  adminSearchKey: Scalars['String'];
  artist: Artist;
  artistAvailability: ArtistAvailability;
  /** Seller with access or admin only. */
  artistAvailabilityCheck: ArtistAvailabilityCheck;
  artistBookingsByBuyerType: Array<BookingByBuyerType>;
  artistBookingsByCity: Array<BookingByCity>;
  artistBookingsByVenue: Array<BookingByVenue>;
  artistBookingsUpcoming: Pipeline;
  artistGamificationMetrics: GamificationMetrics;
  artistMetrics: Metrics;
  artistReview: ArtistReview;
  artistSearchKey: Scalars['String'];
  artistServerSide: ArtistArtistNotFoundResponse;
  artistStats: ArtistStats;
  artists: Array<Artist>;
  booking: Booking;
  bookingConfirmations: Array<BookingConfirmation>;
  bookingPreferences: Array<Question>;
  bookingRequest: BookingRequest;
  bookingRequests: Array<BookingRequest>;
  bookings: Array<Booking>;
  bookingsSearchKey: Scalars['String'];
  bookingsViaFilter: Array<Booking>;
  buyerToSellerAmount: Scalars['Float'];
  cancellationRequests: Array<CancellationRequest>;
  didILikeArtist: Scalars['Boolean'];
  discoverPage: Array<Row>;
  edgedbToFirebase: Scalars['String'];
  externalBooking: ExternalBooking;
  externalBookings: Array<ExternalBooking>;
  firebaseToEdgedb?: Maybe<Scalars['String']>;
  getIpInfo?: Maybe<IpResponse>;
  googleOauthUrl: Scalars['String'];
  hello: Scalars['String'];
  isArtistSlugAvailable: Scalars['Boolean'];
  isVenueSlugAvailable: Scalars['Boolean'];
  locationFromPlaceId: Location;
  me: UserUserDoesNotExist;
  myArtistReviews: Array<ArtistReview>;
  myArtists: Array<Artist>;
  /** @deprecated use my_badges */
  myBadgeCount: Scalars['Int'];
  myBadges: MyBadgeResponse;
  myBookingRequests: Array<BookingRequest>;
  myBookingRequestsWhereActionIsRequired: Array<BookingRequest>;
  myBookingRequestsWhereActionIsRequiredCount: Scalars['Int'];
  myBookings: Array<Booking>;
  myBookingsThatNeedReviews: Array<Booking>;
  myBookingsThatNeedReviewsCount: Scalars['Int'];
  myBookingsToConfirm: Array<Booking>;
  myBookingsWhereActionIsRequired: Array<Booking>;
  myBookingsWhereActionIsRequiredCount: Scalars['Int'];
  myExternalBookings: Array<ExternalBooking>;
  myExternalCalendarEvents: Array<ExternalCalendarEvent>;
  myLikedArtists: Array<ArtistLike>;
  myLikedArtistsSlugs: Array<Scalars['String']>;
  /** @deprecated use booking_requests instead */
  myVenueBookingRequests: Array<BookingRequest>;
  /** authed only */
  myVenues: Array<Venue>;
  plaidLinkToken: Scalars['String'];
  publicUser: PublicUserUserDoesNotExist;
  sellerToBuyerAmount: Scalars['Float'];
  spotifyArtistFromId: ArtistSpotify;
  spotifyArtistsFromName: Array<ArtistSpotify>;
  typesenseTypes: UserTypesenseArtistTypesenseArtistTypesensePublicBookingTypesenseVenueTypesense;
  user: User;
  userTypesSchema: Scalars['Boolean'];
  users: Array<User>;
  venue: Venue;
  venues: Array<Venue>;
};


export type QueryArtistArgs = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryArtistAvailabilityArgs = {
  id: Scalars['UUID'];
};


export type QueryArtistAvailabilityCheckArgs = {
  id: Scalars['UUID'];
};


export type QueryArtistBookingsByBuyerTypeArgs = {
  artistSlug: Scalars['String'];
  sortBy?: SortBy;
};


export type QueryArtistBookingsByCityArgs = {
  artistSlug: Scalars['String'];
  sortBy?: SortBy;
};


export type QueryArtistBookingsByVenueArgs = {
  artistSlug: Scalars['String'];
  sortBy?: SortBy;
};


export type QueryArtistBookingsUpcomingArgs = {
  artistSlug: Scalars['String'];
};


export type QueryArtistGamificationMetricsArgs = {
  artistSlug: Scalars['String'];
};


export type QueryArtistMetricsArgs = {
  artistSlug: Scalars['String'];
};


export type QueryArtistReviewArgs = {
  id: Scalars['String'];
};


export type QueryArtistSearchKeyArgs = {
  userFirebaseId?: InputMaybe<Scalars['String']>;
};


export type QueryArtistServerSideArgs = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryArtistStatsArgs = {
  artistSlug: Scalars['String'];
};


export type QueryArtistsArgs = {
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ArtistOrderBy>;
  published?: InputMaybe<Scalars['Boolean']>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryBookingArgs = {
  id: Scalars['String'];
};


export type QueryBookingConfirmationsArgs = {
  filter?: InputMaybe<FilterBookingConfirmation>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<OrderBookingConfirmation>;
};


export type QueryBookingRequestArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryBookingRequestsArgs = {
  accountExecFirebaseIds?: InputMaybe<Array<Scalars['String']>>;
  accountExecSlugs?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingRequestOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<BookingRequestStatus>>;
  venueQueryName?: InputMaybe<Scalars['String']>;
  venueSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryBookingsArgs = {
  accountExecFirebaseIds?: InputMaybe<Array<Scalars['String']>>;
  accountExecSlugs?: InputMaybe<Array<Scalars['String']>>;
  artistQueryName?: InputMaybe<Scalars['String']>;
  artistSlugs?: InputMaybe<Array<Scalars['String']>>;
  bookingFlows?: InputMaybe<Array<BookingFlow>>;
  cancellationRequestUserRole?: InputMaybe<UserRole>;
  cancellationRequestUserRoles?: InputMaybe<Array<UserRole>>;
  cancellationRequested?: InputMaybe<Scalars['Boolean']>;
  direction?: InputMaybe<Dir>;
  hasCancellationRequest?: InputMaybe<Scalars['Boolean']>;
  hasCharge?: InputMaybe<Scalars['Boolean']>;
  hasPayout?: InputMaybe<Scalars['Boolean']>;
  hasPendingCancellationRequest?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  notStatusesV2?: InputMaybe<Array<BookingStatusV2>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<BookingStatus>>;
  statusesV2?: InputMaybe<Array<BookingStatusV2>>;
  venueQueryName?: InputMaybe<Scalars['String']>;
  venueSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryBookingsViaFilterArgs = {
  filter?: InputMaybe<FilterBooking>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<OrderBooking>;
};


export type QueryBuyerToSellerAmountArgs = {
  bookingFlow: BookingFlow;
  buyerAmount: Scalars['Float'];
};


export type QueryCancellationRequestsArgs = {
  filter?: InputMaybe<FilterCancellationRequest>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<OrderCancellationRequest>;
};


export type QueryDidILikeArtistArgs = {
  artistId: Scalars['String'];
};


export type QueryEdgedbToFirebaseArgs = {
  collection: Collection;
  edgedbId: Scalars['String'];
};


export type QueryExternalBookingArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryExternalBookingsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderByDirection?: InputMaybe<Scalars['String']>;
};


export type QueryFirebaseToEdgedbArgs = {
  collection: Collection;
  firebaseId: Scalars['String'];
};


export type QueryGoogleOauthUrlArgs = {
  redirectUri: Scalars['String'];
};


export type QueryIsArtistSlugAvailableArgs = {
  slug: Scalars['String'];
};


export type QueryIsVenueSlugAvailableArgs = {
  slug: Scalars['String'];
};


export type QueryLocationFromPlaceIdArgs = {
  placeId: Scalars['String'];
};


export type QueryMyArtistReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryMyArtistsArgs = {
  direction?: InputMaybe<Dir>;
  orderBy?: InputMaybe<ArtistOrderBy>;
};


export type QueryMyBookingRequestsArgs = {
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  notStatuses?: InputMaybe<Array<BookingRequestStatus>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingRequestOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<BookingRequestStatus>>;
  venueSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryMyBookingRequestsWhereActionIsRequiredArgs = {
  direction?: Dir;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: BookingRequestOrderBy;
};


export type QueryMyBookingsArgs = {
  artistQueryName?: InputMaybe<Scalars['String']>;
  artistSlugs?: InputMaybe<Array<Scalars['String']>>;
  bookingFlows?: InputMaybe<Array<BookingFlow>>;
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  myBookingsFilter?: InputMaybe<MyBookingsFilter>;
  notStatusesV2?: InputMaybe<Array<BookingStatusV2>>;
  offset: Scalars['Int'];
  orderBy?: InputMaybe<BookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  statusesV2?: InputMaybe<Array<BookingStatusV2>>;
  venueSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryMyBookingsThatNeedReviewsArgs = {
  direction?: Dir;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: BookingOrderBy;
};


export type QueryMyBookingsToConfirmArgs = {
  includeConfirmed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMyBookingsWhereActionIsRequiredArgs = {
  direction?: Dir;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: BookingOrderBy;
};


export type QueryMyExternalBookingsArgs = {
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExternalBookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  venueSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryMyExternalCalendarEventsArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type QueryMyLikedArtistsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryMyVenueBookingRequestsArgs = {
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingRequestOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<BookingStatus>>;
  venueSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryMyVenuesArgs = {
  direction?: InputMaybe<Dir>;
  orderBy?: InputMaybe<VenueOrderBy>;
};


export type QueryPlaidLinkTokenArgs = {
  venueId: Scalars['String'];
};


export type QueryPublicUserArgs = {
  slug: Scalars['String'];
};


export type QuerySellerToBuyerAmountArgs = {
  bookingFlow: BookingFlow;
  sellerAmount: Scalars['Float'];
};


export type QuerySpotifyArtistFromIdArgs = {
  id: Scalars['String'];
};


export type QuerySpotifyArtistsFromNameArgs = {
  name: Scalars['String'];
};


export type QueryTypesenseTypesArgs = {
  collectionName: TypesenseCollectionName;
};


export type QueryUserArgs = {
  firebaseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryUserTypesSchemaArgs = {
  adminUserType: AdminUserType;
  buyerUserType: BuyerUserType;
  sellerUserType: SellerUserType;
};


export type QueryUsersArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UserOrderBy>;
  publicOrPrivate?: InputMaybe<PublicOrPrivate>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  userRoles?: InputMaybe<Array<UserRole>>;
  userTypes?: InputMaybe<Array<UserType>>;
};


export type QueryVenueArgs = {
  frontendCacheIgnorer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryVenuesArgs = {
  direction?: InputMaybe<Dir>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VenueOrderBy>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type Question = {
  __typename: 'Question';
  body: Scalars['String'];
  id: Scalars['String'];
  response?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  type?: Maybe<PreferenceType>;
};

export type ReceiptItem = {
  __typename: 'ReceiptItem';
  description: Scalars['String'];
  dollarAmount: Scalars['Float'];
  percentage?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type ResponseInput = {
  body: Scalars['String'];
  questionId: Scalars['String'];
};

export type Row = {
  __typename: 'Row';
  artists: Array<DiscoverArtist>;
  category?: Maybe<Category>;
  name: Scalars['String'];
  subgenres?: Maybe<Array<Scalars['String']>>;
};

export enum SellerUserType {
  AGENT = 'Agent',
  ARTIST = 'Artist',
  MANAGER = 'Manager',
  OTHER_SELLER = 'Other_Seller'
}

export type SendImageToEmailResponse = {
  __typename: 'SendImageToEmailResponse';
  email: Scalars['String'];
};

export type SendImageToPhoneResponse = {
  __typename: 'SendImageToPhoneResponse';
  phoneNumber: Scalars['String'];
};

export type SetPlaidAccessTokenResponse = {
  __typename: 'SetPlaidAccessTokenResponse';
  allBankAccounts: Array<StripeBankAccount>;
  createdBankAccount: StripeBankAccount;
};

export type ShortMessage = {
  __typename: 'ShortMessage';
  body?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum Size {
  LARGE = 'large',
  MEDIUM = 'medium',
  MINI = 'mini',
  SMALL = 'small',
  XL = 'xl'
}

export type SmallImage = {
  __typename: 'SmallImage';
  height?: Maybe<Scalars['Int']>;
  publicCloudinaryId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type SocialMedia = {
  __typename: 'SocialMedia';
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  soundcloud?: Maybe<Scalars['String']>;
  spotify?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
};

export type SocialMediaInput = {
  facebook?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  soundcloud?: InputMaybe<Scalars['String']>;
  spotify?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
};

export type Songs = {
  __typename: 'Songs';
  soundcloud: Array<Scalars['String']>;
  spotify: Array<Scalars['String']>;
};

export type SongsInput = {
  soundcloud?: Array<Scalars['String']>;
  spotify?: Array<Scalars['String']>;
};

export enum SortBy {
  BOOKINGS_COUNT = 'bookings_count',
  REVENUE = 'revenue'
}

export enum Status {
  CLICKED = 'CLICKED',
  DELIVERED = 'DELIVERED',
  ENQUEUED = 'ENQUEUED',
  OPENED = 'OPENED',
  SENT = 'SENT',
  UNDELIVERABLE = 'UNDELIVERABLE',
  UNMAPPED = 'UNMAPPED',
  UNROUTABLE = 'UNROUTABLE'
}

export type StatusInformation = {
  __typename: 'StatusInformation';
  currentStep: StatusNode;
  currentStepIndex: Scalars['Int'];
  statusBar: Array<StatusNode>;
  totalStepCount: Scalars['Int'];
};

export type StatusNode = {
  __typename: 'StatusNode';
  buyerDescription: Scalars['String'];
  possibleActions: PossibleActions;
  sellerDescription: Scalars['String'];
  status: BookingStatusV2;
};

export type StripeBankAccount = {
  __typename: 'StripeBankAccount';
  accountHolderName?: Maybe<Scalars['String']>;
  accountHolderType?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  fingerprint?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Tooltip = {
  __typename: 'Tooltip';
  tempField?: Maybe<Scalars['String']>;
};

export type TransferMetadata = {
  __typename: 'TransferMetadata';
  bookingId?: Maybe<Scalars['String']>;
};

export type TransferStripe = {
  __typename: 'TransferStripe';
  amount: Scalars['Int'];
  amountReversed: Scalars['Int'];
  balanceTransaction: Scalars['String'];
  created: Scalars['Int'];
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metadata: TransferMetadata;
  object: Scalars['String'];
  reversed: Scalars['Boolean'];
  sourceTransaction?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
};

export enum TypesenseCollectionName {
  ARTISTS = 'artists',
  BOOKINGS = 'bookings',
  USERS = 'users',
  VENUES = 'venues'
}

export type User = {
  __typename: 'User';
  accountExecBookings: Array<Booking>;
  allMyVenues: Array<Venue>;
  approval?: Maybe<Approval>;
  approved: Scalars['Boolean'];
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<User>;
  artists: Array<Artist>;
  badgeCount: Scalars['Int'];
  bookingBadges: BookingBadgesResponse;
  bookingPreferences: Array<Question>;
  bookingRequestBadges: BookingRequestBadgesResponse;
  bookings: Array<Booking>;
  createdAt: Scalars['DateTime'];
  defaultStateAbbr?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  externalCalendarEvents: Array<ExternalCalendarEvent>;
  firebaseId: Scalars['String'];
  hasSyncedCalendar: Scalars['Boolean'];
  id: Scalars['String'];
  isApproved: Scalars['Boolean'];
  lastUpdated: Scalars['DateTime'];
  likes: Array<ArtistLike>;
  metadata: Metadata;
  name: Scalars['String'];
  numberOfArtists: Scalars['Int'];
  numberOfVenues: Scalars['Int'];
  otherStateResponse?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  profileImage?: Maybe<Image>;
  publicOrPrivate: PublicOrPrivate;
  signUpMessage?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  userRole: UserRole;
  userType: UserType;
  venues: Array<Venue>;
  venuesAssignedTo: Array<Venue>;
};


export type UserAccountExecBookingsArgs = {
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
};


export type UserAllMyVenuesArgs = {
  direction?: InputMaybe<Dir>;
  orderBy?: InputMaybe<VenueOrderBy>;
};


export type UserArtistsArgs = {
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ArtistOrderBy>;
};


export type UserBookingsArgs = {
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
};


export type UserExternalCalendarEventsArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type UserLikesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserVenuesArgs = {
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VenueOrderBy>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
};


export type UserVenuesAssignedToArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type UserDoesNotExist = {
  __typename: 'UserDoesNotExist';
  exists: Scalars['Boolean'];
};

export type UserInput = {
  acceptTermsConditions: Scalars['Boolean'];
  defaultStateAbbr?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  metadata: MetadataInput;
  name: Scalars['String'];
  otherStateResponse?: InputMaybe<Scalars['String']>;
  profileImage?: InputMaybe<ImageInput>;
  userRole: UserRole;
};

export enum UserOrderBy {
  CREATED_AT = 'created_at',
  LAST_UPDATED = 'last_updated'
}

export type UserPatch = {
  email?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<MetadataInput>;
  name?: InputMaybe<Scalars['String']>;
  profileImage?: InputMaybe<ImageInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum UserRole {
  ADMIN = 'admin',
  BUYER = 'buyer',
  SELLER = 'seller'
}

export enum UserType {
  AGENT = 'Agent',
  ARTIST = 'Artist',
  BAR = 'Bar',
  BREWERY = 'Brewery',
  CORPORATE_EVENT = 'Corporate_Event',
  COUNTRY_CLUB = 'Country_Club',
  FRATERNITY_SORORITY = 'Fraternity_Sorority',
  HOTEL_RESORT = 'Hotel_Resort',
  MANAGER = 'Manager',
  MUNICIPALITY = 'Municipality',
  NIGHTCLUB = 'Nightclub',
  OTHER_BUYER = 'Other_Buyer',
  OTHER_SELLER = 'Other_Seller',
  PROMOTER = 'Promoter',
  RESTAURANT = 'Restaurant',
  THEATER = 'Theater',
  UNIVERSITY_PROGRAM_BOARD = 'University_Program_Board',
  VINEYARD_WINERY = 'Vineyard_Winery',
  WEDDING = 'Wedding',
  EMPLOYEE = 'employee',
  OWNER = 'owner',
  READ_ONLY = 'read_only'
}

export type UserTypesense = {
  __typename: 'UserTypesense';
  approved: Scalars['Boolean'];
  artistNamesStr?: Maybe<Scalars['String']>;
  createdAt: Scalars['Int'];
  email: Scalars['String'];
  firebaseId: Scalars['String'];
  id: Scalars['String'];
  lastTriggeredToTypesenseAt: Scalars['Int'];
  lastUpdated: Scalars['Int'];
  metadata: Metadata;
  metadataLocation?: Maybe<Scalars['String']>;
  metadataOrganization?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  objectID: Scalars['String'];
  phoneNumber: Scalars['String'];
  profileImage?: Maybe<Image>;
  publicOrPrivate: PublicOrPrivate;
  slug: Scalars['String'];
  userRole: UserRole;
  userType: UserType;
  venueNamesStr?: Maybe<Scalars['String']>;
};

export type UserTypesenseArtistTypesenseArtistTypesensePublicBookingTypesenseVenueTypesense = ArtistTypesense | ArtistTypesensePublic | BookingTypesense | UserTypesense | VenueTypesense;

export type UserUserDoesNotExist = User | UserDoesNotExist;

export enum Variant {
  ACCENT = 'accent',
  CALLOUT = 'callout',
  DEFAULT = 'default',
  ERROR = 'error',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  WARNING = 'warning'
}

export type Venue = {
  __typename: 'Venue';
  accountExec?: Maybe<User>;
  bankAccounts: Array<StripeBankAccount>;
  bookingRequests: Array<BookingRequest>;
  bookings: Array<Booking>;
  budget?: Maybe<PriceRangeOptional>;
  calendarBookings: CalendarBookingsResponse;
  capacity?: Maybe<Scalars['Int']>;
  colors?: Maybe<Colors>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  defaultBankAccount?: Maybe<StripeBankAccount>;
  description?: Maybe<Scalars['String']>;
  displayImages?: Maybe<DisplayImages>;
  externalBookings: Array<ExternalBooking>;
  firebaseId: Scalars['String'];
  genresBooked?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  images?: Maybe<Array<Image>>;
  invoices: Array<PublicInvoice>;
  lastUpdated: Scalars['DateTime'];
  location: Location;
  logo?: Maybe<Image>;
  name: Scalars['String'];
  numStages: Scalars['Int'];
  owners: Array<User>;
  parkingAndLoadingAccess?: Maybe<Scalars['String']>;
  pendingUserPhoneNumbers: Array<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  placeId: Scalars['String'];
  productionAndVenueSpecs?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  socialMedia?: Maybe<SocialMedia>;
  venueType: VenueType;
  website?: Maybe<Scalars['String']>;
};


export type VenueBookingRequestsArgs = {
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BookingRequestOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<BookingRequestStatus>>;
};


export type VenueBookingsArgs = {
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  notStatusesV2?: InputMaybe<Array<BookingStatusV2>>;
  orderBy?: InputMaybe<BookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  statusesV2?: InputMaybe<Array<BookingStatusV2>>;
};


export type VenueCalendarBookingsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type VenueExternalBookingsArgs = {
  direction?: InputMaybe<Dir>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExternalBookingOrderBy>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
};


export type VenueInvoicesArgs = {
  limit?: Scalars['Int'];
};

export enum VenueOrderBy {
  CREATED_AT = 'created_at',
  LAST_UPDATED = 'last_updated'
}

export type VenuePatch = {
  budget?: InputMaybe<PriceRangeOptionalInput>;
  capacity?: InputMaybe<Scalars['Int']>;
  colors?: InputMaybe<ColorsInput>;
  description?: InputMaybe<Scalars['String']>;
  displayImages?: InputMaybe<DisplayImagesInput>;
  genresBooked?: InputMaybe<Array<Scalars['String']>>;
  images?: InputMaybe<Array<ImageInput>>;
  logo?: InputMaybe<ImageInput>;
  name?: InputMaybe<Scalars['String']>;
  numStages?: InputMaybe<Scalars['Int']>;
  parkingAndLoadingAccess?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  productionAndVenueSpecs?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<SocialMediaInput>;
  venueType?: InputMaybe<VenueType>;
  website?: InputMaybe<Scalars['String']>;
};

export enum VenueType {
  BAR = 'Bar',
  BREWERY = 'Brewery',
  COUNTRY_CLUB = 'Country_Club',
  HOTEL = 'Hotel',
  MUNICIPALITY = 'Municipality',
  NIGHTCLUB = 'Nightclub',
  OTHER_VENUE = 'Other_Venue',
  RESTAURANT = 'Restaurant',
  THEATER = 'Theater',
  VINEYARD_WINERY = 'Vineyard_Winery'
}

export type VenueTypesense = {
  __typename: 'VenueTypesense';
  createdAt: Scalars['Int'];
  firebaseId: Scalars['String'];
  id: Scalars['String'];
  lastTriggeredToTypesenseAt: Scalars['Int'];
  lastUpdated: Scalars['Int'];
  location: Location;
  locationGeopoint: Array<Scalars['Float']>;
  name: Scalars['String'];
  objectID: Scalars['String'];
  slug: Scalars['String'];
  venueType: VenueType;
};

export enum VerticalAlign {
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  TOP = 'TOP'
}

export type Videos = {
  __typename: 'Videos';
  youtube: Array<Scalars['String']>;
};

export type VideosInput = {
  youtube?: Array<Scalars['String']>;
};

export enum WhatShouldIDoAlert {
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  AWAITING_RESPONSE = 'AWAITING_RESPONSE'
}

export type WhatShouldIDoAlerts = {
  __typename: 'WhatShouldIDoAlerts';
  buyer?: Maybe<WhatShouldIDoAlert>;
  seller?: Maybe<WhatShouldIDoAlert>;
};

export type WhenDate = {
  __typename: 'WhenDate';
  date: Scalars['Date'];
};

export type WhenDatespan = {
  __typename: 'WhenDatespan';
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type WhenTime = {
  __typename: 'WhenTime';
  time: Scalars['DateTime'];
};

export type WhenTimeWhenTimespanWhenDateWhenDatespan = WhenDate | WhenDatespan | WhenTime | WhenTimespan;

export type WhenTimespan = {
  __typename: 'WhenTimespan';
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};

export type ArtistBillingQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  redirectUrl: Scalars['String'];
}>;


export type ArtistBillingQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, slug: string, billing: { __typename: 'ConnectAccountDisplay', id: string, needsToOnboard: boolean, needsToAddInformation: boolean, canTransfer: boolean, dashboardLink?: string | undefined, onboardingLink?: string | undefined, payoutMethod?: { __typename: 'PayoutMethod', bankName?: string | undefined, brand?: string | undefined, id?: string | undefined, last4?: string | undefined, expMonth?: number | undefined, expYear?: number | undefined } | undefined, button: { __typename: 'Button', url: string, text: string, subtext: string } } } };

export type LinkSellerToArtistMutationVariables = Exact<{
  artistSlug: Scalars['String'];
  phoneNumber: Scalars['String'];
  remove: Scalars['Boolean'];
}>;


export type LinkSellerToArtistMutation = { __typename: 'Mutation', createLinkToArtist: { __typename: 'Artist', pendingUserPhoneNumbers: Array<string>, id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, sellers: Array<{ __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }>, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type SellersOfArtistQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type SellersOfArtistQuery = { __typename: 'Query', artist: { __typename: 'Artist', pendingUserPhoneNumbers: Array<string>, id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, sellers: Array<{ __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }>, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type BuyerAcceptBidMutationVariables = Exact<{
  bidId: Scalars['String'];
}>;


export type BuyerAcceptBidMutation = { __typename: 'Mutation', acceptBidBuyer: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, bookingRequest: { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } };

export type AdminWriteBookingRequestBidMutationVariables = Exact<{
  bookingRequestId: Scalars['String'];
  artistId: Scalars['String'];
  sellerPrice: Scalars['Float'];
  input: BidInput;
  notifyBuyers: Scalars['Boolean'];
  artistDetailsForBuyerByAdmin?: InputMaybe<Scalars['String']>;
}>;


export type AdminWriteBookingRequestBidMutation = { __typename: 'Mutation', createBidAdmin: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, bookingRequest: { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } };

export type CancelBookingRequestsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type CancelBookingRequestsMutation = { __typename: 'Mutation', cancelBookingRequests: Array<{ __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type CreateBookingRequestsBuyerMutationVariables = Exact<{
  input: BookingRequestInput;
  startTimes: Array<Scalars['DateTime']> | Scalars['DateTime'];
  venueId: Scalars['String'];
  artistIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateBookingRequestsBuyerMutation = { __typename: 'Mutation', createBookingRequestsBuyer: Array<{ __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type BookingRequestArtistFragment = { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined };

export type BookingRequestFragment = { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined };

export type BookingRequestQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BookingRequestQuery = { __typename: 'Query', bookingRequest: { __typename: 'BookingRequest', publicEventDescription?: string | undefined, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', productionAndVenueSpecs?: string | undefined, name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined } };

export type BuyerRejectBidMutationVariables = Exact<{
  bidId: Scalars['String'];
  rejectionMessage: Scalars['String'];
}>;


export type BuyerRejectBidMutation = { __typename: 'Mutation', rejectBid: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, bookingRequest: { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } };

export type RemoveBookingRequestArtistMutationVariables = Exact<{
  bookingRequestId: Array<Scalars['String']> | Scalars['String'];
  artistId: Array<Scalars['String']> | Scalars['String'];
}>;


export type RemoveBookingRequestArtistMutation = { __typename: 'Mutation', removeArtistsFromBookingRequests: Array<{ __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type SellerDeclineBookingRequestMutationVariables = Exact<{
  bookingRequestId: Scalars['String'];
  artistId: Scalars['String'];
  reasonForDecline: Scalars['String'];
}>;


export type SellerDeclineBookingRequestMutation = { __typename: 'Mutation', declineBookingRequest: { __typename: 'BookingRequestDecline', id: string, bookingRequest: { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined } } };

export type UpdateBookingRequestArtistMutationVariables = Exact<{
  bookingRequestId: Array<Scalars['String']> | Scalars['String'];
  artistId: Array<Scalars['String']> | Scalars['String'];
  input: Array<ExtraArtistInfoInput> | ExtraArtistInfoInput;
}>;


export type UpdateBookingRequestArtistMutation = { __typename: 'Mutation', addArtistsToBookingRequests: Array<{ __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type UpdateBookingRequestMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  patch: BookingRequestPatch;
}>;


export type UpdateBookingRequestMutation = { __typename: 'Mutation', updateBookingRequests: Array<{ __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type SellerWithdrawBidMutationVariables = Exact<{
  bidId: Scalars['String'];
}>;


export type SellerWithdrawBidMutation = { __typename: 'Mutation', withdrawBid: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, bookingRequest: { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } };

export type CreateBidSellerMutationVariables = Exact<{
  bookingRequestId: Scalars['String'];
  artistId: Scalars['String'];
  sellerPrice: Scalars['Float'];
  input: BidInput;
}>;


export type CreateBidSellerMutation = { __typename: 'Mutation', createBidSeller: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, bookingRequest: { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } };

export type SellerToBuyerPriceQueryVariables = Exact<{
  sellerAmount: Scalars['Float'];
  bookingFlow: BookingFlow;
}>;


export type SellerToBuyerPriceQuery = { __typename: 'Query', sellerToBuyerAmount: number };

export type SendImageToEmailMutationVariables = Exact<{
  subject: Scalars['String'];
  imageUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
  message: Scalars['String'];
}>;


export type SendImageToEmailMutation = { __typename: 'Mutation', sendPromoImageToEmail: { __typename: 'SendImageToEmailResponse', email: string } };

export type SendImageToPhoneMutationVariables = Exact<{
  imageUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
  message: Scalars['String'];
}>;


export type SendImageToPhoneMutation = { __typename: 'Mutation', sendPromoImageToPhone: { __typename: 'SendImageToPhoneResponse', phoneNumber: string } };

export type AdminSearchKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminSearchKeyQuery = { __typename: 'Query', adminSearchKey: string };

export type ArtistReviewFragment = { __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined };

export type BandConfigurationItemFragment = { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } };

export type ArtistPublicFragment = { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> };

export type BandConfigurationFragment = { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined };

export type ArtistFragment = { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> };

export type ArtistQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type ArtistQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type ArtistPublicQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type ArtistPublicQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type ConnectAccountFragment = { __typename: 'ConnectAccountDisplay', id: string, needsToOnboard: boolean, needsToAddInformation: boolean, canTransfer: boolean, dashboardLink?: string | undefined, onboardingLink?: string | undefined, payoutMethod?: { __typename: 'PayoutMethod', bankName?: string | undefined, brand?: string | undefined, id?: string | undefined, last4?: string | undefined, expMonth?: number | undefined, expYear?: number | undefined } | undefined, button: { __typename: 'Button', url: string, text: string, subtext: string } };

export type BookingBillingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BookingBillingQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, bookingBilling?: { __typename: 'BookingBilling', frontendDirections: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, filling?: Filling | undefined, size?: Size | undefined, label?: string | undefined }> | undefined }, buyerBilling?: { __typename: 'BuyerBilling', bankAccount?: { __typename: 'StripeBankAccount', id: string, isDefault?: boolean | undefined, status?: string | undefined, last4?: string | undefined, customer?: string | undefined, accountHolderName?: string | undefined, bankName?: string | undefined } | undefined, needsBankAccountCard?: { __typename: 'Card', header: string, message: string, disclaimer?: string | undefined, buttonText?: string | undefined } | undefined } | undefined, buyerNeedsBankAccountCard?: { __typename: 'Card', header: string, message: string, disclaimer?: string | undefined, buttonText?: string | undefined } | undefined, connectAccount?: { __typename: 'ConnectAccountDisplay', id: string, needsToOnboard: boolean, needsToAddInformation: boolean, canTransfer: boolean, dashboardLink?: string | undefined, onboardingLink?: string | undefined, payoutMethod?: { __typename: 'PayoutMethod', bankName?: string | undefined, brand?: string | undefined, id?: string | undefined, last4?: string | undefined, expMonth?: number | undefined, expYear?: number | undefined } | undefined, button: { __typename: 'Button', url: string, text: string, subtext: string } } | undefined, sellerNeedsPayoutMethodCard?: { __typename: 'Card', header: string, message: string, disclaimer?: string | undefined, buttonText?: string | undefined } | undefined, receiptItems?: Array<{ __typename: 'ReceiptItem', title: string, description: string, dollarAmount: number, percentage?: number | undefined }> | undefined } | undefined } };

export type NegotiationStepFragment = { __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } };

export type BookingStatusInformationFragment = { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } };

export type BookingFragment = { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } };

export type AdminBookingFragment = { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } };

export type BookingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BookingQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type AdminBookingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminBookingQuery = { __typename: 'Query', booking: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type BookingScreenQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BookingScreenQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type CreateArtistVenueApplicationMutationVariables = Exact<{
  artistId: Scalars['String'];
  venueId: Scalars['String'];
  message: Scalars['String'];
}>;


export type CreateArtistVenueApplicationMutation = { __typename: 'Mutation', createArtistVenueApplication: { __typename: 'ArtistVenueApplicationStraw', id: string, message: string } };

export type LikeArtistMutationVariables = Exact<{
  slug: Scalars['String'];
  unlike: Scalars['Boolean'];
}>;


export type LikeArtistMutation = { __typename: 'Mutation', likeArtist: boolean };

export type LikedArtistsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type LikedArtistsQuery = { __typename: 'Query', myLikedArtists: Array<{ __typename: 'ArtistLike', timestamp: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, profileImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined } }> };

export type LikedArtistSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type LikedArtistSlugsQuery = { __typename: 'Query', myLikedArtistsSlugs: Array<string> };

export type MyArtistsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyArtistsQuery = { __typename: 'Query', myArtists: Array<{ __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> }> };

export type MyVenuesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyVenuesQuery = { __typename: 'Query', myVenues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }> };

export type PublishArtistMutationVariables = Exact<{
  id: Scalars['String'];
  unpublish: Scalars['Boolean'];
}>;


export type PublishArtistMutation = { __typename: 'Mutation', publishArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UserFromAdminFragment = { __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined };

export type UserFromAdminQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserFromAdminQuery = { __typename: 'Query', user: { __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type VenuePublicQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type VenuePublicQuery = { __typename: 'Query', venue: { __typename: 'Venue', id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', height: number, width: number, public_cloudinary_id: string }> | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export type VenuePublicFragment = { __typename: 'Venue', id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', height: number, width: number, public_cloudinary_id: string }> | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined };

export type LocationFragment = { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined };

export type VenueSmallFragment = { __typename: 'Venue', id: string, name: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } };

export type VenueFragment = { __typename: 'Venue', genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined };

export type VenueQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type VenueQuery = { __typename: 'Query', venue: { __typename: 'Venue', genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export type ViewArtistMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ViewArtistMutation = { __typename: 'Mutation', viewArtist: number };

export type LinkBuyerToVenueMutationVariables = Exact<{
  venueId: Scalars['String'];
  phoneNumber: Scalars['String'];
  remove: Scalars['Boolean'];
}>;


export type LinkBuyerToVenueMutation = { __typename: 'Mutation', createLinkToVenue: { __typename: 'Venue', pendingUserPhoneNumbers: Array<string>, genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, owners: Array<{ __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }>, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export type OwnersOfVenueQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type OwnersOfVenueQuery = { __typename: 'Query', venue: { __typename: 'Venue', pendingUserPhoneNumbers: Array<string>, genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, owners: Array<{ __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }>, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export type VenuesFromAccountExecsQueryVariables = Exact<{
  execSlugs: Array<Scalars['String']> | Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VenuesFromAccountExecsQuery = { __typename: 'Query', users: Array<{ __typename: 'User', id: string, name: string, slug: string, firebaseId: string, venuesAssignedTo: Array<{ __typename: 'Venue', id: string, name: string, slug: string }> }> };

export type RemoveVenueBankAccountMutationVariables = Exact<{
  venueId: Scalars['String'];
  bankAccountId: Scalars['String'];
}>;


export type RemoveVenueBankAccountMutation = { __typename: 'Mutation', deleteBankAccount?: { __typename: 'StripeBankAccount', id: string, isDefault?: boolean | undefined, status?: string | undefined, last4?: string | undefined, customer?: string | undefined, accountHolderName?: string | undefined, bankName?: string | undefined } | undefined };

export type SetVenueBankAccountMutationVariables = Exact<{
  venueId: Scalars['String'];
  bankAccountId: Scalars['String'];
}>;


export type SetVenueBankAccountMutation = { __typename: 'Mutation', setDefaultBankAccount?: { __typename: 'StripeBankAccount', id: string, isDefault?: boolean | undefined, status?: string | undefined, last4?: string | undefined, customer?: string | undefined, accountHolderName?: string | undefined, bankName?: string | undefined } | undefined };

export type BankAccountFragment = { __typename: 'StripeBankAccount', id: string, isDefault?: boolean | undefined, status?: string | undefined, last4?: string | undefined, customer?: string | undefined, accountHolderName?: string | undefined, bankName?: string | undefined };

export type VenueBillingQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;


export type VenueBillingQuery = { __typename: 'Query', venue: { __typename: 'Venue', id: string, bankAccounts: Array<{ __typename: 'StripeBankAccount', id: string, isDefault?: boolean | undefined, status?: string | undefined, last4?: string | undefined, customer?: string | undefined, accountHolderName?: string | undefined, bankName?: string | undefined }>, defaultBankAccount?: { __typename: 'StripeBankAccount', id: string, isDefault?: boolean | undefined, status?: string | undefined, last4?: string | undefined, customer?: string | undefined, accountHolderName?: string | undefined, bankName?: string | undefined } | undefined } };

export type DiscoverPageQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscoverPageQuery = { __typename: 'Query', discoverPage: Array<{ __typename: 'Row', name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, artists: Array<{ __typename: 'DiscoverArtist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', publicCloudinaryId: string, height: number, width: number } | undefined, displayPriceRange?: { __typename: 'PriceRange', high: number, low: number } | undefined }> }> };

export type UploadImageMutationVariables = Exact<{
  imageBytes: Scalars['String'];
}>;


export type UploadImageMutation = { __typename: 'Mutation', uploadImage: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } };

export type ViewNotificationMutationVariables = Exact<{
  trackingUrl: Scalars['String'];
  pushTrackingEvent: PushTrackingEvent;
}>;


export type ViewNotificationMutation = { __typename: 'Mutation', trackPushNotificationEvent: boolean };

export type SetExpoDeviceMutationVariables = Exact<{
  deviceName: Scalars['String'];
  token: Scalars['String'];
}>;


export type SetExpoDeviceMutation = { __typename: 'Mutation', setDevice: boolean };

export type UnsetExpoDeviceMutationVariables = Exact<{
  deviceName: Scalars['String'];
}>;


export type UnsetExpoDeviceMutation = { __typename: 'Mutation', unsetDevice: boolean };

export type BuyerBookingConfirmationNoteQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BuyerBookingConfirmationNoteQuery = { __typename: 'Query', bookingRequest: { __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, booking?: { __typename: 'Booking', id: string } | undefined, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined } };

export type AdminBookingRequestArtistFragment = { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, bandConfiguration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined };

export type SmallArtistForAdminDropdownQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type SmallArtistForAdminDropdownQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, bandConfiguration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } };

export type IpAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type IpAddressQuery = { __typename: 'Query', ipAddress?: { __typename: 'IpResponse', stateAbbr: string, countryAbbr: string } | undefined };

export type MyArtistIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyArtistIdsQuery = { __typename: 'Query', myArtists: Array<{ __typename: 'Artist', id: string, slug: string }> };

export type CreateUserMutationVariables = Exact<{
  input: UserInput;
  signUpMessage?: InputMaybe<Scalars['String']>;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, bookingPreferences: Array<{ __typename: 'Question', id: string, body: string, type?: PreferenceType | undefined, response?: string | undefined }>, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type UserFragment = { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined };

export type MyAccountFragment = { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename: 'Query', me: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | { __typename: 'UserDoesNotExist', exists: boolean } };

export type BarChartsFragment = { __typename: 'BarChartEdge', monthly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined, yearly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined };

export type BarChartMetricFragment = { __typename: 'Metric', barCharts: { __typename: 'BarChartEdge', monthly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined, yearly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined }, overview?: { __typename: 'Overview', allTimeValue: number, growth?: number | undefined } | undefined };

export type GamificationMetricFragment = { __typename: 'GamificationMetric', value: number, score: number, quality: Quality };

export type ArtistMetricsQueryVariables = Exact<{
  slug: Scalars['String'];
  sortBy: SortBy;
}>;


export type ArtistMetricsQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, slug: string, name: string, likeCount: number, viewCount: number, avgRating: number, numberOfReviews: number, profile_image?: { __typename: 'Image', public_cloudinary_id: string } | undefined }, artistMetrics: { __typename: 'Metrics', revenue: { __typename: 'Metric', barCharts: { __typename: 'BarChartEdge', monthly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined, yearly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined }, overview?: { __typename: 'Overview', allTimeValue: number, growth?: number | undefined } | undefined }, bookingsCount: { __typename: 'Metric', barCharts: { __typename: 'BarChartEdge', monthly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined, yearly?: { __typename: 'BarChart', labels: Array<string>, data: Array<number>, firstFutureIndex?: number | undefined } | undefined }, overview?: { __typename: 'Overview', allTimeValue: number, growth?: number | undefined } | undefined } }, artistBookingsByVenue: Array<{ __typename: 'BookingByVenue', revenue: number, bookingsCount: number, venueName: string, venueType: VenueType, venueId?: string | undefined, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined } }>, artistBookingsByCity: Array<{ __typename: 'BookingByCity', revenue: number, bookingsCount: number, cityName: string, sampleLocation: { __typename: 'Location', stateAbbr?: string | undefined, countryId?: number | undefined } }>, artistBookingsByBuyerType: Array<{ __typename: 'BookingByBuyerType', buyerUserType: UserType, revenue: number, bookingsCount: number }>, artistBookingsUpcoming: { __typename: 'Pipeline', confirmed: { __typename: 'PipelineMetrics', revenue: number, bookingsCount: number }, pending: { __typename: 'PipelineMetrics', revenue: number, bookingsCount: number } }, artistGamificationMetrics: { __typename: 'GamificationMetrics', likeCount: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, viewCount: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, avgRating: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, numberOfReviews: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, bookingsCount: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, responseTimeMins: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, responseRate: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, cancellationsCount: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality }, cancellationRate: { __typename: 'GamificationMetric', value: number, score: number, quality: Quality } } };

export type CreateArtistMutationVariables = Exact<{
  name: Scalars['String'];
  spotifyId?: InputMaybe<Scalars['String']>;
}>;


export type CreateArtistMutation = { __typename: 'Mutation', createArtist: { __typename: 'Artist', id: string, slug: string } };

export type SpotifyArtistQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SpotifyArtistQuery = { __typename: 'Query', spotifyArtistFromId: { __typename: 'ArtistSpotify', genres: Array<string>, href: string, id: string, name: string, popularity: number, images: Array<{ __typename: 'ImageSpotify', height: number, url: string, width: number }>, followers: { __typename: 'Followers', total?: number | undefined }, externalUrls?: { __typename: 'ExternalUrls', spotify?: string | undefined } | undefined } };

export type NewArtistSplashMyArtistsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewArtistSplashMyArtistsQuery = { __typename: 'Query', myArtists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, profileImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined }> };

export type SpotifyArtistFragment = { __typename: 'ArtistSpotify', genres: Array<string>, href: string, id: string, name: string, popularity: number, images: Array<{ __typename: 'ImageSpotify', height: number, url: string, width: number }>, followers: { __typename: 'Followers', total?: number | undefined }, externalUrls?: { __typename: 'ExternalUrls', spotify?: string | undefined } | undefined };

export type SpotifyArtistsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SpotifyArtistsQuery = { __typename: 'Query', artists: Array<{ __typename: 'ArtistSpotify', genres: Array<string>, href: string, id: string, name: string, popularity: number, images: Array<{ __typename: 'ImageSpotify', height: number, url: string, width: number }>, followers: { __typename: 'Followers', total?: number | undefined }, externalUrls?: { __typename: 'ExternalUrls', spotify?: string | undefined } | undefined }> };

export type UpdateArtistBioMutationVariables = Exact<{
  artistId: Scalars['String'];
  bio: Scalars['String'];
}>;


export type UpdateArtistBioMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistCategoryMutationVariables = Exact<{
  artistId: Scalars['String'];
  category: Category;
}>;


export type UpdateArtistCategoryMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistContactMutationVariables = Exact<{
  artistId: Scalars['String'];
  contactInformation: ContactInformationInput;
}>;


export type UpdateArtistContactMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, contactInformation?: { __typename: 'ContactInformation', email?: string | undefined, phoneNumber?: string | undefined, name?: string | undefined } | undefined, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type ArtistContactInfoQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ArtistContactInfoQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, contactInformation?: { __typename: 'ContactInformation', email?: string | undefined, phoneNumber?: string | undefined, name?: string | undefined } | undefined, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistGenresMutationVariables = Exact<{
  artistId: Scalars['String'];
  subgenres: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateArtistGenresMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistLocationMutationVariables = Exact<{
  artistId: Scalars['String'];
  location: LocationInput;
}>;


export type UpdateArtistLocationMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistImagesMutationVariables = Exact<{
  artistId: Scalars['String'];
  images: Array<ImageInput> | ImageInput;
}>;


export type UpdateArtistImagesMutation = { __typename: 'Mutation', updateArtistImages: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistSongsMutationVariables = Exact<{
  artistId: Scalars['String'];
  songs: SongsInput;
}>;


export type UpdateArtistSongsMutation = { __typename: 'Mutation', updateArtistSongs: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistVideosMutationVariables = Exact<{
  artistId: Scalars['String'];
  videos: VideosInput;
}>;


export type UpdateArtistVideosMutation = { __typename: 'Mutation', updateArtistVideos: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateMultipleBandConifgsMutationVariables = Exact<{
  artistId: Scalars['String'];
  bandConfig: BandConfigInput;
}>;


export type UpdateMultipleBandConifgsMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateSinglePriceMutationVariables = Exact<{
  artistId: Scalars['String'];
  patch: ConfigInfoInput;
}>;


export type UpdateSinglePriceMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistProfileMutationVariables = Exact<{
  artistId: Scalars['String'];
  name: Scalars['String'];
  profileImage?: InputMaybe<ImageInput>;
  coverImage?: InputMaybe<ImageInput>;
}>;


export type UpdateArtistProfileMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistSlugMutationVariables = Exact<{
  artistId: Scalars['String'];
  slug: Scalars['String'];
}>;


export type UpdateArtistSlugMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type UpdateArtistSocialMediaMutationVariables = Exact<{
  socialMedia: SocialMediaInput;
  artistId: Scalars['String'];
}>;


export type UpdateArtistSocialMediaMutation = { __typename: 'Mutation', updateArtist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type InputArtistQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type InputArtistQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, contactInformation?: { __typename: 'ContactInformation', phoneNumber?: string | undefined, email?: string | undefined, name?: string | undefined } | undefined, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type ArtistAvailabilityCheckAdminFragment = { __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, createdAt: DateTime, lastUpdated: DateTime, courierNotificationIds: Array<string>, notifiedAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, respondedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, createdBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, courierMessages: Array<{ __typename: 'CourierMessage', id: string, clicked?: DateTime | undefined, courierUrl: string, recipient: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, reason?: string | undefined, enqueued?: DateTime | undefined, status: Status, channel?: { __typename: 'CourierChannel', name?: string | undefined } | undefined, providers?: Array<{ __typename: 'CourierProvider', provider: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, clicked?: DateTime | undefined, status: Status }> | undefined }> };

export type ArtistAvailabilityAdminFragment = { __typename: 'ArtistAvailability', id: any, createdAt: DateTime, status: ArtistAvailabilityStatus, performanceLengthMins?: number | undefined, startTime: DateTime, buyerDisplayName?: string | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined }, checks: Array<{ __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, createdAt: DateTime, lastUpdated: DateTime, courierNotificationIds: Array<string>, notifiedAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, respondedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, createdBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, courierMessages: Array<{ __typename: 'CourierMessage', id: string, clicked?: DateTime | undefined, courierUrl: string, recipient: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, reason?: string | undefined, enqueued?: DateTime | undefined, status: Status, channel?: { __typename: 'CourierChannel', name?: string | undefined } | undefined, providers?: Array<{ __typename: 'CourierProvider', provider: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, clicked?: DateTime | undefined, status: Status }> | undefined }> }> };

export type ArtistAvailabilityAdminQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ArtistAvailabilityAdminQuery = { __typename: 'Query', artistAvailability: { __typename: 'ArtistAvailability', id: any, createdAt: DateTime, status: ArtistAvailabilityStatus, performanceLengthMins?: number | undefined, startTime: DateTime, buyerDisplayName?: string | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined }, checks: Array<{ __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, createdAt: DateTime, lastUpdated: DateTime, courierNotificationIds: Array<string>, notifiedAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, respondedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, createdBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, courierMessages: Array<{ __typename: 'CourierMessage', id: string, clicked?: DateTime | undefined, courierUrl: string, recipient: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, reason?: string | undefined, enqueued?: DateTime | undefined, status: Status, channel?: { __typename: 'CourierChannel', name?: string | undefined } | undefined, providers?: Array<{ __typename: 'CourierProvider', provider: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, clicked?: DateTime | undefined, status: Status }> | undefined }> }> } };

export type CreateArtistAvailabilityCheckMutationVariables = Exact<{
  artistId: Scalars['UUID'];
  artistAvailabilityId: Scalars['UUID'];
}>;


export type CreateArtistAvailabilityCheckMutation = { __typename: 'Mutation', createArtistAvailabilityCheck: { __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, createdAt: DateTime, lastUpdated: DateTime, courierNotificationIds: Array<string>, notifiedAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, respondedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, createdBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, courierMessages: Array<{ __typename: 'CourierMessage', id: string, clicked?: DateTime | undefined, courierUrl: string, recipient: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, reason?: string | undefined, enqueued?: DateTime | undefined, status: Status, channel?: { __typename: 'CourierChannel', name?: string | undefined } | undefined, providers?: Array<{ __typename: 'CourierProvider', provider: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, clicked?: DateTime | undefined, status: Status }> | undefined }> } };

export type ArtistAvailabilityCheckFragment = { __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, lastUpdated: DateTime, createdAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, artistAvailability: { __typename: 'ArtistAvailability', performanceLengthMins?: number | undefined, id: any, startTime: DateTime, status: ArtistAvailabilityStatus, location: { __typename: 'Location', timezone: string, countryName?: string | undefined, city?: string | undefined, stateAbbr?: string | undefined } } };

export type ArtistAvailabilityCheckDetailSellerQueryVariables = Exact<{
  checkId: Scalars['UUID'];
}>;


export type ArtistAvailabilityCheckDetailSellerQuery = { __typename: 'Query', artistAvailabilityCheck: { __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, lastUpdated: DateTime, createdAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, artistAvailability: { __typename: 'ArtistAvailability', performanceLengthMins?: number | undefined, id: any, startTime: DateTime, status: ArtistAvailabilityStatus, location: { __typename: 'Location', timezone: string, countryName?: string | undefined, city?: string | undefined, stateAbbr?: string | undefined } } } };

export type GiveArtistAvailabilityMutationVariables = Exact<{
  checkId: Scalars['UUID'];
  response: ArtistAvailabilityResponse;
  responseMessage?: InputMaybe<Scalars['String']>;
}>;


export type GiveArtistAvailabilityMutation = { __typename: 'Mutation', giveArtistAvailability: { __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, lastUpdated: DateTime, createdAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, artistAvailability: { __typename: 'ArtistAvailability', performanceLengthMins?: number | undefined, id: any, startTime: DateTime, status: ArtistAvailabilityStatus, location: { __typename: 'Location', timezone: string, countryName?: string | undefined, city?: string | undefined, stateAbbr?: string | undefined } } } };

export type BookingCancellationRequestsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  cancellationRequestUserRole: Array<UserRole> | UserRole;
  startTimeMin: Scalars['DateTime'];
  notStatusV2: Array<BookingStatusV2> | BookingStatusV2;
}>;


export type BookingCancellationRequestsQuery = { __typename: 'Query', bookings: Array<{ __typename: 'Booking', id: string, statusV2: BookingStatusV2, artistName: string, artistSlug: string, artistId: string, buyerName: string, buyerSlug: string, venueName?: string | undefined, venueSlug?: string | undefined, firebaseId: string, startTime: DateTime, cancellationRequested?: boolean | undefined, cancellationMessage?: string | undefined, buyerMetadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined }, cancellationRequests: Array<{ __typename: 'CancellationRequest', id: string, createdAt: DateTime, lastUpdated: DateTime, resolved: boolean, message?: string | undefined, user: { __typename: 'User', id: string, name: string, email: string, firebaseId: string, phoneNumber: string, userRole: UserRole, profileImage?: { __typename: 'Image', public_cloudinary_id: string } | undefined, metadata: { __typename: 'Metadata', userType: UserType, location?: string | undefined, organization?: string | undefined } } }>, artistAvailability?: { __typename: 'ArtistAvailability', id: any, createdAt: DateTime, status: ArtistAvailabilityStatus, performanceLengthMins?: number | undefined, startTime: DateTime, buyerDisplayName?: string | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined }, checks: Array<{ __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, createdAt: DateTime, lastUpdated: DateTime, courierNotificationIds: Array<string>, notifiedAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, respondedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, createdBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, courierMessages: Array<{ __typename: 'CourierMessage', id: string, clicked?: DateTime | undefined, courierUrl: string, recipient: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, reason?: string | undefined, enqueued?: DateTime | undefined, status: Status, channel?: { __typename: 'CourierChannel', name?: string | undefined } | undefined, providers?: Array<{ __typename: 'CourierProvider', provider: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, clicked?: DateTime | undefined, status: Status }> | undefined }> }> } | undefined, artist: { __typename: 'Artist', id: string, slug: string, profileImage?: { __typename: 'Image', public_cloudinary_id: string } | undefined }, location: { __typename: 'Location', timezone: string } }> };

export type CancellationRequestFragment = { __typename: 'CancellationRequest', id: string, createdAt: DateTime, lastUpdated: DateTime, resolved: boolean, message?: string | undefined, user: { __typename: 'User', id: string, name: string, email: string, firebaseId: string, phoneNumber: string, userRole: UserRole, profileImage?: { __typename: 'Image', public_cloudinary_id: string } | undefined, metadata: { __typename: 'Metadata', userType: UserType, location?: string | undefined, organization?: string | undefined } } };

export type ResolveCancellationRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResolveCancellationRequestMutation = { __typename: 'Mutation', resolveCancellationRequest: { __typename: 'CancellationRequest', id: string, createdAt: DateTime, lastUpdated: DateTime, resolved: boolean, message?: string | undefined, user: { __typename: 'User', id: string, name: string, email: string, firebaseId: string, phoneNumber: string, userRole: UserRole, profileImage?: { __typename: 'Image', public_cloudinary_id: string } | undefined, metadata: { __typename: 'Metadata', userType: UserType, location?: string | undefined, organization?: string | undefined } } } };

export type BookingConfirmationsAdminQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter: FilterBooking;
  order: OrderBooking;
}>;


export type BookingConfirmationsAdminQuery = { __typename: 'Query', bookingsViaFilter: Array<{ __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, confirmation?: { __typename: 'BookingConfirmation', id: any, confirmedAt: DateTime, response: BookingConfirmationResponse } | undefined, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type AdminBookingConfirmationsOverviewQueryVariables = Exact<{
  startTimeFilter: FilterDateTime;
  filter?: InputMaybe<Array<FilterBooking> | FilterBooking>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AdminBookingConfirmationsOverviewQuery = { __typename: 'Query', canceled: Array<{ __typename: 'Booking', id: string }>, confirmed: Array<{ __typename: 'Booking', id: string }>, pending: Array<{ __typename: 'Booking', id: string }> };

export type BookingConfirmationFragment = { __typename: 'BookingConfirmation', id: any, confirmedAt: DateTime, response: BookingConfirmationResponse };

export type MyBookingsToConfirmQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBookingsToConfirmQuery = { __typename: 'Query', myBookingsToConfirm: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, confirmation?: { __typename: 'BookingConfirmation', id: any, confirmedAt: DateTime, response: BookingConfirmationResponse } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type BookingConfirmationResponseMutationVariables = Exact<{
  bookingId: Scalars['UUID'];
  response: BookingConfirmationResponse;
}>;


export type BookingConfirmationResponseMutation = { __typename: 'Mutation', confirmBooking: { __typename: 'BookingConfirmation', booking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, confirmation?: { __typename: 'BookingConfirmation', id: any, confirmedAt: DateTime, response: BookingConfirmationResponse } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } } };

export type UpdateBookingOfferAmountMutationVariables = Exact<{
  newBuyerPrice: Scalars['Float'];
  bookingId: Scalars['String'];
  takePercentage?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateBookingOfferAmountMutation = { __typename: 'Mutation', updateLastOfferAmount: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type UpdateBookingBuyerPriceMutationVariables = Exact<{
  newBuyerPrice: Scalars['Float'];
  bookingId: Scalars['String'];
}>;


export type UpdateBookingBuyerPriceMutation = { __typename: 'Mutation', updateBuyerPrice: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type UpdateBookingSellerPriceMutationVariables = Exact<{
  newSellerPrice: Scalars['Float'];
  bookingId: Scalars['String'];
}>;


export type UpdateBookingSellerPriceMutation = { __typename: 'Mutation', updateSellerPrice: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type CreateArtistAvailabilityForBookingMutationVariables = Exact<{
  bookingId: Scalars['UUID'];
}>;


export type CreateArtistAvailabilityForBookingMutation = { __typename: 'Mutation', createArtistAvailability: { __typename: 'ArtistAvailability', id: any, createdAt: DateTime, status: ArtistAvailabilityStatus, performanceLengthMins?: number | undefined, startTime: DateTime, buyerDisplayName?: string | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined }, checks: Array<{ __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, createdAt: DateTime, lastUpdated: DateTime, courierNotificationIds: Array<string>, notifiedAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, respondedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, createdBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, courierMessages: Array<{ __typename: 'CourierMessage', id: string, clicked?: DateTime | undefined, courierUrl: string, recipient: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, reason?: string | undefined, enqueued?: DateTime | undefined, status: Status, channel?: { __typename: 'CourierChannel', name?: string | undefined } | undefined, providers?: Array<{ __typename: 'CourierProvider', provider: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, clicked?: DateTime | undefined, status: Status }> | undefined }> }> } };

export type BookingWithArtistAvailabilityAdminQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type BookingWithArtistAvailabilityAdminQuery = { __typename: 'Query', booking: { __typename: 'Booking', lastSellerOfferAmount: number, lastOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, artistAvailability?: { __typename: 'ArtistAvailability', id: any, createdAt: DateTime, status: ArtistAvailabilityStatus, performanceLengthMins?: number | undefined, startTime: DateTime, buyerDisplayName?: string | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined }, checks: Array<{ __typename: 'ArtistAvailabilityCheck', id: any, response?: ArtistAvailabilityResponse | undefined, responseMessage?: string | undefined, createdAt: DateTime, lastUpdated: DateTime, courierNotificationIds: Array<string>, notifiedAt: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, respondedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, createdBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, courierMessages: Array<{ __typename: 'CourierMessage', id: string, clicked?: DateTime | undefined, courierUrl: string, recipient: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, reason?: string | undefined, enqueued?: DateTime | undefined, status: Status, channel?: { __typename: 'CourierChannel', name?: string | undefined } | undefined, providers?: Array<{ __typename: 'CourierProvider', provider: string, sent?: DateTime | undefined, opened?: DateTime | undefined, delivered?: DateTime | undefined, error?: string | undefined, clicked?: DateTime | undefined, status: Status }> | undefined }> }> } | undefined, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type BuyerToSellerPriceQueryVariables = Exact<{
  buyerOfferAmount: Scalars['Float'];
  bookingFlow: BookingFlow;
}>;


export type BuyerToSellerPriceQuery = { __typename: 'Query', buyerToSellerAmount: number };

export type ReplaceArtistOnBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  newArtistId: Scalars['String'];
  cancelOnBehalfOfRole: OnBehalfOfRole;
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  adminCancellationMessage?: InputMaybe<Scalars['String']>;
  newOfferAmount: Scalars['Float'];
}>;


export type ReplaceArtistOnBookingMutation = { __typename: 'Mutation', replaceArtistOnBooking: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type BuyerPreferencesFromAdminQueryVariables = Exact<{
  firebaseId: Scalars['String'];
}>;


export type BuyerPreferencesFromAdminQuery = { __typename: 'Query', user: { __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, bookingPreferences: Array<{ __typename: 'Question', id: string, body: string, type?: PreferenceType | undefined, response?: string | undefined }>, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type BuyerBookingPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerBookingPreferencesQuery = { __typename: 'Query', me: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, bookingPreferences: Array<{ __typename: 'Question', id: string, body: string, type?: PreferenceType | undefined, response?: string | undefined }>, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | { __typename: 'UserDoesNotExist', exists: boolean } };

export type BuyerBookingPreferenceFragment = { __typename: 'Question', id: string, body: string, type?: PreferenceType | undefined, response?: string | undefined };

export type UpdateBuyerBookingPreferencesMutationVariables = Exact<{
  responses: Array<ResponseInput> | ResponseInput;
}>;


export type UpdateBuyerBookingPreferencesMutation = { __typename: 'Mutation', updateBookingPreferences: Array<{ __typename: 'Question', id: string, body: string, type?: PreferenceType | undefined, response?: string | undefined }> };

export type GoogleOAuthUrlQueryVariables = Exact<{
  redirectUri: Scalars['String'];
}>;


export type GoogleOAuthUrlQuery = { __typename: 'Query', googleOauthUrl: string };

export type ExchangeAuthCodeGoogleMutationVariables = Exact<{
  code: Scalars['String'];
  redirectUri: Scalars['String'];
}>;


export type ExchangeAuthCodeGoogleMutation = { __typename: 'Mutation', exchangeAuthCodeGoogle: boolean };

export type CreateVenueMutationVariables = Exact<{
  venueType: VenueType;
  placeId: Scalars['String'];
  accountExecId?: InputMaybe<Scalars['String']>;
  venueName?: InputMaybe<Scalars['String']>;
}>;


export type CreateVenueMutation = { __typename: 'Mutation', createVenueFromPlaceId: { __typename: 'Venue', genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export type SingleEventPromoQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type SingleEventPromoQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, firebaseId: string, startTime: DateTime, artist: { __typename: 'Artist', name: string, id: string, slug: string, profileImage?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined }, venue?: { __typename: 'Venue', id: string, name: string, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } } | undefined } };

export type LocationFromPlaceIdQueryVariables = Exact<{
  placeId: Scalars['String'];
}>;


export type LocationFromPlaceIdQuery = { __typename: 'Query', locationFromPlaceId: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined } };

export type StaticallyGeneratedArtistQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type StaticallyGeneratedArtistQuery = { __typename: 'Query', artistServerSide: { __typename: 'Artist', id: string, name: string, slug: string, published: boolean, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined } | { __typename: 'ArtistNotFoundResponse', message: string } };

export type PromoApiBookingQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type PromoApiBookingQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, artistId: string, startTime: DateTime, artist: { __typename: 'Artist', profileImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined } } };

export type SetPlaidAccessTokenMutationVariables = Exact<{
  publicToken: Scalars['String'];
  venueId: Scalars['String'];
  metadataStringified: Scalars['String'];
}>;


export type SetPlaidAccessTokenMutation = { __typename: 'Mutation', setPlaidAccessToken?: { __typename: 'SetPlaidAccessTokenResponse', createdBankAccount: { __typename: 'StripeBankAccount', id: string, isDefault?: boolean | undefined, status?: string | undefined, last4?: string | undefined, customer?: string | undefined, accountHolderName?: string | undefined, bankName?: string | undefined } } | undefined };

export type PlaidLinkTokenQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;


export type PlaidLinkTokenQuery = { __typename: 'Query', plaidLinkToken: string };

export type GetCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type GetCodeMutation = { __typename: 'Mutation', getCodeTestUser: boolean };

export type GetTokenMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
  code: Scalars['String'];
}>;


export type GetTokenMutation = { __typename: 'Mutation', createCustomToken: string };

export type LoginMutationVariables = Exact<{ [key: string]: never; }>;


export type LoginMutation = { __typename: 'Mutation', login: boolean };

export type AdminBookingsListQueryVariables = Exact<{
  accountExecSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  artistQueryName: Scalars['String'];
  venueQueryName?: InputMaybe<Scalars['String']>;
  bookingFlows?: InputMaybe<Array<BookingFlow> | BookingFlow>;
  statuses?: InputMaybe<Array<BookingStatusV2> | BookingStatusV2>;
  hasCharge?: InputMaybe<Scalars['Boolean']>;
  hasPayout?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  artistSlugs: Array<Scalars['String']> | Scalars['String'];
  venueSlugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type AdminBookingsListQuery = { __typename: 'Query', bookings: Array<{ __typename: 'Booking', id: string, firebaseId: string, status: BookingStatusV2, start_time: DateTime, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', public_cloudinary_id: string } | undefined }, buyer: { __typename: 'User', id: string, name: string, phoneNumber: string, email: string, firebaseId: string, metadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } }> };

export type VenuesFromAdminQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  slugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type VenuesFromAdminQuery = { __typename: 'Query', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo?: { __typename: 'Image', public_cloudinary_id: string } | undefined, images?: Array<{ __typename: 'Image', public_cloudinary_id: string }> | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, accountExec?: { __typename: 'User', id: string, firebaseId: string, name: string } | undefined, owners: Array<{ __typename: 'User', id: string, firebaseId: string, name: string }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined }> };

export type AdminCalendarQueryVariables = Exact<{
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  accountExecSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  artistQueryName?: InputMaybe<Scalars['String']>;
  venueQueryName?: InputMaybe<Scalars['String']>;
  bookingFlows?: InputMaybe<Array<BookingFlow> | BookingFlow>;
  statuses?: InputMaybe<Array<BookingStatusV2> | BookingStatusV2>;
  hasCharge?: InputMaybe<Scalars['Boolean']>;
  hasPayout?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  venueSlugs: Array<Scalars['String']> | Scalars['String'];
  artistSlugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type AdminCalendarQuery = { __typename: 'Query', bookings: Array<{ __typename: 'Booking', id: string, firebaseId: string, artistName: string, venueName?: string | undefined, performanceLengthMins: number, startTime: DateTime, status: BookingStatusV2, buyerMetadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined }, location: { __typename: 'Location', timezone: string }, charge?: { __typename: 'Charge', chargedBuyer: boolean, invoiceId?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, transferId?: string | undefined } | undefined }> };

export type AdminUserScreenQueryVariables = Exact<{
  firebaseId: Scalars['String'];
}>;


export type AdminUserScreenQuery = { __typename: 'Query', user: { __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type AdminUserArtistsQueryVariables = Exact<{
  firebaseId: Scalars['String'];
}>;


export type AdminUserArtistsQuery = { __typename: 'Query', user: { __typename: 'User', id: string, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }> } };

export type AdminUserLikesQueryVariables = Exact<{
  firebaseId: Scalars['String'];
}>;


export type AdminUserLikesQuery = { __typename: 'Query', user: { __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, likes: Array<{ __typename: 'ArtistLike', timestamp: DateTime, artist: { __typename: 'Artist', id: string, slug: string, name: string, profileImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined } }>, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type AdminUpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  patch: UserPatch;
}>;


export type AdminUpdateUserMutation = { __typename: 'Mutation', updateUserAdmin: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type AdminUserVenuesQueryVariables = Exact<{
  firebaseId: Scalars['String'];
}>;


export type AdminUserVenuesQuery = { __typename: 'Query', user: { __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, venues: Array<{ __typename: 'Venue', id: string, slug: string, name: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined }, owners: Array<{ __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }>, accountExec?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, images?: Array<{ __typename: 'Image', publicCloudinaryId: string }> | undefined }>, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type AllArtistsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  published?: InputMaybe<Scalars['Boolean']>;
  slugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type AllArtistsQuery = { __typename: 'Query', artists: Array<{ __typename: 'Artist', id: string, name: string, category?: Category | undefined, subgenres?: Array<string> | undefined, bio?: string | undefined, slug: string, published: boolean, avgRating: number, numberOfReviews: number, last_updated: DateTime, sellers: Array<{ __typename: 'User', id: string, slug: string, firebaseId: string, name: string }>, display_band_configuration?: { __typename: 'BandConfig', solo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, duo?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, trio?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, four_plus?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined, fallback?: { __typename: 'ConfigInfo', notes?: string | undefined, prices: { __typename: 'Prices', private?: { __typename: 'PriceRange', low: number, high: number } | undefined, public?: { __typename: 'PriceRange', low: number, high: number } | undefined } } | undefined } | undefined, location?: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, soundcloud?: string | undefined, youtube?: string | undefined, instagram?: string | undefined, twitter?: string | undefined, spotify?: string | undefined } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, url: string, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profile_image?: { __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string } | undefined, media?: { __typename: 'Media', songs: { __typename: 'Songs', soundcloud: Array<string>, spotify: Array<string> }, videos: { __typename: 'Videos', youtube: Array<string> }, images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> } } | undefined, topReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> }> };

export type UserApplicantsFromAdminQueryVariables = Exact<{
  userRoles?: InputMaybe<Array<UserRole> | UserRole>;
  approved?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  publicOrPrivate?: InputMaybe<PublicOrPrivate>;
  userTypes?: InputMaybe<Array<UserType> | UserType>;
}>;


export type UserApplicantsFromAdminQuery = { __typename: 'Query', users: Array<{ __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }> };

export type ArtistPayoutsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ArtistPayoutsQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, slug: string, transfers: Array<{ __typename: 'TransferStripe', id: string, amount: number, currency: string, created: number, description?: string | undefined, metadata: { __typename: 'TransferMetadata', bookingId?: string | undefined } }> } };

export type ArtistReviewsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ArtistReviewsQuery = { __typename: 'Query', artist: { __typename: 'Artist', slug: string, id: string, numberOfReviews: number, name: string, avgRating: number, groupedReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }> } };

export type ArtistStatsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ArtistStatsQuery = { __typename: 'Query', artistStats: { __typename: 'GamificationMetrics', bookingsCount: { __typename: 'GamificationMetric', value: number, quality: Quality }, cancellationRate: { __typename: 'GamificationMetric', value: number, quality: Quality }, responseRate: { __typename: 'GamificationMetric', value: number, quality: Quality }, responseTimeMins: { __typename: 'GamificationMetric', value: number, quality: Quality }, numberOfReviews: { __typename: 'GamificationMetric', value: number, quality: Quality } } };

export type CancelBookingMutationVariables = Exact<{
  id: Scalars['String'];
  cancellationMessage: Scalars['String'];
}>;


export type CancelBookingMutation = { __typename: 'Mutation', cancelBooking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type CancelBookingAdminMutationVariables = Exact<{
  id: Scalars['String'];
  cancellationMessage: Scalars['String'];
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  onBehalfOfRole: OnBehalfOfRole;
  adminCancellationMessage?: InputMaybe<Scalars['String']>;
}>;


export type CancelBookingAdminMutation = { __typename: 'Mutation', cancelBookingAdmin: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type MyBookingsListQueryVariables = Exact<{
  direction: Dir;
  orderBy: BookingOrderBy;
  startTimeMax: Scalars['DateTime'];
  startTimeMin: Scalars['DateTime'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type MyBookingsListQuery = { __typename: 'Query', myBookings: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type BidFragment = { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } };

export type CalendarBookingRequestFragment = { __typename: 'BookingRequest', id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue: { __typename: 'Venue', name: string, id: string }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined };

export type CalendarBookingFragment = { __typename: 'Booking', id: string, venueName?: string | undefined, artist_name: string, start_time: DateTime, status: BookingStatusV2, performance_length_mins: number, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, location: { __typename: 'Location', timezone: string, placeId?: string | undefined }, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } };

export type CalendarExternalBookingFragment = { __typename: 'ExternalBooking', id: string, start_time: DateTime, artist_name: string, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', timezone: string, placeId?: string | undefined } } };

export type ExternalCalendarEventFragment = { __typename: 'ExternalCalendarEvent', busy: boolean, id: string, title: string, status: EventStatus, description?: string | undefined, location?: string | undefined, participants: Array<{ __typename: 'Participant', email: string, status: ParticipantStatus, name?: string | undefined, comment?: string | undefined }>, when: { __typename: 'WhenDate', date: any } | { __typename: 'WhenDatespan', startDate: any, endDate: any } | { __typename: 'WhenTime', time: DateTime } | { __typename: 'WhenTimespan', startTime: DateTime, endTime: DateTime } };

export type MyExternalCalendarEventsQueryVariables = Exact<{
  startTimeMin: Scalars['DateTime'];
  startTimeMax: Scalars['DateTime'];
}>;


export type MyExternalCalendarEventsQuery = { __typename: 'Query', myExternalCalendarEvents: Array<{ __typename: 'ExternalCalendarEvent', busy: boolean, id: string, title: string, status: EventStatus, description?: string | undefined, location?: string | undefined, participants: Array<{ __typename: 'Participant', email: string, status: ParticipantStatus, name?: string | undefined, comment?: string | undefined }>, when: { __typename: 'WhenDate', date: any } | { __typename: 'WhenDatespan', startDate: any, endDate: any } | { __typename: 'WhenTime', time: DateTime } | { __typename: 'WhenTimespan', startTime: DateTime, endTime: DateTime } }> };

export type CalendarScreenQueryVariables = Exact<{
  venueSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  startTimeMin: Scalars['DateTime'];
  startTimeMax: Scalars['DateTime'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type CalendarScreenQuery = { __typename: 'Query', myBookings: Array<{ __typename: 'Booking', id: string, venueName?: string | undefined, artist_name: string, start_time: DateTime, status: BookingStatusV2, performance_length_mins: number, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, location: { __typename: 'Location', timezone: string, placeId?: string | undefined }, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }>, myExternalBookings: Array<{ __typename: 'ExternalBooking', id: string, start_time: DateTime, artist_name: string, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', timezone: string, placeId?: string | undefined } } }>, myBookingRequests: Array<{ __typename: 'BookingRequest', id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue: { __typename: 'Venue', name: string, id: string }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type SyncdExternalCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type SyncdExternalCalendarQuery = { __typename: 'Query', me: { __typename: 'User', hasSyncedCalendar: boolean, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | { __typename: 'UserDoesNotExist', exists: boolean } };

export type CreateBookingMutationVariables = Exact<{
  bookingFlow: BookingFlow;
  booking: BookingInput;
  artistId: Scalars['String'];
  startTimes: Array<Scalars['DateTime']> | Scalars['DateTime'];
  offerAmount: Scalars['Float'];
  venueId?: InputMaybe<Scalars['String']>;
  venueLocationInput: LocationInput;
}>;


export type CreateBookingMutation = { __typename: 'Mutation', createBookingsBuyer: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type ExternalBookingFragment = { __typename: 'ExternalBooking', id: string, startTime: DateTime, performanceLengthMins: number, isPublished: boolean, artistName: string, publicEventDescription?: string | undefined, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, coverImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, venue: { __typename: 'Venue', id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, timezone: string } } };

export type CreateExternalBookingMutationVariables = Exact<{
  venueId: Scalars['String'];
  input: ExternalBookingInput;
}>;


export type CreateExternalBookingMutation = { __typename: 'Mutation', createExternalBooking: { __typename: 'ExternalBooking', id: string, startTime: DateTime, performanceLengthMins: number, isPublished: boolean, artistName: string, publicEventDescription?: string | undefined, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, coverImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, venue: { __typename: 'Venue', id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, timezone: string } } } };

export type ArtistPerformanceDataInputQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type ArtistPerformanceDataInputQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, name: string, slug: string, performanceData?: { __typename: 'ArtistPerformanceData', id: any, songsTxt?: string | undefined } | undefined } };

export type UpdateArtistSongsCoveredMutationVariables = Exact<{
  id: Scalars['String'];
  songsTxt: Scalars['String'];
}>;


export type UpdateArtistSongsCoveredMutation = { __typename: 'Mutation', updateArtistPerformanceDataSongs: { __typename: 'ArtistPerformanceData', id: any, songsTxt?: string | undefined, songs?: Array<string> | undefined } };

export type UpdateBookingMutationVariables = Exact<{
  patch: BookingPatch;
  ids: Array<Scalars['String']> | Scalars['String'];
  notifySellers?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateBookingMutation = { __typename: 'Mutation', updateBookings: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type DeleteExternalBookingMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteExternalBookingMutation = { __typename: 'Mutation', deleteExternalBooking: { __typename: 'ExternalBooking', id: string, startTime: DateTime, performanceLengthMins: number, isPublished: boolean, artistName: string, publicEventDescription?: string | undefined, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, coverImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, venue: { __typename: 'Venue', id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, timezone: string } } } };

export type InputExternalBookingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type InputExternalBookingQuery = { __typename: 'Query', externalBooking: { __typename: 'ExternalBooking', id: string, startTime: DateTime, performanceLengthMins: number, isPublished: boolean, artistName: string, publicEventDescription?: string | undefined, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, coverImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, venue: { __typename: 'Venue', genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } } };

export type UpdateExternalBookingMutationVariables = Exact<{
  id: Scalars['String'];
  patch: ExternalBookingPatch;
}>;


export type UpdateExternalBookingMutation = { __typename: 'Mutation', updateExternalBooking: { __typename: 'ExternalBooking', id: string, startTime: DateTime, performanceLengthMins: number, isPublished: boolean, artistName: string, publicEventDescription?: string | undefined, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, coverImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, venue: { __typename: 'Venue', id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, timezone: string } } } };

export type UpdateVenueMutationVariables = Exact<{
  venueId: Scalars['String'];
  patch: VenuePatch;
}>;


export type UpdateVenueMutation = { __typename: 'Mutation', updateVenue: { __typename: 'Venue', genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export type LocationCamelFragment = { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined };

export type ImageCamelFragment = { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string };

export type InputVenueQueryVariables = Exact<{
  slug: Scalars['String'];
  cacheIgnorer?: InputMaybe<Scalars['String']>;
}>;


export type InputVenueQuery = { __typename: 'Query', venue: { __typename: 'Venue', id: string, description?: string | undefined, name: string, venueType: VenueType, numStages: number, capacity?: number | undefined, productionAndVenueSpecs?: string | undefined, parkingAndLoadingAccess?: string | undefined, genresBooked?: Array<string> | undefined, website?: string | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, logo?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, images?: Array<{ __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string }> | undefined, socialMedia?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined } } };

export type VenueInvoicesQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;


export type VenueInvoicesQuery = { __typename: 'Query', venue: { __typename: 'Venue', id: string, invoices: Array<{ __typename: 'PublicInvoice', created: DateTime, customerName: string, status: InvoiceStatus, paid: boolean, amountDue: number, hostedInvoiceUrl?: string | undefined, invoicePdf?: string | undefined, id: string }> } };

export type BookingPreviewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BookingPreviewQuery = { __typename: 'Query', booking: { __typename: 'Booking', venueName?: string | undefined, venueSlug?: string | undefined, id: string, firebaseId: string, bandConfiguration?: BandConfigurationOption | undefined, performanceLengthMins: number, startTime: DateTime, publicEventDescription?: string | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined, countryId?: number | undefined }, artist: { __typename: 'Artist', id: string, subgenres?: Array<string> | undefined, slug: string, bio?: string | undefined, name: string, category?: Category | undefined, coverImage?: { __typename: 'Image', height: number, width: number, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profileImage?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined }, publicCoverImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, publicProfileImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, venue?: { __typename: 'Venue', id: string, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, postalCode?: string | undefined, unit?: string | undefined, placeId?: string | undefined, timezone: string } } | undefined } };

export type EditUserProfileImageMutationVariables = Exact<{
  profileImage: ImageInput;
}>;


export type EditUserProfileImageMutation = { __typename: 'Mutation', updateUser: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type BadgeCountQueryVariables = Exact<{ [key: string]: never; }>;


export type BadgeCountQuery = { __typename: 'Query', myBadges: { __typename: 'MyBadgeResponse', total: number, bookings: number, bookingRequests: number } };

export type BookingSearchKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingSearchKeyQuery = { __typename: 'Query', bookingsSearchKey: string };

export type TypesenseArtistApiKeyQueryVariables = Exact<{
  userFirebaseId?: InputMaybe<Scalars['String']>;
}>;


export type TypesenseArtistApiKeyQuery = { __typename: 'Query', artistSearchKey: string };

export type ArtistPublishedQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ArtistPublishedQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, name: string, published: boolean, slug: string } };

export type AdvanceBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  notifySellers: Scalars['Boolean'];
  notifyBuyers: Scalars['Boolean'];
}>;


export type AdvanceBookingMutation = { __typename: 'Mutation', advanceBooking: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type MarkChargedBuyerMutationVariables = Exact<{
  bookingId: Scalars['String'];
  undo: Scalars['Boolean'];
}>;


export type MarkChargedBuyerMutation = { __typename: 'Mutation', markBookingAsCharged: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type ChargeBuyerMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type ChargeBuyerMutation = { __typename: 'Mutation', chargeBooking: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type MarkPaidOutMutationVariables = Exact<{
  bookingId: Scalars['String'];
  undo: Scalars['Boolean'];
}>;


export type MarkPaidOutMutation = { __typename: 'Mutation', markBookingAsPaidOut: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type PayoutSellerMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type PayoutSellerMutation = { __typename: 'Mutation', payoutBooking: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type AdminBookingRequestsListQueryVariables = Exact<{
  orderBy: BookingRequestOrderBy;
  direction: Dir;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  venueSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AdminBookingRequestsListQuery = { __typename: 'Query', bookingRequests: Array<{ __typename: 'BookingRequest', createdAt: DateTime, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type AdminApproveUserMutationVariables = Exact<{
  id: Scalars['String'];
  disapprove: Scalars['Boolean'];
}>;


export type AdminApproveUserMutation = { __typename: 'Mutation', approve: { __typename: 'User', approvedAt?: DateTime | undefined, id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, approvedBy?: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } | undefined, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined } };

export type ArtistPerformanceDataQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type ArtistPerformanceDataQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, slug: string, name: string, performanceData?: { __typename: 'ArtistPerformanceData', id: any, songs?: Array<string> | undefined } | undefined } };

export type ImageFragment = { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string };

export type SmallArtistPublicFragment = { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined };

export type SmallArtistFragment = { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined };

export type SimilarArtistsPublicQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SimilarArtistsPublicQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, relatedArtists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }> } };

export type SimilarArtistsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SimilarArtistsQuery = { __typename: 'Query', artist: { __typename: 'Artist', id: string, relatedArtists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }> } };

export type CalendarSelectedDayQueryVariables = Exact<{
  startTimeMin: Scalars['DateTime'];
  startTimeMax: Scalars['DateTime'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type CalendarSelectedDayQuery = { __typename: 'Query', myBookingRequests: Array<{ __typename: 'BookingRequest', id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue: { __typename: 'Venue', name: string, id: string }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }>, myBookings: Array<{ __typename: 'Booking', id: string, venueName?: string | undefined, artist_name: string, start_time: DateTime, status: BookingStatusV2, performance_length_mins: number, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, location: { __typename: 'Location', timezone: string, placeId?: string | undefined }, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }>, myExternalBookings: Array<{ __typename: 'ExternalBooking', id: string, start_time: DateTime, artist_name: string, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', timezone: string, placeId?: string | undefined } } }> };

export type AutoPublishBookingMutationVariables = Exact<{
  bookingId: Array<Scalars['String']> | Scalars['String'];
  shouldAutoPublish: Scalars['Boolean'];
}>;


export type AutoPublishBookingMutation = { __typename: 'Mutation', updateBookings: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type AcceptBookingBuyerMutationVariables = Exact<{
  bookingId: Scalars['String'];
  offerAmount: Scalars['Float'];
}>;


export type AcceptBookingBuyerMutation = { __typename: 'Mutation', acceptBooking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type AcceptBookingSellerMutationVariables = Exact<{
  bookingId: Scalars['String'];
  sellerOfferAmount: Scalars['Float'];
}>;


export type AcceptBookingSellerMutation = { __typename: 'Mutation', acceptBooking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type AcceptBookingAdminMutationVariables = Exact<{
  bookingId: Scalars['String'];
  onBehalfOfRole: OnBehalfOfRole;
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  offerAmount?: InputMaybe<Scalars['Float']>;
  sellerOfferAmount?: InputMaybe<Scalars['Float']>;
}>;


export type AcceptBookingAdminMutation = { __typename: 'Mutation', acceptBooking: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type CounterBookingBuyerMutationVariables = Exact<{
  bookingId: Scalars['String'];
  offerAmount: Scalars['Float'];
}>;


export type CounterBookingBuyerMutation = { __typename: 'Mutation', counter: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type CounterBookingSellerMutationVariables = Exact<{
  bookingId: Scalars['String'];
  sellerOfferAmount: Scalars['Float'];
}>;


export type CounterBookingSellerMutation = { __typename: 'Mutation', counter: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type CounterbookingAdminMutationVariables = Exact<{
  bookingId: Scalars['String'];
  onBehalfOfRole: OnBehalfOfRole;
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
  offerAmount?: InputMaybe<Scalars['Float']>;
  sellerOfferAmount?: InputMaybe<Scalars['Float']>;
}>;


export type CounterbookingAdminMutation = { __typename: 'Mutation', counter: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type DeclineBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type DeclineBookingMutation = { __typename: 'Mutation', declineBooking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type DeclineBookingAdminMutationVariables = Exact<{
  bookingId: Scalars['String'];
  onBehalfOf: OnBehalfOfRole;
  notifyBuyers: Scalars['Boolean'];
  notifySellers: Scalars['Boolean'];
}>;


export type DeclineBookingAdminMutation = { __typename: 'Mutation', declineBookingAdmin: { __typename: 'Booking', lastOfferAmount: number, lastSellerOfferAmount: number, id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, buyer: { __typename: 'User', id: string, firebaseId: string, name: string, email: string, user_role: UserRole, phone_number: string, approved: boolean, last_updated: DateTime, created_at: DateTime, public_or_private: PublicOrPrivate, metadata: { __typename: 'Metadata', organization?: string | undefined, location?: string | undefined, user_type: UserType }, profile_image?: { __typename: 'Image', width: number, height: number, public_cloudinary_id: string } | undefined }, charge?: { __typename: 'Charge', chargedBuyer: boolean, manuallyChargedBuyer: boolean, invoiceId?: string | undefined, invoiceItemId?: string | undefined, cancelledInvoiceId?: string | undefined, manuallyChargedBuyerBy?: string | undefined } | undefined, payout?: { __typename: 'Payout', paidSeller: boolean, manuallyPaidSeller: boolean, transferId?: string | undefined, manuallyPaidSellerBy?: string | undefined } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type UpdateBookingPublicEventDescriptionMutationVariables = Exact<{
  bookingId: Array<Scalars['String']> | Scalars['String'];
  publicEventDescription: Scalars['String'];
}>;


export type UpdateBookingPublicEventDescriptionMutation = { __typename: 'Mutation', updateBookings: Array<{ __typename: 'Booking', id: string, publicEventDescription?: string | undefined }> };

export type PublishBookingMutationVariables = Exact<{
  id: Scalars['String'];
  unpublish: Scalars['Boolean'];
}>;


export type PublishBookingMutation = { __typename: 'Mutation', publishBooking: { __typename: 'Booking', id: string, isPublished: boolean } };

export type BookingRequestAdminFragment = { __typename: 'BookingRequest', createdAt: DateTime, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined };

export type BookingRequestAdminQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BookingRequestAdminQuery = { __typename: 'Query', bookingRequest: { __typename: 'BookingRequest', createdAt: DateTime, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined } };

export type SellerBookingRequestsListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: BookingRequestOrderBy;
  startTimeMin?: InputMaybe<Scalars['DateTime']>;
  startTimeMax?: InputMaybe<Scalars['DateTime']>;
  direction: Dir;
}>;


export type SellerBookingRequestsListQuery = { __typename: 'Query', myBookingRequests: Array<{ __typename: 'BookingRequest', indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, bandConfigurationOptions?: Array<BandConfigurationOption> | undefined, billing?: Billing | undefined, artistInstructions?: string | undefined, genres?: Array<string> | undefined, adminInstructions?: string | undefined, canIEdit: boolean, id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, venue: { __typename: 'Venue', name: string, id: string, slug: string, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, extraArtistInfos: Array<{ __typename: 'ExtraArtistInfo', id: string, recommendedPrice?: number | undefined, artistDetailsForBuyerByAdmin?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, declines: Array<{ __typename: 'BookingRequestDecline', id: string, artist: { __typename: 'Artist', id: string, slug: string, name: string, avgRating: number, numberOfReviews: number, bio?: string | undefined, category?: Category | undefined, subgenres?: Array<string> | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type BookingReviewsQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type BookingReviewsQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, artistReviews: Array<{ __typename: 'ArtistReview', id: string, rating: number, comment?: string | undefined, timestamp: DateTime, authorFirstName?: string | undefined, authorOrgStr?: string | undefined, authorLocStr?: string | undefined, published: boolean, count?: number | undefined, authorProfileImage?: { __typename: 'SmallImage', height?: number | undefined, width?: number | undefined, url: string, public_cloudinary_id?: string | undefined } | undefined }>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } } };

export type BadgesFragment = { __typename: 'MyBadgeResponse', total: number, bookings: number, bookingRequests: number };

export type ActionRequiredListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ActionRequiredListQuery = { __typename: 'Query', myBookingsWhereActionIsRequired: Array<{ __typename: 'Booking', id: string, venueName?: string | undefined, artist_name: string, start_time: DateTime, status: BookingStatusV2, performance_length_mins: number, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, location: { __typename: 'Location', timezone: string, placeId?: string | undefined }, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }>, myBookingRequestsWhereActionIsRequired: Array<{ __typename: 'BookingRequest', id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue: { __typename: 'Venue', name: string, id: string }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }> };

export type HomebaseArtistsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type HomebaseArtistsQuery = { __typename: 'Query', artists: Array<{ __typename: 'Artist', id: string, slug: string, profileImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined }> };

export type HomebaseQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  startTimeMin: Scalars['DateTime'];
}>;


export type HomebaseQuery = { __typename: 'Query', myBookings: Array<{ __typename: 'Booking', id: string, venueName?: string | undefined, artist_name: string, start_time: DateTime, status: BookingStatusV2, performance_length_mins: number, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, location: { __typename: 'Location', timezone: string, placeId?: string | undefined }, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }>, myBookingRequests: Array<{ __typename: 'BookingRequest', id: string, isActionRequired: boolean, status: BookingRequestStatus, areAllMyBidsRejected?: boolean | undefined, didSomeoneElsesBidGetChosen: boolean, isPast: boolean, start_time: DateTime, last_updated: DateTime, performance_length_mins: number, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue: { __typename: 'Venue', name: string, id: string }, whatShouldIDoAlerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, artists: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, myAcceptedBid?: { __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } } | undefined, myArtistsThatCanBid: Array<{ __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }>, bids: Array<{ __typename: 'Bid', id: string, buyerPrice: number, sellerPrice: number, status: BidStatus, bandConfiguration?: BandConfigurationOption | undefined, lastUpdated: DateTime, notes?: string | undefined, rejectionMessage?: string | undefined, artist: { __typename: 'Artist', id: string, slug: string, name: string, numberOfReviews: number, avgRating: number, profileImage?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined } }>, booking?: { __typename: 'Booking', id: string } | undefined, buyer_frontend_copy?: { __typename: 'FrontendDirections', notes?: Array<{ __typename: 'Note', message: string, variant?: Variant | undefined, label?: string | undefined }> | undefined, short_message?: { __typename: 'ShortMessage', title?: string | undefined, body?: string | undefined } | undefined } | undefined }>, myBookingsToConfirm: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, confirmation?: { __typename: 'BookingConfirmation', id: any, confirmedAt: DateTime, response: BookingConfirmationResponse } | undefined, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type HomebaseReviewsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type HomebaseReviewsQuery = { __typename: 'Query', myBookingsThatNeedReviewsCount: number, myBookingsThatNeedReviews: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type MyVenuesListQueryVariables = Exact<{ [key: string]: never; }>;


export type MyVenuesListQuery = { __typename: 'Query', myVenues: Array<{ __typename: 'Venue', capacity?: number | undefined, genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', height: number, width: number, url: string, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined }> };

export type NextUpcomingBookingIdQueryVariables = Exact<{
  startTimeMin: Scalars['DateTime'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type NextUpcomingBookingIdQuery = { __typename: 'Query', myBookings: Array<{ __typename: 'Booking', id: string, firebaseId: string }> };

export type ExternalBookingPublicQueryVariables = Exact<{
  externalBookingId: Scalars['String'];
}>;


export type ExternalBookingPublicQuery = { __typename: 'Query', externalBooking: { __typename: 'ExternalBooking', id: string, artistName: string, publicEventDescription?: string | undefined, indoorsOrOutdoors?: IndoorsOrOutdoors | undefined, startTime: DateTime, performanceLengthMins: number, venue: { __typename: 'Venue', location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined } }, coverImage?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } };

export type PublicBookingFragment = { __typename: 'Booking', id: string, firebaseId: string, bandConfiguration?: BandConfigurationOption | undefined, performanceLengthMins: number, startTime: DateTime, publicEventDescription?: string | undefined, publicCoverImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, publicProfileImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, artist: { __typename: 'Artist', bio?: string | undefined, id: string, name: string, slug: string, category?: Category | undefined, coverImage?: { __typename: 'Image', height: number, width: number, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profileImage?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined }, venue?: { __typename: 'Venue', id: string, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, postalCode?: string | undefined, unit?: string | undefined, placeId?: string | undefined, timezone: string } } | undefined };

export type PublicBookingQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type PublicBookingQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, firebaseId: string, bandConfiguration?: BandConfigurationOption | undefined, performanceLengthMins: number, startTime: DateTime, publicEventDescription?: string | undefined, publicCoverImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, publicProfileImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, artist: { __typename: 'Artist', bio?: string | undefined, id: string, name: string, slug: string, category?: Category | undefined, coverImage?: { __typename: 'Image', height: number, width: number, verticalAlign?: VerticalAlign | undefined, public_cloudinary_id: string } | undefined, profileImage?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined }, venue?: { __typename: 'Venue', id: string, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, postalCode?: string | undefined, unit?: string | undefined, placeId?: string | undefined, timezone: string } } | undefined } };

export type VenueCalendarBookingsQueryVariables = Exact<{
  slug: Scalars['String'];
  start: Scalars['DateTime'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type VenueCalendarBookingsQuery = { __typename: 'Query', venue: { __typename: 'Venue', id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, calendarBookings: { __typename: 'CalendarBookingsResponse', canFetchMore: boolean, bookings: Array<{ __typename: 'CalendarBooking', performanceLengthMins: number, artistCategory?: Category | undefined, bandConfiguration?: BandConfigurationOption | undefined, artistName: string, startTime: DateTime, bookingType: CalendarBookingType, id: string, artistProfileImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined, artistCoverImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined, publicCoverImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined, publicProfileImage?: { __typename: 'Image', publicCloudinaryId: string } | undefined }> }, images?: Array<{ __typename: 'Image', height: number, width: number, public_cloudinary_id: string }> | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export type BookingToEditImagesForFragment = { __typename: 'Booking', id: string, firebaseId: string, bandConfiguration?: BandConfigurationOption | undefined, performanceLengthMins: number, startTime: DateTime, publicEventDescription?: string | undefined, artist: { __typename: 'Artist', bio?: string | undefined, id: string, name: string, slug: string, category?: Category | undefined, avgRating: number, numberOfReviews: number, subgenres?: Array<string> | undefined, media?: { __typename: 'Media', images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string }> } } | undefined, coverImage?: { __typename: 'Image', height: number, width: number, verticalAlign?: VerticalAlign | undefined, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, profileImage?: { __typename: 'Image', height: number, width: number, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, publicProfileImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, publicCoverImage?: { __typename: 'Image', verticalAlign?: VerticalAlign | undefined, url: string, width: number, height: number, publicCloudinaryId: string } | undefined, venue?: { __typename: 'Venue', id: string, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, postalCode?: string | undefined, unit?: string | undefined, placeId?: string | undefined, timezone: string } } | undefined };

export type BookingToEditImagesForQueryVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type BookingToEditImagesForQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, firebaseId: string, bandConfiguration?: BandConfigurationOption | undefined, performanceLengthMins: number, startTime: DateTime, publicEventDescription?: string | undefined, artist: { __typename: 'Artist', bio?: string | undefined, id: string, name: string, slug: string, category?: Category | undefined, avgRating: number, numberOfReviews: number, subgenres?: Array<string> | undefined, media?: { __typename: 'Media', images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string }> } } | undefined, coverImage?: { __typename: 'Image', height: number, width: number, verticalAlign?: VerticalAlign | undefined, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, profileImage?: { __typename: 'Image', height: number, width: number, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, publicProfileImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, publicCoverImage?: { __typename: 'Image', verticalAlign?: VerticalAlign | undefined, url: string, width: number, height: number, publicCloudinaryId: string } | undefined, venue?: { __typename: 'Venue', id: string, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, postalCode?: string | undefined, unit?: string | undefined, placeId?: string | undefined, timezone: string } } | undefined } };

export type UpdateBookingPublicCoverImageMutationVariables = Exact<{
  bookingId: Array<Scalars['String']> | Scalars['String'];
  image: ImageInput;
}>;


export type UpdateBookingPublicCoverImageMutation = { __typename: 'Mutation', updateBookings: Array<{ __typename: 'Booking', id: string, firebaseId: string, bandConfiguration?: BandConfigurationOption | undefined, performanceLengthMins: number, startTime: DateTime, publicEventDescription?: string | undefined, artist: { __typename: 'Artist', bio?: string | undefined, id: string, name: string, slug: string, category?: Category | undefined, avgRating: number, numberOfReviews: number, subgenres?: Array<string> | undefined, media?: { __typename: 'Media', images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string }> } } | undefined, coverImage?: { __typename: 'Image', height: number, width: number, verticalAlign?: VerticalAlign | undefined, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, profileImage?: { __typename: 'Image', height: number, width: number, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, publicProfileImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, publicCoverImage?: { __typename: 'Image', verticalAlign?: VerticalAlign | undefined, url: string, width: number, height: number, publicCloudinaryId: string } | undefined, venue?: { __typename: 'Venue', id: string, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, postalCode?: string | undefined, unit?: string | undefined, placeId?: string | undefined, timezone: string } } | undefined }> };

export type UpdateBookingPublicProfileImageMutationVariables = Exact<{
  bookingId: Array<Scalars['String']> | Scalars['String'];
  image: ImageInput;
}>;


export type UpdateBookingPublicProfileImageMutation = { __typename: 'Mutation', updateBookings: Array<{ __typename: 'Booking', id: string, firebaseId: string, bandConfiguration?: BandConfigurationOption | undefined, performanceLengthMins: number, startTime: DateTime, publicEventDescription?: string | undefined, artist: { __typename: 'Artist', bio?: string | undefined, id: string, name: string, slug: string, category?: Category | undefined, avgRating: number, numberOfReviews: number, subgenres?: Array<string> | undefined, media?: { __typename: 'Media', images: { __typename: 'Images', gallery: Array<{ __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string }> } } | undefined, coverImage?: { __typename: 'Image', height: number, width: number, verticalAlign?: VerticalAlign | undefined, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, profileImage?: { __typename: 'Image', height: number, width: number, url: string, publicCloudinaryId: string, public_cloudinary_id: string } | undefined, defaultPriceRange?: { __typename: 'PriceRange', low: number, high: number } | undefined, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, publicProfileImage?: { __typename: 'Image', url: string, width: number, height: number, publicCloudinaryId: string } | undefined, publicCoverImage?: { __typename: 'Image', verticalAlign?: VerticalAlign | undefined, url: string, width: number, height: number, publicCloudinaryId: string } | undefined, venue?: { __typename: 'Venue', id: string, location: { __typename: 'Location', city?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, postalCode?: string | undefined, unit?: string | undefined, placeId?: string | undefined, timezone: string } } | undefined }> };

export type CreateArtistReviewMutationVariables = Exact<{
  bookingId: Scalars['String'];
  input: ArtistReviewInput;
}>;


export type CreateArtistReviewMutation = { __typename: 'Mutation', createArtistReview: { __typename: 'ArtistReview', id: string, comment?: string | undefined } };

export type MyBookingsThatNeedReviewsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type MyBookingsThatNeedReviewsQuery = { __typename: 'Query', myBookingsThatNeedReviews: Array<{ __typename: 'Booking', id: string, firebaseId: string, capacity?: number | undefined, shouldAutoPublish?: boolean | undefined, autoPublishMessage: string, comments?: string | undefined, billing: Billing, isPublished: boolean, bookingFlow: BookingFlow, status: BookingStatusV2, public_event_description?: string | undefined, artist_id: string, start_time: DateTime, venue_name?: string | undefined, venue_slug?: string | undefined, venue_id?: string | undefined, created_at: DateTime, last_updated: DateTime, production_and_venue_specs?: string | undefined, performance_length_mins: number, indoors_or_outdoors: IndoorsOrOutdoors, band_configuration?: BandConfigurationOption | undefined, can_i_edit: boolean, can_i_advance_booking: boolean, can_i_auto_publish: boolean, can_i_edit_event_description: boolean, can_i_publish: boolean, do_i_need_to_review: boolean, possible_actions: Array<NegotiationAction>, what_should_i_do_alerts?: { __typename: 'WhatShouldIDoAlerts', buyer?: WhatShouldIDoAlert | undefined, seller?: WhatShouldIDoAlert | undefined } | undefined, venue_location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, venue?: { __typename: 'Venue', id: string, productionAndVenueSpecs?: string | undefined } | undefined, negotiation_steps: Array<{ __typename: 'NegotiationStep', action: NegotiationAction, timestamp: DateTime, user_id: string, user_role: UserRole, on_behalf_of_role: OnBehalfOfRole, seller_offer_amount: number, offer_ammount: number, description: { __typename: 'NegotiationStepDescription', buyer: string, seller: string, admin: string } }>, display_prices: { __typename: 'DisplayPrices', buyer: number, seller: number }, artist: { __typename: 'Artist', id: string, name: string, slug: string, profile_image?: { __typename: 'Image', url: string, height: number, width: number, public_cloudinary_id: string } | undefined }, status_information?: { __typename: 'StatusInformation', current_step_index: number, total_step_count: number, status_bar: Array<{ __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string }>, current_step: { __typename: 'StatusNode', status: BookingStatusV2, buyer_description: string, seller_description: string } } | undefined, buyerMetadata: { __typename: 'Metadata', userType: UserType, organization?: string | undefined, location?: string | undefined } }> };

export type MyBookingsThatNeedReviewsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBookingsThatNeedReviewsCountQuery = { __typename: 'Query', myBookingsThatNeedReviewsCount: number };

export type VenueAccountExecQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueAccountExecQuery = { __typename: 'Query', venue: { __typename: 'Venue', id: string, name: string, accountExec?: { __typename: 'User', id: string, name: string } | undefined } };

export type AssignVenueAccountExecMutationVariables = Exact<{
  venueId: Scalars['String'];
  accountExecId: Scalars['String'];
  remove: Scalars['Boolean'];
}>;


export type AssignVenueAccountExecMutation = { __typename: 'Mutation', linkAccountExec: { __typename: 'Venue', id: string, accountExec?: { __typename: 'User', id: string, name: string } | undefined } };

export type AccountExecsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountExecsQuery = { __typename: 'Query', users: Array<{ __typename: 'User', id: string, name: string, slug: string, firebaseId: string, profileImage?: { __typename: 'Image', publicCloudinaryId: string, height: number, width: number } | undefined, metadata: { __typename: 'Metadata', userType: UserType }, venuesAssignedTo: Array<{ __typename: 'Venue', id: string, name: string, slug: string }> }> };

export type VenueColorsMutationVariables = Exact<{
  venueId: Scalars['String'];
  patch: VenuePatch;
}>;


export type VenueColorsMutation = { __typename: 'Mutation', updateVenue: { __typename: 'Venue', genresBooked?: Array<string> | undefined, id: string, name: string, slug: string, website?: string | undefined, capacity?: number | undefined, firebaseId: string, description?: string | undefined, parkingAndLoadingAccess?: string | undefined, venue_type: VenueType, num_stages: number, production_and_venue_specs?: string | undefined, last_updated: DateTime, created_at: DateTime, images?: Array<{ __typename: 'Image', width: number, height: number, public_cloudinary_id: string }> | undefined, budget?: { __typename: 'PriceRangeOptional', low?: number | undefined, high?: number | undefined } | undefined, social_media?: { __typename: 'SocialMedia', facebook?: string | undefined, instagram?: string | undefined, youtube?: string | undefined, twitter?: string | undefined, soundcloud?: string | undefined, spotify?: string | undefined } | undefined, display_images?: { __typename: 'DisplayImages', profile_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, cover_image?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined } | undefined, logo?: { __typename: 'Image', height: number, width: number, public_cloudinary_id: string } | undefined, location: { __typename: 'Location', placeId?: string | undefined, stateAbbr?: string | undefined, streetAddress?: string | undefined, countryName?: string | undefined, postalCode?: string | undefined, lat: number, lng: number, timezone: string, city?: string | undefined, unit?: string | undefined }, colors?: { __typename: 'Colors', primary: string, colorMode: ColorMode } | undefined } };

export const LocationFragmentDoc = /*#__PURE__*/ gql`
    fragment Location on Location {
  placeId
  stateAbbr
  streetAddress
  countryName
  postalCode
  lat
  lng
  timezone
  city
  unit
}
    `;
export const ArtistReviewFragmentDoc = /*#__PURE__*/ gql`
    fragment ArtistReview on ArtistReview {
  id
  rating
  comment
  timestamp
  authorFirstName
  authorProfileImage {
    public_cloudinary_id: publicCloudinaryId
    height
    width
    url
  }
  authorOrgStr
  authorLocStr
  published
  count
}
    `;
export const ArtistPublicFragmentDoc = /*#__PURE__*/ gql`
    fragment ArtistPublic on Artist {
  id
  name
  category
  subgenres
  bio
  slug
  location {
    ...Location
  }
  social_media: socialMedia {
    facebook
    soundcloud
    youtube
    instagram
    twitter
    spotify
  }
  cover_image: coverImage {
    public_cloudinary_id: publicCloudinaryId
    height
    width
    url
    verticalAlign
  }
  profile_image: profileImage {
    public_cloudinary_id: publicCloudinaryId
    height
    width
    url
  }
  last_updated: lastUpdated
  published
  media {
    songs {
      soundcloud
      spotify
    }
    videos {
      youtube
    }
    images {
      gallery {
        height
        width
        url
        public_cloudinary_id: publicCloudinaryId
      }
    }
  }
  avgRating
  numberOfReviews
  topReviews {
    ...ArtistReview
  }
}
    ${LocationFragmentDoc}
${ArtistReviewFragmentDoc}`;
export const BandConfigurationItemFragmentDoc = /*#__PURE__*/ gql`
    fragment BandConfigurationItem on ConfigInfo {
  prices {
    private {
      low
      high
    }
    public {
      low
      high
    }
  }
  notes
}
    `;
export const BandConfigurationFragmentDoc = /*#__PURE__*/ gql`
    fragment BandConfiguration on BandConfig {
  solo {
    ...BandConfigurationItem
  }
  duo {
    ...BandConfigurationItem
  }
  trio {
    ...BandConfigurationItem
  }
  four_plus: fourPlus {
    ...BandConfigurationItem
  }
  fallback {
    ...BandConfigurationItem
  }
}
    ${BandConfigurationItemFragmentDoc}`;
export const ArtistFragmentDoc = /*#__PURE__*/ gql`
    fragment Artist on Artist {
  ...ArtistPublic
  display_band_configuration: bandConfiguration {
    ...BandConfiguration
  }
}
    ${ArtistPublicFragmentDoc}
${BandConfigurationFragmentDoc}`;
export const ConnectAccountFragmentDoc = /*#__PURE__*/ gql`
    fragment ConnectAccount on ConnectAccountDisplay {
  id
  needsToOnboard
  needsToAddInformation
  canTransfer
  dashboardLink
  onboardingLink
  payoutMethod {
    bankName
    brand
    id
    last4
    expMonth
    expYear
  }
  button {
    url
    text
    subtext
  }
}
    `;
export const NegotiationStepFragmentDoc = /*#__PURE__*/ gql`
    fragment NegotiationStep on NegotiationStep {
  user_id: userId
  user_role: userRole
  on_behalf_of_role: onBehalfOfRole
  action
  seller_offer_amount: sellerOfferAmount
  offer_ammount: offerAmount
  timestamp
  description {
    buyer
    seller
    admin
  }
}
    `;
export const BookingStatusInformationFragmentDoc = /*#__PURE__*/ gql`
    fragment BookingStatusInformation on StatusInformation {
  status_bar: statusBar {
    status
    buyer_description: buyerDescription
    seller_description: sellerDescription
  }
  current_step_index: currentStepIndex
  current_step: currentStep {
    status
    buyer_description: buyerDescription
    seller_description: sellerDescription
  }
  total_step_count: totalStepCount
}
    `;
export const BookingFragmentDoc = /*#__PURE__*/ gql`
    fragment Booking on Booking {
  id
  firebaseId
  status: statusV2
  public_event_description: publicEventDescription
  capacity
  what_should_i_do_alerts: whatShouldIDoAlerts {
    buyer
    seller
  }
  shouldAutoPublish
  autoPublishMessage
  comments
  artist_id: artistId
  start_time: startTime
  venue_location: location {
    ...Location
  }
  venue {
    id
    productionAndVenueSpecs
  }
  venue_name: venueName
  venue_slug: venueSlug
  venue_id: venueId
  billing
  created_at: createdAt
  last_updated: lastUpdated
  production_and_venue_specs: productionAndVenueSpecs
  performance_length_mins: performanceLengthMins
  negotiation_steps: negotiationSteps {
    ...NegotiationStep
  }
  isPublished
  bookingFlow
  indoors_or_outdoors: indoorsOrOutdoors
  band_configuration: bandConfiguration
  can_i_edit: canIEdit
  can_i_advance_booking: canIAdvanceBooking
  can_i_auto_publish: canIAutoPublish
  can_i_edit_event_description: canIEditEventDescription
  can_i_publish: canIPublish
  do_i_need_to_review: doINeedToReview
  display_prices: displayPrices {
    buyer
    seller
  }
  possible_actions: possibleActions
  artist {
    id
    name
    profile_image: profileImage {
      url
      height
      width
      public_cloudinary_id: publicCloudinaryId
    }
    slug
  }
  status_information: statusInformation {
    ...BookingStatusInformation
  }
  buyerMetadata {
    userType
    organization
    location
  }
}
    ${LocationFragmentDoc}
${NegotiationStepFragmentDoc}
${BookingStatusInformationFragmentDoc}`;
export const UserFragmentDoc = /*#__PURE__*/ gql`
    fragment User on User {
  id
  firebaseId
  name
  user_role: userRole
  metadata {
    organization
    location
    user_type: userType
  }
  profile_image: profileImage {
    public_cloudinary_id: publicCloudinaryId
    width
    height
  }
  email
  phone_number: phoneNumber
  approved: isApproved
  last_updated: lastUpdated
  created_at: createdAt
  public_or_private: publicOrPrivate
  __typename
}
    `;
export const AdminBookingFragmentDoc = /*#__PURE__*/ gql`
    fragment AdminBooking on Booking {
  ...Booking
  lastOfferAmount
  lastSellerOfferAmount
  buyer {
    ...User
  }
  charge {
    chargedBuyer
    manuallyChargedBuyer
    invoiceId
    invoiceItemId
    cancelledInvoiceId
    manuallyChargedBuyerBy
  }
  payout {
    paidSeller
    manuallyPaidSeller
    transferId
    manuallyPaidSellerBy
  }
}
    ${BookingFragmentDoc}
${UserFragmentDoc}`;
export const UserFromAdminFragmentDoc = /*#__PURE__*/ gql`
    fragment UserFromAdmin on User {
  ...User
  approvedAt
  approvedBy {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const VenuePublicFragmentDoc = /*#__PURE__*/ gql`
    fragment VenuePublic on Venue {
  id
  name
  slug
  venue_type: venueType
  num_stages: numStages
  images {
    public_cloudinary_id: publicCloudinaryId
    height
    width
  }
  website
  capacity
  social_media: socialMedia {
    facebook
    instagram
    youtube
    twitter
    soundcloud
    spotify
  }
  display_images: displayImages {
    profile_image: profileImage {
      public_cloudinary_id: publicCloudinaryId
      height
      width
    }
    cover_image: coverImage {
      public_cloudinary_id: publicCloudinaryId
      height
      width
    }
  }
  logo {
    height
    width
    public_cloudinary_id: publicCloudinaryId
  }
  firebaseId
  location {
    ...Location
  }
  colors {
    primary
    colorMode
  }
  description
  production_and_venue_specs: productionAndVenueSpecs
  last_updated: lastUpdated
  parkingAndLoadingAccess
  created_at: createdAt
  capacity
}
    ${LocationFragmentDoc}`;
export const VenueFragmentDoc = /*#__PURE__*/ gql`
    fragment Venue on Venue {
  ...VenuePublic
  images {
    width
    height
    public_cloudinary_id: publicCloudinaryId
  }
  genresBooked
  budget {
    low
    high
  }
}
    ${VenuePublicFragmentDoc}`;
export const BankAccountFragmentDoc = /*#__PURE__*/ gql`
    fragment BankAccount on StripeBankAccount {
  id
  isDefault
  status
  last4
  customer
  accountHolderName
  bankName
}
    `;
export const ImageFragmentDoc = /*#__PURE__*/ gql`
    fragment Image on Image {
  url
  public_cloudinary_id: publicCloudinaryId
  height
  width
}
    `;
export const BookingRequestArtistFragmentDoc = /*#__PURE__*/ gql`
    fragment BookingRequestArtist on Artist {
  id
  slug
  name
  numberOfReviews
  avgRating
  profileImage {
    ...Image
  }
}
    ${ImageFragmentDoc}`;
export const AdminBookingRequestArtistFragmentDoc = /*#__PURE__*/ gql`
    fragment AdminBookingRequestArtist on Artist {
  ...BookingRequestArtist
  defaultPriceRange {
    low
    high
  }
  bandConfiguration {
    ...BandConfiguration
  }
}
    ${BookingRequestArtistFragmentDoc}
${BandConfigurationFragmentDoc}`;
export const MyAccountFragmentDoc = /*#__PURE__*/ gql`
    fragment MyAccount on User {
  ...User
}
    ${UserFragmentDoc}`;
export const BarChartsFragmentDoc = /*#__PURE__*/ gql`
    fragment BarCharts on BarChartEdge {
  monthly {
    labels
    data
    firstFutureIndex
  }
  yearly {
    labels
    data
    firstFutureIndex
  }
}
    `;
export const BarChartMetricFragmentDoc = /*#__PURE__*/ gql`
    fragment BarChartMetric on Metric {
  barCharts {
    ...BarCharts
  }
  overview {
    allTimeValue
    growth
  }
}
    ${BarChartsFragmentDoc}`;
export const GamificationMetricFragmentDoc = /*#__PURE__*/ gql`
    fragment GamificationMetric on GamificationMetric {
  value
  score
  quality
}
    `;
export const SpotifyArtistFragmentDoc = /*#__PURE__*/ gql`
    fragment SpotifyArtist on ArtistSpotify {
  genres
  href
  id
  images {
    height
    url
    width
  }
  name
  popularity
  followers {
    total
  }
  externalUrls {
    spotify
  }
}
    `;
export const LocationCamelFragmentDoc = /*#__PURE__*/ gql`
    fragment LocationCamel on Location {
  placeId
  stateAbbr
  streetAddress
  countryName
  postalCode
  lat
  lng
  timezone
  city
  unit
  countryId
}
    `;
export const SmallArtistPublicFragmentDoc = /*#__PURE__*/ gql`
    fragment SmallArtistPublic on Artist {
  id
  slug
  name
  profile_image: profileImage {
    ...Image
  }
  avgRating
  numberOfReviews
  bio
  category
  subgenres
  cover_image: coverImage {
    ...Image
  }
}
    ${ImageFragmentDoc}`;
export const SmallArtistFragmentDoc = /*#__PURE__*/ gql`
    fragment SmallArtist on Artist {
  ...SmallArtistPublic
  defaultPriceRange {
    low
    high
  }
}
    ${SmallArtistPublicFragmentDoc}`;
export const ArtistAvailabilityCheckAdminFragmentDoc = /*#__PURE__*/ gql`
    fragment ArtistAvailabilityCheckAdmin on ArtistAvailabilityCheck {
  id
  artist {
    ...SmallArtist
  }
  response
  responseMessage
  respondedBy {
    ...User
  }
  createdBy {
    ...User
  }
  createdAt
  lastUpdated
  courierNotificationIds
  notifiedAt
  courierMessages {
    id
    clicked
    channel {
      name
    }
    providers {
      provider
      sent
      opened
      delivered
      error
      clicked
      status
    }
    courierUrl
    recipient
    sent
    opened
    delivered
    error
    reason
    enqueued
    status
  }
}
    ${SmallArtistFragmentDoc}
${UserFragmentDoc}`;
export const ArtistAvailabilityAdminFragmentDoc = /*#__PURE__*/ gql`
    fragment ArtistAvailabilityAdmin on ArtistAvailability {
  id
  createdAt
  status
  performanceLengthMins
  startTime
  buyerDisplayName
  location {
    ...LocationCamel
  }
  checks {
    ...ArtistAvailabilityCheckAdmin
  }
}
    ${LocationCamelFragmentDoc}
${ArtistAvailabilityCheckAdminFragmentDoc}`;
export const ArtistAvailabilityCheckFragmentDoc = /*#__PURE__*/ gql`
    fragment ArtistAvailabilityCheck on ArtistAvailabilityCheck {
  id
  artist {
    ...SmallArtist
  }
  response
  responseMessage
  lastUpdated
  createdAt
  artistAvailability {
    performanceLengthMins
    id
    startTime
    location {
      timezone
      countryName
      city
      stateAbbr
    }
    status
  }
}
    ${SmallArtistFragmentDoc}`;
export const CancellationRequestFragmentDoc = /*#__PURE__*/ gql`
    fragment CancellationRequest on CancellationRequest {
  id
  createdAt
  lastUpdated
  resolved
  message
  user {
    id
    name
    email
    firebaseId
    phoneNumber
    profileImage {
      public_cloudinary_id: publicCloudinaryId
    }
    userRole
    metadata {
      userType
      location
      organization
    }
  }
}
    `;
export const BookingConfirmationFragmentDoc = /*#__PURE__*/ gql`
    fragment BookingConfirmation on BookingConfirmation {
  id
  confirmedAt
  response
}
    `;
export const BuyerBookingPreferenceFragmentDoc = /*#__PURE__*/ gql`
    fragment BuyerBookingPreference on Question {
  id
  body
  type
  response
}
    `;
export const CalendarBookingFragmentDoc = /*#__PURE__*/ gql`
    fragment CalendarBooking on Booking {
  id
  artist_name: artistName
  start_time: startTime
  status: statusV2
  venueName
  performance_length_mins: performanceLengthMins
  artist {
    ...BookingRequestArtist
  }
  location {
    timezone
    placeId
  }
  buyerMetadata {
    userType
    organization
    location
  }
}
    ${BookingRequestArtistFragmentDoc}`;
export const CalendarExternalBookingFragmentDoc = /*#__PURE__*/ gql`
    fragment CalendarExternalBooking on ExternalBooking {
  start_time: startTime
  id
  artist_name: artistName
  venue {
    name
    id
    slug
    location {
      timezone
      placeId
    }
  }
  performance_length_mins: performanceLengthMins
}
    `;
export const ExternalCalendarEventFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalCalendarEvent on ExternalCalendarEvent {
  busy
  id
  title
  status
  participants {
    email
    status
    name
    comment
  }
  when {
    ... on WhenDate {
      date
    }
    ... on WhenDatespan {
      startDate
      endDate
    }
    ... on WhenTime {
      time
    }
    ... on WhenTimespan {
      startTime
      endTime
    }
  }
  description
  location
}
    `;
export const ExternalBookingFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalBooking on ExternalBooking {
  id
  startTime
  performanceLengthMins
  isPublished
  coverImage {
    ...Image
  }
  artistName
  publicEventDescription
  indoorsOrOutdoors
  venue {
    id
    slug
    location {
      placeId
      timezone
    }
  }
}
    ${ImageFragmentDoc}`;
export const BidFragmentDoc = /*#__PURE__*/ gql`
    fragment Bid on Bid {
  id
  buyerPrice
  sellerPrice
  artist {
    ...BookingRequestArtist
  }
  status
  bandConfiguration
  lastUpdated
  notes
  rejectionMessage
}
    ${BookingRequestArtistFragmentDoc}`;
export const CalendarBookingRequestFragmentDoc = /*#__PURE__*/ gql`
    fragment CalendarBookingRequest on BookingRequest {
  id
  isActionRequired
  start_time: startTime
  status
  budget {
    low
    high
  }
  venue_location: venueLocation {
    ...Location
  }
  venue {
    name
    id
  }
  whatShouldIDoAlerts {
    buyer
    seller
  }
  last_updated: lastUpdated
  performance_length_mins: performanceLengthMins
  artists {
    ...BookingRequestArtist
  }
  areAllMyBidsRejected
  myAcceptedBid {
    ...Bid
  }
  didSomeoneElsesBidGetChosen
  myArtistsThatCanBid {
    ...BookingRequestArtist
  }
  isPast
  bids {
    ...Bid
  }
  booking {
    id
  }
  buyer_frontend_copy: buyerFrontendCopy {
    notes {
      message
      variant
      label
    }
    short_message: shortMessage {
      title
      body
    }
  }
}
    ${LocationFragmentDoc}
${BookingRequestArtistFragmentDoc}
${BidFragmentDoc}`;
export const VenueSmallFragmentDoc = /*#__PURE__*/ gql`
    fragment VenueSmall on Venue {
  id
  name
  slug
  location {
    ...Location
  }
}
    ${LocationFragmentDoc}`;
export const BookingRequestFragmentDoc = /*#__PURE__*/ gql`
    fragment BookingRequest on BookingRequest {
  ...CalendarBookingRequest
  indoorsOrOutdoors
  bandConfigurationOptions
  venue {
    ...VenueSmall
  }
  billing
  artistInstructions
  extraArtistInfos {
    id
    recommendedPrice
    artistDetailsForBuyerByAdmin
    artist {
      ...BookingRequestArtist
    }
  }
  genres
  adminInstructions
  canIEdit
  declines {
    id
    artist {
      ...SmallArtistPublic
    }
  }
}
    ${CalendarBookingRequestFragmentDoc}
${VenueSmallFragmentDoc}
${BookingRequestArtistFragmentDoc}
${SmallArtistPublicFragmentDoc}`;
export const BookingRequestAdminFragmentDoc = /*#__PURE__*/ gql`
    fragment BookingRequestAdmin on BookingRequest {
  ...BookingRequest
  createdAt
}
    ${BookingRequestFragmentDoc}`;
export const BadgesFragmentDoc = /*#__PURE__*/ gql`
    fragment Badges on MyBadgeResponse {
  total
  bookings
  bookingRequests
}
    `;
export const ImageCamelFragmentDoc = /*#__PURE__*/ gql`
    fragment ImageCamel on Image {
  url
  width
  height
  publicCloudinaryId
}
    `;
export const PublicBookingFragmentDoc = /*#__PURE__*/ gql`
    fragment PublicBooking on Booking {
  id
  firebaseId
  bandConfiguration
  performanceLengthMins
  startTime
  publicCoverImage {
    ...ImageCamel
  }
  publicProfileImage {
    ...ImageCamel
  }
  artist {
    bio
    id
    name
    slug
    category
    coverImage {
      public_cloudinary_id: publicCloudinaryId
      height
      width
      verticalAlign
    }
    profileImage {
      public_cloudinary_id: publicCloudinaryId
      height
      width
    }
  }
  publicEventDescription
  venue {
    id
    location {
      city
      stateAbbr
      streetAddress
      postalCode
      unit
      placeId
      timezone
    }
  }
}
    ${ImageCamelFragmentDoc}`;
export const BookingToEditImagesForFragmentDoc = /*#__PURE__*/ gql`
    fragment BookingToEditImagesFor on Booking {
  ...PublicBooking
  artist {
    ...SmallArtist
    media {
      images {
        gallery {
          ...ImageCamel
        }
      }
    }
    coverImage {
      ...ImageCamel
    }
    profileImage {
      ...ImageCamel
    }
  }
  publicProfileImage {
    ...ImageCamel
  }
  publicCoverImage {
    ...ImageCamel
    verticalAlign
  }
}
    ${PublicBookingFragmentDoc}
${SmallArtistFragmentDoc}
${ImageCamelFragmentDoc}`;
export const ArtistBillingDocument = /*#__PURE__*/ gql`
    query ArtistBilling($slug: String, $id: String, $redirectUrl: String!) {
  artist(slug: $slug, id: $id) {
    id
    slug
    billing(redirectUrl: $redirectUrl) {
      ...ConnectAccount
    }
  }
}
    ${ConnectAccountFragmentDoc}`;

export function useArtistBillingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistBillingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistBillingQuery, ArtistBillingQueryVariables>({ query: ArtistBillingDocument, ...options });
};
export const LinkSellerToArtistDocument = /*#__PURE__*/ gql`
    mutation LinkSellerToArtist($artistSlug: String!, $phoneNumber: String!, $remove: Boolean!) {
  createLinkToArtist(
    slug: $artistSlug
    phoneNumber: $phoneNumber
    remove: $remove
  ) {
    ...Artist
    sellers {
      ...User
    }
    pendingUserPhoneNumbers
  }
}
    ${ArtistFragmentDoc}
${UserFragmentDoc}`;

export function useLinkSellerToArtistMutation() {
  return Urql.useMutation<LinkSellerToArtistMutation, LinkSellerToArtistMutationVariables>(LinkSellerToArtistDocument);
};
export const SellersOfArtistDocument = /*#__PURE__*/ gql`
    query SellersOfArtist($slug: String!) {
  artist(slug: $slug) {
    sellers {
      ...User
    }
    ...Artist
    pendingUserPhoneNumbers
  }
}
    ${UserFragmentDoc}
${ArtistFragmentDoc}`;

export function useSellersOfArtistQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SellersOfArtistQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SellersOfArtistQuery, SellersOfArtistQueryVariables>({ query: SellersOfArtistDocument, ...options });
};
export const BuyerAcceptBidDocument = /*#__PURE__*/ gql`
    mutation BuyerAcceptBid($bidId: String!) {
  acceptBidBuyer(bidId: $bidId) {
    ...Bid
    bookingRequest {
      ...BookingRequest
    }
  }
}
    ${BidFragmentDoc}
${BookingRequestFragmentDoc}`;

export function useBuyerAcceptBidMutation() {
  return Urql.useMutation<BuyerAcceptBidMutation, BuyerAcceptBidMutationVariables>(BuyerAcceptBidDocument);
};
export const AdminWriteBookingRequestBidDocument = /*#__PURE__*/ gql`
    mutation AdminWriteBookingRequestBid($bookingRequestId: String!, $artistId: String!, $sellerPrice: Float!, $input: BidInput!, $notifyBuyers: Boolean!, $artistDetailsForBuyerByAdmin: String) {
  createBidAdmin(
    bookingRequestId: $bookingRequestId
    artistId: $artistId
    sellerPrice: $sellerPrice
    input: $input
    notifyBuyers: $notifyBuyers
    artistDetailsForBuyerByAdmin: $artistDetailsForBuyerByAdmin
  ) {
    ...Bid
    bookingRequest {
      ...BookingRequest
    }
  }
}
    ${BidFragmentDoc}
${BookingRequestFragmentDoc}`;

export function useAdminWriteBookingRequestBidMutation() {
  return Urql.useMutation<AdminWriteBookingRequestBidMutation, AdminWriteBookingRequestBidMutationVariables>(AdminWriteBookingRequestBidDocument);
};
export const CancelBookingRequestsDocument = /*#__PURE__*/ gql`
    mutation CancelBookingRequests($ids: [String!]!) {
  cancelBookingRequests(bookingRequestIds: $ids, cancellationMessage: "") {
    ...BookingRequest
  }
}
    ${BookingRequestFragmentDoc}`;

export function useCancelBookingRequestsMutation() {
  return Urql.useMutation<CancelBookingRequestsMutation, CancelBookingRequestsMutationVariables>(CancelBookingRequestsDocument);
};
export const CreateBookingRequestsBuyerDocument = /*#__PURE__*/ gql`
    mutation CreateBookingRequestsBuyer($input: BookingRequestInput!, $startTimes: [DateTime!]!, $venueId: String!, $artistIds: [String!]!) {
  createBookingRequestsBuyer(
    input: $input
    startTimes: $startTimes
    venueId: $venueId
    artistIds: $artistIds
  ) {
    ...BookingRequest
  }
}
    ${BookingRequestFragmentDoc}`;

export function useCreateBookingRequestsBuyerMutation() {
  return Urql.useMutation<CreateBookingRequestsBuyerMutation, CreateBookingRequestsBuyerMutationVariables>(CreateBookingRequestsBuyerDocument);
};
export const BookingRequestDocument = /*#__PURE__*/ gql`
    query BookingRequest($id: String!) {
  bookingRequest(id: $id) {
    ...BookingRequest
    venue {
      productionAndVenueSpecs
    }
    publicEventDescription
  }
}
    ${BookingRequestFragmentDoc}`;

export function useBookingRequestQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingRequestQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingRequestQuery, BookingRequestQueryVariables>({ query: BookingRequestDocument, ...options });
};
export const BuyerRejectBidDocument = /*#__PURE__*/ gql`
    mutation BuyerRejectBid($bidId: String!, $rejectionMessage: String!) {
  rejectBid(bidId: $bidId, rejectionMessage: $rejectionMessage) {
    ...Bid
    bookingRequest {
      ...BookingRequest
    }
  }
}
    ${BidFragmentDoc}
${BookingRequestFragmentDoc}`;

export function useBuyerRejectBidMutation() {
  return Urql.useMutation<BuyerRejectBidMutation, BuyerRejectBidMutationVariables>(BuyerRejectBidDocument);
};
export const RemoveBookingRequestArtistDocument = /*#__PURE__*/ gql`
    mutation RemoveBookingRequestArtist($bookingRequestId: [String!]!, $artistId: [String!]!) {
  removeArtistsFromBookingRequests(
    bookingRequestIds: $bookingRequestId
    artistIds: $artistId
  ) {
    ...BookingRequest
  }
}
    ${BookingRequestFragmentDoc}`;

export function useRemoveBookingRequestArtistMutation() {
  return Urql.useMutation<RemoveBookingRequestArtistMutation, RemoveBookingRequestArtistMutationVariables>(RemoveBookingRequestArtistDocument);
};
export const SellerDeclineBookingRequestDocument = /*#__PURE__*/ gql`
    mutation SellerDeclineBookingRequest($bookingRequestId: String!, $artistId: String!, $reasonForDecline: String!) {
  declineBookingRequest(
    bookingRequestId: $bookingRequestId
    artistId: $artistId
    reasonForDecline: $reasonForDecline
  ) {
    id
    bookingRequest {
      ...BookingRequest
    }
  }
}
    ${BookingRequestFragmentDoc}`;

export function useSellerDeclineBookingRequestMutation() {
  return Urql.useMutation<SellerDeclineBookingRequestMutation, SellerDeclineBookingRequestMutationVariables>(SellerDeclineBookingRequestDocument);
};
export const UpdateBookingRequestArtistDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingRequestArtist($bookingRequestId: [String!]!, $artistId: [String!]!, $input: [ExtraArtistInfoInput!]!) {
  addArtistsToBookingRequests(
    bookingRequestIds: $bookingRequestId
    artistIds: $artistId
    extraArtistInfoInputs: $input
  ) {
    ...BookingRequest
  }
}
    ${BookingRequestFragmentDoc}`;

export function useUpdateBookingRequestArtistMutation() {
  return Urql.useMutation<UpdateBookingRequestArtistMutation, UpdateBookingRequestArtistMutationVariables>(UpdateBookingRequestArtistDocument);
};
export const UpdateBookingRequestDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingRequest($ids: [String!]!, $patch: BookingRequestPatch!) {
  updateBookingRequests(patch: $patch, bookingRequestIds: $ids) {
    ...BookingRequest
  }
}
    ${BookingRequestFragmentDoc}`;

export function useUpdateBookingRequestMutation() {
  return Urql.useMutation<UpdateBookingRequestMutation, UpdateBookingRequestMutationVariables>(UpdateBookingRequestDocument);
};
export const SellerWithdrawBidDocument = /*#__PURE__*/ gql`
    mutation SellerWithdrawBid($bidId: String!) {
  withdrawBid(bidId: $bidId, withdrawalMessage: "") {
    ...Bid
    bookingRequest {
      ...BookingRequest
    }
  }
}
    ${BidFragmentDoc}
${BookingRequestFragmentDoc}`;

export function useSellerWithdrawBidMutation() {
  return Urql.useMutation<SellerWithdrawBidMutation, SellerWithdrawBidMutationVariables>(SellerWithdrawBidDocument);
};
export const CreateBidSellerDocument = /*#__PURE__*/ gql`
    mutation CreateBidSeller($bookingRequestId: String!, $artistId: String!, $sellerPrice: Float!, $input: BidInput!) {
  createBidSeller(
    bookingRequestId: $bookingRequestId
    artistId: $artistId
    sellerPrice: $sellerPrice
    input: $input
  ) {
    ...Bid
    bookingRequest {
      ...BookingRequest
    }
  }
}
    ${BidFragmentDoc}
${BookingRequestFragmentDoc}`;

export function useCreateBidSellerMutation() {
  return Urql.useMutation<CreateBidSellerMutation, CreateBidSellerMutationVariables>(CreateBidSellerDocument);
};
export const SellerToBuyerPriceDocument = /*#__PURE__*/ gql`
    query SellerToBuyerPrice($sellerAmount: Float!, $bookingFlow: BookingFlow!) {
  sellerToBuyerAmount(sellerAmount: $sellerAmount, bookingFlow: $bookingFlow)
}
    `;

export function useSellerToBuyerPriceQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SellerToBuyerPriceQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SellerToBuyerPriceQuery, SellerToBuyerPriceQueryVariables>({ query: SellerToBuyerPriceDocument, ...options });
};
export const SendImageToEmailDocument = /*#__PURE__*/ gql`
    mutation SendImageToEmail($subject: String!, $imageUrl: String!, $redirectUrl: String!, $message: String!) {
  sendPromoImageToEmail(
    message: $message
    imgUrl: $imageUrl
    redirectUrl: $redirectUrl
    subject: $subject
  ) {
    email
  }
}
    `;

export function useSendImageToEmailMutation() {
  return Urql.useMutation<SendImageToEmailMutation, SendImageToEmailMutationVariables>(SendImageToEmailDocument);
};
export const SendImageToPhoneDocument = /*#__PURE__*/ gql`
    mutation SendImageToPhone($imageUrl: String!, $redirectUrl: String!, $message: String!) {
  sendPromoImageToPhone(
    message: $message
    imgUrl: $imageUrl
    redirectUrl: $redirectUrl
  ) {
    phoneNumber
  }
}
    `;

export function useSendImageToPhoneMutation() {
  return Urql.useMutation<SendImageToPhoneMutation, SendImageToPhoneMutationVariables>(SendImageToPhoneDocument);
};
export const AdminSearchKeyDocument = /*#__PURE__*/ gql`
    query AdminSearchKey {
  adminSearchKey
}
    `;

export function useAdminSearchKeyQuery(options?: Omit<Urql.UseQueryArgs<AdminSearchKeyQueryVariables>, 'query'>) {
  return Urql.useQuery<AdminSearchKeyQuery, AdminSearchKeyQueryVariables>({ query: AdminSearchKeyDocument, ...options });
};
export const ArtistDocument = /*#__PURE__*/ gql`
    query Artist($slug: String, $id: String) {
  artist(slug: $slug, id: $id) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useArtistQuery(options?: Omit<Urql.UseQueryArgs<ArtistQueryVariables>, 'query'>) {
  return Urql.useQuery<ArtistQuery, ArtistQueryVariables>({ query: ArtistDocument, ...options });
};
export const ArtistPublicDocument = /*#__PURE__*/ gql`
    query ArtistPublic($slug: String, $id: String) {
  artist(slug: $slug, id: $id) {
    ...ArtistPublic
  }
}
    ${ArtistPublicFragmentDoc}`;

export function useArtistPublicQuery(options?: Omit<Urql.UseQueryArgs<ArtistPublicQueryVariables>, 'query'>) {
  return Urql.useQuery<ArtistPublicQuery, ArtistPublicQueryVariables>({ query: ArtistPublicDocument, ...options });
};
export const BookingBillingDocument = /*#__PURE__*/ gql`
    query BookingBilling($id: String!) {
  booking(id: $id) {
    id
    payout {
      paidSeller
      manuallyPaidSeller
      transferId
      manuallyPaidSellerBy
    }
    bookingBilling {
      frontendDirections {
        notes {
          message
          variant
          filling
          size
          label
        }
      }
      buyerBilling {
        bankAccount {
          ...BankAccount
        }
        needsBankAccountCard {
          header
          message
          disclaimer
          buttonText
        }
      }
      buyerNeedsBankAccountCard {
        header
        message
        disclaimer
        buttonText
      }
      connectAccount {
        ...ConnectAccount
      }
      sellerNeedsPayoutMethodCard {
        header
        message
        disclaimer
        buttonText
      }
      receiptItems {
        title
        description
        dollarAmount
        percentage
      }
    }
  }
}
    ${BankAccountFragmentDoc}
${ConnectAccountFragmentDoc}`;

export function useBookingBillingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingBillingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingBillingQuery, BookingBillingQueryVariables>({ query: BookingBillingDocument, ...options });
};
export const BookingDocument = /*#__PURE__*/ gql`
    query Booking($id: String!) {
  booking(id: $id) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useBookingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingQuery, BookingQueryVariables>({ query: BookingDocument, ...options });
};
export const AdminBookingDocument = /*#__PURE__*/ gql`
    query AdminBooking($id: String!) {
  booking(id: $id) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useAdminBookingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminBookingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminBookingQuery, AdminBookingQueryVariables>({ query: AdminBookingDocument, ...options });
};
export const BookingScreenDocument = /*#__PURE__*/ gql`
    query BookingScreen($id: String!) {
  booking(id: $id) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useBookingScreenQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingScreenQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingScreenQuery, BookingScreenQueryVariables>({ query: BookingScreenDocument, ...options });
};
export const CreateArtistVenueApplicationDocument = /*#__PURE__*/ gql`
    mutation CreateArtistVenueApplication($artistId: String!, $venueId: String!, $message: String!) {
  createArtistVenueApplication(
    artistId: $artistId
    venueId: $venueId
    message: $message
  ) {
    id
    message
  }
}
    `;

export function useCreateArtistVenueApplicationMutation() {
  return Urql.useMutation<CreateArtistVenueApplicationMutation, CreateArtistVenueApplicationMutationVariables>(CreateArtistVenueApplicationDocument);
};
export const LikeArtistDocument = /*#__PURE__*/ gql`
    mutation LikeArtist($slug: String!, $unlike: Boolean!) {
  likeArtist(artistSlug: $slug, unlike: $unlike)
}
    `;

export function useLikeArtistMutation() {
  return Urql.useMutation<LikeArtistMutation, LikeArtistMutationVariables>(LikeArtistDocument);
};
export const LikedArtistsDocument = /*#__PURE__*/ gql`
    query LikedArtists($limit: Int!, $offset: Int!) {
  myLikedArtists(limit: $limit, offset: $offset) {
    timestamp
    artist {
      id
      slug
      name
      profileImage {
        publicCloudinaryId
      }
    }
  }
}
    `;

export function useLikedArtistsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<LikedArtistsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<LikedArtistsQuery, LikedArtistsQueryVariables>({ query: LikedArtistsDocument, ...options });
};
export const LikedArtistSlugsDocument = /*#__PURE__*/ gql`
    query LikedArtistSlugs {
  myLikedArtistsSlugs
}
    `;

export function useLikedArtistSlugsQuery(options?: Omit<Urql.UseQueryArgs<LikedArtistSlugsQueryVariables>, 'query'>) {
  return Urql.useQuery<LikedArtistSlugsQuery, LikedArtistSlugsQueryVariables>({ query: LikedArtistSlugsDocument, ...options });
};
export const MyArtistsDocument = /*#__PURE__*/ gql`
    query MyArtists {
  myArtists {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useMyArtistsQuery(options?: Omit<Urql.UseQueryArgs<MyArtistsQueryVariables>, 'query'>) {
  return Urql.useQuery<MyArtistsQuery, MyArtistsQueryVariables>({ query: MyArtistsDocument, ...options });
};
export const MyVenuesDocument = /*#__PURE__*/ gql`
    query MyVenues {
  myVenues {
    ...VenueSmall
  }
}
    ${VenueSmallFragmentDoc}`;

export function useMyVenuesQuery(options?: Omit<Urql.UseQueryArgs<MyVenuesQueryVariables>, 'query'>) {
  return Urql.useQuery<MyVenuesQuery, MyVenuesQueryVariables>({ query: MyVenuesDocument, ...options });
};
export const PublishArtistDocument = /*#__PURE__*/ gql`
    mutation PublishArtist($id: String!, $unpublish: Boolean!) {
  publishArtist(artistId: $id, unpublish: $unpublish) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function usePublishArtistMutation() {
  return Urql.useMutation<PublishArtistMutation, PublishArtistMutationVariables>(PublishArtistDocument);
};
export const UserFromAdminDocument = /*#__PURE__*/ gql`
    query UserFromAdmin($id: String!) {
  user(id: $id) {
    ...UserFromAdmin
  }
}
    ${UserFromAdminFragmentDoc}`;

export function useUserFromAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<UserFromAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<UserFromAdminQuery, UserFromAdminQueryVariables>({ query: UserFromAdminDocument, ...options });
};
export const VenuePublicDocument = /*#__PURE__*/ gql`
    query VenuePublic($slug: String!) {
  venue(slug: $slug) {
    ...VenuePublic
  }
}
    ${VenuePublicFragmentDoc}`;

export function useVenuePublicQuery(options: RequireFields<Omit<Urql.UseQueryArgs<VenuePublicQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<VenuePublicQuery, VenuePublicQueryVariables>({ query: VenuePublicDocument, ...options });
};
export const VenueDocument = /*#__PURE__*/ gql`
    query Venue($slug: String, $id: String) {
  venue(slug: $slug, id: $id) {
    ...Venue
  }
}
    ${VenueFragmentDoc}`;

export function useVenueQuery(options?: Omit<Urql.UseQueryArgs<VenueQueryVariables>, 'query'>) {
  return Urql.useQuery<VenueQuery, VenueQueryVariables>({ query: VenueDocument, ...options });
};
export const ViewArtistDocument = /*#__PURE__*/ gql`
    mutation ViewArtist($id: String!) {
  viewArtist(artistId: $id)
}
    `;

export function useViewArtistMutation() {
  return Urql.useMutation<ViewArtistMutation, ViewArtistMutationVariables>(ViewArtistDocument);
};
export const LinkBuyerToVenueDocument = /*#__PURE__*/ gql`
    mutation LinkBuyerToVenue($venueId: String!, $phoneNumber: String!, $remove: Boolean!) {
  createLinkToVenue(venueId: $venueId, phoneNumber: $phoneNumber, remove: $remove) {
    ...Venue
    owners {
      ...User
    }
    pendingUserPhoneNumbers
  }
}
    ${VenueFragmentDoc}
${UserFragmentDoc}`;

export function useLinkBuyerToVenueMutation() {
  return Urql.useMutation<LinkBuyerToVenueMutation, LinkBuyerToVenueMutationVariables>(LinkBuyerToVenueDocument);
};
export const OwnersOfVenueDocument = /*#__PURE__*/ gql`
    query OwnersOfVenue($slug: String!) {
  venue(slug: $slug) {
    ...Venue
    owners {
      ...User
    }
    pendingUserPhoneNumbers
  }
}
    ${VenueFragmentDoc}
${UserFragmentDoc}`;

export function useOwnersOfVenueQuery(options: RequireFields<Omit<Urql.UseQueryArgs<OwnersOfVenueQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<OwnersOfVenueQuery, OwnersOfVenueQueryVariables>({ query: OwnersOfVenueDocument, ...options });
};
export const VenuesFromAccountExecsDocument = /*#__PURE__*/ gql`
    query VenuesFromAccountExecs($execSlugs: [String!]!, $limit: Int!, $offset: Int!) {
  users(
    slugs: $execSlugs
    approved: true
    userRoles: admin
    limit: $limit
    offset: $offset
  ) {
    id
    name
    slug
    firebaseId
    venuesAssignedTo {
      id
      name
      slug
    }
  }
}
    `;

export function useVenuesFromAccountExecsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<VenuesFromAccountExecsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<VenuesFromAccountExecsQuery, VenuesFromAccountExecsQueryVariables>({ query: VenuesFromAccountExecsDocument, ...options });
};
export const RemoveVenueBankAccountDocument = /*#__PURE__*/ gql`
    mutation RemoveVenueBankAccount($venueId: String!, $bankAccountId: String!) {
  deleteBankAccount(venueId: $venueId, bankAccountId: $bankAccountId) {
    ...BankAccount
  }
}
    ${BankAccountFragmentDoc}`;

export function useRemoveVenueBankAccountMutation() {
  return Urql.useMutation<RemoveVenueBankAccountMutation, RemoveVenueBankAccountMutationVariables>(RemoveVenueBankAccountDocument);
};
export const SetVenueBankAccountDocument = /*#__PURE__*/ gql`
    mutation SetVenueBankAccount($venueId: String!, $bankAccountId: String!) {
  setDefaultBankAccount(venueId: $venueId, bankAccountId: $bankAccountId) {
    ...BankAccount
  }
}
    ${BankAccountFragmentDoc}`;

export function useSetVenueBankAccountMutation() {
  return Urql.useMutation<SetVenueBankAccountMutation, SetVenueBankAccountMutationVariables>(SetVenueBankAccountDocument);
};
export const VenueBillingDocument = /*#__PURE__*/ gql`
    query VenueBilling($venueId: String!) {
  venue(id: $venueId) {
    id
    bankAccounts {
      ...BankAccount
    }
    defaultBankAccount {
      ...BankAccount
    }
  }
}
    ${BankAccountFragmentDoc}`;

export function useVenueBillingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<VenueBillingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<VenueBillingQuery, VenueBillingQueryVariables>({ query: VenueBillingDocument, ...options });
};
export const DiscoverPageDocument = /*#__PURE__*/ gql`
    query DiscoverPage {
  discoverPage {
    name
    category
    subgenres
    artists {
      id
      slug
      name
      profileImage {
        publicCloudinaryId
        height
        width
      }
      numberOfReviews
      avgRating
      displayPriceRange {
        high
        low
      }
    }
  }
}
    `;

export function useDiscoverPageQuery(options?: Omit<Urql.UseQueryArgs<DiscoverPageQueryVariables>, 'query'>) {
  return Urql.useQuery<DiscoverPageQuery, DiscoverPageQueryVariables>({ query: DiscoverPageDocument, ...options });
};
export const UploadImageDocument = /*#__PURE__*/ gql`
    mutation UploadImage($imageBytes: String!) {
  uploadImage(imageBytes: $imageBytes) {
    url
    height
    width
    public_cloudinary_id: publicCloudinaryId
  }
}
    `;

export function useUploadImageMutation() {
  return Urql.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument);
};
export const ViewNotificationDocument = /*#__PURE__*/ gql`
    mutation ViewNotification($trackingUrl: String!, $pushTrackingEvent: PushTrackingEvent!) {
  trackPushNotificationEvent(
    trackingUrl: $trackingUrl
    pushTrackingEvent: $pushTrackingEvent
  )
}
    `;

export function useViewNotificationMutation() {
  return Urql.useMutation<ViewNotificationMutation, ViewNotificationMutationVariables>(ViewNotificationDocument);
};
export const SetExpoDeviceDocument = /*#__PURE__*/ gql`
    mutation SetExpoDevice($deviceName: String!, $token: String!) {
  setDevice(deviceName: $deviceName, notificationToken: $token)
}
    `;

export function useSetExpoDeviceMutation() {
  return Urql.useMutation<SetExpoDeviceMutation, SetExpoDeviceMutationVariables>(SetExpoDeviceDocument);
};
export const UnsetExpoDeviceDocument = /*#__PURE__*/ gql`
    mutation UnsetExpoDevice($deviceName: String!) {
  unsetDevice(deviceName: $deviceName)
}
    `;

export function useUnsetExpoDeviceMutation() {
  return Urql.useMutation<UnsetExpoDeviceMutation, UnsetExpoDeviceMutationVariables>(UnsetExpoDeviceDocument);
};
export const BuyerBookingConfirmationNoteDocument = /*#__PURE__*/ gql`
    query BuyerBookingConfirmationNote($id: String!) {
  bookingRequest(id: $id) {
    ...BookingRequest
    booking {
      id
    }
  }
}
    ${BookingRequestFragmentDoc}`;

export function useBuyerBookingConfirmationNoteQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BuyerBookingConfirmationNoteQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BuyerBookingConfirmationNoteQuery, BuyerBookingConfirmationNoteQueryVariables>({ query: BuyerBookingConfirmationNoteDocument, ...options });
};
export const SmallArtistForAdminDropdownDocument = /*#__PURE__*/ gql`
    query SmallArtistForAdminDropdown($slug: String!) {
  artist(slug: $slug) {
    ...AdminBookingRequestArtist
  }
}
    ${AdminBookingRequestArtistFragmentDoc}`;

export function useSmallArtistForAdminDropdownQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SmallArtistForAdminDropdownQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SmallArtistForAdminDropdownQuery, SmallArtistForAdminDropdownQueryVariables>({ query: SmallArtistForAdminDropdownDocument, ...options });
};
export const IpAddressDocument = /*#__PURE__*/ gql`
    query IpAddress {
  ipAddress: getIpInfo {
    stateAbbr
    countryAbbr
  }
}
    `;

export function useIpAddressQuery(options?: Omit<Urql.UseQueryArgs<IpAddressQueryVariables>, 'query'>) {
  return Urql.useQuery<IpAddressQuery, IpAddressQueryVariables>({ query: IpAddressDocument, ...options });
};
export const MyArtistIdsDocument = /*#__PURE__*/ gql`
    query MyArtistIds {
  myArtists {
    id
    slug
  }
}
    `;

export function useMyArtistIdsQuery(options?: Omit<Urql.UseQueryArgs<MyArtistIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<MyArtistIdsQuery, MyArtistIdsQueryVariables>({ query: MyArtistIdsDocument, ...options });
};
export const CreateUserDocument = /*#__PURE__*/ gql`
    mutation CreateUser($input: UserInput!, $signUpMessage: String) {
  createUser(input: $input, signUpMessage: $signUpMessage) {
    ...MyAccount
    bookingPreferences {
      ...BuyerBookingPreference
    }
  }
}
    ${MyAccountFragmentDoc}
${BuyerBookingPreferenceFragmentDoc}`;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const MeDocument = /*#__PURE__*/ gql`
    query Me {
  me {
    ... on User {
      ...MyAccount
    }
    ... on UserDoesNotExist {
      exists
      __typename
    }
  }
}
    ${MyAccountFragmentDoc}`;

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
};
export const ArtistMetricsDocument = /*#__PURE__*/ gql`
    query ArtistMetrics($slug: String!, $sortBy: SortBy!) {
  artist(slug: $slug) {
    id
    slug
    name
    likeCount
    viewCount
    avgRating
    numberOfReviews
    profile_image: profileImage {
      public_cloudinary_id: publicCloudinaryId
    }
  }
  artistMetrics(artistSlug: $slug) {
    revenue {
      ...BarChartMetric
    }
    bookingsCount {
      ...BarChartMetric
    }
  }
  artistBookingsByVenue(artistSlug: $slug, sortBy: $sortBy) {
    revenue
    bookingsCount
    venueName
    venueType
    venueId
    location {
      city
      stateAbbr
    }
  }
  artistBookingsByCity(artistSlug: $slug, sortBy: $sortBy) {
    revenue
    bookingsCount
    cityName
    sampleLocation {
      stateAbbr
      countryId
    }
  }
  artistBookingsByBuyerType(artistSlug: $slug, sortBy: $sortBy) {
    buyerUserType
    revenue
    bookingsCount
  }
  artistBookingsUpcoming(artistSlug: $slug) {
    confirmed {
      revenue
      bookingsCount
    }
    pending {
      revenue
      bookingsCount
    }
  }
  artistGamificationMetrics(artistSlug: $slug) {
    likeCount {
      ...GamificationMetric
    }
    viewCount {
      ...GamificationMetric
    }
    avgRating {
      ...GamificationMetric
    }
    numberOfReviews {
      ...GamificationMetric
    }
    avgRating {
      ...GamificationMetric
    }
    bookingsCount {
      ...GamificationMetric
    }
    responseTimeMins {
      ...GamificationMetric
    }
    responseRate {
      ...GamificationMetric
    }
    cancellationsCount {
      ...GamificationMetric
    }
    cancellationRate {
      ...GamificationMetric
    }
  }
}
    ${BarChartMetricFragmentDoc}
${GamificationMetricFragmentDoc}`;

export function useArtistMetricsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistMetricsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistMetricsQuery, ArtistMetricsQueryVariables>({ query: ArtistMetricsDocument, ...options });
};
export const CreateArtistDocument = /*#__PURE__*/ gql`
    mutation CreateArtist($name: String!, $spotifyId: String) {
  createArtist(name: $name, spotifyId: $spotifyId) {
    id
    slug
  }
}
    `;

export function useCreateArtistMutation() {
  return Urql.useMutation<CreateArtistMutation, CreateArtistMutationVariables>(CreateArtistDocument);
};
export const SpotifyArtistDocument = /*#__PURE__*/ gql`
    query SpotifyArtist($id: String!) {
  spotifyArtistFromId(id: $id) {
    ...SpotifyArtist
  }
}
    ${SpotifyArtistFragmentDoc}`;

export function useSpotifyArtistQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SpotifyArtistQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SpotifyArtistQuery, SpotifyArtistQueryVariables>({ query: SpotifyArtistDocument, ...options });
};
export const NewArtistSplashMyArtistsDocument = /*#__PURE__*/ gql`
    query NewArtistSplashMyArtists {
  myArtists {
    id
    slug
    name
    profileImage {
      publicCloudinaryId
    }
  }
}
    `;

export function useNewArtistSplashMyArtistsQuery(options?: Omit<Urql.UseQueryArgs<NewArtistSplashMyArtistsQueryVariables>, 'query'>) {
  return Urql.useQuery<NewArtistSplashMyArtistsQuery, NewArtistSplashMyArtistsQueryVariables>({ query: NewArtistSplashMyArtistsDocument, ...options });
};
export const SpotifyArtistsDocument = /*#__PURE__*/ gql`
    query SpotifyArtists($name: String!) {
  artists: spotifyArtistsFromName(name: $name) {
    ...SpotifyArtist
  }
}
    ${SpotifyArtistFragmentDoc}`;

export function useSpotifyArtistsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SpotifyArtistsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SpotifyArtistsQuery, SpotifyArtistsQueryVariables>({ query: SpotifyArtistsDocument, ...options });
};
export const UpdateArtistBioDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistBio($artistId: String!, $bio: String!) {
  updateArtist(artistId: $artistId, patch: {bio: $bio}) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistBioMutation() {
  return Urql.useMutation<UpdateArtistBioMutation, UpdateArtistBioMutationVariables>(UpdateArtistBioDocument);
};
export const UpdateArtistCategoryDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistCategory($artistId: String!, $category: Category!) {
  updateArtist(artistId: $artistId, patch: {category: $category}) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistCategoryMutation() {
  return Urql.useMutation<UpdateArtistCategoryMutation, UpdateArtistCategoryMutationVariables>(UpdateArtistCategoryDocument);
};
export const UpdateArtistContactDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistContact($artistId: String!, $contactInformation: ContactInformationInput!) {
  updateArtist(
    artistId: $artistId
    patch: {contactInformation: $contactInformation}
  ) {
    ...Artist
    contactInformation {
      email
      phoneNumber
      name
    }
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistContactMutation() {
  return Urql.useMutation<UpdateArtistContactMutation, UpdateArtistContactMutationVariables>(UpdateArtistContactDocument);
};
export const ArtistContactInfoDocument = /*#__PURE__*/ gql`
    query ArtistContactInfo($slug: String!) {
  artist(slug: $slug) {
    ...Artist
    contactInformation {
      email
      phoneNumber
      name
    }
  }
}
    ${ArtistFragmentDoc}`;

export function useArtistContactInfoQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistContactInfoQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistContactInfoQuery, ArtistContactInfoQueryVariables>({ query: ArtistContactInfoDocument, ...options });
};
export const UpdateArtistGenresDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistGenres($artistId: String!, $subgenres: [String!]!) {
  updateArtist(artistId: $artistId, patch: {subgenres: $subgenres}) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistGenresMutation() {
  return Urql.useMutation<UpdateArtistGenresMutation, UpdateArtistGenresMutationVariables>(UpdateArtistGenresDocument);
};
export const UpdateArtistLocationDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistLocation($artistId: String!, $location: LocationInput!) {
  updateArtist(artistId: $artistId, patch: {location: $location}) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistLocationMutation() {
  return Urql.useMutation<UpdateArtistLocationMutation, UpdateArtistLocationMutationVariables>(UpdateArtistLocationDocument);
};
export const UpdateArtistImagesDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistImages($artistId: String!, $images: [ImageInput!]!) {
  updateArtistImages(artistId: $artistId, images: $images) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistImagesMutation() {
  return Urql.useMutation<UpdateArtistImagesMutation, UpdateArtistImagesMutationVariables>(UpdateArtistImagesDocument);
};
export const UpdateArtistSongsDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistSongs($artistId: String!, $songs: SongsInput!) {
  updateArtistSongs(artistId: $artistId, songs: $songs) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistSongsMutation() {
  return Urql.useMutation<UpdateArtistSongsMutation, UpdateArtistSongsMutationVariables>(UpdateArtistSongsDocument);
};
export const UpdateArtistVideosDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistVideos($artistId: String!, $videos: VideosInput!) {
  updateArtistVideos(artistId: $artistId, videos: $videos) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistVideosMutation() {
  return Urql.useMutation<UpdateArtistVideosMutation, UpdateArtistVideosMutationVariables>(UpdateArtistVideosDocument);
};
export const UpdateMultipleBandConifgsDocument = /*#__PURE__*/ gql`
    mutation UpdateMultipleBandConifgs($artistId: String!, $bandConfig: BandConfigInput!) {
  updateArtist(artistId: $artistId, patch: {bandConfiguration: $bandConfig}) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateMultipleBandConifgsMutation() {
  return Urql.useMutation<UpdateMultipleBandConifgsMutation, UpdateMultipleBandConifgsMutationVariables>(UpdateMultipleBandConifgsDocument);
};
export const UpdateSinglePriceDocument = /*#__PURE__*/ gql`
    mutation UpdateSinglePrice($artistId: String!, $patch: ConfigInfoInput!) {
  updateArtist(
    artistId: $artistId
    patch: {bandConfiguration: {unspecified: $patch}}
  ) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateSinglePriceMutation() {
  return Urql.useMutation<UpdateSinglePriceMutation, UpdateSinglePriceMutationVariables>(UpdateSinglePriceDocument);
};
export const UpdateArtistProfileDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistProfile($artistId: String!, $name: String!, $profileImage: ImageInput, $coverImage: ImageInput) {
  updateArtist(
    artistId: $artistId
    patch: {name: $name, profileImage: $profileImage, coverImage: $coverImage}
  ) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistProfileMutation() {
  return Urql.useMutation<UpdateArtistProfileMutation, UpdateArtistProfileMutationVariables>(UpdateArtistProfileDocument);
};
export const UpdateArtistSlugDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistSlug($artistId: String!, $slug: String!) {
  updateArtist(artistId: $artistId, patch: {slug: $slug}) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistSlugMutation() {
  return Urql.useMutation<UpdateArtistSlugMutation, UpdateArtistSlugMutationVariables>(UpdateArtistSlugDocument);
};
export const UpdateArtistSocialMediaDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistSocialMedia($socialMedia: SocialMediaInput!, $artistId: String!) {
  updateArtist(artistId: $artistId, patch: {socialMedia: $socialMedia}) {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;

export function useUpdateArtistSocialMediaMutation() {
  return Urql.useMutation<UpdateArtistSocialMediaMutation, UpdateArtistSocialMediaMutationVariables>(UpdateArtistSocialMediaDocument);
};
export const InputArtistDocument = /*#__PURE__*/ gql`
    query InputArtist($slug: String!) {
  artist(slug: $slug) {
    ...Artist
    contactInformation {
      phoneNumber
      email
      name
    }
  }
}
    ${ArtistFragmentDoc}`;

export function useInputArtistQuery(options: RequireFields<Omit<Urql.UseQueryArgs<InputArtistQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<InputArtistQuery, InputArtistQueryVariables>({ query: InputArtistDocument, ...options });
};
export const ArtistAvailabilityAdminDocument = /*#__PURE__*/ gql`
    query ArtistAvailabilityAdmin($id: UUID!) {
  artistAvailability(id: $id) {
    ...ArtistAvailabilityAdmin
  }
}
    ${ArtistAvailabilityAdminFragmentDoc}`;

export function useArtistAvailabilityAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistAvailabilityAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistAvailabilityAdminQuery, ArtistAvailabilityAdminQueryVariables>({ query: ArtistAvailabilityAdminDocument, ...options });
};
export const CreateArtistAvailabilityCheckDocument = /*#__PURE__*/ gql`
    mutation CreateArtistAvailabilityCheck($artistId: UUID!, $artistAvailabilityId: UUID!) {
  createArtistAvailabilityCheck(
    artistId: $artistId
    artistAvailabilityId: $artistAvailabilityId
  ) {
    ...ArtistAvailabilityCheckAdmin
  }
}
    ${ArtistAvailabilityCheckAdminFragmentDoc}`;

export function useCreateArtistAvailabilityCheckMutation() {
  return Urql.useMutation<CreateArtistAvailabilityCheckMutation, CreateArtistAvailabilityCheckMutationVariables>(CreateArtistAvailabilityCheckDocument);
};
export const ArtistAvailabilityCheckDetailSellerDocument = /*#__PURE__*/ gql`
    query ArtistAvailabilityCheckDetailSeller($checkId: UUID!) {
  artistAvailabilityCheck(id: $checkId) {
    ...ArtistAvailabilityCheck
  }
}
    ${ArtistAvailabilityCheckFragmentDoc}`;

export function useArtistAvailabilityCheckDetailSellerQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistAvailabilityCheckDetailSellerQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistAvailabilityCheckDetailSellerQuery, ArtistAvailabilityCheckDetailSellerQueryVariables>({ query: ArtistAvailabilityCheckDetailSellerDocument, ...options });
};
export const GiveArtistAvailabilityDocument = /*#__PURE__*/ gql`
    mutation GiveArtistAvailability($checkId: UUID!, $response: ArtistAvailabilityResponse!, $responseMessage: String) {
  giveArtistAvailability(
    artistAvailabilityCheckId: $checkId
    response: $response
    responseMessage: $responseMessage
  ) {
    ...ArtistAvailabilityCheck
  }
}
    ${ArtistAvailabilityCheckFragmentDoc}`;

export function useGiveArtistAvailabilityMutation() {
  return Urql.useMutation<GiveArtistAvailabilityMutation, GiveArtistAvailabilityMutationVariables>(GiveArtistAvailabilityDocument);
};
export const BookingCancellationRequestsDocument = /*#__PURE__*/ gql`
    query BookingCancellationRequests($offset: Int!, $limit: Int!, $cancellationRequestUserRole: [UserRole!]!, $startTimeMin: DateTime!, $notStatusV2: [BookingStatusV2!]!) {
  bookings(
    cancellationRequested: true
    limit: $limit
    offset: $offset
    cancellationRequestUserRoles: $cancellationRequestUserRole
    startTimeMin: $startTimeMin
    notStatusesV2: $notStatusV2
    orderBy: created_at
    direction: desc
  ) {
    id
    statusV2
    artistName
    artistSlug
    artistId
    buyerName
    buyerSlug
    venueName
    venueSlug
    buyerMetadata {
      organization
      location
    }
    cancellationRequests {
      ...CancellationRequest
    }
    artistAvailability {
      ...ArtistAvailabilityAdmin
    }
    artist {
      id
      profileImage {
        public_cloudinary_id: publicCloudinaryId
      }
      slug
    }
    firebaseId
    startTime
    location {
      timezone
    }
    cancellationRequested
    cancellationMessage
  }
}
    ${CancellationRequestFragmentDoc}
${ArtistAvailabilityAdminFragmentDoc}`;

export function useBookingCancellationRequestsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingCancellationRequestsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingCancellationRequestsQuery, BookingCancellationRequestsQueryVariables>({ query: BookingCancellationRequestsDocument, ...options });
};
export const ResolveCancellationRequestDocument = /*#__PURE__*/ gql`
    mutation ResolveCancellationRequest($id: String!) {
  resolveCancellationRequest(id: $id) {
    ...CancellationRequest
  }
}
    ${CancellationRequestFragmentDoc}`;

export function useResolveCancellationRequestMutation() {
  return Urql.useMutation<ResolveCancellationRequestMutation, ResolveCancellationRequestMutationVariables>(ResolveCancellationRequestDocument);
};
export const BookingConfirmationsAdminDocument = /*#__PURE__*/ gql`
    query BookingConfirmationsAdmin($offset: Int!, $limit: Int!, $filter: FilterBooking!, $order: OrderBooking!) {
  bookingsViaFilter(
    offset: $offset
    limit: $limit
    filter: $filter
    order: $order
  ) {
    ...AdminBooking
    confirmation {
      ...BookingConfirmation
    }
  }
}
    ${AdminBookingFragmentDoc}
${BookingConfirmationFragmentDoc}`;

export function useBookingConfirmationsAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingConfirmationsAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingConfirmationsAdminQuery, BookingConfirmationsAdminQueryVariables>({ query: BookingConfirmationsAdminDocument, ...options });
};
export const AdminBookingConfirmationsOverviewDocument = /*#__PURE__*/ gql`
    query AdminBookingConfirmationsOverview($startTimeFilter: FilterDateTime!, $filter: [FilterBooking!], $limit: Int!, $offset: Int!) {
  canceled: bookingsViaFilter(
    offset: $offset
    limit: $limit
    filter: {startTime: $startTimeFilter, confirmation: {response: {eq: cancel}}, and: $filter}
  ) {
    id
  }
  confirmed: bookingsViaFilter(
    offset: $offset
    limit: $limit
    filter: {startTime: $startTimeFilter, confirmation: {response: {eq: confirm}}, and: $filter}
  ) {
    id
  }
  pending: bookingsViaFilter(
    offset: $offset
    limit: $limit
    filter: {startTime: $startTimeFilter, confirmation: {exists: false}, and: $filter}
  ) {
    id
  }
}
    `;

export function useAdminBookingConfirmationsOverviewQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminBookingConfirmationsOverviewQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminBookingConfirmationsOverviewQuery, AdminBookingConfirmationsOverviewQueryVariables>({ query: AdminBookingConfirmationsOverviewDocument, ...options });
};
export const MyBookingsToConfirmDocument = /*#__PURE__*/ gql`
    query MyBookingsToConfirm {
  myBookingsToConfirm(includeConfirmed: true) {
    ...Booking
    confirmation {
      ...BookingConfirmation
    }
  }
}
    ${BookingFragmentDoc}
${BookingConfirmationFragmentDoc}`;

export function useMyBookingsToConfirmQuery(options?: Omit<Urql.UseQueryArgs<MyBookingsToConfirmQueryVariables>, 'query'>) {
  return Urql.useQuery<MyBookingsToConfirmQuery, MyBookingsToConfirmQueryVariables>({ query: MyBookingsToConfirmDocument, ...options });
};
export const BookingConfirmationResponseDocument = /*#__PURE__*/ gql`
    mutation BookingConfirmationResponse($bookingId: UUID!, $response: BookingConfirmationResponse!) {
  confirmBooking(bookingId: $bookingId, response: $response) {
    booking {
      ...Booking
      confirmation {
        ...BookingConfirmation
      }
    }
  }
}
    ${BookingFragmentDoc}
${BookingConfirmationFragmentDoc}`;

export function useBookingConfirmationResponseMutation() {
  return Urql.useMutation<BookingConfirmationResponseMutation, BookingConfirmationResponseMutationVariables>(BookingConfirmationResponseDocument);
};
export const UpdateBookingOfferAmountDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingOfferAmount($newBuyerPrice: Float!, $bookingId: String!, $takePercentage: Float) {
  updateLastOfferAmount(
    bookingId: $bookingId
    newBuyerPrice: $newBuyerPrice
    takePercentage: $takePercentage
  ) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useUpdateBookingOfferAmountMutation() {
  return Urql.useMutation<UpdateBookingOfferAmountMutation, UpdateBookingOfferAmountMutationVariables>(UpdateBookingOfferAmountDocument);
};
export const UpdateBookingBuyerPriceDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingBuyerPrice($newBuyerPrice: Float!, $bookingId: String!) {
  updateBuyerPrice(bookingId: $bookingId, newPrice: $newBuyerPrice) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useUpdateBookingBuyerPriceMutation() {
  return Urql.useMutation<UpdateBookingBuyerPriceMutation, UpdateBookingBuyerPriceMutationVariables>(UpdateBookingBuyerPriceDocument);
};
export const UpdateBookingSellerPriceDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingSellerPrice($newSellerPrice: Float!, $bookingId: String!) {
  updateSellerPrice(bookingId: $bookingId, newPrice: $newSellerPrice) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useUpdateBookingSellerPriceMutation() {
  return Urql.useMutation<UpdateBookingSellerPriceMutation, UpdateBookingSellerPriceMutationVariables>(UpdateBookingSellerPriceDocument);
};
export const CreateArtistAvailabilityForBookingDocument = /*#__PURE__*/ gql`
    mutation CreateArtistAvailabilityForBooking($bookingId: UUID!) {
  createArtistAvailability(bookingId: $bookingId) {
    ...ArtistAvailabilityAdmin
  }
}
    ${ArtistAvailabilityAdminFragmentDoc}`;

export function useCreateArtistAvailabilityForBookingMutation() {
  return Urql.useMutation<CreateArtistAvailabilityForBookingMutation, CreateArtistAvailabilityForBookingMutationVariables>(CreateArtistAvailabilityForBookingDocument);
};
export const BookingWithArtistAvailabilityAdminDocument = /*#__PURE__*/ gql`
    query BookingWithArtistAvailabilityAdmin($bookingId: String!) {
  booking(id: $bookingId) {
    ...AdminBooking
    artistAvailability {
      ...ArtistAvailabilityAdmin
    }
    lastSellerOfferAmount
    lastOfferAmount
  }
}
    ${AdminBookingFragmentDoc}
${ArtistAvailabilityAdminFragmentDoc}`;

export function useBookingWithArtistAvailabilityAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingWithArtistAvailabilityAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingWithArtistAvailabilityAdminQuery, BookingWithArtistAvailabilityAdminQueryVariables>({ query: BookingWithArtistAvailabilityAdminDocument, ...options });
};
export const BuyerToSellerPriceDocument = /*#__PURE__*/ gql`
    query BuyerToSellerPrice($buyerOfferAmount: Float!, $bookingFlow: BookingFlow!) {
  buyerToSellerAmount(buyerAmount: $buyerOfferAmount, bookingFlow: $bookingFlow)
}
    `;

export function useBuyerToSellerPriceQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BuyerToSellerPriceQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BuyerToSellerPriceQuery, BuyerToSellerPriceQueryVariables>({ query: BuyerToSellerPriceDocument, ...options });
};
export const ReplaceArtistOnBookingDocument = /*#__PURE__*/ gql`
    mutation ReplaceArtistOnBooking($bookingId: String!, $newArtistId: String!, $cancelOnBehalfOfRole: OnBehalfOfRole!, $notifyBuyers: Boolean!, $notifySellers: Boolean!, $adminCancellationMessage: String, $newOfferAmount: Float!) {
  replaceArtistOnBooking(
    newArtistId: $newArtistId
    bookingId: $bookingId
    cancelOnBehalfOfRole: $cancelOnBehalfOfRole
    notifyBuyers: $notifyBuyers
    notifySellers: $notifySellers
    cancellationMessage: ""
    notifyOldSellers: true
    adminCancellationMessage: $adminCancellationMessage
    newOfferAmount: $newOfferAmount
  ) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useReplaceArtistOnBookingMutation() {
  return Urql.useMutation<ReplaceArtistOnBookingMutation, ReplaceArtistOnBookingMutationVariables>(ReplaceArtistOnBookingDocument);
};
export const BuyerPreferencesFromAdminDocument = /*#__PURE__*/ gql`
    query BuyerPreferencesFromAdmin($firebaseId: String!) {
  user(firebaseId: $firebaseId) {
    ...UserFromAdmin
    bookingPreferences {
      ...BuyerBookingPreference
    }
  }
}
    ${UserFromAdminFragmentDoc}
${BuyerBookingPreferenceFragmentDoc}`;

export function useBuyerPreferencesFromAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BuyerPreferencesFromAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BuyerPreferencesFromAdminQuery, BuyerPreferencesFromAdminQueryVariables>({ query: BuyerPreferencesFromAdminDocument, ...options });
};
export const BuyerBookingPreferencesDocument = /*#__PURE__*/ gql`
    query BuyerBookingPreferences {
  me {
    ... on UserDoesNotExist {
      exists
    }
    ... on User {
      ...MyAccount
      bookingPreferences {
        ...BuyerBookingPreference
      }
    }
  }
}
    ${MyAccountFragmentDoc}
${BuyerBookingPreferenceFragmentDoc}`;

export function useBuyerBookingPreferencesQuery(options?: Omit<Urql.UseQueryArgs<BuyerBookingPreferencesQueryVariables>, 'query'>) {
  return Urql.useQuery<BuyerBookingPreferencesQuery, BuyerBookingPreferencesQueryVariables>({ query: BuyerBookingPreferencesDocument, ...options });
};
export const UpdateBuyerBookingPreferencesDocument = /*#__PURE__*/ gql`
    mutation UpdateBuyerBookingPreferences($responses: [ResponseInput!]!) {
  updateBookingPreferences(responses: $responses) {
    ...BuyerBookingPreference
  }
}
    ${BuyerBookingPreferenceFragmentDoc}`;

export function useUpdateBuyerBookingPreferencesMutation() {
  return Urql.useMutation<UpdateBuyerBookingPreferencesMutation, UpdateBuyerBookingPreferencesMutationVariables>(UpdateBuyerBookingPreferencesDocument);
};
export const GoogleOAuthUrlDocument = /*#__PURE__*/ gql`
    query GoogleOAuthUrl($redirectUri: String!) {
  googleOauthUrl(redirectUri: $redirectUri)
}
    `;

export function useGoogleOAuthUrlQuery(options: RequireFields<Omit<Urql.UseQueryArgs<GoogleOAuthUrlQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<GoogleOAuthUrlQuery, GoogleOAuthUrlQueryVariables>({ query: GoogleOAuthUrlDocument, ...options });
};
export const ExchangeAuthCodeGoogleDocument = /*#__PURE__*/ gql`
    mutation ExchangeAuthCodeGoogle($code: String!, $redirectUri: String!) {
  exchangeAuthCodeGoogle(authCode: $code, redirectUri: $redirectUri)
}
    `;

export function useExchangeAuthCodeGoogleMutation() {
  return Urql.useMutation<ExchangeAuthCodeGoogleMutation, ExchangeAuthCodeGoogleMutationVariables>(ExchangeAuthCodeGoogleDocument);
};
export const CreateVenueDocument = /*#__PURE__*/ gql`
    mutation CreateVenue($venueType: VenueType!, $placeId: String!, $accountExecId: String, $venueName: String) {
  createVenueFromPlaceId(
    venueType: $venueType
    placeId: $placeId
    accountExecId: $accountExecId
    venueName: $venueName
  ) {
    ...Venue
  }
}
    ${VenueFragmentDoc}`;

export function useCreateVenueMutation() {
  return Urql.useMutation<CreateVenueMutation, CreateVenueMutationVariables>(CreateVenueDocument);
};
export const SingleEventPromoDocument = /*#__PURE__*/ gql`
    query SingleEventPromo($bookingId: String!) {
  booking(id: $bookingId) {
    id
    firebaseId
    startTime
    artist {
      name
      profileImage {
        height
        width
        public_cloudinary_id: publicCloudinaryId
      }
      id
      slug
    }
    venue {
      id
      name
      logo {
        height
        width
        public_cloudinary_id: publicCloudinaryId
      }
      location {
        ...Location
      }
    }
  }
}
    ${LocationFragmentDoc}`;

export function useSingleEventPromoQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SingleEventPromoQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SingleEventPromoQuery, SingleEventPromoQueryVariables>({ query: SingleEventPromoDocument, ...options });
};
export const LocationFromPlaceIdDocument = /*#__PURE__*/ gql`
    query LocationFromPlaceId($placeId: String!) {
  locationFromPlaceId(placeId: $placeId) {
    ...LocationCamel
  }
}
    ${LocationCamelFragmentDoc}`;

export function useLocationFromPlaceIdQuery(options: RequireFields<Omit<Urql.UseQueryArgs<LocationFromPlaceIdQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<LocationFromPlaceIdQuery, LocationFromPlaceIdQueryVariables>({ query: LocationFromPlaceIdDocument, ...options });
};
export const StaticallyGeneratedArtistDocument = /*#__PURE__*/ gql`
    query StaticallyGeneratedArtist($slug: String!) {
  artistServerSide(slug: $slug) {
    ... on ArtistNotFoundResponse {
      message
      __typename
    }
    ... on Artist {
      id
      name
      slug
      published
      __typename
      cover_image: coverImage {
        public_cloudinary_id: publicCloudinaryId
        height
        width
        url
        verticalAlign
      }
      profile_image: profileImage {
        public_cloudinary_id: publicCloudinaryId
        height
        width
        url
      }
      media {
        songs {
          soundcloud
          spotify
        }
        videos {
          youtube
        }
        images {
          gallery {
            height
            width
            url
            public_cloudinary_id: publicCloudinaryId
          }
        }
      }
    }
  }
}
    `;

export function useStaticallyGeneratedArtistQuery(options: RequireFields<Omit<Urql.UseQueryArgs<StaticallyGeneratedArtistQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<StaticallyGeneratedArtistQuery, StaticallyGeneratedArtistQueryVariables>({ query: StaticallyGeneratedArtistDocument, ...options });
};
export const PromoApiBookingDocument = /*#__PURE__*/ gql`
    query PromoAPIBooking($bookingId: String!) {
  booking(id: $bookingId) {
    id
    artistId
    startTime
    artist {
      profileImage {
        publicCloudinaryId
      }
    }
  }
}
    `;

export function usePromoApiBookingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<PromoApiBookingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<PromoApiBookingQuery, PromoApiBookingQueryVariables>({ query: PromoApiBookingDocument, ...options });
};
export const SetPlaidAccessTokenDocument = /*#__PURE__*/ gql`
    mutation SetPlaidAccessToken($publicToken: String!, $venueId: String!, $metadataStringified: String!) {
  setPlaidAccessToken(
    venueId: $venueId
    publicToken: $publicToken
    metadataStringified: $metadataStringified
  ) {
    createdBankAccount {
      ...BankAccount
    }
  }
}
    ${BankAccountFragmentDoc}`;

export function useSetPlaidAccessTokenMutation() {
  return Urql.useMutation<SetPlaidAccessTokenMutation, SetPlaidAccessTokenMutationVariables>(SetPlaidAccessTokenDocument);
};
export const PlaidLinkTokenDocument = /*#__PURE__*/ gql`
    query PlaidLinkToken($venueId: String!) {
  plaidLinkToken(venueId: $venueId)
}
    `;

export function usePlaidLinkTokenQuery(options: RequireFields<Omit<Urql.UseQueryArgs<PlaidLinkTokenQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<PlaidLinkTokenQuery, PlaidLinkTokenQueryVariables>({ query: PlaidLinkTokenDocument, ...options });
};
export const GetCodeDocument = /*#__PURE__*/ gql`
    mutation GetCode($phoneNumber: String!) {
  getCodeTestUser(phoneNumber: $phoneNumber)
}
    `;

export function useGetCodeMutation() {
  return Urql.useMutation<GetCodeMutation, GetCodeMutationVariables>(GetCodeDocument);
};
export const GetTokenDocument = /*#__PURE__*/ gql`
    mutation GetToken($phoneNumber: String!, $code: String!) {
  createCustomToken(phoneNumber: $phoneNumber, code: $code)
}
    `;

export function useGetTokenMutation() {
  return Urql.useMutation<GetTokenMutation, GetTokenMutationVariables>(GetTokenDocument);
};
export const LoginDocument = /*#__PURE__*/ gql`
    mutation Login {
  login
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const AdminBookingsListDocument = /*#__PURE__*/ gql`
    query AdminBookingsList($accountExecSlugs: [String!], $artistQueryName: String!, $venueQueryName: String, $bookingFlows: [BookingFlow!], $statuses: [BookingStatusV2!], $hasCharge: Boolean, $hasPayout: Boolean, $limit: Int!, $offset: Int!, $artistSlugs: [String!]!, $venueSlugs: [String!]!) {
  bookings(
    artistQueryName: $artistQueryName
    bookingFlows: $bookingFlows
    orderBy: last_updated
    direction: desc
    statusesV2: $statuses
    hasCharge: $hasCharge
    hasPayout: $hasPayout
    venueQueryName: $venueQueryName
    accountExecSlugs: $accountExecSlugs
    limit: $limit
    offset: $offset
    venueSlugs: $venueSlugs
    artistSlugs: $artistSlugs
  ) {
    id
    firebaseId
    status: statusV2
    display_prices: displayPrices {
      buyer
      seller
    }
    negotiation_steps: negotiationSteps {
      ...NegotiationStep
    }
    status_information: statusInformation {
      ...BookingStatusInformation
    }
    start_time: startTime
    venue_location: location {
      ...Location
    }
    what_should_i_do_alerts: whatShouldIDoAlerts {
      buyer
      seller
    }
    artist {
      id
      name
      slug
      profile_image: profileImage {
        public_cloudinary_id: publicCloudinaryId
      }
    }
    buyer {
      id
      name
      phoneNumber
      email
      firebaseId
      metadata {
        userType
        organization
        location
      }
    }
  }
}
    ${NegotiationStepFragmentDoc}
${BookingStatusInformationFragmentDoc}
${LocationFragmentDoc}`;

export function useAdminBookingsListQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminBookingsListQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminBookingsListQuery, AdminBookingsListQueryVariables>({ query: AdminBookingsListDocument, ...options });
};
export const VenuesFromAdminDocument = /*#__PURE__*/ gql`
    query VenuesFromAdmin($limit: Int!, $offset: Int!, $slugs: [String!]!) {
  venues(limit: $limit, offset: $offset, slugs: $slugs) {
    id
    name
    slug
    logo {
      public_cloudinary_id: publicCloudinaryId
    }
    images {
      public_cloudinary_id: publicCloudinaryId
    }
    name
    location {
      ...Location
    }
    accountExec {
      id
      firebaseId
      name
    }
    owners {
      id
      firebaseId
      name
    }
    budget {
      low
      high
    }
  }
}
    ${LocationFragmentDoc}`;

export function useVenuesFromAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<VenuesFromAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<VenuesFromAdminQuery, VenuesFromAdminQueryVariables>({ query: VenuesFromAdminDocument, ...options });
};
export const AdminCalendarDocument = /*#__PURE__*/ gql`
    query AdminCalendar($startTimeMin: DateTime, $startTimeMax: DateTime, $accountExecSlugs: [String!], $artistQueryName: String, $venueQueryName: String, $bookingFlows: [BookingFlow!], $statuses: [BookingStatusV2!], $hasCharge: Boolean, $hasPayout: Boolean, $limit: Int!, $offset: Int!, $venueSlugs: [String!]!, $artistSlugs: [String!]!) {
  bookings(
    startTimeMin: $startTimeMin
    startTimeMax: $startTimeMax
    artistQueryName: $artistQueryName
    bookingFlows: $bookingFlows
    orderBy: start_time
    statusesV2: $statuses
    hasCharge: $hasCharge
    hasPayout: $hasPayout
    venueQueryName: $venueQueryName
    accountExecSlugs: $accountExecSlugs
    limit: $limit
    offset: $offset
    venueSlugs: $venueSlugs
    artistSlugs: $artistSlugs
  ) {
    id
    firebaseId
    artistName
    venueName
    status: statusV2
    buyerMetadata {
      organization
      location
    }
    performanceLengthMins
    startTime
    location {
      timezone
    }
    charge {
      chargedBuyer
      invoiceId
    }
    payout {
      paidSeller
      transferId
    }
  }
}
    `;

export function useAdminCalendarQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminCalendarQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminCalendarQuery, AdminCalendarQueryVariables>({ query: AdminCalendarDocument, ...options });
};
export const AdminUserScreenDocument = /*#__PURE__*/ gql`
    query AdminUserScreen($firebaseId: String!) {
  user(firebaseId: $firebaseId) {
    ...UserFromAdmin
  }
}
    ${UserFromAdminFragmentDoc}`;

export function useAdminUserScreenQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminUserScreenQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminUserScreenQuery, AdminUserScreenQueryVariables>({ query: AdminUserScreenDocument, ...options });
};
export const AdminUserArtistsDocument = /*#__PURE__*/ gql`
    query AdminUserArtists($firebaseId: String!) {
  user(firebaseId: $firebaseId) {
    id
    artists {
      ...SmallArtist
    }
  }
}
    ${SmallArtistFragmentDoc}`;

export function useAdminUserArtistsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminUserArtistsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminUserArtistsQuery, AdminUserArtistsQueryVariables>({ query: AdminUserArtistsDocument, ...options });
};
export const AdminUserLikesDocument = /*#__PURE__*/ gql`
    query AdminUserLikes($firebaseId: String!) {
  user(firebaseId: $firebaseId) {
    ...UserFromAdmin
    likes {
      timestamp
      artist {
        id
        slug
        name
        profileImage {
          publicCloudinaryId
        }
      }
    }
  }
}
    ${UserFromAdminFragmentDoc}`;

export function useAdminUserLikesQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminUserLikesQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminUserLikesQuery, AdminUserLikesQueryVariables>({ query: AdminUserLikesDocument, ...options });
};
export const AdminUpdateUserDocument = /*#__PURE__*/ gql`
    mutation AdminUpdateUser($id: String!, $patch: UserPatch!) {
  updateUserAdmin(userId: $id, patch: $patch) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useAdminUpdateUserMutation() {
  return Urql.useMutation<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>(AdminUpdateUserDocument);
};
export const AdminUserVenuesDocument = /*#__PURE__*/ gql`
    query AdminUserVenues($firebaseId: String!) {
  user(firebaseId: $firebaseId) {
    ...UserFromAdmin
    venues {
      id
      slug
      name
      location {
        ...LocationCamel
      }
      owners {
        ...User
      }
      accountExec {
        ...User
      }
      images {
        publicCloudinaryId
      }
    }
  }
}
    ${UserFromAdminFragmentDoc}
${LocationCamelFragmentDoc}
${UserFragmentDoc}`;

export function useAdminUserVenuesQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminUserVenuesQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminUserVenuesQuery, AdminUserVenuesQueryVariables>({ query: AdminUserVenuesDocument, ...options });
};
export const AllArtistsDocument = /*#__PURE__*/ gql`
    query AllArtists($limit: Int!, $offset: Int!, $published: Boolean, $slugs: [String!]!) {
  artists(
    limit: $limit
    offset: $offset
    published: $published
    orderBy: last_updated
    direction: desc
    slugs: $slugs
  ) {
    ...Artist
    sellers {
      id
      slug
      firebaseId
      name
    }
  }
}
    ${ArtistFragmentDoc}`;

export function useAllArtistsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AllArtistsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AllArtistsQuery, AllArtistsQueryVariables>({ query: AllArtistsDocument, ...options });
};
export const UserApplicantsFromAdminDocument = /*#__PURE__*/ gql`
    query UserApplicantsFromAdmin($userRoles: [UserRole!], $approved: Boolean, $limit: Int!, $offset: Int!, $publicOrPrivate: PublicOrPrivate, $userTypes: [UserType!]) {
  users(
    userRoles: $userRoles
    approved: $approved
    limit: $limit
    offset: $offset
    publicOrPrivate: $publicOrPrivate
    userTypes: $userTypes
  ) {
    ...UserFromAdmin
  }
}
    ${UserFromAdminFragmentDoc}`;

export function useUserApplicantsFromAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<UserApplicantsFromAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<UserApplicantsFromAdminQuery, UserApplicantsFromAdminQueryVariables>({ query: UserApplicantsFromAdminDocument, ...options });
};
export const ArtistPayoutsDocument = /*#__PURE__*/ gql`
    query ArtistPayouts($slug: String!) {
  artist(slug: $slug) {
    id
    slug
    transfers {
      id
      amount
      currency
      created
      description
      metadata {
        bookingId
      }
    }
  }
}
    `;

export function useArtistPayoutsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistPayoutsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistPayoutsQuery, ArtistPayoutsQueryVariables>({ query: ArtistPayoutsDocument, ...options });
};
export const ArtistReviewsDocument = /*#__PURE__*/ gql`
    query ArtistReviews($slug: String!) {
  artist(slug: $slug) {
    slug
    id
    numberOfReviews
    name
    avgRating
    groupedReviews {
      ...ArtistReview
    }
  }
}
    ${ArtistReviewFragmentDoc}`;

export function useArtistReviewsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistReviewsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistReviewsQuery, ArtistReviewsQueryVariables>({ query: ArtistReviewsDocument, ...options });
};
export const ArtistStatsDocument = /*#__PURE__*/ gql`
    query ArtistStats($slug: String!) {
  artistStats: artistGamificationMetrics(artistSlug: $slug) {
    bookingsCount {
      value
      quality
    }
    cancellationRate {
      value
      quality
    }
    responseRate {
      value
      quality
    }
    responseTimeMins {
      value
      quality
    }
    numberOfReviews {
      value
      quality
    }
  }
}
    `;

export function useArtistStatsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistStatsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistStatsQuery, ArtistStatsQueryVariables>({ query: ArtistStatsDocument, ...options });
};
export const CancelBookingDocument = /*#__PURE__*/ gql`
    mutation CancelBooking($id: String!, $cancellationMessage: String!) {
  cancelBooking(bookingId: $id, cancellationMessage: $cancellationMessage) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useCancelBookingMutation() {
  return Urql.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument);
};
export const CancelBookingAdminDocument = /*#__PURE__*/ gql`
    mutation CancelBookingAdmin($id: String!, $cancellationMessage: String!, $notifyBuyers: Boolean!, $notifySellers: Boolean!, $onBehalfOfRole: OnBehalfOfRole!, $adminCancellationMessage: String) {
  cancelBookingAdmin(
    bookingId: $id
    cancellationMessage: $cancellationMessage
    notifyBuyers: $notifyBuyers
    notifySellers: $notifySellers
    onBehalfOfRole: $onBehalfOfRole
    adminCancellationMessage: $adminCancellationMessage
  ) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useCancelBookingAdminMutation() {
  return Urql.useMutation<CancelBookingAdminMutation, CancelBookingAdminMutationVariables>(CancelBookingAdminDocument);
};
export const MyBookingsListDocument = /*#__PURE__*/ gql`
    query MyBookingsList($direction: Dir!, $orderBy: BookingOrderBy!, $startTimeMax: DateTime!, $startTimeMin: DateTime!, $limit: Int!, $offset: Int!) {
  myBookings(
    orderBy: $orderBy
    direction: $direction
    startTimeMax: $startTimeMax
    startTimeMin: $startTimeMin
    limit: $limit
    offset: $offset
    notStatusesV2: [canceled, declined]
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useMyBookingsListQuery(options: RequireFields<Omit<Urql.UseQueryArgs<MyBookingsListQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<MyBookingsListQuery, MyBookingsListQueryVariables>({ query: MyBookingsListDocument, ...options });
};
export const MyExternalCalendarEventsDocument = /*#__PURE__*/ gql`
    query MyExternalCalendarEvents($startTimeMin: DateTime!, $startTimeMax: DateTime!) {
  myExternalCalendarEvents(startTime: $startTimeMin, endTime: $startTimeMax) {
    ...ExternalCalendarEvent
  }
}
    ${ExternalCalendarEventFragmentDoc}`;

export function useMyExternalCalendarEventsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<MyExternalCalendarEventsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<MyExternalCalendarEventsQuery, MyExternalCalendarEventsQueryVariables>({ query: MyExternalCalendarEventsDocument, ...options });
};
export const CalendarScreenDocument = /*#__PURE__*/ gql`
    query CalendarScreen($venueSlugs: [String!], $startTimeMin: DateTime!, $startTimeMax: DateTime!, $limit: Int!, $offset: Int!) {
  myBookings(
    startTimeMin: $startTimeMin
    startTimeMax: $startTimeMax
    notStatusesV2: [canceled, declined]
    venueSlugs: $venueSlugs
    limit: $limit
    offset: $offset
    orderBy: start_time
    direction: asc
  ) {
    ...CalendarBooking
  }
  myExternalBookings(
    startTimeMin: $startTimeMin
    startTimeMax: $startTimeMax
    venueSlugs: $venueSlugs
  ) {
    ...CalendarExternalBooking
  }
  myBookingRequests(
    startTimeMin: $startTimeMin
    startTimeMax: $startTimeMax
    venueSlugs: $venueSlugs
    statuses: pending
    limit: $limit
    offset: $offset
    orderBy: start_time
    direction: asc
  ) {
    ...CalendarBookingRequest
  }
}
    ${CalendarBookingFragmentDoc}
${CalendarExternalBookingFragmentDoc}
${CalendarBookingRequestFragmentDoc}`;

export function useCalendarScreenQuery(options: RequireFields<Omit<Urql.UseQueryArgs<CalendarScreenQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<CalendarScreenQuery, CalendarScreenQueryVariables>({ query: CalendarScreenDocument, ...options });
};
export const SyncdExternalCalendarDocument = /*#__PURE__*/ gql`
    query SyncdExternalCalendar {
  me {
    ... on User {
      ...MyAccount
      hasSyncedCalendar
      id
      firebaseId
    }
    ... on UserDoesNotExist {
      exists
    }
  }
}
    ${MyAccountFragmentDoc}`;

export function useSyncdExternalCalendarQuery(options?: Omit<Urql.UseQueryArgs<SyncdExternalCalendarQueryVariables>, 'query'>) {
  return Urql.useQuery<SyncdExternalCalendarQuery, SyncdExternalCalendarQueryVariables>({ query: SyncdExternalCalendarDocument, ...options });
};
export const CreateBookingDocument = /*#__PURE__*/ gql`
    mutation CreateBooking($bookingFlow: BookingFlow!, $booking: BookingInput!, $artistId: String!, $startTimes: [DateTime!]!, $offerAmount: Float!, $venueId: String, $venueLocationInput: LocationInput!) {
  createBookingsBuyer(
    input: $booking
    artistId: $artistId
    offerAmount: $offerAmount
    startTimes: $startTimes
    bookingFlow: $bookingFlow
    venueId: $venueId
    venueLocationInput: $venueLocationInput
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useCreateBookingMutation() {
  return Urql.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument);
};
export const CreateExternalBookingDocument = /*#__PURE__*/ gql`
    mutation CreateExternalBooking($venueId: String!, $input: ExternalBookingInput!) {
  createExternalBooking(venueId: $venueId, input: $input) {
    ...ExternalBooking
  }
}
    ${ExternalBookingFragmentDoc}`;

export function useCreateExternalBookingMutation() {
  return Urql.useMutation<CreateExternalBookingMutation, CreateExternalBookingMutationVariables>(CreateExternalBookingDocument);
};
export const ArtistPerformanceDataInputDocument = /*#__PURE__*/ gql`
    query ArtistPerformanceDataInput($slug: String, $id: String) {
  artist(slug: $slug, id: $id) {
    id
    name
    slug
    performanceData {
      id
      songsTxt
    }
  }
}
    `;

export function useArtistPerformanceDataInputQuery(options?: Omit<Urql.UseQueryArgs<ArtistPerformanceDataInputQueryVariables>, 'query'>) {
  return Urql.useQuery<ArtistPerformanceDataInputQuery, ArtistPerformanceDataInputQueryVariables>({ query: ArtistPerformanceDataInputDocument, ...options });
};
export const UpdateArtistSongsCoveredDocument = /*#__PURE__*/ gql`
    mutation UpdateArtistSongsCovered($id: String!, $songsTxt: String!) {
  updateArtistPerformanceDataSongs(artistId: $id, songsTxt: $songsTxt) {
    id
    songsTxt
    songs
  }
}
    `;

export function useUpdateArtistSongsCoveredMutation() {
  return Urql.useMutation<UpdateArtistSongsCoveredMutation, UpdateArtistSongsCoveredMutationVariables>(UpdateArtistSongsCoveredDocument);
};
export const UpdateBookingDocument = /*#__PURE__*/ gql`
    mutation UpdateBooking($patch: BookingPatch!, $ids: [String!]!, $notifySellers: Boolean) {
  updateBookings(patch: $patch, bookingIds: $ids, notifySellers: $notifySellers) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useUpdateBookingMutation() {
  return Urql.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument);
};
export const DeleteExternalBookingDocument = /*#__PURE__*/ gql`
    mutation DeleteExternalBooking($id: String!) {
  deleteExternalBooking(externalBookingId: $id) {
    ...ExternalBooking
  }
}
    ${ExternalBookingFragmentDoc}`;

export function useDeleteExternalBookingMutation() {
  return Urql.useMutation<DeleteExternalBookingMutation, DeleteExternalBookingMutationVariables>(DeleteExternalBookingDocument);
};
export const InputExternalBookingDocument = /*#__PURE__*/ gql`
    query InputExternalBooking($id: String!) {
  externalBooking(id: $id) {
    id
    startTime
    performanceLengthMins
    isPublished
    coverImage {
      ...ImageCamel
    }
    artistName
    publicEventDescription
    indoorsOrOutdoors
    venue {
      ...Venue
    }
  }
}
    ${ImageCamelFragmentDoc}
${VenueFragmentDoc}`;

export function useInputExternalBookingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<InputExternalBookingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<InputExternalBookingQuery, InputExternalBookingQueryVariables>({ query: InputExternalBookingDocument, ...options });
};
export const UpdateExternalBookingDocument = /*#__PURE__*/ gql`
    mutation UpdateExternalBooking($id: String!, $patch: ExternalBookingPatch!) {
  updateExternalBooking(externalBookingId: $id, patch: $patch) {
    ...ExternalBooking
  }
}
    ${ExternalBookingFragmentDoc}`;

export function useUpdateExternalBookingMutation() {
  return Urql.useMutation<UpdateExternalBookingMutation, UpdateExternalBookingMutationVariables>(UpdateExternalBookingDocument);
};
export const UpdateVenueDocument = /*#__PURE__*/ gql`
    mutation UpdateVenue($venueId: String!, $patch: VenuePatch!) {
  updateVenue(venueId: $venueId, patch: $patch) {
    ...Venue
  }
}
    ${VenueFragmentDoc}`;

export function useUpdateVenueMutation() {
  return Urql.useMutation<UpdateVenueMutation, UpdateVenueMutationVariables>(UpdateVenueDocument);
};
export const InputVenueDocument = /*#__PURE__*/ gql`
    query InputVenue($slug: String!, $cacheIgnorer: String) {
  venue(slug: $slug, frontendCacheIgnorer: $cacheIgnorer) {
    id
    budget {
      low
      high
    }
    logo {
      ...ImageCamel
    }
    images {
      ...ImageCamel
    }
    description
    name
    venueType
    numStages
    socialMedia {
      facebook
      instagram
      youtube
      twitter
    }
    capacity
    productionAndVenueSpecs
    parkingAndLoadingAccess
    genresBooked
    website
    location {
      ...LocationCamel
    }
  }
}
    ${ImageCamelFragmentDoc}
${LocationCamelFragmentDoc}`;

export function useInputVenueQuery(options: RequireFields<Omit<Urql.UseQueryArgs<InputVenueQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<InputVenueQuery, InputVenueQueryVariables>({ query: InputVenueDocument, ...options });
};
export const VenueInvoicesDocument = /*#__PURE__*/ gql`
    query VenueInvoices($venueId: String!) {
  venue(id: $venueId) {
    id
    invoices {
      created
      customerName
      status
      paid
      amountDue
      hostedInvoiceUrl
      invoicePdf
      id
    }
  }
}
    `;

export function useVenueInvoicesQuery(options: RequireFields<Omit<Urql.UseQueryArgs<VenueInvoicesQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<VenueInvoicesQuery, VenueInvoicesQueryVariables>({ query: VenueInvoicesDocument, ...options });
};
export const BookingPreviewDocument = /*#__PURE__*/ gql`
    query BookingPreview($id: String!) {
  booking(id: $id) {
    ...PublicBooking
    location {
      ...LocationCamel
    }
    venueName
    venueSlug
    artist {
      id
      subgenres
      slug
    }
  }
}
    ${PublicBookingFragmentDoc}
${LocationCamelFragmentDoc}`;

export function useBookingPreviewQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingPreviewQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingPreviewQuery, BookingPreviewQueryVariables>({ query: BookingPreviewDocument, ...options });
};
export const EditUserProfileImageDocument = /*#__PURE__*/ gql`
    mutation EditUserProfileImage($profileImage: ImageInput!) {
  updateUser(patch: {profileImage: $profileImage}) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useEditUserProfileImageMutation() {
  return Urql.useMutation<EditUserProfileImageMutation, EditUserProfileImageMutationVariables>(EditUserProfileImageDocument);
};
export const BadgeCountDocument = /*#__PURE__*/ gql`
    query BadgeCount {
  myBadges {
    ...Badges
  }
}
    ${BadgesFragmentDoc}`;

export function useBadgeCountQuery(options?: Omit<Urql.UseQueryArgs<BadgeCountQueryVariables>, 'query'>) {
  return Urql.useQuery<BadgeCountQuery, BadgeCountQueryVariables>({ query: BadgeCountDocument, ...options });
};
export const BookingSearchKeyDocument = /*#__PURE__*/ gql`
    query BookingSearchKey {
  bookingsSearchKey
}
    `;

export function useBookingSearchKeyQuery(options?: Omit<Urql.UseQueryArgs<BookingSearchKeyQueryVariables>, 'query'>) {
  return Urql.useQuery<BookingSearchKeyQuery, BookingSearchKeyQueryVariables>({ query: BookingSearchKeyDocument, ...options });
};
export const TypesenseArtistApiKeyDocument = /*#__PURE__*/ gql`
    query TypesenseArtistApiKey($userFirebaseId: String) {
  artistSearchKey(userFirebaseId: $userFirebaseId)
}
    `;

export function useTypesenseArtistApiKeyQuery(options?: Omit<Urql.UseQueryArgs<TypesenseArtistApiKeyQueryVariables>, 'query'>) {
  return Urql.useQuery<TypesenseArtistApiKeyQuery, TypesenseArtistApiKeyQueryVariables>({ query: TypesenseArtistApiKeyDocument, ...options });
};
export const ArtistPublishedDocument = /*#__PURE__*/ gql`
    query ArtistPublished($id: String!) {
  artist(id: $id) {
    id
    name
    published
    slug
  }
}
    `;

export function useArtistPublishedQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ArtistPublishedQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ArtistPublishedQuery, ArtistPublishedQueryVariables>({ query: ArtistPublishedDocument, ...options });
};
export const AdvanceBookingDocument = /*#__PURE__*/ gql`
    mutation AdvanceBooking($bookingId: String!, $notifySellers: Boolean!, $notifyBuyers: Boolean!) {
  advanceBooking(
    bookingId: $bookingId
    notifySellers: $notifySellers
    notifyBuyers: $notifyBuyers
  ) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useAdvanceBookingMutation() {
  return Urql.useMutation<AdvanceBookingMutation, AdvanceBookingMutationVariables>(AdvanceBookingDocument);
};
export const MarkChargedBuyerDocument = /*#__PURE__*/ gql`
    mutation MarkChargedBuyer($bookingId: String!, $undo: Boolean!) {
  markBookingAsCharged(bookingId: $bookingId, undo: $undo) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useMarkChargedBuyerMutation() {
  return Urql.useMutation<MarkChargedBuyerMutation, MarkChargedBuyerMutationVariables>(MarkChargedBuyerDocument);
};
export const ChargeBuyerDocument = /*#__PURE__*/ gql`
    mutation ChargeBuyer($bookingId: String!) {
  chargeBooking(bookingId: $bookingId) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useChargeBuyerMutation() {
  return Urql.useMutation<ChargeBuyerMutation, ChargeBuyerMutationVariables>(ChargeBuyerDocument);
};
export const MarkPaidOutDocument = /*#__PURE__*/ gql`
    mutation MarkPaidOut($bookingId: String!, $undo: Boolean!) {
  markBookingAsPaidOut(bookingId: $bookingId, undo: $undo) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useMarkPaidOutMutation() {
  return Urql.useMutation<MarkPaidOutMutation, MarkPaidOutMutationVariables>(MarkPaidOutDocument);
};
export const PayoutSellerDocument = /*#__PURE__*/ gql`
    mutation PayoutSeller($bookingId: String!) {
  payoutBooking(bookingId: $bookingId) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function usePayoutSellerMutation() {
  return Urql.useMutation<PayoutSellerMutation, PayoutSellerMutationVariables>(PayoutSellerDocument);
};
export const AdminBookingRequestsListDocument = /*#__PURE__*/ gql`
    query AdminBookingRequestsList($orderBy: BookingRequestOrderBy!, $direction: Dir!, $offset: Int!, $limit: Int!, $venueSlugs: [String!]) {
  bookingRequests(
    orderBy: $orderBy
    direction: $direction
    offset: $offset
    limit: $limit
    venueSlugs: $venueSlugs
  ) {
    ...BookingRequestAdmin
  }
}
    ${BookingRequestAdminFragmentDoc}`;

export function useAdminBookingRequestsListQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AdminBookingRequestsListQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AdminBookingRequestsListQuery, AdminBookingRequestsListQueryVariables>({ query: AdminBookingRequestsListDocument, ...options });
};
export const AdminApproveUserDocument = /*#__PURE__*/ gql`
    mutation AdminApproveUser($id: String!, $disapprove: Boolean!) {
  approve(userId: $id, disapprove: $disapprove) {
    ...UserFromAdmin
  }
}
    ${UserFromAdminFragmentDoc}`;

export function useAdminApproveUserMutation() {
  return Urql.useMutation<AdminApproveUserMutation, AdminApproveUserMutationVariables>(AdminApproveUserDocument);
};
export const ArtistPerformanceDataDocument = /*#__PURE__*/ gql`
    query ArtistPerformanceData($slug: String, $id: String) {
  artist(slug: $slug, id: $id) {
    id
    slug
    name
    performanceData {
      id
      songs
    }
  }
}
    `;

export function useArtistPerformanceDataQuery(options?: Omit<Urql.UseQueryArgs<ArtistPerformanceDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ArtistPerformanceDataQuery, ArtistPerformanceDataQueryVariables>({ query: ArtistPerformanceDataDocument, ...options });
};
export const SimilarArtistsPublicDocument = /*#__PURE__*/ gql`
    query SimilarArtistsPublic($id: String!) {
  artist(id: $id) {
    id
    relatedArtists {
      ...SmallArtistPublic
    }
  }
}
    ${SmallArtistPublicFragmentDoc}`;

export function useSimilarArtistsPublicQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SimilarArtistsPublicQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SimilarArtistsPublicQuery, SimilarArtistsPublicQueryVariables>({ query: SimilarArtistsPublicDocument, ...options });
};
export const SimilarArtistsDocument = /*#__PURE__*/ gql`
    query SimilarArtists($id: String!) {
  artist(id: $id) {
    id
    relatedArtists {
      ...SmallArtist
    }
  }
}
    ${SmallArtistFragmentDoc}`;

export function useSimilarArtistsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SimilarArtistsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SimilarArtistsQuery, SimilarArtistsQueryVariables>({ query: SimilarArtistsDocument, ...options });
};
export const CalendarSelectedDayDocument = /*#__PURE__*/ gql`
    query CalendarSelectedDay($startTimeMin: DateTime!, $startTimeMax: DateTime!, $limit: Int!, $offset: Int!) {
  myBookingRequests(
    startTimeMin: $startTimeMin
    startTimeMax: $startTimeMax
    statuses: pending
    limit: $limit
    offset: $offset
  ) {
    ...CalendarBookingRequest
  }
  myBookings(
    startTimeMin: $startTimeMin
    startTimeMax: $startTimeMax
    notStatusesV2: [canceled, declined]
    limit: $limit
    offset: $offset
  ) {
    ...CalendarBooking
  }
  myExternalBookings(startTimeMin: $startTimeMin, startTimeMax: $startTimeMax) {
    ...CalendarExternalBooking
  }
}
    ${CalendarBookingRequestFragmentDoc}
${CalendarBookingFragmentDoc}
${CalendarExternalBookingFragmentDoc}`;

export function useCalendarSelectedDayQuery(options: RequireFields<Omit<Urql.UseQueryArgs<CalendarSelectedDayQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<CalendarSelectedDayQuery, CalendarSelectedDayQueryVariables>({ query: CalendarSelectedDayDocument, ...options });
};
export const AutoPublishBookingDocument = /*#__PURE__*/ gql`
    mutation AutoPublishBooking($bookingId: [String!]!, $shouldAutoPublish: Boolean!) {
  updateBookings(
    patch: {shouldAutoPublish: $shouldAutoPublish}
    bookingIds: $bookingId
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useAutoPublishBookingMutation() {
  return Urql.useMutation<AutoPublishBookingMutation, AutoPublishBookingMutationVariables>(AutoPublishBookingDocument);
};
export const AcceptBookingBuyerDocument = /*#__PURE__*/ gql`
    mutation AcceptBookingBuyer($bookingId: String!, $offerAmount: Float!) {
  acceptBooking: acceptBookingBuyer(
    bookingId: $bookingId
    offerAmount: $offerAmount
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useAcceptBookingBuyerMutation() {
  return Urql.useMutation<AcceptBookingBuyerMutation, AcceptBookingBuyerMutationVariables>(AcceptBookingBuyerDocument);
};
export const AcceptBookingSellerDocument = /*#__PURE__*/ gql`
    mutation AcceptBookingSeller($bookingId: String!, $sellerOfferAmount: Float!) {
  acceptBooking: acceptBookingSeller(
    bookingId: $bookingId
    sellerOfferAmount: $sellerOfferAmount
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useAcceptBookingSellerMutation() {
  return Urql.useMutation<AcceptBookingSellerMutation, AcceptBookingSellerMutationVariables>(AcceptBookingSellerDocument);
};
export const AcceptBookingAdminDocument = /*#__PURE__*/ gql`
    mutation AcceptBookingAdmin($bookingId: String!, $onBehalfOfRole: OnBehalfOfRole!, $notifyBuyers: Boolean!, $notifySellers: Boolean!, $offerAmount: Float, $sellerOfferAmount: Float) {
  acceptBooking: acceptBookingAdmin(
    bookingId: $bookingId
    onBehalfOfRole: $onBehalfOfRole
    notifyBuyers: $notifyBuyers
    notifySellers: $notifySellers
    offerAmount: $offerAmount
    sellerOfferAmount: $sellerOfferAmount
  ) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useAcceptBookingAdminMutation() {
  return Urql.useMutation<AcceptBookingAdminMutation, AcceptBookingAdminMutationVariables>(AcceptBookingAdminDocument);
};
export const CounterBookingBuyerDocument = /*#__PURE__*/ gql`
    mutation CounterBookingBuyer($bookingId: String!, $offerAmount: Float!) {
  counter: counterBookingBuyer(bookingId: $bookingId, offerAmount: $offerAmount) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useCounterBookingBuyerMutation() {
  return Urql.useMutation<CounterBookingBuyerMutation, CounterBookingBuyerMutationVariables>(CounterBookingBuyerDocument);
};
export const CounterBookingSellerDocument = /*#__PURE__*/ gql`
    mutation CounterBookingSeller($bookingId: String!, $sellerOfferAmount: Float!) {
  counter: counterBookingSeller(
    bookingId: $bookingId
    sellerOfferAmount: $sellerOfferAmount
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useCounterBookingSellerMutation() {
  return Urql.useMutation<CounterBookingSellerMutation, CounterBookingSellerMutationVariables>(CounterBookingSellerDocument);
};
export const CounterbookingAdminDocument = /*#__PURE__*/ gql`
    mutation CounterbookingAdmin($bookingId: String!, $onBehalfOfRole: OnBehalfOfRole!, $notifyBuyers: Boolean!, $notifySellers: Boolean!, $offerAmount: Float, $sellerOfferAmount: Float) {
  counter: counterBookingAdmin(
    bookingId: $bookingId
    onBehalfOfRole: $onBehalfOfRole
    notifyBuyers: $notifyBuyers
    notifySellers: $notifySellers
    offerAmount: $offerAmount
    sellerOfferAmount: $sellerOfferAmount
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useCounterbookingAdminMutation() {
  return Urql.useMutation<CounterbookingAdminMutation, CounterbookingAdminMutationVariables>(CounterbookingAdminDocument);
};
export const DeclineBookingDocument = /*#__PURE__*/ gql`
    mutation DeclineBooking($bookingId: String!) {
  declineBooking(bookingId: $bookingId) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useDeclineBookingMutation() {
  return Urql.useMutation<DeclineBookingMutation, DeclineBookingMutationVariables>(DeclineBookingDocument);
};
export const DeclineBookingAdminDocument = /*#__PURE__*/ gql`
    mutation DeclineBookingAdmin($bookingId: String!, $onBehalfOf: OnBehalfOfRole!, $notifyBuyers: Boolean!, $notifySellers: Boolean!) {
  declineBookingAdmin(
    bookingId: $bookingId
    onBehalfOfRole: $onBehalfOf
    notifyBuyers: $notifyBuyers
    notifySellers: $notifySellers
  ) {
    ...AdminBooking
  }
}
    ${AdminBookingFragmentDoc}`;

export function useDeclineBookingAdminMutation() {
  return Urql.useMutation<DeclineBookingAdminMutation, DeclineBookingAdminMutationVariables>(DeclineBookingAdminDocument);
};
export const UpdateBookingPublicEventDescriptionDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingPublicEventDescription($bookingId: [String!]!, $publicEventDescription: String!) {
  updateBookings(
    patch: {publicEventDescription: $publicEventDescription}
    bookingIds: $bookingId
  ) {
    id
    publicEventDescription
  }
}
    `;

export function useUpdateBookingPublicEventDescriptionMutation() {
  return Urql.useMutation<UpdateBookingPublicEventDescriptionMutation, UpdateBookingPublicEventDescriptionMutationVariables>(UpdateBookingPublicEventDescriptionDocument);
};
export const PublishBookingDocument = /*#__PURE__*/ gql`
    mutation PublishBooking($id: String!, $unpublish: Boolean!) {
  publishBooking(bookingId: $id, unpublish: $unpublish) {
    id
    isPublished
  }
}
    `;

export function usePublishBookingMutation() {
  return Urql.useMutation<PublishBookingMutation, PublishBookingMutationVariables>(PublishBookingDocument);
};
export const BookingRequestAdminDocument = /*#__PURE__*/ gql`
    query BookingRequestAdmin($id: String!) {
  bookingRequest(id: $id) {
    ...BookingRequestAdmin
  }
}
    ${BookingRequestAdminFragmentDoc}`;

export function useBookingRequestAdminQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingRequestAdminQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingRequestAdminQuery, BookingRequestAdminQueryVariables>({ query: BookingRequestAdminDocument, ...options });
};
export const SellerBookingRequestsListDocument = /*#__PURE__*/ gql`
    query SellerBookingRequestsList($limit: Int!, $offset: Int!, $orderBy: BookingRequestOrderBy!, $startTimeMin: DateTime, $startTimeMax: DateTime, $direction: Dir!) {
  myBookingRequests(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    startTimeMin: $startTimeMin
    startTimeMax: $startTimeMax
    direction: $direction
  ) {
    ...BookingRequest
  }
}
    ${BookingRequestFragmentDoc}`;

export function useSellerBookingRequestsListQuery(options: RequireFields<Omit<Urql.UseQueryArgs<SellerBookingRequestsListQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<SellerBookingRequestsListQuery, SellerBookingRequestsListQueryVariables>({ query: SellerBookingRequestsListDocument, ...options });
};
export const BookingReviewsDocument = /*#__PURE__*/ gql`
    query BookingReviews($bookingId: String!) {
  booking(id: $bookingId) {
    ...Booking
    artistReviews {
      ...ArtistReview
    }
  }
}
    ${BookingFragmentDoc}
${ArtistReviewFragmentDoc}`;

export function useBookingReviewsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingReviewsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingReviewsQuery, BookingReviewsQueryVariables>({ query: BookingReviewsDocument, ...options });
};
export const ActionRequiredListDocument = /*#__PURE__*/ gql`
    query ActionRequiredList($limit: Int!, $offset: Int!) {
  myBookingsWhereActionIsRequired(limit: $limit, offset: $offset, direction: desc) {
    ...CalendarBooking
  }
  myBookingRequestsWhereActionIsRequired(
    limit: $limit
    offset: $offset
    direction: desc
  ) {
    ...CalendarBookingRequest
  }
}
    ${CalendarBookingFragmentDoc}
${CalendarBookingRequestFragmentDoc}`;

export function useActionRequiredListQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ActionRequiredListQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ActionRequiredListQuery, ActionRequiredListQueryVariables>({ query: ActionRequiredListDocument, ...options });
};
export const HomebaseArtistsDocument = /*#__PURE__*/ gql`
    query HomebaseArtists($limit: Int!, $offset: Int!) {
  artists(limit: $limit, offset: $offset) {
    id
    slug
    profileImage {
      publicCloudinaryId
    }
  }
}
    `;

export function useHomebaseArtistsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<HomebaseArtistsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<HomebaseArtistsQuery, HomebaseArtistsQueryVariables>({ query: HomebaseArtistsDocument, ...options });
};
export const HomebaseDocument = /*#__PURE__*/ gql`
    query Homebase($limit: Int!, $offset: Int!, $startTimeMin: DateTime!) {
  myBookings(
    limit: $limit
    offset: $offset
    notStatusesV2: [canceled, declined]
    startTimeMin: $startTimeMin
    orderBy: start_time
    direction: asc
  ) {
    ...CalendarBooking
    whatShouldIDoAlerts {
      buyer
      seller
    }
  }
  myBookingRequests(
    limit: $limit
    offset: $offset
    statuses: pending
    startTimeMin: $startTimeMin
    orderBy: start_time
    direction: asc
  ) {
    ...CalendarBookingRequest
  }
  myBookingsToConfirm(includeConfirmed: true) {
    ...Booking
    confirmation {
      ...BookingConfirmation
    }
  }
}
    ${CalendarBookingFragmentDoc}
${CalendarBookingRequestFragmentDoc}
${BookingFragmentDoc}
${BookingConfirmationFragmentDoc}`;

export function useHomebaseQuery(options: RequireFields<Omit<Urql.UseQueryArgs<HomebaseQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<HomebaseQuery, HomebaseQueryVariables>({ query: HomebaseDocument, ...options });
};
export const HomebaseReviewsDocument = /*#__PURE__*/ gql`
    query HomebaseReviews($limit: Int!, $offset: Int!) {
  myBookingsThatNeedReviewsCount
  myBookingsThatNeedReviews(
    limit: $limit
    offset: $offset
    orderBy: start_time
    direction: asc
  ) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useHomebaseReviewsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<HomebaseReviewsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<HomebaseReviewsQuery, HomebaseReviewsQueryVariables>({ query: HomebaseReviewsDocument, ...options });
};
export const MyVenuesListDocument = /*#__PURE__*/ gql`
    query MyVenuesList {
  myVenues {
    ...Venue
    capacity
    images {
      public_cloudinary_id: publicCloudinaryId
      height
      width
      url
    }
  }
}
    ${VenueFragmentDoc}`;

export function useMyVenuesListQuery(options?: Omit<Urql.UseQueryArgs<MyVenuesListQueryVariables>, 'query'>) {
  return Urql.useQuery<MyVenuesListQuery, MyVenuesListQueryVariables>({ query: MyVenuesListDocument, ...options });
};
export const NextUpcomingBookingIdDocument = /*#__PURE__*/ gql`
    query NextUpcomingBookingId($startTimeMin: DateTime!, $limit: Int!, $offset: Int!) {
  myBookings(
    limit: $limit
    offset: $offset
    startTimeMin: $startTimeMin
    isPublished: true
    orderBy: start_time
    direction: asc
    bookingFlows: venue
  ) {
    id
    firebaseId
  }
}
    `;

export function useNextUpcomingBookingIdQuery(options: RequireFields<Omit<Urql.UseQueryArgs<NextUpcomingBookingIdQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<NextUpcomingBookingIdQuery, NextUpcomingBookingIdQueryVariables>({ query: NextUpcomingBookingIdDocument, ...options });
};
export const ExternalBookingPublicDocument = /*#__PURE__*/ gql`
    query ExternalBookingPublic($externalBookingId: String!) {
  externalBooking(id: $externalBookingId) {
    id
    artistName
    publicEventDescription
    indoorsOrOutdoors
    startTime
    venue {
      location {
        ...Location
      }
    }
    performanceLengthMins
    coverImage {
      height
      width
      public_cloudinary_id: publicCloudinaryId
    }
  }
}
    ${LocationFragmentDoc}`;

export function useExternalBookingPublicQuery(options: RequireFields<Omit<Urql.UseQueryArgs<ExternalBookingPublicQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<ExternalBookingPublicQuery, ExternalBookingPublicQueryVariables>({ query: ExternalBookingPublicDocument, ...options });
};
export const PublicBookingDocument = /*#__PURE__*/ gql`
    query PublicBooking($bookingId: String!) {
  booking(id: $bookingId) {
    ...PublicBooking
  }
}
    ${PublicBookingFragmentDoc}`;

export function usePublicBookingQuery(options: RequireFields<Omit<Urql.UseQueryArgs<PublicBookingQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<PublicBookingQuery, PublicBookingQueryVariables>({ query: PublicBookingDocument, ...options });
};
export const VenueCalendarBookingsDocument = /*#__PURE__*/ gql`
    query VenueCalendarBookings($slug: String!, $start: DateTime!, $offset: Int!, $limit: Int!) {
  venue(slug: $slug) {
    ...VenuePublic
    calendarBookings(start: $start, limit: $limit, offset: $offset) {
      bookings: calendarBookings {
        performanceLengthMins
        artistCategory
        bandConfiguration
        artistName
        artistProfileImage {
          publicCloudinaryId
        }
        artistCoverImage {
          publicCloudinaryId
        }
        publicCoverImage {
          publicCloudinaryId
        }
        publicProfileImage {
          publicCloudinaryId
        }
        startTime
        bookingType
        id
      }
      canFetchMore
    }
  }
}
    ${VenuePublicFragmentDoc}`;

export function useVenueCalendarBookingsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<VenueCalendarBookingsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<VenueCalendarBookingsQuery, VenueCalendarBookingsQueryVariables>({ query: VenueCalendarBookingsDocument, ...options });
};
export const BookingToEditImagesForDocument = /*#__PURE__*/ gql`
    query BookingToEditImagesFor($bookingId: String!) {
  booking(id: $bookingId) {
    ...BookingToEditImagesFor
  }
}
    ${BookingToEditImagesForFragmentDoc}`;

export function useBookingToEditImagesForQuery(options: RequireFields<Omit<Urql.UseQueryArgs<BookingToEditImagesForQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<BookingToEditImagesForQuery, BookingToEditImagesForQueryVariables>({ query: BookingToEditImagesForDocument, ...options });
};
export const UpdateBookingPublicCoverImageDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingPublicCoverImage($bookingId: [String!]!, $image: ImageInput!) {
  updateBookings(bookingIds: $bookingId, patch: {publicCoverImage: $image}) {
    ...BookingToEditImagesFor
  }
}
    ${BookingToEditImagesForFragmentDoc}`;

export function useUpdateBookingPublicCoverImageMutation() {
  return Urql.useMutation<UpdateBookingPublicCoverImageMutation, UpdateBookingPublicCoverImageMutationVariables>(UpdateBookingPublicCoverImageDocument);
};
export const UpdateBookingPublicProfileImageDocument = /*#__PURE__*/ gql`
    mutation UpdateBookingPublicProfileImage($bookingId: [String!]!, $image: ImageInput!) {
  updateBookings(bookingIds: $bookingId, patch: {publicProfileImage: $image}) {
    ...BookingToEditImagesFor
  }
}
    ${BookingToEditImagesForFragmentDoc}`;

export function useUpdateBookingPublicProfileImageMutation() {
  return Urql.useMutation<UpdateBookingPublicProfileImageMutation, UpdateBookingPublicProfileImageMutationVariables>(UpdateBookingPublicProfileImageDocument);
};
export const CreateArtistReviewDocument = /*#__PURE__*/ gql`
    mutation CreateArtistReview($bookingId: String!, $input: ArtistReviewInput!) {
  createArtistReview(bookingId: $bookingId, input: $input) {
    id
    comment
  }
}
    `;

export function useCreateArtistReviewMutation() {
  return Urql.useMutation<CreateArtistReviewMutation, CreateArtistReviewMutationVariables>(CreateArtistReviewDocument);
};
export const MyBookingsThatNeedReviewsDocument = /*#__PURE__*/ gql`
    query MyBookingsThatNeedReviews($limit: Int!, $offset: Int!) {
  myBookingsThatNeedReviews(limit: $limit, offset: $offset) {
    ...Booking
  }
}
    ${BookingFragmentDoc}`;

export function useMyBookingsThatNeedReviewsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<MyBookingsThatNeedReviewsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<MyBookingsThatNeedReviewsQuery, MyBookingsThatNeedReviewsQueryVariables>({ query: MyBookingsThatNeedReviewsDocument, ...options });
};
export const MyBookingsThatNeedReviewsCountDocument = /*#__PURE__*/ gql`
    query MyBookingsThatNeedReviewsCount {
  myBookingsThatNeedReviewsCount
}
    `;

export function useMyBookingsThatNeedReviewsCountQuery(options?: Omit<Urql.UseQueryArgs<MyBookingsThatNeedReviewsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<MyBookingsThatNeedReviewsCountQuery, MyBookingsThatNeedReviewsCountQueryVariables>({ query: MyBookingsThatNeedReviewsCountDocument, ...options });
};
export const VenueAccountExecDocument = /*#__PURE__*/ gql`
    query VenueAccountExec($venueSlug: String!) {
  venue(slug: $venueSlug) {
    id
    name
    accountExec {
      id
      name
    }
  }
}
    `;

export function useVenueAccountExecQuery(options: RequireFields<Omit<Urql.UseQueryArgs<VenueAccountExecQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<VenueAccountExecQuery, VenueAccountExecQueryVariables>({ query: VenueAccountExecDocument, ...options });
};
export const AssignVenueAccountExecDocument = /*#__PURE__*/ gql`
    mutation AssignVenueAccountExec($venueId: String!, $accountExecId: String!, $remove: Boolean!) {
  linkAccountExec(
    venueId: $venueId
    accountExecId: $accountExecId
    remove: $remove
  ) {
    id
    accountExec {
      id
      name
    }
  }
}
    `;

export function useAssignVenueAccountExecMutation() {
  return Urql.useMutation<AssignVenueAccountExecMutation, AssignVenueAccountExecMutationVariables>(AssignVenueAccountExecDocument);
};
export const AccountExecsDocument = /*#__PURE__*/ gql`
    query AccountExecs($limit: Int!, $offset: Int!) {
  users(userRoles: [admin], approved: true, limit: $limit, offset: $offset) {
    id
    name
    slug
    firebaseId
    profileImage {
      publicCloudinaryId
      height
      width
    }
    metadata {
      userType
    }
    venuesAssignedTo {
      id
      name
      slug
    }
  }
}
    `;

export function useAccountExecsQuery(options: RequireFields<Omit<Urql.UseQueryArgs<AccountExecsQueryVariables>, 'query'>, 'variables'>) {
  return Urql.useQuery<AccountExecsQuery, AccountExecsQueryVariables>({ query: AccountExecsDocument, ...options });
};
export const VenueColorsDocument = /*#__PURE__*/ gql`
    mutation VenueColors($venueId: String!, $patch: VenuePatch!) {
  updateVenue(venueId: $venueId, patch: $patch) {
    ...Venue
  }
}
    ${VenueFragmentDoc}`;

export function useVenueColorsMutation() {
  return Urql.useMutation<VenueColorsMutation, VenueColorsMutationVariables>(VenueColorsDocument);
};
export type WithTypename<T extends { __typename?: any }> = { [K in Exclude<keyof T, '__typename'>]?: T[K] } & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  Approval?: (data: WithTypename<Approval>) => null | string,
  Artist?: (data: WithTypename<Artist>) => null | string,
  ArtistAvailability?: (data: WithTypename<ArtistAvailability>) => null | string,
  ArtistAvailabilityCheck?: (data: WithTypename<ArtistAvailabilityCheck>) => null | string,
  ArtistLike?: (data: WithTypename<ArtistLike>) => null | string,
  ArtistNotFoundResponse?: (data: WithTypename<ArtistNotFoundResponse>) => null | string,
  ArtistPerformanceData?: (data: WithTypename<ArtistPerformanceData>) => null | string,
  ArtistReview?: (data: WithTypename<ArtistReview>) => null | string,
  ArtistSpotify?: (data: WithTypename<ArtistSpotify>) => null | string,
  ArtistStats?: (data: WithTypename<ArtistStats>) => null | string,
  ArtistTypesense?: (data: WithTypename<ArtistTypesense>) => null | string,
  ArtistTypesensePublic?: (data: WithTypename<ArtistTypesensePublic>) => null | string,
  ArtistVenueApplicationStraw?: (data: WithTypename<ArtistVenueApplicationStraw>) => null | string,
  BandConfig?: (data: WithTypename<BandConfig>) => null | string,
  BarChart?: (data: WithTypename<BarChart>) => null | string,
  BarChartEdge?: (data: WithTypename<BarChartEdge>) => null | string,
  Bid?: (data: WithTypename<Bid>) => null | string,
  Booking?: (data: WithTypename<Booking>) => null | string,
  BookingBadgesResponse?: (data: WithTypename<BookingBadgesResponse>) => null | string,
  BookingBilling?: (data: WithTypename<BookingBilling>) => null | string,
  BookingByBuyerType?: (data: WithTypename<BookingByBuyerType>) => null | string,
  BookingByCity?: (data: WithTypename<BookingByCity>) => null | string,
  BookingByVenue?: (data: WithTypename<BookingByVenue>) => null | string,
  BookingConfirmation?: (data: WithTypename<BookingConfirmation>) => null | string,
  BookingDispute?: (data: WithTypename<BookingDispute>) => null | string,
  BookingRequest?: (data: WithTypename<BookingRequest>) => null | string,
  BookingRequestBadgesResponse?: (data: WithTypename<BookingRequestBadgesResponse>) => null | string,
  BookingRequestDecline?: (data: WithTypename<BookingRequestDecline>) => null | string,
  BookingTypesense?: (data: WithTypename<BookingTypesense>) => null | string,
  Button?: (data: WithTypename<Button>) => null | string,
  BuyerBilling?: (data: WithTypename<BuyerBilling>) => null | string,
  CalendarBooking?: (data: WithTypename<CalendarBooking>) => null | string,
  CalendarBookingsResponse?: (data: WithTypename<CalendarBookingsResponse>) => null | string,
  CancellationRequest?: (data: WithTypename<CancellationRequest>) => null | string,
  Card?: (data: WithTypename<Card>) => null | string,
  Charge?: (data: WithTypename<Charge>) => null | string,
  Colors?: (data: WithTypename<Colors>) => null | string,
  ConfigInfo?: (data: WithTypename<ConfigInfo>) => null | string,
  ConnectAccountDisplay?: (data: WithTypename<ConnectAccountDisplay>) => null | string,
  ContactInformation?: (data: WithTypename<ContactInformation>) => null | string,
  CourierChannel?: (data: WithTypename<CourierChannel>) => null | string,
  CourierMessage?: (data: WithTypename<CourierMessage>) => null | string,
  CourierProvider?: (data: WithTypename<CourierProvider>) => null | string,
  DiscoverArtist?: (data: WithTypename<DiscoverArtist>) => null | string,
  DisplayImages?: (data: WithTypename<DisplayImages>) => null | string,
  DisplayPrices?: (data: WithTypename<DisplayPrices>) => null | string,
  ExternalBooking?: (data: WithTypename<ExternalBooking>) => null | string,
  ExternalCalendarEvent?: (data: WithTypename<ExternalCalendarEvent>) => null | string,
  ExternalUrls?: (data: WithTypename<ExternalUrls>) => null | string,
  ExtraArtistInfo?: (data: WithTypename<ExtraArtistInfo>) => null | string,
  Followers?: (data: WithTypename<Followers>) => null | string,
  FrontendDirections?: (data: WithTypename<FrontendDirections>) => null | string,
  GamificationMetric?: (data: WithTypename<GamificationMetric>) => null | string,
  GamificationMetrics?: (data: WithTypename<GamificationMetrics>) => null | string,
  GeoLoc?: (data: WithTypename<GeoLoc>) => null | string,
  Image?: (data: WithTypename<Image>) => null | string,
  ImageSpotify?: (data: WithTypename<ImageSpotify>) => null | string,
  Images?: (data: WithTypename<Images>) => null | string,
  IpResponse?: (data: WithTypename<IpResponse>) => null | string,
  LastMoved?: (data: WithTypename<LastMoved>) => null | string,
  Location?: (data: WithTypename<Location>) => null | string,
  Media?: (data: WithTypename<Media>) => null | string,
  Metadata?: (data: WithTypename<Metadata>) => null | string,
  Metric?: (data: WithTypename<Metric>) => null | string,
  Metrics?: (data: WithTypename<Metrics>) => null | string,
  MyBadgeResponse?: (data: WithTypename<MyBadgeResponse>) => null | string,
  NegotiationStep?: (data: WithTypename<NegotiationStep>) => null | string,
  NegotiationStepDescription?: (data: WithTypename<NegotiationStepDescription>) => null | string,
  Note?: (data: WithTypename<Note>) => null | string,
  Overview?: (data: WithTypename<Overview>) => null | string,
  Participant?: (data: WithTypename<Participant>) => null | string,
  Payout?: (data: WithTypename<Payout>) => null | string,
  PayoutMethod?: (data: WithTypename<PayoutMethod>) => null | string,
  Pipeline?: (data: WithTypename<Pipeline>) => null | string,
  PipelineMetrics?: (data: WithTypename<PipelineMetrics>) => null | string,
  PossibleActions?: (data: WithTypename<PossibleActions>) => null | string,
  PriceRange?: (data: WithTypename<PriceRange>) => null | string,
  PriceRangeOptional?: (data: WithTypename<PriceRangeOptional>) => null | string,
  Prices?: (data: WithTypename<Prices>) => null | string,
  PublicInvoice?: (data: WithTypename<PublicInvoice>) => null | string,
  PublicUser?: (data: WithTypename<PublicUser>) => null | string,
  Question?: (data: WithTypename<Question>) => null | string,
  ReceiptItem?: (data: WithTypename<ReceiptItem>) => null | string,
  Row?: (data: WithTypename<Row>) => null | string,
  SendImageToEmailResponse?: (data: WithTypename<SendImageToEmailResponse>) => null | string,
  SendImageToPhoneResponse?: (data: WithTypename<SendImageToPhoneResponse>) => null | string,
  SetPlaidAccessTokenResponse?: (data: WithTypename<SetPlaidAccessTokenResponse>) => null | string,
  ShortMessage?: (data: WithTypename<ShortMessage>) => null | string,
  SmallImage?: (data: WithTypename<SmallImage>) => null | string,
  SocialMedia?: (data: WithTypename<SocialMedia>) => null | string,
  Songs?: (data: WithTypename<Songs>) => null | string,
  StatusInformation?: (data: WithTypename<StatusInformation>) => null | string,
  StatusNode?: (data: WithTypename<StatusNode>) => null | string,
  StripeBankAccount?: (data: WithTypename<StripeBankAccount>) => null | string,
  Tooltip?: (data: WithTypename<Tooltip>) => null | string,
  TransferMetadata?: (data: WithTypename<TransferMetadata>) => null | string,
  TransferStripe?: (data: WithTypename<TransferStripe>) => null | string,
  User?: (data: WithTypename<User>) => null | string,
  UserDoesNotExist?: (data: WithTypename<UserDoesNotExist>) => null | string,
  UserTypesense?: (data: WithTypename<UserTypesense>) => null | string,
  Venue?: (data: WithTypename<Venue>) => null | string,
  VenueTypesense?: (data: WithTypename<VenueTypesense>) => null | string,
  Videos?: (data: WithTypename<Videos>) => null | string,
  WhatShouldIDoAlerts?: (data: WithTypename<WhatShouldIDoAlerts>) => null | string,
  WhenDate?: (data: WithTypename<WhenDate>) => null | string,
  WhenDatespan?: (data: WithTypename<WhenDatespan>) => null | string,
  WhenTime?: (data: WithTypename<WhenTime>) => null | string,
  WhenTimespan?: (data: WithTypename<WhenTimespan>) => null | string
}

export type GraphCacheResolvers = {
  Query?: {
    hello?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['String'] | string>,
    me?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<UserUserDoesNotExist> | string>,
    publicUser?: GraphCacheResolver<WithTypename<Query>, QueryPublicUserArgs, WithTypename<PublicUserUserDoesNotExist> | string>,
    user?: GraphCacheResolver<WithTypename<Query>, QueryUserArgs, WithTypename<User> | string>,
    users?: GraphCacheResolver<WithTypename<Query>, QueryUsersArgs, Array<WithTypename<User> | string>>,
    userTypesSchema?: GraphCacheResolver<WithTypename<Query>, QueryUserTypesSchemaArgs, Scalars['Boolean'] | string>,
    artist?: GraphCacheResolver<WithTypename<Query>, QueryArtistArgs, WithTypename<Artist> | string>,
    artistServerSide?: GraphCacheResolver<WithTypename<Query>, QueryArtistServerSideArgs, WithTypename<ArtistArtistNotFoundResponse> | string>,
    myArtists?: GraphCacheResolver<WithTypename<Query>, QueryMyArtistsArgs, Array<WithTypename<Artist> | string>>,
    artistSearchKey?: GraphCacheResolver<WithTypename<Query>, QueryArtistSearchKeyArgs, Scalars['String'] | string>,
    isArtistSlugAvailable?: GraphCacheResolver<WithTypename<Query>, QueryIsArtistSlugAvailableArgs, Scalars['Boolean'] | string>,
    artists?: GraphCacheResolver<WithTypename<Query>, QueryArtistsArgs, Array<WithTypename<Artist> | string>>,
    venue?: GraphCacheResolver<WithTypename<Query>, QueryVenueArgs, WithTypename<Venue> | string>,
    myVenues?: GraphCacheResolver<WithTypename<Query>, QueryMyVenuesArgs, Array<WithTypename<Venue> | string>>,
    isVenueSlugAvailable?: GraphCacheResolver<WithTypename<Query>, QueryIsVenueSlugAvailableArgs, Scalars['Boolean'] | string>,
    venues?: GraphCacheResolver<WithTypename<Query>, QueryVenuesArgs, Array<WithTypename<Venue> | string>>,
    locationFromPlaceId?: GraphCacheResolver<WithTypename<Query>, QueryLocationFromPlaceIdArgs, WithTypename<Location> | string>,
    booking?: GraphCacheResolver<WithTypename<Query>, QueryBookingArgs, WithTypename<Booking> | string>,
    myBookings?: GraphCacheResolver<WithTypename<Query>, QueryMyBookingsArgs, Array<WithTypename<Booking> | string>>,
    myBookingsThatNeedReviews?: GraphCacheResolver<WithTypename<Query>, QueryMyBookingsThatNeedReviewsArgs, Array<WithTypename<Booking> | string>>,
    myBookingsThatNeedReviewsCount?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['Int'] | string>,
    bookings?: GraphCacheResolver<WithTypename<Query>, QueryBookingsArgs, Array<WithTypename<Booking> | string>>,
    bookingsViaFilter?: GraphCacheResolver<WithTypename<Query>, QueryBookingsViaFilterArgs, Array<WithTypename<Booking> | string>>,
    externalBooking?: GraphCacheResolver<WithTypename<Query>, QueryExternalBookingArgs, WithTypename<ExternalBooking> | string>,
    externalBookings?: GraphCacheResolver<WithTypename<Query>, QueryExternalBookingsArgs, Array<WithTypename<ExternalBooking> | string>>,
    myExternalBookings?: GraphCacheResolver<WithTypename<Query>, QueryMyExternalBookingsArgs, Array<WithTypename<ExternalBooking> | string>>,
    artistReview?: GraphCacheResolver<WithTypename<Query>, QueryArtistReviewArgs, WithTypename<ArtistReview> | string>,
    myArtistReviews?: GraphCacheResolver<WithTypename<Query>, QueryMyArtistReviewsArgs, Array<WithTypename<ArtistReview> | string>>,
    spotifyArtistsFromName?: GraphCacheResolver<WithTypename<Query>, QuerySpotifyArtistsFromNameArgs, Array<WithTypename<ArtistSpotify> | string>>,
    spotifyArtistFromId?: GraphCacheResolver<WithTypename<Query>, QuerySpotifyArtistFromIdArgs, WithTypename<ArtistSpotify> | string>,
    bookingRequest?: GraphCacheResolver<WithTypename<Query>, QueryBookingRequestArgs, WithTypename<BookingRequest> | string>,
    myBookingRequests?: GraphCacheResolver<WithTypename<Query>, QueryMyBookingRequestsArgs, Array<WithTypename<BookingRequest> | string>>,
    myVenueBookingRequests?: GraphCacheResolver<WithTypename<Query>, QueryMyVenueBookingRequestsArgs, Array<WithTypename<BookingRequest> | string>>,
    bookingRequests?: GraphCacheResolver<WithTypename<Query>, QueryBookingRequestsArgs, Array<WithTypename<BookingRequest> | string>>,
    getIpInfo?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<IpResponse> | string>,
    artistStats?: GraphCacheResolver<WithTypename<Query>, QueryArtistStatsArgs, WithTypename<ArtistStats> | string>,
    myLikedArtists?: GraphCacheResolver<WithTypename<Query>, QueryMyLikedArtistsArgs, Array<WithTypename<ArtistLike> | string>>,
    didILikeArtist?: GraphCacheResolver<WithTypename<Query>, QueryDidILikeArtistArgs, Scalars['Boolean'] | string>,
    myLikedArtistsSlugs?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<Scalars['String'] | string>>,
    googleOauthUrl?: GraphCacheResolver<WithTypename<Query>, QueryGoogleOauthUrlArgs, Scalars['String'] | string>,
    myExternalCalendarEvents?: GraphCacheResolver<WithTypename<Query>, QueryMyExternalCalendarEventsArgs, Array<WithTypename<ExternalCalendarEvent> | string>>,
    plaidLinkToken?: GraphCacheResolver<WithTypename<Query>, QueryPlaidLinkTokenArgs, Scalars['String'] | string>,
    firebaseToEdgedb?: GraphCacheResolver<WithTypename<Query>, QueryFirebaseToEdgedbArgs, Scalars['String'] | string>,
    edgedbToFirebase?: GraphCacheResolver<WithTypename<Query>, QueryEdgedbToFirebaseArgs, Scalars['String'] | string>,
    sellerToBuyerAmount?: GraphCacheResolver<WithTypename<Query>, QuerySellerToBuyerAmountArgs, Scalars['Float'] | string>,
    buyerToSellerAmount?: GraphCacheResolver<WithTypename<Query>, QueryBuyerToSellerAmountArgs, Scalars['Float'] | string>,
    myBookingsWhereActionIsRequired?: GraphCacheResolver<WithTypename<Query>, QueryMyBookingsWhereActionIsRequiredArgs, Array<WithTypename<Booking> | string>>,
    myBookingsWhereActionIsRequiredCount?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['Int'] | string>,
    myBookingRequestsWhereActionIsRequired?: GraphCacheResolver<WithTypename<Query>, QueryMyBookingRequestsWhereActionIsRequiredArgs, Array<WithTypename<BookingRequest> | string>>,
    myBookingRequestsWhereActionIsRequiredCount?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['Int'] | string>,
    myBadgeCount?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['Int'] | string>,
    myBadges?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<MyBadgeResponse> | string>,
    artistMetrics?: GraphCacheResolver<WithTypename<Query>, QueryArtistMetricsArgs, WithTypename<Metrics> | string>,
    artistBookingsByVenue?: GraphCacheResolver<WithTypename<Query>, QueryArtistBookingsByVenueArgs, Array<WithTypename<BookingByVenue> | string>>,
    artistBookingsByCity?: GraphCacheResolver<WithTypename<Query>, QueryArtistBookingsByCityArgs, Array<WithTypename<BookingByCity> | string>>,
    artistBookingsByBuyerType?: GraphCacheResolver<WithTypename<Query>, QueryArtistBookingsByBuyerTypeArgs, Array<WithTypename<BookingByBuyerType> | string>>,
    artistBookingsUpcoming?: GraphCacheResolver<WithTypename<Query>, QueryArtistBookingsUpcomingArgs, WithTypename<Pipeline> | string>,
    artistGamificationMetrics?: GraphCacheResolver<WithTypename<Query>, QueryArtistGamificationMetricsArgs, WithTypename<GamificationMetrics> | string>,
    adminSearchKey?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['String'] | string>,
    bookingsSearchKey?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['String'] | string>,
    typesenseTypes?: GraphCacheResolver<WithTypename<Query>, QueryTypesenseTypesArgs, WithTypename<UserTypesenseArtistTypesenseArtistTypesensePublicBookingTypesenseVenueTypesense> | string>,
    discoverPage?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<Row> | string>>,
    artistAvailability?: GraphCacheResolver<WithTypename<Query>, QueryArtistAvailabilityArgs, WithTypename<ArtistAvailability> | string>,
    artistAvailabilityCheck?: GraphCacheResolver<WithTypename<Query>, QueryArtistAvailabilityCheckArgs, WithTypename<ArtistAvailabilityCheck> | string>,
    bookingPreferences?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<Question> | string>>,
    cancellationRequests?: GraphCacheResolver<WithTypename<Query>, QueryCancellationRequestsArgs, Array<WithTypename<CancellationRequest> | string>>,
    bookingConfirmations?: GraphCacheResolver<WithTypename<Query>, QueryBookingConfirmationsArgs, Array<WithTypename<BookingConfirmation> | string>>,
    myBookingsToConfirm?: GraphCacheResolver<WithTypename<Query>, QueryMyBookingsToConfirmArgs, Array<WithTypename<Booking> | string>>
  },
  Approval?: {
    adminId?: GraphCacheResolver<WithTypename<Approval>, Record<string, never>, Scalars['String'] | string>,
    admin?: GraphCacheResolver<WithTypename<Approval>, Record<string, never>, WithTypename<User> | string>,
    timestamp?: GraphCacheResolver<WithTypename<Approval>, Record<string, never>, Scalars['DateTime'] | string>
  },
  Artist?: {
    id?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['String'] | string>,
    published?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['Boolean'] | string>,
    subgenres?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Array<Scalars['String'] | string>>,
    category?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Category | string>,
    bio?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['String'] | string>,
    socialMedia?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<SocialMedia> | string>,
    profileImage?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<Image> | string>,
    coverImage?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<Image> | string>,
    media?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<Media> | string>,
    location?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<Location> | string>,
    spotifyId?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['String'] | string>,
    contactInformation?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<ContactInformation> | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['DateTime'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['DateTime'] | string>,
    adminDetails?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['String'] | string>,
    venueTakePercentages?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['JSON'] | string>,
    sellers?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Array<WithTypename<User> | string>>,
    pendingUserPhoneNumbers?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Array<Scalars['String'] | string>>,
    bookings?: GraphCacheResolver<WithTypename<Artist>, ArtistBookingsArgs, Array<WithTypename<Booking> | string>>,
    relatedArtists?: GraphCacheResolver<WithTypename<Artist>, ArtistRelatedArtistsArgs, Array<WithTypename<Artist> | string>>,
    groupedReviews?: GraphCacheResolver<WithTypename<Artist>, ArtistGroupedReviewsArgs, Array<WithTypename<ArtistReview> | string>>,
    artistReviews?: GraphCacheResolver<WithTypename<Artist>, ArtistArtistReviewsArgs, Array<WithTypename<ArtistReview> | string>>,
    topReviews?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Array<WithTypename<ArtistReview> | string>>,
    avgRating?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['Float'] | string>,
    numberOfReviews?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['Int'] | string>,
    defaultPriceRange?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<PriceRange> | string>,
    bandConfiguration?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<BandConfig> | string>,
    iLiked?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['Boolean'] | string>,
    performanceData?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, WithTypename<ArtistPerformanceData> | string>,
    likeCount?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['Int'] | string>,
    viewCount?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Scalars['Int'] | string>,
    billing?: GraphCacheResolver<WithTypename<Artist>, ArtistBillingArgs, WithTypename<ConnectAccountDisplay> | string>,
    transfers?: GraphCacheResolver<WithTypename<Artist>, Record<string, never>, Array<WithTypename<TransferStripe> | string>>
  },
  ArtistAvailability?: {
    id?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, Scalars['UUID'] | string>,
    status?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, ArtistAvailabilityStatus | string>,
    createdAt?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, Scalars['DateTime'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, Scalars['DateTime'] | string>,
    startTime?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, Scalars['DateTime'] | string>,
    location?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, WithTypename<Location> | string>,
    buyerDisplayName?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, Scalars['String'] | string>,
    performanceLengthMins?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, Scalars['Int'] | string>,
    createdBy?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, WithTypename<User> | string>,
    booking?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, WithTypename<Booking> | string>,
    checks?: GraphCacheResolver<WithTypename<ArtistAvailability>, Record<string, never>, Array<WithTypename<ArtistAvailabilityCheck> | string>>
  },
  ArtistAvailabilityCheck?: {
    id?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Scalars['UUID'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Scalars['DateTime'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Scalars['DateTime'] | string>,
    notifiedAt?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Scalars['DateTime'] | string>,
    courierNotificationIds?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Array<Scalars['String'] | string>>,
    respondedAt?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Scalars['DateTime'] | string>,
    response?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, ArtistAvailabilityResponse | string>,
    responseMessage?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Scalars['String'] | string>,
    respondedBy?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, WithTypename<User> | string>,
    createdBy?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, WithTypename<User> | string>,
    artistAvailability?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, WithTypename<ArtistAvailability> | string>,
    artist?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, WithTypename<Artist> | string>,
    courierMessages?: GraphCacheResolver<WithTypename<ArtistAvailabilityCheck>, Record<string, never>, Array<WithTypename<CourierMessage> | string>>
  },
  ArtistLike?: {
    timestamp?: GraphCacheResolver<WithTypename<ArtistLike>, Record<string, never>, Scalars['DateTime'] | string>,
    user?: GraphCacheResolver<WithTypename<ArtistLike>, Record<string, never>, WithTypename<User> | string>,
    artist?: GraphCacheResolver<WithTypename<ArtistLike>, Record<string, never>, WithTypename<Artist> | string>
  },
  ArtistNotFoundResponse?: {
    message?: GraphCacheResolver<WithTypename<ArtistNotFoundResponse>, Record<string, never>, Scalars['String'] | string>
  },
  ArtistPerformanceData?: {
    id?: GraphCacheResolver<WithTypename<ArtistPerformanceData>, Record<string, never>, Scalars['UUID'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<ArtistPerformanceData>, Record<string, never>, Scalars['String'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<ArtistPerformanceData>, Record<string, never>, Scalars['DateTime'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<ArtistPerformanceData>, Record<string, never>, Scalars['DateTime'] | string>,
    songs?: GraphCacheResolver<WithTypename<ArtistPerformanceData>, Record<string, never>, Array<Scalars['String'] | string>>,
    songsTxt?: GraphCacheResolver<WithTypename<ArtistPerformanceData>, Record<string, never>, Scalars['String'] | string>,
    states?: GraphCacheResolver<WithTypename<ArtistPerformanceData>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  ArtistReview?: {
    id?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['String'] | string>,
    rating?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['Int'] | string>,
    timestamp?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['DateTime'] | string>,
    published?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['Boolean'] | string>,
    comment?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['String'] | string>,
    authorProfileImage?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, WithTypename<SmallImage> | string>,
    authorOrgStr?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['String'] | string>,
    authorLocStr?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['String'] | string>,
    count?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['Int'] | string>,
    avgRating?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['Float'] | string>,
    fromVenue?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['Boolean'] | string>,
    authorFirstName?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, Scalars['String'] | string>,
    artist?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, WithTypename<Artist> | string>,
    author?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, WithTypename<User> | string>,
    booking?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, WithTypename<Booking> | string>,
    venue?: GraphCacheResolver<WithTypename<ArtistReview>, Record<string, never>, WithTypename<Venue> | string>
  },
  ArtistSpotify?: {
    followers?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, WithTypename<Followers> | string>,
    genres?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, Array<Scalars['String'] | string>>,
    href?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, Scalars['String'] | string>,
    images?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, Array<WithTypename<ImageSpotify> | string>>,
    name?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, Scalars['String'] | string>,
    popularity?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, Scalars['Int'] | string>,
    externalUrls?: GraphCacheResolver<WithTypename<ArtistSpotify>, Record<string, never>, WithTypename<ExternalUrls> | string>
  },
  ArtistStats?: {
    numberOfBookings?: GraphCacheResolver<WithTypename<ArtistStats>, Record<string, never>, Scalars['Int'] | string>,
    numberOfCancellations?: GraphCacheResolver<WithTypename<ArtistStats>, Record<string, never>, Scalars['Int'] | string>,
    hasVerifiedBadge?: GraphCacheResolver<WithTypename<ArtistStats>, Record<string, never>, Scalars['Boolean'] | string>,
    responseTimeMins?: GraphCacheResolver<WithTypename<ArtistStats>, Record<string, never>, Scalars['Float'] | string>,
    responseRate?: GraphCacheResolver<WithTypename<ArtistStats>, Record<string, never>, Scalars['Float'] | string>,
    cancellationRate?: GraphCacheResolver<WithTypename<ArtistStats>, Record<string, never>, Scalars['Float'] | string>
  },
  ArtistTypesense?: {
    bandConfiguration?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, WithTypename<BandConfig> | string>,
    id?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    published?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Boolean'] | string>,
    lastTriggeredToTypesenseAt?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    numberOfReviews?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    avgRating?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Float'] | string>,
    spotifyPopularityAndReviews?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    objectID?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['String'] | string>,
    privateSoloPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateSoloPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicSoloPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicSoloPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateDuoPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateDuoPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicDuoPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicDuoPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateTrioPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateTrioPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicTrioPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicTrioPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateFourPlusPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateFourPlusPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicFourPlusPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicFourPlusPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateDefaultPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    privateDefaultPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicDefaultPriceLow?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicDefaultPriceHigh?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    bandConfigurationOptions?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Array<Scalars['String'] | string>>,
    category?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['String'] | string>,
    subgenres?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Array<Scalars['String'] | string>>,
    profileImage?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, WithTypename<Image> | string>,
    coverImage?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, WithTypename<Image> | string>,
    spotifyPopularity?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Scalars['Int'] | string>,
    locationGeopoint?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, Array<Scalars['Float'] | string>>,
    _geoloc?: GraphCacheResolver<WithTypename<ArtistTypesense>, Record<string, never>, WithTypename<GeoLoc> | string>
  },
  ArtistTypesensePublic?: {
    id?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Int'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Int'] | string>,
    published?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Boolean'] | string>,
    lastTriggeredToTypesenseAt?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Int'] | string>,
    numberOfReviews?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Int'] | string>,
    avgRating?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Float'] | string>,
    spotifyPopularityAndReviews?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Int'] | string>,
    objectID?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['String'] | string>,
    category?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['String'] | string>,
    subgenres?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Array<Scalars['String'] | string>>,
    profileImage?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, WithTypename<Image> | string>,
    coverImage?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, WithTypename<Image> | string>,
    spotifyPopularity?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Scalars['Int'] | string>,
    locationGeopoint?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, Array<Scalars['Float'] | string>>,
    _geoloc?: GraphCacheResolver<WithTypename<ArtistTypesensePublic>, Record<string, never>, WithTypename<GeoLoc> | string>
  },
  ArtistVenueApplicationStraw?: {
    id?: GraphCacheResolver<WithTypename<ArtistVenueApplicationStraw>, Record<string, never>, Scalars['String'] | string>,
    message?: GraphCacheResolver<WithTypename<ArtistVenueApplicationStraw>, Record<string, never>, Scalars['String'] | string>
  },
  BandConfig?: {
    fallback?: GraphCacheResolver<WithTypename<BandConfig>, Record<string, never>, WithTypename<ConfigInfo> | string>,
    bandConfigOptionTypes?: GraphCacheResolver<WithTypename<BandConfig>, Record<string, never>, BandConfigOptionFrontend | string>,
    solo?: GraphCacheResolver<WithTypename<BandConfig>, Record<string, never>, WithTypename<ConfigInfo> | string>,
    duo?: GraphCacheResolver<WithTypename<BandConfig>, Record<string, never>, WithTypename<ConfigInfo> | string>,
    trio?: GraphCacheResolver<WithTypename<BandConfig>, Record<string, never>, WithTypename<ConfigInfo> | string>,
    fourPlus?: GraphCacheResolver<WithTypename<BandConfig>, Record<string, never>, WithTypename<ConfigInfo> | string>
  },
  BarChart?: {
    labels?: GraphCacheResolver<WithTypename<BarChart>, Record<string, never>, Array<Scalars['String'] | string>>,
    data?: GraphCacheResolver<WithTypename<BarChart>, Record<string, never>, Array<Scalars['Float'] | string>>,
    firstFutureIndex?: GraphCacheResolver<WithTypename<BarChart>, Record<string, never>, Scalars['Int'] | string>
  },
  BarChartEdge?: {
    monthly?: GraphCacheResolver<WithTypename<BarChartEdge>, Record<string, never>, WithTypename<BarChart> | string>,
    yearly?: GraphCacheResolver<WithTypename<BarChartEdge>, Record<string, never>, WithTypename<BarChart> | string>
  },
  Bid?: {
    id?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['DateTime'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['DateTime'] | string>,
    status?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, BidStatus | string>,
    notes?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['String'] | string>,
    buyerHasSeen?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['Boolean'] | string>,
    buyerSawAt?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['DateTime'] | string>,
    rejectionMessage?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['String'] | string>,
    withdrawalMessage?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['String'] | string>,
    bandConfiguration?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, BandConfigurationOption | string>,
    buyerPrice?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['Float'] | string>,
    sellerPrice?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, Scalars['Float'] | string>,
    createdBy?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, WithTypename<User> | string>,
    artist?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, WithTypename<Artist> | string>,
    bookingRequest?: GraphCacheResolver<WithTypename<Bid>, Record<string, never>, WithTypename<BookingRequest> | string>
  },
  Booking?: {
    id?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    startTime?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['DateTime'] | string>,
    performanceLengthMins?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Int'] | string>,
    isPublished?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    bookingFlow?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, BookingFlow | string>,
    status?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, BookingStatus | string>,
    statusV2?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, BookingStatusV2 | string>,
    bandConfiguration?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, BandConfigurationOption | string>,
    publicEventDescription?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    capacity?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Int'] | string>,
    comments?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    productionAndVenueSpecs?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    billing?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Billing | string>,
    indoorsOrOutdoors?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, IndoorsOrOutdoors | string>,
    artistName?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    artistSlug?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    artistId?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    venueName?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    venueSlug?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    venueId?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    buyerName?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    buyerSlug?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    buyerId?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    buyerMetadata?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Metadata> | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['DateTime'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['DateTime'] | string>,
    shouldAutoPublish?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    adminCancellationMessage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    cancellationMessage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    cancellationRequested?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    rescheduleMessage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    oldStartTime?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['DateTime'] | string>,
    buyerHasReviewed?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    refundedInCredits?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    negotiationSteps?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Array<WithTypename<NegotiationStep> | string>>,
    lastOfferAmount?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Float'] | string>,
    lastSellerOfferAmount?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Float'] | string>,
    charge?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Charge> | string>,
    payout?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Payout> | string>,
    location?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Location> | string>,
    venue?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Venue> | string>,
    artist?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Artist> | string>,
    buyer?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<User> | string>,
    accountExec?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<User> | string>,
    artistReviews?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Array<WithTypename<ArtistReview> | string>>,
    cancellationRequests?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Array<WithTypename<CancellationRequest> | string>>,
    artistAvailability?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<ArtistAvailability> | string>,
    whatShouldIDoAlerts?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<WhatShouldIDoAlerts> | string>,
    canIEdit?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    canIAdvanceBooking?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    canIEditEventDescription?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    canIPublish?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    canIAutoPublish?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    publishedMessage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    autoPublishMessage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    doINeedToReview?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    doINeedToReviewMessage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['String'] | string>,
    displayPrices?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<DisplayPrices> | string>,
    possibleActions?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Array<NegotiationAction | string>>,
    canSellerSee?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, Scalars['Boolean'] | string>,
    bookingBilling?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<BookingBilling> | string>,
    statusInformation?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<StatusInformation> | string>,
    bookingDispute?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<BookingDispute> | string>,
    confirmation?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<BookingConfirmation> | string>,
    publicCoverImage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Image> | string>,
    publicProfileImage?: GraphCacheResolver<WithTypename<Booking>, Record<string, never>, WithTypename<Image> | string>
  },
  BookingBadgesResponse?: {
    badgeCount?: GraphCacheResolver<WithTypename<BookingBadgesResponse>, Record<string, never>, Scalars['Int'] | string>,
    bookings?: GraphCacheResolver<WithTypename<BookingBadgesResponse>, Record<string, never>, Array<WithTypename<Booking> | string>>
  },
  BookingBilling?: {
    frontendDirections?: GraphCacheResolver<WithTypename<BookingBilling>, Record<string, never>, WithTypename<FrontendDirections> | string>,
    buyerBilling?: GraphCacheResolver<WithTypename<BookingBilling>, Record<string, never>, WithTypename<BuyerBilling> | string>,
    buyerNeedsBankAccountCard?: GraphCacheResolver<WithTypename<BookingBilling>, Record<string, never>, WithTypename<Card> | string>,
    connectAccount?: GraphCacheResolver<WithTypename<BookingBilling>, Record<string, never>, WithTypename<ConnectAccountDisplay> | string>,
    sellerNeedsPayoutMethodCard?: GraphCacheResolver<WithTypename<BookingBilling>, Record<string, never>, WithTypename<Card> | string>,
    receiptItems?: GraphCacheResolver<WithTypename<BookingBilling>, Record<string, never>, Array<WithTypename<ReceiptItem> | string>>
  },
  BookingByBuyerType?: {
    buyerUserType?: GraphCacheResolver<WithTypename<BookingByBuyerType>, Record<string, never>, UserType | string>,
    revenue?: GraphCacheResolver<WithTypename<BookingByBuyerType>, Record<string, never>, Scalars['Float'] | string>,
    bookingsCount?: GraphCacheResolver<WithTypename<BookingByBuyerType>, Record<string, never>, Scalars['Int'] | string>
  },
  BookingByCity?: {
    revenue?: GraphCacheResolver<WithTypename<BookingByCity>, Record<string, never>, Scalars['Float'] | string>,
    bookingsCount?: GraphCacheResolver<WithTypename<BookingByCity>, Record<string, never>, Scalars['Int'] | string>,
    cityName?: GraphCacheResolver<WithTypename<BookingByCity>, Record<string, never>, Scalars['String'] | string>,
    sampleLocation?: GraphCacheResolver<WithTypename<BookingByCity>, Record<string, never>, WithTypename<Location> | string>
  },
  BookingByVenue?: {
    revenue?: GraphCacheResolver<WithTypename<BookingByVenue>, Record<string, never>, Scalars['Float'] | string>,
    bookingsCount?: GraphCacheResolver<WithTypename<BookingByVenue>, Record<string, never>, Scalars['Int'] | string>,
    venueName?: GraphCacheResolver<WithTypename<BookingByVenue>, Record<string, never>, Scalars['String'] | string>,
    venueType?: GraphCacheResolver<WithTypename<BookingByVenue>, Record<string, never>, VenueType | string>,
    location?: GraphCacheResolver<WithTypename<BookingByVenue>, Record<string, never>, WithTypename<Location> | string>,
    venueId?: GraphCacheResolver<WithTypename<BookingByVenue>, Record<string, never>, Scalars['String'] | string>
  },
  BookingConfirmation?: {
    id?: GraphCacheResolver<WithTypename<BookingConfirmation>, Record<string, never>, Scalars['UUID'] | string>,
    confirmedAt?: GraphCacheResolver<WithTypename<BookingConfirmation>, Record<string, never>, Scalars['DateTime'] | string>,
    response?: GraphCacheResolver<WithTypename<BookingConfirmation>, Record<string, never>, BookingConfirmationResponse | string>,
    confirmedBy?: GraphCacheResolver<WithTypename<BookingConfirmation>, Record<string, never>, WithTypename<User> | string>,
    booking?: GraphCacheResolver<WithTypename<BookingConfirmation>, Record<string, never>, WithTypename<Booking> | string>
  },
  BookingDispute?: {
    id?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, Scalars['String'] | string>,
    message?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, Scalars['String'] | string>,
    resolved?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, Scalars['Boolean'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, Scalars['DateTime'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, Scalars['DateTime'] | string>,
    resolvedAt?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, Scalars['DateTime'] | string>,
    user?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, WithTypename<User> | string>,
    booking?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, WithTypename<Booking> | string>,
    resolvedBy?: GraphCacheResolver<WithTypename<BookingDispute>, Record<string, never>, WithTypename<User> | string>
  },
  BookingRequest?: {
    id?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    startTime?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['DateTime'] | string>,
    performanceLengthMins?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Int'] | string>,
    status?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, BookingRequestStatus | string>,
    createdAt?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['DateTime'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['DateTime'] | string>,
    bandConfigurationOptions?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<BandConfigurationOption | string>>,
    artistInstructions?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    indoorsOrOutdoors?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, IndoorsOrOutdoors | string>,
    publicEventDescription?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    capacity?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Int'] | string>,
    billing?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Billing | string>,
    genres?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<Scalars['String'] | string>>,
    budget?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<PriceRangeOptional> | string>,
    budgetBuyer?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<PriceRangeOptional> | string>,
    shouldAutoPublish?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Boolean'] | string>,
    venueLocation?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<Location> | string>,
    venueName?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    venueSlug?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    venueId?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    venue?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<Venue> | string>,
    artistsBuyer?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<WithTypename<Artist> | string>>,
    artists?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<WithTypename<Artist> | string>>,
    accountExec?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<User> | string>,
    adminInstructionsBuyer?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    adminInstructions?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['String'] | string>,
    whatShouldIDoAlerts?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<WhatShouldIDoAlerts> | string>,
    bids?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<WithTypename<Bid> | string>>,
    buyerFrontendCopy?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<FrontendDirections> | string>,
    otherBookingRequestsInGroup?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<WithTypename<BookingRequest> | string>>,
    createdBy?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<User> | string>,
    booking?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<Booking> | string>,
    isActionRequired?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Boolean'] | string>,
    canIEdit?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Boolean'] | string>,
    areAllMyBidsRejected?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Boolean'] | string>,
    myArtistsThatCanBid?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<WithTypename<Artist> | string>>,
    didSomeoneElsesBidGetChosen?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Boolean'] | string>,
    myAcceptedBid?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, WithTypename<Bid> | string>,
    isPast?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Scalars['Boolean'] | string>,
    declines?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<WithTypename<BookingRequestDecline> | string>>,
    extraArtistInfos?: GraphCacheResolver<WithTypename<BookingRequest>, Record<string, never>, Array<WithTypename<ExtraArtistInfo> | string>>
  },
  BookingRequestBadgesResponse?: {
    badgeCount?: GraphCacheResolver<WithTypename<BookingRequestBadgesResponse>, Record<string, never>, Scalars['Int'] | string>,
    bookingRequests?: GraphCacheResolver<WithTypename<BookingRequestBadgesResponse>, Record<string, never>, Array<WithTypename<BookingRequest> | string>>
  },
  BookingRequestDecline?: {
    id?: GraphCacheResolver<WithTypename<BookingRequestDecline>, Record<string, never>, Scalars['String'] | string>,
    timestamp?: GraphCacheResolver<WithTypename<BookingRequestDecline>, Record<string, never>, Scalars['DateTime'] | string>,
    reasonForDecline?: GraphCacheResolver<WithTypename<BookingRequestDecline>, Record<string, never>, Scalars['String'] | string>,
    artist?: GraphCacheResolver<WithTypename<BookingRequestDecline>, Record<string, never>, WithTypename<Artist> | string>,
    declinedBy?: GraphCacheResolver<WithTypename<BookingRequestDecline>, Record<string, never>, WithTypename<User> | string>,
    bookingRequest?: GraphCacheResolver<WithTypename<BookingRequestDecline>, Record<string, never>, WithTypename<BookingRequest> | string>
  },
  BookingTypesense?: {
    id?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    artistId?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    artistName?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    isPublished?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['Boolean'] | string>,
    startTime?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['Int'] | string>,
    location?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, WithTypename<Location> | string>,
    locationGeopoint?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Array<Scalars['Float'] | string>>,
    lastUpdated?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['Int'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['Int'] | string>,
    lastTriggeredToTypesenseAt?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['Int'] | string>,
    statusV2?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, BookingStatusV2 | string>,
    buyerName?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    startTimeQueryableStr?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    latLngStr?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    yearMonthStr?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    artistProfileImage?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, WithTypename<Image> | string>,
    venueId?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    venueName?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    venueProfileImage?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, WithTypename<Image> | string>,
    buyerMetadataLocation?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    buyerMetadataOrganization?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    artistCategory?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Scalars['String'] | string>,
    artistSubgenres?: GraphCacheResolver<WithTypename<BookingTypesense>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  Button?: {
    url?: GraphCacheResolver<WithTypename<Button>, Record<string, never>, Scalars['String'] | string>,
    text?: GraphCacheResolver<WithTypename<Button>, Record<string, never>, Scalars['String'] | string>,
    subtext?: GraphCacheResolver<WithTypename<Button>, Record<string, never>, Scalars['String'] | string>
  },
  BuyerBilling?: {
    bankAccount?: GraphCacheResolver<WithTypename<BuyerBilling>, Record<string, never>, WithTypename<StripeBankAccount> | string>,
    needsBankAccountCard?: GraphCacheResolver<WithTypename<BuyerBilling>, Record<string, never>, WithTypename<Card> | string>
  },
  CalendarBooking?: {
    id?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['String'] | string>,
    beatgigId?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['String'] | string>,
    artistName?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['String'] | string>,
    startTime?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['DateTime'] | string>,
    bookingType?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, CalendarBookingType | string>,
    performanceLengthMins?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['Int'] | string>,
    artistProfileImage?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, WithTypename<Image> | string>,
    artistCoverImage?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, WithTypename<Image> | string>,
    artistBio?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['String'] | string>,
    publicEventDescription?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['String'] | string>,
    artistSlug?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Scalars['String'] | string>,
    publicCoverImage?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, WithTypename<Image> | string>,
    publicProfileImage?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, WithTypename<Image> | string>,
    artistCategory?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, Category | string>,
    bandConfiguration?: GraphCacheResolver<WithTypename<CalendarBooking>, Record<string, never>, BandConfigurationOption | string>
  },
  CalendarBookingsResponse?: {
    calendarBookings?: GraphCacheResolver<WithTypename<CalendarBookingsResponse>, Record<string, never>, Array<WithTypename<CalendarBooking> | string>>,
    canFetchMore?: GraphCacheResolver<WithTypename<CalendarBookingsResponse>, Record<string, never>, Scalars['Boolean'] | string>,
    venueLocation?: GraphCacheResolver<WithTypename<CalendarBookingsResponse>, Record<string, never>, WithTypename<Location> | string>,
    venueId?: GraphCacheResolver<WithTypename<CalendarBookingsResponse>, Record<string, never>, Scalars['String'] | string>
  },
  CancellationRequest?: {
    id?: GraphCacheResolver<WithTypename<CancellationRequest>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<CancellationRequest>, Record<string, never>, Scalars['DateTime'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<CancellationRequest>, Record<string, never>, Scalars['DateTime'] | string>,
    resolved?: GraphCacheResolver<WithTypename<CancellationRequest>, Record<string, never>, Scalars['Boolean'] | string>,
    message?: GraphCacheResolver<WithTypename<CancellationRequest>, Record<string, never>, Scalars['String'] | string>,
    user?: GraphCacheResolver<WithTypename<CancellationRequest>, Record<string, never>, WithTypename<User> | string>,
    booking?: GraphCacheResolver<WithTypename<CancellationRequest>, Record<string, never>, WithTypename<Booking> | string>
  },
  Card?: {
    header?: GraphCacheResolver<WithTypename<Card>, Record<string, never>, Scalars['String'] | string>,
    message?: GraphCacheResolver<WithTypename<Card>, Record<string, never>, Scalars['String'] | string>,
    disclaimer?: GraphCacheResolver<WithTypename<Card>, Record<string, never>, Scalars['String'] | string>,
    buttonText?: GraphCacheResolver<WithTypename<Card>, Record<string, never>, Scalars['String'] | string>
  },
  Charge?: {
    chargedBuyer?: GraphCacheResolver<WithTypename<Charge>, Record<string, never>, Scalars['Boolean'] | string>,
    manuallyChargedBuyer?: GraphCacheResolver<WithTypename<Charge>, Record<string, never>, Scalars['Boolean'] | string>,
    invoiceId?: GraphCacheResolver<WithTypename<Charge>, Record<string, never>, Scalars['String'] | string>,
    invoiceItemId?: GraphCacheResolver<WithTypename<Charge>, Record<string, never>, Scalars['String'] | string>,
    cancelledInvoiceId?: GraphCacheResolver<WithTypename<Charge>, Record<string, never>, Scalars['String'] | string>,
    manuallyChargedBuyerBy?: GraphCacheResolver<WithTypename<Charge>, Record<string, never>, Scalars['String'] | string>
  },
  Colors?: {
    primary?: GraphCacheResolver<WithTypename<Colors>, Record<string, never>, Scalars['String'] | string>,
    colorMode?: GraphCacheResolver<WithTypename<Colors>, Record<string, never>, ColorMode | string>
  },
  ConfigInfo?: {
    prices?: GraphCacheResolver<WithTypename<ConfigInfo>, Record<string, never>, WithTypename<Prices> | string>,
    notes?: GraphCacheResolver<WithTypename<ConfigInfo>, Record<string, never>, Scalars['String'] | string>
  },
  ConnectAccountDisplay?: {
    id?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, Scalars['String'] | string>,
    needsToOnboard?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, Scalars['Boolean'] | string>,
    needsToAddInformation?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, Scalars['Boolean'] | string>,
    canTransfer?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, Scalars['Boolean'] | string>,
    button?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, WithTypename<Button> | string>,
    payoutMethod?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, WithTypename<PayoutMethod> | string>,
    onboardingLink?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, Scalars['String'] | string>,
    dashboardLink?: GraphCacheResolver<WithTypename<ConnectAccountDisplay>, Record<string, never>, Scalars['String'] | string>
  },
  ContactInformation?: {
    phoneNumber?: GraphCacheResolver<WithTypename<ContactInformation>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<ContactInformation>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<ContactInformation>, Record<string, never>, Scalars['String'] | string>
  },
  CourierChannel?: {
    key?: GraphCacheResolver<WithTypename<CourierChannel>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<CourierChannel>, Record<string, never>, Scalars['String'] | string>,
    template?: GraphCacheResolver<WithTypename<CourierChannel>, Record<string, never>, Scalars['String'] | string>
  },
  CourierMessage?: {
    id?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Status | string>,
    recipient?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    recipientId?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    event?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    courierUrl?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    enqueued?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['DateTime'] | string>,
    sent?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['DateTime'] | string>,
    delivered?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['DateTime'] | string>,
    opened?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['DateTime'] | string>,
    clicked?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['DateTime'] | string>,
    notification?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    error?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    reason?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Scalars['String'] | string>,
    channel?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, WithTypename<CourierChannel> | string>,
    providers?: GraphCacheResolver<WithTypename<CourierMessage>, Record<string, never>, Array<WithTypename<CourierProvider> | string>>
  },
  CourierProvider?: {
    provider?: GraphCacheResolver<WithTypename<CourierProvider>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<CourierProvider>, Record<string, never>, Status | string>,
    sent?: GraphCacheResolver<WithTypename<CourierProvider>, Record<string, never>, Scalars['DateTime'] | string>,
    delivered?: GraphCacheResolver<WithTypename<CourierProvider>, Record<string, never>, Scalars['DateTime'] | string>,
    clicked?: GraphCacheResolver<WithTypename<CourierProvider>, Record<string, never>, Scalars['DateTime'] | string>,
    opened?: GraphCacheResolver<WithTypename<CourierProvider>, Record<string, never>, Scalars['DateTime'] | string>,
    error?: GraphCacheResolver<WithTypename<CourierProvider>, Record<string, never>, Scalars['String'] | string>
  },
  DiscoverArtist?: {
    id?: GraphCacheResolver<WithTypename<DiscoverArtist>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<DiscoverArtist>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<DiscoverArtist>, Record<string, never>, Scalars['String'] | string>,
    numberOfReviews?: GraphCacheResolver<WithTypename<DiscoverArtist>, Record<string, never>, Scalars['Int'] | string>,
    avgRating?: GraphCacheResolver<WithTypename<DiscoverArtist>, Record<string, never>, Scalars['Float'] | string>,
    profileImage?: GraphCacheResolver<WithTypename<DiscoverArtist>, Record<string, never>, WithTypename<Image> | string>,
    displayPriceRange?: GraphCacheResolver<WithTypename<DiscoverArtist>, Record<string, never>, WithTypename<PriceRange> | string>
  },
  DisplayImages?: {
    profileImage?: GraphCacheResolver<WithTypename<DisplayImages>, Record<string, never>, WithTypename<Image> | string>,
    coverImage?: GraphCacheResolver<WithTypename<DisplayImages>, Record<string, never>, WithTypename<Image> | string>
  },
  DisplayPrices?: {
    buyer?: GraphCacheResolver<WithTypename<DisplayPrices>, Record<string, never>, Scalars['Float'] | string>,
    seller?: GraphCacheResolver<WithTypename<DisplayPrices>, Record<string, never>, Scalars['Float'] | string>
  },
  ExternalBooking?: {
    id?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['String'] | string>,
    startTime?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['DateTime'] | string>,
    performanceLengthMins?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['Int'] | string>,
    isPublished?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['Boolean'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['String'] | string>,
    artistName?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['String'] | string>,
    coverImage?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, WithTypename<Image> | string>,
    indoorsOrOutdoors?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, IndoorsOrOutdoors | string>,
    publicEventDescription?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['String'] | string>,
    venue?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, WithTypename<Venue> | string>,
    canIEdit?: GraphCacheResolver<WithTypename<ExternalBooking>, Record<string, never>, Scalars['Boolean'] | string>
  },
  ExternalCalendarEvent?: {
    busy?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, Scalars['Boolean'] | string>,
    calendarId?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, EventStatus | string>,
    participants?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, Array<WithTypename<Participant> | string>>,
    when?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, WithTypename<WhenTimeWhenTimespanWhenDateWhenDatespan> | string>,
    description?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, Scalars['String'] | string>,
    location?: GraphCacheResolver<WithTypename<ExternalCalendarEvent>, Record<string, never>, Scalars['String'] | string>
  },
  ExternalUrls?: {
    spotify?: GraphCacheResolver<WithTypename<ExternalUrls>, Record<string, never>, Scalars['String'] | string>
  },
  ExtraArtistInfo?: {
    id?: GraphCacheResolver<WithTypename<ExtraArtistInfo>, Record<string, never>, Scalars['String'] | string>,
    recommendedPrice?: GraphCacheResolver<WithTypename<ExtraArtistInfo>, Record<string, never>, Scalars['Float'] | string>,
    artistDetailsForBuyerByAdmin?: GraphCacheResolver<WithTypename<ExtraArtistInfo>, Record<string, never>, Scalars['String'] | string>,
    artist?: GraphCacheResolver<WithTypename<ExtraArtistInfo>, Record<string, never>, WithTypename<Artist> | string>,
    recommendedBy?: GraphCacheResolver<WithTypename<ExtraArtistInfo>, Record<string, never>, WithTypename<User> | string>,
    bookingRequest?: GraphCacheResolver<WithTypename<ExtraArtistInfo>, Record<string, never>, WithTypename<BookingRequest> | string>
  },
  Followers?: {
    total?: GraphCacheResolver<WithTypename<Followers>, Record<string, never>, Scalars['Int'] | string>
  },
  FrontendDirections?: {
    notes?: GraphCacheResolver<WithTypename<FrontendDirections>, Record<string, never>, Array<WithTypename<Note> | string>>,
    tooltip?: GraphCacheResolver<WithTypename<FrontendDirections>, Record<string, never>, WithTypename<Tooltip> | string>,
    shortMessage?: GraphCacheResolver<WithTypename<FrontendDirections>, Record<string, never>, WithTypename<ShortMessage> | string>
  },
  GamificationMetric?: {
    value?: GraphCacheResolver<WithTypename<GamificationMetric>, Record<string, never>, Scalars['Float'] | string>,
    score?: GraphCacheResolver<WithTypename<GamificationMetric>, Record<string, never>, Scalars['Int'] | string>,
    quality?: GraphCacheResolver<WithTypename<GamificationMetric>, Record<string, never>, Quality | string>
  },
  GamificationMetrics?: {
    likeCount?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    viewCount?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    avgRating?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    numberOfReviews?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    bookingsCount?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    cancellationsCount?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    responseTimeMins?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    responseRate?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>,
    cancellationRate?: GraphCacheResolver<WithTypename<GamificationMetrics>, Record<string, never>, WithTypename<GamificationMetric> | string>
  },
  GeoLoc?: {
    lat?: GraphCacheResolver<WithTypename<GeoLoc>, Record<string, never>, Scalars['Float'] | string>,
    lng?: GraphCacheResolver<WithTypename<GeoLoc>, Record<string, never>, Scalars['Float'] | string>
  },
  Image?: {
    height?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, Scalars['Int'] | string>,
    width?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, Scalars['Int'] | string>,
    url?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, Scalars['String'] | string>,
    publicCloudinaryId?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, Scalars['String'] | string>,
    verticalAlign?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, VerticalAlign | string>
  },
  ImageSpotify?: {
    url?: GraphCacheResolver<WithTypename<ImageSpotify>, Record<string, never>, Scalars['String'] | string>,
    height?: GraphCacheResolver<WithTypename<ImageSpotify>, Record<string, never>, Scalars['Int'] | string>,
    width?: GraphCacheResolver<WithTypename<ImageSpotify>, Record<string, never>, Scalars['Int'] | string>
  },
  Images?: {
    gallery?: GraphCacheResolver<WithTypename<Images>, Record<string, never>, Array<WithTypename<Image> | string>>,
    allSources?: GraphCacheResolver<WithTypename<Images>, Record<string, never>, Array<WithTypename<Image> | string>>
  },
  IpResponse?: {
    stateAbbr?: GraphCacheResolver<WithTypename<IpResponse>, Record<string, never>, Scalars['String'] | string>,
    countryAbbr?: GraphCacheResolver<WithTypename<IpResponse>, Record<string, never>, Scalars['String'] | string>
  },
  LastMoved?: {
    buyer?: GraphCacheResolver<WithTypename<LastMoved>, Record<string, never>, Array<NegotiationAction | string>>,
    seller?: GraphCacheResolver<WithTypename<LastMoved>, Record<string, never>, Array<NegotiationAction | string>>
  },
  Location?: {
    lat?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['Float'] | string>,
    lng?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['Float'] | string>,
    timezone?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>,
    city?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>,
    stateAbbr?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>,
    countryId?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['Int'] | string>,
    countryName?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>,
    postalCode?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>,
    streetAddress?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>,
    unit?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>,
    placeId?: GraphCacheResolver<WithTypename<Location>, Record<string, never>, Scalars['String'] | string>
  },
  Media?: {
    songs?: GraphCacheResolver<WithTypename<Media>, Record<string, never>, WithTypename<Songs> | string>,
    videos?: GraphCacheResolver<WithTypename<Media>, Record<string, never>, WithTypename<Videos> | string>,
    images?: GraphCacheResolver<WithTypename<Media>, Record<string, never>, WithTypename<Images> | string>
  },
  Metadata?: {
    userType?: GraphCacheResolver<WithTypename<Metadata>, Record<string, never>, UserType | string>,
    organization?: GraphCacheResolver<WithTypename<Metadata>, Record<string, never>, Scalars['String'] | string>,
    location?: GraphCacheResolver<WithTypename<Metadata>, Record<string, never>, Scalars['String'] | string>
  },
  Metric?: {
    barCharts?: GraphCacheResolver<WithTypename<Metric>, Record<string, never>, WithTypename<BarChartEdge> | string>,
    overview?: GraphCacheResolver<WithTypename<Metric>, Record<string, never>, WithTypename<Overview> | string>
  },
  Metrics?: {
    revenue?: GraphCacheResolver<WithTypename<Metrics>, Record<string, never>, WithTypename<Metric> | string>,
    bookingsCount?: GraphCacheResolver<WithTypename<Metrics>, Record<string, never>, WithTypename<Metric> | string>
  },
  MyBadgeResponse?: {
    total?: GraphCacheResolver<WithTypename<MyBadgeResponse>, Record<string, never>, Scalars['Int'] | string>,
    bookings?: GraphCacheResolver<WithTypename<MyBadgeResponse>, Record<string, never>, Scalars['Int'] | string>,
    bookingRequests?: GraphCacheResolver<WithTypename<MyBadgeResponse>, Record<string, never>, Scalars['Int'] | string>,
    artistAvailChecks?: GraphCacheResolver<WithTypename<MyBadgeResponse>, Record<string, never>, Scalars['Int'] | string>
  },
  NegotiationStep?: {
    userId?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, Scalars['String'] | string>,
    userRole?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, UserRole | string>,
    onBehalfOfRole?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, OnBehalfOfRole | string>,
    action?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, NegotiationAction | string>,
    offerAmount?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, Scalars['Float'] | string>,
    sellerOfferAmount?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, Scalars['Float'] | string>,
    timestamp?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, Scalars['DateTime'] | string>,
    description?: GraphCacheResolver<WithTypename<NegotiationStep>, Record<string, never>, WithTypename<NegotiationStepDescription> | string>
  },
  NegotiationStepDescription?: {
    buyer?: GraphCacheResolver<WithTypename<NegotiationStepDescription>, Record<string, never>, Scalars['String'] | string>,
    seller?: GraphCacheResolver<WithTypename<NegotiationStepDescription>, Record<string, never>, Scalars['String'] | string>,
    admin?: GraphCacheResolver<WithTypename<NegotiationStepDescription>, Record<string, never>, Scalars['String'] | string>
  },
  Note?: {
    message?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Scalars['String'] | string>,
    variant?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Variant | string>,
    filling?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Filling | string>,
    size?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Size | string>,
    label?: GraphCacheResolver<WithTypename<Note>, Record<string, never>, Scalars['String'] | string>
  },
  Overview?: {
    allTimeValue?: GraphCacheResolver<WithTypename<Overview>, Record<string, never>, Scalars['Float'] | string>,
    growth?: GraphCacheResolver<WithTypename<Overview>, Record<string, never>, Scalars['Float'] | string>
  },
  Participant?: {
    email?: GraphCacheResolver<WithTypename<Participant>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<Participant>, Record<string, never>, ParticipantStatus | string>,
    name?: GraphCacheResolver<WithTypename<Participant>, Record<string, never>, Scalars['String'] | string>,
    comment?: GraphCacheResolver<WithTypename<Participant>, Record<string, never>, Scalars['String'] | string>,
    phoneNumber?: GraphCacheResolver<WithTypename<Participant>, Record<string, never>, Scalars['String'] | string>
  },
  Payout?: {
    paidSeller?: GraphCacheResolver<WithTypename<Payout>, Record<string, never>, Scalars['Boolean'] | string>,
    manuallyPaidSeller?: GraphCacheResolver<WithTypename<Payout>, Record<string, never>, Scalars['Boolean'] | string>,
    transferId?: GraphCacheResolver<WithTypename<Payout>, Record<string, never>, Scalars['String'] | string>,
    manuallyPaidSellerBy?: GraphCacheResolver<WithTypename<Payout>, Record<string, never>, Scalars['String'] | string>
  },
  PayoutMethod?: {
    brand?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    country?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    currency?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    expMonth?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['Int'] | string>,
    expYear?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['Int'] | string>,
    funding?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    last4?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    availablePayoutMethods?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Array<Scalars['String'] | string>>,
    object?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    bankName?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>,
    routingNumber?: GraphCacheResolver<WithTypename<PayoutMethod>, Record<string, never>, Scalars['String'] | string>
  },
  Pipeline?: {
    confirmed?: GraphCacheResolver<WithTypename<Pipeline>, Record<string, never>, WithTypename<PipelineMetrics> | string>,
    pending?: GraphCacheResolver<WithTypename<Pipeline>, Record<string, never>, WithTypename<PipelineMetrics> | string>
  },
  PipelineMetrics?: {
    revenue?: GraphCacheResolver<WithTypename<PipelineMetrics>, Record<string, never>, Scalars['Float'] | string>,
    bookingsCount?: GraphCacheResolver<WithTypename<PipelineMetrics>, Record<string, never>, Scalars['Int'] | string>
  },
  PossibleActions?: {
    buyer?: GraphCacheResolver<WithTypename<PossibleActions>, Record<string, never>, WithTypename<LastMoved> | string>,
    seller?: GraphCacheResolver<WithTypename<PossibleActions>, Record<string, never>, WithTypename<LastMoved> | string>
  },
  PriceRange?: {
    low?: GraphCacheResolver<WithTypename<PriceRange>, Record<string, never>, Scalars['Float'] | string>,
    high?: GraphCacheResolver<WithTypename<PriceRange>, Record<string, never>, Scalars['Float'] | string>
  },
  PriceRangeOptional?: {
    low?: GraphCacheResolver<WithTypename<PriceRangeOptional>, Record<string, never>, Scalars['Float'] | string>,
    high?: GraphCacheResolver<WithTypename<PriceRangeOptional>, Record<string, never>, Scalars['Float'] | string>
  },
  Prices?: {
    private?: GraphCacheResolver<WithTypename<Prices>, Record<string, never>, WithTypename<PriceRange> | string>,
    public?: GraphCacheResolver<WithTypename<Prices>, Record<string, never>, WithTypename<PriceRange> | string>
  },
  PublicInvoice?: {
    id?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, Scalars['String'] | string>,
    created?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, Scalars['DateTime'] | string>,
    customerName?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, InvoiceStatus | string>,
    paid?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, Scalars['Boolean'] | string>,
    amountDue?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, Scalars['Int'] | string>,
    hostedInvoiceUrl?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, Scalars['String'] | string>,
    invoicePdf?: GraphCacheResolver<WithTypename<PublicInvoice>, Record<string, never>, Scalars['String'] | string>
  },
  PublicUser?: {
    id?: GraphCacheResolver<WithTypename<PublicUser>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<PublicUser>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<PublicUser>, Record<string, never>, Scalars['String'] | string>
  },
  Question?: {
    id?: GraphCacheResolver<WithTypename<Question>, Record<string, never>, Scalars['String'] | string>,
    body?: GraphCacheResolver<WithTypename<Question>, Record<string, never>, Scalars['String'] | string>,
    subtitle?: GraphCacheResolver<WithTypename<Question>, Record<string, never>, Scalars['String'] | string>,
    type?: GraphCacheResolver<WithTypename<Question>, Record<string, never>, PreferenceType | string>,
    response?: GraphCacheResolver<WithTypename<Question>, Record<string, never>, Scalars['String'] | string>
  },
  ReceiptItem?: {
    title?: GraphCacheResolver<WithTypename<ReceiptItem>, Record<string, never>, Scalars['String'] | string>,
    description?: GraphCacheResolver<WithTypename<ReceiptItem>, Record<string, never>, Scalars['String'] | string>,
    dollarAmount?: GraphCacheResolver<WithTypename<ReceiptItem>, Record<string, never>, Scalars['Float'] | string>,
    percentage?: GraphCacheResolver<WithTypename<ReceiptItem>, Record<string, never>, Scalars['Float'] | string>
  },
  Row?: {
    name?: GraphCacheResolver<WithTypename<Row>, Record<string, never>, Scalars['String'] | string>,
    artists?: GraphCacheResolver<WithTypename<Row>, Record<string, never>, Array<WithTypename<DiscoverArtist> | string>>,
    category?: GraphCacheResolver<WithTypename<Row>, Record<string, never>, Category | string>,
    subgenres?: GraphCacheResolver<WithTypename<Row>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  SendImageToEmailResponse?: {
    email?: GraphCacheResolver<WithTypename<SendImageToEmailResponse>, Record<string, never>, Scalars['String'] | string>
  },
  SendImageToPhoneResponse?: {
    phoneNumber?: GraphCacheResolver<WithTypename<SendImageToPhoneResponse>, Record<string, never>, Scalars['String'] | string>
  },
  SetPlaidAccessTokenResponse?: {
    allBankAccounts?: GraphCacheResolver<WithTypename<SetPlaidAccessTokenResponse>, Record<string, never>, Array<WithTypename<StripeBankAccount> | string>>,
    createdBankAccount?: GraphCacheResolver<WithTypename<SetPlaidAccessTokenResponse>, Record<string, never>, WithTypename<StripeBankAccount> | string>
  },
  ShortMessage?: {
    title?: GraphCacheResolver<WithTypename<ShortMessage>, Record<string, never>, Scalars['String'] | string>,
    body?: GraphCacheResolver<WithTypename<ShortMessage>, Record<string, never>, Scalars['String'] | string>
  },
  SmallImage?: {
    url?: GraphCacheResolver<WithTypename<SmallImage>, Record<string, never>, Scalars['String'] | string>,
    publicCloudinaryId?: GraphCacheResolver<WithTypename<SmallImage>, Record<string, never>, Scalars['String'] | string>,
    height?: GraphCacheResolver<WithTypename<SmallImage>, Record<string, never>, Scalars['Int'] | string>,
    width?: GraphCacheResolver<WithTypename<SmallImage>, Record<string, never>, Scalars['Int'] | string>
  },
  SocialMedia?: {
    facebook?: GraphCacheResolver<WithTypename<SocialMedia>, Record<string, never>, Scalars['String'] | string>,
    soundcloud?: GraphCacheResolver<WithTypename<SocialMedia>, Record<string, never>, Scalars['String'] | string>,
    youtube?: GraphCacheResolver<WithTypename<SocialMedia>, Record<string, never>, Scalars['String'] | string>,
    twitter?: GraphCacheResolver<WithTypename<SocialMedia>, Record<string, never>, Scalars['String'] | string>,
    instagram?: GraphCacheResolver<WithTypename<SocialMedia>, Record<string, never>, Scalars['String'] | string>,
    spotify?: GraphCacheResolver<WithTypename<SocialMedia>, Record<string, never>, Scalars['String'] | string>
  },
  Songs?: {
    soundcloud?: GraphCacheResolver<WithTypename<Songs>, Record<string, never>, Array<Scalars['String'] | string>>,
    spotify?: GraphCacheResolver<WithTypename<Songs>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  StatusInformation?: {
    statusBar?: GraphCacheResolver<WithTypename<StatusInformation>, Record<string, never>, Array<WithTypename<StatusNode> | string>>,
    currentStepIndex?: GraphCacheResolver<WithTypename<StatusInformation>, Record<string, never>, Scalars['Int'] | string>,
    currentStep?: GraphCacheResolver<WithTypename<StatusInformation>, Record<string, never>, WithTypename<StatusNode> | string>,
    totalStepCount?: GraphCacheResolver<WithTypename<StatusInformation>, Record<string, never>, Scalars['Int'] | string>
  },
  StatusNode?: {
    status?: GraphCacheResolver<WithTypename<StatusNode>, Record<string, never>, BookingStatusV2 | string>,
    buyerDescription?: GraphCacheResolver<WithTypename<StatusNode>, Record<string, never>, Scalars['String'] | string>,
    sellerDescription?: GraphCacheResolver<WithTypename<StatusNode>, Record<string, never>, Scalars['String'] | string>,
    possibleActions?: GraphCacheResolver<WithTypename<StatusNode>, Record<string, never>, WithTypename<PossibleActions> | string>
  },
  StripeBankAccount?: {
    id?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    object?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    accountHolderName?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    accountHolderType?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    bankName?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    country?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    currency?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    customer?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    fingerprint?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    last4?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    routingNumber?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['String'] | string>,
    isDefault?: GraphCacheResolver<WithTypename<StripeBankAccount>, Record<string, never>, Scalars['Boolean'] | string>
  },
  Tooltip?: {
    tempField?: GraphCacheResolver<WithTypename<Tooltip>, Record<string, never>, Scalars['String'] | string>
  },
  TransferMetadata?: {
    bookingId?: GraphCacheResolver<WithTypename<TransferMetadata>, Record<string, never>, Scalars['String'] | string>
  },
  TransferStripe?: {
    id?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>,
    object?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>,
    amount?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['Int'] | string>,
    amountReversed?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['Int'] | string>,
    balanceTransaction?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>,
    created?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['Int'] | string>,
    currency?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>,
    reversed?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['Boolean'] | string>,
    metadata?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, WithTypename<TransferMetadata> | string>,
    description?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>,
    sourceTransaction?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>,
    sourceType?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>,
    transferGroup?: GraphCacheResolver<WithTypename<TransferStripe>, Record<string, never>, Scalars['String'] | string>
  },
  User?: {
    id?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    userRole?: GraphCacheResolver<WithTypename<User>, Record<string, never>, UserRole | string>,
    userType?: GraphCacheResolver<WithTypename<User>, Record<string, never>, UserType | string>,
    slug?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['DateTime'] | string>,
    approved?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    approval?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<Approval> | string>,
    defaultStateAbbr?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    otherStateResponse?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    profileImage?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<Image> | string>,
    metadata?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<Metadata> | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['DateTime'] | string>,
    isApproved?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    email?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    phoneNumber?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    approvedBy?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<User> | string>,
    approvedAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['DateTime'] | string>,
    publicOrPrivate?: GraphCacheResolver<WithTypename<User>, Record<string, never>, PublicOrPrivate | string>,
    artists?: GraphCacheResolver<WithTypename<User>, UserArtistsArgs, Array<WithTypename<Artist> | string>>,
    venues?: GraphCacheResolver<WithTypename<User>, UserVenuesArgs, Array<WithTypename<Venue> | string>>,
    allMyVenues?: GraphCacheResolver<WithTypename<User>, UserAllMyVenuesArgs, Array<WithTypename<Venue> | string>>,
    venuesAssignedTo?: GraphCacheResolver<WithTypename<User>, UserVenuesAssignedToArgs, Array<WithTypename<Venue> | string>>,
    bookings?: GraphCacheResolver<WithTypename<User>, UserBookingsArgs, Array<WithTypename<Booking> | string>>,
    accountExecBookings?: GraphCacheResolver<WithTypename<User>, UserAccountExecBookingsArgs, Array<WithTypename<Booking> | string>>,
    numberOfArtists?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Int'] | string>,
    numberOfVenues?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Int'] | string>,
    signUpMessage?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    bookingBadges?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<BookingBadgesResponse> | string>,
    bookingRequestBadges?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<BookingRequestBadgesResponse> | string>,
    likes?: GraphCacheResolver<WithTypename<User>, UserLikesArgs, Array<WithTypename<ArtistLike> | string>>,
    hasSyncedCalendar?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    externalCalendarEvents?: GraphCacheResolver<WithTypename<User>, UserExternalCalendarEventsArgs, Array<WithTypename<ExternalCalendarEvent> | string>>,
    badgeCount?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Int'] | string>,
    bookingPreferences?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Array<WithTypename<Question> | string>>
  },
  UserDoesNotExist?: {
    exists?: GraphCacheResolver<WithTypename<UserDoesNotExist>, Record<string, never>, Scalars['Boolean'] | string>
  },
  UserTypesense?: {
    id?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    phoneNumber?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    userRole?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, UserRole | string>,
    userType?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, UserType | string>,
    createdAt?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['Int'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['Int'] | string>,
    approved?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['Boolean'] | string>,
    lastTriggeredToTypesenseAt?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['Int'] | string>,
    publicOrPrivate?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, PublicOrPrivate | string>,
    metadata?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, WithTypename<Metadata> | string>,
    objectID?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    profileImage?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, WithTypename<Image> | string>,
    metadataLocation?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    metadataOrganization?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    venueNamesStr?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>,
    artistNamesStr?: GraphCacheResolver<WithTypename<UserTypesense>, Record<string, never>, Scalars['String'] | string>
  },
  Venue?: {
    id?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    placeId?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    venueType?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, VenueType | string>,
    name?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    numStages?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['Int'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['DateTime'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['DateTime'] | string>,
    description?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    parkingAndLoadingAccess?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    website?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    phoneNumber?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    productionAndVenueSpecs?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['String'] | string>,
    displayImages?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<DisplayImages> | string>,
    capacity?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Scalars['Int'] | string>,
    socialMedia?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<SocialMedia> | string>,
    images?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Array<WithTypename<Image> | string>>,
    logo?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<Image> | string>,
    colors?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<Colors> | string>,
    location?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<Location> | string>,
    budget?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<PriceRangeOptional> | string>,
    genresBooked?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Array<Scalars['String'] | string>>,
    owners?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Array<WithTypename<User> | string>>,
    pendingUserPhoneNumbers?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Array<Scalars['String'] | string>>,
    accountExec?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<User> | string>,
    createdBy?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<User> | string>,
    bookings?: GraphCacheResolver<WithTypename<Venue>, VenueBookingsArgs, Array<WithTypename<Booking> | string>>,
    bookingRequests?: GraphCacheResolver<WithTypename<Venue>, VenueBookingRequestsArgs, Array<WithTypename<BookingRequest> | string>>,
    externalBookings?: GraphCacheResolver<WithTypename<Venue>, VenueExternalBookingsArgs, Array<WithTypename<ExternalBooking> | string>>,
    calendarBookings?: GraphCacheResolver<WithTypename<Venue>, VenueCalendarBookingsArgs, WithTypename<CalendarBookingsResponse> | string>,
    invoices?: GraphCacheResolver<WithTypename<Venue>, VenueInvoicesArgs, Array<WithTypename<PublicInvoice> | string>>,
    bankAccounts?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, Array<WithTypename<StripeBankAccount> | string>>,
    defaultBankAccount?: GraphCacheResolver<WithTypename<Venue>, Record<string, never>, WithTypename<StripeBankAccount> | string>
  },
  VenueTypesense?: {
    id?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['String'] | string>,
    firebaseId?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['String'] | string>,
    venueType?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, VenueType | string>,
    createdAt?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['Int'] | string>,
    lastUpdated?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['Int'] | string>,
    lastTriggeredToTypesenseAt?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['Int'] | string>,
    location?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, WithTypename<Location> | string>,
    locationGeopoint?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Array<Scalars['Float'] | string>>,
    objectID?: GraphCacheResolver<WithTypename<VenueTypesense>, Record<string, never>, Scalars['String'] | string>
  },
  Videos?: {
    youtube?: GraphCacheResolver<WithTypename<Videos>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  WhatShouldIDoAlerts?: {
    buyer?: GraphCacheResolver<WithTypename<WhatShouldIDoAlerts>, Record<string, never>, WhatShouldIDoAlert | string>,
    seller?: GraphCacheResolver<WithTypename<WhatShouldIDoAlerts>, Record<string, never>, WhatShouldIDoAlert | string>
  },
  WhenDate?: {
    date?: GraphCacheResolver<WithTypename<WhenDate>, Record<string, never>, Scalars['Date'] | string>
  },
  WhenDatespan?: {
    startDate?: GraphCacheResolver<WithTypename<WhenDatespan>, Record<string, never>, Scalars['Date'] | string>,
    endDate?: GraphCacheResolver<WithTypename<WhenDatespan>, Record<string, never>, Scalars['Date'] | string>
  },
  WhenTime?: {
    time?: GraphCacheResolver<WithTypename<WhenTime>, Record<string, never>, Scalars['DateTime'] | string>
  },
  WhenTimespan?: {
    startTime?: GraphCacheResolver<WithTypename<WhenTimespan>, Record<string, never>, Scalars['DateTime'] | string>,
    endTime?: GraphCacheResolver<WithTypename<WhenTimespan>, Record<string, never>, Scalars['DateTime'] | string>
  }
};

export type GraphCacheOptimisticUpdaters = {
  helloMutation?: GraphCacheOptimisticMutationResolver<Record<string, never>, Scalars['String']>,
  createUser?: GraphCacheOptimisticMutationResolver<MutationCreateUserArgs, WithTypename<User>>,
  updateUser?: GraphCacheOptimisticMutationResolver<MutationUpdateUserArgs, WithTypename<User>>,
  deleteUser?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<User>>,
  login?: GraphCacheOptimisticMutationResolver<Record<string, never>, Scalars['Boolean']>,
  updateUserAdmin?: GraphCacheOptimisticMutationResolver<MutationUpdateUserAdminArgs, WithTypename<User>>,
  deleteUserAdmin?: GraphCacheOptimisticMutationResolver<MutationDeleteUserAdminArgs, WithTypename<User>>,
  changeUserRole?: GraphCacheOptimisticMutationResolver<MutationChangeUserRoleArgs, WithTypename<User>>,
  approve?: GraphCacheOptimisticMutationResolver<MutationApproveArgs, WithTypename<User>>,
  createLinkToVenue?: GraphCacheOptimisticMutationResolver<MutationCreateLinkToVenueArgs, WithTypename<Venue>>,
  createLinkToArtist?: GraphCacheOptimisticMutationResolver<MutationCreateLinkToArtistArgs, WithTypename<Artist>>,
  createVenueFromPlaceId?: GraphCacheOptimisticMutationResolver<MutationCreateVenueFromPlaceIdArgs, WithTypename<Venue>>,
  updateVenue?: GraphCacheOptimisticMutationResolver<MutationUpdateVenueArgs, WithTypename<Venue>>,
  deleteBankAccount?: GraphCacheOptimisticMutationResolver<MutationDeleteBankAccountArgs, Maybe<WithTypename<StripeBankAccount>>>,
  setDefaultBankAccount?: GraphCacheOptimisticMutationResolver<MutationSetDefaultBankAccountArgs, Maybe<WithTypename<StripeBankAccount>>>,
  deleteVenue?: GraphCacheOptimisticMutationResolver<MutationDeleteVenueArgs, WithTypename<Venue>>,
  linkAccountExec?: GraphCacheOptimisticMutationResolver<MutationLinkAccountExecArgs, WithTypename<Venue>>,
  changePlaceId?: GraphCacheOptimisticMutationResolver<MutationChangePlaceIdArgs, WithTypename<Venue>>,
  setDevice?: GraphCacheOptimisticMutationResolver<MutationSetDeviceArgs, Scalars['Boolean']>,
  unsetDevice?: GraphCacheOptimisticMutationResolver<MutationUnsetDeviceArgs, Scalars['Boolean']>,
  trackPushNotificationEvent?: GraphCacheOptimisticMutationResolver<MutationTrackPushNotificationEventArgs, Scalars['Boolean']>,
  textUserLink?: GraphCacheOptimisticMutationResolver<MutationTextUserLinkArgs, Scalars['Boolean']>,
  createArtist?: GraphCacheOptimisticMutationResolver<MutationCreateArtistArgs, WithTypename<Artist>>,
  updateArtist?: GraphCacheOptimisticMutationResolver<MutationUpdateArtistArgs, WithTypename<Artist>>,
  updateArtistSongs?: GraphCacheOptimisticMutationResolver<MutationUpdateArtistSongsArgs, WithTypename<Artist>>,
  updateArtistVideos?: GraphCacheOptimisticMutationResolver<MutationUpdateArtistVideosArgs, WithTypename<Artist>>,
  updateArtistImages?: GraphCacheOptimisticMutationResolver<MutationUpdateArtistImagesArgs, WithTypename<Artist>>,
  updateSpotifyId?: GraphCacheOptimisticMutationResolver<MutationUpdateSpotifyIdArgs, WithTypename<Artist>>,
  deleteArtist?: GraphCacheOptimisticMutationResolver<MutationDeleteArtistArgs, WithTypename<Artist>>,
  publishArtist?: GraphCacheOptimisticMutationResolver<MutationPublishArtistArgs, WithTypename<Artist>>,
  updateAdminDetails?: GraphCacheOptimisticMutationResolver<MutationUpdateAdminDetailsArgs, WithTypename<Artist>>,
  createExternalBooking?: GraphCacheOptimisticMutationResolver<MutationCreateExternalBookingArgs, WithTypename<ExternalBooking>>,
  updateExternalBooking?: GraphCacheOptimisticMutationResolver<MutationUpdateExternalBookingArgs, WithTypename<ExternalBooking>>,
  deleteExternalBooking?: GraphCacheOptimisticMutationResolver<MutationDeleteExternalBookingArgs, WithTypename<ExternalBooking>>,
  createBookingsBuyer?: GraphCacheOptimisticMutationResolver<MutationCreateBookingsBuyerArgs, Array<WithTypename<Booking>>>,
  createBookingsAdmin?: GraphCacheOptimisticMutationResolver<MutationCreateBookingsAdminArgs, Array<WithTypename<Booking>>>,
  updateBookings?: GraphCacheOptimisticMutationResolver<MutationUpdateBookingsArgs, Array<WithTypename<Booking>>>,
  publishBooking?: GraphCacheOptimisticMutationResolver<MutationPublishBookingArgs, WithTypename<Booking>>,
  replaceVenue?: GraphCacheOptimisticMutationResolver<MutationReplaceVenueArgs, WithTypename<Booking>>,
  updateBuyerPrice?: GraphCacheOptimisticMutationResolver<MutationUpdateBuyerPriceArgs, WithTypename<Booking>>,
  updateSellerPrice?: GraphCacheOptimisticMutationResolver<MutationUpdateSellerPriceArgs, WithTypename<Booking>>,
  updateLastOfferAmount?: GraphCacheOptimisticMutationResolver<MutationUpdateLastOfferAmountArgs, WithTypename<Booking>>,
  assignAccountExecToBooking?: GraphCacheOptimisticMutationResolver<MutationAssignAccountExecToBookingArgs, WithTypename<Booking>>,
  advanceBooking?: GraphCacheOptimisticMutationResolver<MutationAdvanceBookingArgs, WithTypename<Booking>>,
  duplicateBooking?: GraphCacheOptimisticMutationResolver<MutationDuplicateBookingArgs, WithTypename<Booking>>,
  replaceArtistOnBooking?: GraphCacheOptimisticMutationResolver<MutationReplaceArtistOnBookingArgs, WithTypename<Booking>>,
  acceptBookingBuyer?: GraphCacheOptimisticMutationResolver<MutationAcceptBookingBuyerArgs, WithTypename<Booking>>,
  acceptBookingSeller?: GraphCacheOptimisticMutationResolver<MutationAcceptBookingSellerArgs, WithTypename<Booking>>,
  acceptBookingAdmin?: GraphCacheOptimisticMutationResolver<MutationAcceptBookingAdminArgs, WithTypename<Booking>>,
  counterBookingBuyer?: GraphCacheOptimisticMutationResolver<MutationCounterBookingBuyerArgs, WithTypename<Booking>>,
  counterBookingSeller?: GraphCacheOptimisticMutationResolver<MutationCounterBookingSellerArgs, WithTypename<Booking>>,
  counterBookingAdmin?: GraphCacheOptimisticMutationResolver<MutationCounterBookingAdminArgs, WithTypename<Booking>>,
  declineBooking?: GraphCacheOptimisticMutationResolver<MutationDeclineBookingArgs, WithTypename<Booking>>,
  declineBookingAdmin?: GraphCacheOptimisticMutationResolver<MutationDeclineBookingAdminArgs, WithTypename<Booking>>,
  cancelBooking?: GraphCacheOptimisticMutationResolver<MutationCancelBookingArgs, WithTypename<Booking>>,
  cancelBookingAdmin?: GraphCacheOptimisticMutationResolver<MutationCancelBookingAdminArgs, WithTypename<Booking>>,
  createBookingRequestsBuyer?: GraphCacheOptimisticMutationResolver<MutationCreateBookingRequestsBuyerArgs, Array<WithTypename<BookingRequest>>>,
  updateBookingRequests?: GraphCacheOptimisticMutationResolver<MutationUpdateBookingRequestsArgs, Array<WithTypename<BookingRequest>>>,
  cancelBookingRequests?: GraphCacheOptimisticMutationResolver<MutationCancelBookingRequestsArgs, Array<WithTypename<BookingRequest>>>,
  createBookingRequestsAdmin?: GraphCacheOptimisticMutationResolver<MutationCreateBookingRequestsAdminArgs, Array<WithTypename<BookingRequest>>>,
  addArtistsToBookingRequests?: GraphCacheOptimisticMutationResolver<MutationAddArtistsToBookingRequestsArgs, Array<WithTypename<BookingRequest>>>,
  removeArtistsFromBookingRequests?: GraphCacheOptimisticMutationResolver<MutationRemoveArtistsFromBookingRequestsArgs, Array<WithTypename<BookingRequest>>>,
  assignAccountExecToBookingRequest?: GraphCacheOptimisticMutationResolver<MutationAssignAccountExecToBookingRequestArgs, WithTypename<BookingRequest>>,
  updateBid?: GraphCacheOptimisticMutationResolver<MutationUpdateBidArgs, WithTypename<Bid>>,
  withdrawBid?: GraphCacheOptimisticMutationResolver<MutationWithdrawBidArgs, WithTypename<Bid>>,
  updateSellerPriceOnBid?: GraphCacheOptimisticMutationResolver<MutationUpdateSellerPriceOnBidArgs, WithTypename<Bid>>,
  createBidAdmin?: GraphCacheOptimisticMutationResolver<MutationCreateBidAdminArgs, WithTypename<Bid>>,
  setCustomBuyerPriceOnBid?: GraphCacheOptimisticMutationResolver<MutationSetCustomBuyerPriceOnBidArgs, WithTypename<Bid>>,
  createBidSeller?: GraphCacheOptimisticMutationResolver<MutationCreateBidSellerArgs, WithTypename<Bid>>,
  rejectBid?: GraphCacheOptimisticMutationResolver<MutationRejectBidArgs, WithTypename<Bid>>,
  acceptBidBuyer?: GraphCacheOptimisticMutationResolver<MutationAcceptBidBuyerArgs, WithTypename<Bid>>,
  acceptBidAdmin?: GraphCacheOptimisticMutationResolver<MutationAcceptBidAdminArgs, WithTypename<Bid>>,
  likeArtist?: GraphCacheOptimisticMutationResolver<MutationLikeArtistArgs, Scalars['Boolean']>,
  viewArtist?: GraphCacheOptimisticMutationResolver<MutationViewArtistArgs, Scalars['Int']>,
  exchangeAuthCodeGoogle?: GraphCacheOptimisticMutationResolver<MutationExchangeAuthCodeGoogleArgs, Scalars['Boolean']>,
  removeCalendar?: GraphCacheOptimisticMutationResolver<Record<string, never>, Scalars['Boolean']>,
  updateArtistPerformanceDataSongs?: GraphCacheOptimisticMutationResolver<MutationUpdateArtistPerformanceDataSongsArgs, WithTypename<ArtistPerformanceData>>,
  resolveCancellationRequest?: GraphCacheOptimisticMutationResolver<MutationResolveCancellationRequestArgs, WithTypename<CancellationRequest>>,
  setPlaidAccessToken?: GraphCacheOptimisticMutationResolver<MutationSetPlaidAccessTokenArgs, Maybe<WithTypename<SetPlaidAccessTokenResponse>>>,
  propagateUser?: GraphCacheOptimisticMutationResolver<MutationPropagateUserArgs, Scalars['JSON']>,
  propagateArtist?: GraphCacheOptimisticMutationResolver<MutationPropagateArtistArgs, Scalars['JSON']>,
  propagateBooking?: GraphCacheOptimisticMutationResolver<MutationPropagateBookingArgs, Scalars['JSON']>,
  createArtistReview?: GraphCacheOptimisticMutationResolver<MutationCreateArtistReviewArgs, WithTypename<ArtistReview>>,
  updateArtistReview?: GraphCacheOptimisticMutationResolver<MutationUpdateArtistReviewArgs, WithTypename<ArtistReview>>,
  deleteArtistReview?: GraphCacheOptimisticMutationResolver<MutationDeleteArtistReviewArgs, WithTypename<ArtistReview>>,
  publishArtistReview?: GraphCacheOptimisticMutationResolver<MutationPublishArtistReviewArgs, WithTypename<ArtistReview>>,
  disputeBooking?: GraphCacheOptimisticMutationResolver<MutationDisputeBookingArgs, WithTypename<BookingDispute>>,
  resolveBookingDispute?: GraphCacheOptimisticMutationResolver<MutationResolveBookingDisputeArgs, WithTypename<BookingDispute>>,
  createExtraArtistInfo?: GraphCacheOptimisticMutationResolver<MutationCreateExtraArtistInfoArgs, WithTypename<ExtraArtistInfo>>,
  updateExtraArtistInfo?: GraphCacheOptimisticMutationResolver<MutationUpdateExtraArtistInfoArgs, WithTypename<ExtraArtistInfo>>,
  deleteExtraArtistInfo?: GraphCacheOptimisticMutationResolver<MutationDeleteExtraArtistInfoArgs, WithTypename<ExtraArtistInfo>>,
  declineBookingRequest?: GraphCacheOptimisticMutationResolver<MutationDeclineBookingRequestArgs, WithTypename<BookingRequestDecline>>,
  undoDeclineBookingRequest?: GraphCacheOptimisticMutationResolver<MutationUndoDeclineBookingRequestArgs, WithTypename<BookingRequestDecline>>,
  uploadImage?: GraphCacheOptimisticMutationResolver<MutationUploadImageArgs, WithTypename<Image>>,
  sendPromoImageToEmail?: GraphCacheOptimisticMutationResolver<MutationSendPromoImageToEmailArgs, WithTypename<SendImageToEmailResponse>>,
  sendPromoImageToPhone?: GraphCacheOptimisticMutationResolver<MutationSendPromoImageToPhoneArgs, WithTypename<SendImageToPhoneResponse>>,
  trackPromoExport?: GraphCacheOptimisticMutationResolver<MutationTrackPromoExportArgs, Scalars['Boolean']>,
  createArtistVenueApplication?: GraphCacheOptimisticMutationResolver<MutationCreateArtistVenueApplicationArgs, WithTypename<ArtistVenueApplicationStraw>>,
  propagateVenue?: GraphCacheOptimisticMutationResolver<MutationPropagateVenueArgs, Scalars['JSON']>,
  refreshDiscoverPage?: GraphCacheOptimisticMutationResolver<MutationRefreshDiscoverPageArgs, Scalars['Boolean']>,
  deleteUserForTesting?: GraphCacheOptimisticMutationResolver<MutationDeleteUserForTestingArgs, Scalars['Boolean']>,
  getCodeTestUser?: GraphCacheOptimisticMutationResolver<MutationGetCodeTestUserArgs, Scalars['Boolean']>,
  createCustomToken?: GraphCacheOptimisticMutationResolver<MutationCreateCustomTokenArgs, Scalars['String']>,
  createArtistAvailability?: GraphCacheOptimisticMutationResolver<MutationCreateArtistAvailabilityArgs, WithTypename<ArtistAvailability>>,
  createArtistAvailabilityCheck?: GraphCacheOptimisticMutationResolver<MutationCreateArtistAvailabilityCheckArgs, WithTypename<ArtistAvailabilityCheck>>,
  resendCheck?: GraphCacheOptimisticMutationResolver<MutationResendCheckArgs, WithTypename<ArtistAvailabilityCheck>>,
  giveArtistAvailability?: GraphCacheOptimisticMutationResolver<MutationGiveArtistAvailabilityArgs, WithTypename<ArtistAvailabilityCheck>>,
  setArtistAvailabilityStatus?: GraphCacheOptimisticMutationResolver<MutationSetArtistAvailabilityStatusArgs, WithTypename<ArtistAvailability>>,
  requestArtistAvailabilityForBooking?: GraphCacheOptimisticMutationResolver<MutationRequestArtistAvailabilityForBookingArgs, WithTypename<ArtistAvailability>>,
  switchBuyerToSeller?: GraphCacheOptimisticMutationResolver<MutationSwitchBuyerToSellerArgs, WithTypename<User>>,
  switchSellerToBuyer?: GraphCacheOptimisticMutationResolver<MutationSwitchSellerToBuyerArgs, WithTypename<User>>,
  updateBookingPreferences?: GraphCacheOptimisticMutationResolver<MutationUpdateBookingPreferencesArgs, Array<WithTypename<Question>>>,
  updateBookingPreference?: GraphCacheOptimisticMutationResolver<MutationUpdateBookingPreferenceArgs, Array<WithTypename<Question>>>,
  markBookingAsCharged?: GraphCacheOptimisticMutationResolver<MutationMarkBookingAsChargedArgs, WithTypename<Booking>>,
  markBookingAsPaidOut?: GraphCacheOptimisticMutationResolver<MutationMarkBookingAsPaidOutArgs, WithTypename<Booking>>,
  chargeBooking?: GraphCacheOptimisticMutationResolver<MutationChargeBookingArgs, WithTypename<Booking>>,
  payoutBooking?: GraphCacheOptimisticMutationResolver<MutationPayoutBookingArgs, WithTypename<Booking>>,
  confirmBooking?: GraphCacheOptimisticMutationResolver<MutationConfirmBookingArgs, WithTypename<BookingConfirmation>>
};

export type GraphCacheUpdaters = {
  Mutation?: {
    helloMutation?: GraphCacheUpdateResolver<{ helloMutation: Scalars['String'] }, Record<string, never>>,
    createUser?: GraphCacheUpdateResolver<{ createUser: WithTypename<User> }, MutationCreateUserArgs>,
    updateUser?: GraphCacheUpdateResolver<{ updateUser: WithTypename<User> }, MutationUpdateUserArgs>,
    deleteUser?: GraphCacheUpdateResolver<{ deleteUser: WithTypename<User> }, Record<string, never>>,
    login?: GraphCacheUpdateResolver<{ login: Scalars['Boolean'] }, Record<string, never>>,
    updateUserAdmin?: GraphCacheUpdateResolver<{ updateUserAdmin: WithTypename<User> }, MutationUpdateUserAdminArgs>,
    deleteUserAdmin?: GraphCacheUpdateResolver<{ deleteUserAdmin: WithTypename<User> }, MutationDeleteUserAdminArgs>,
    changeUserRole?: GraphCacheUpdateResolver<{ changeUserRole: WithTypename<User> }, MutationChangeUserRoleArgs>,
    approve?: GraphCacheUpdateResolver<{ approve: WithTypename<User> }, MutationApproveArgs>,
    createLinkToVenue?: GraphCacheUpdateResolver<{ createLinkToVenue: WithTypename<Venue> }, MutationCreateLinkToVenueArgs>,
    createLinkToArtist?: GraphCacheUpdateResolver<{ createLinkToArtist: WithTypename<Artist> }, MutationCreateLinkToArtistArgs>,
    createVenueFromPlaceId?: GraphCacheUpdateResolver<{ createVenueFromPlaceId: WithTypename<Venue> }, MutationCreateVenueFromPlaceIdArgs>,
    updateVenue?: GraphCacheUpdateResolver<{ updateVenue: WithTypename<Venue> }, MutationUpdateVenueArgs>,
    deleteBankAccount?: GraphCacheUpdateResolver<{ deleteBankAccount: Maybe<WithTypename<StripeBankAccount>> }, MutationDeleteBankAccountArgs>,
    setDefaultBankAccount?: GraphCacheUpdateResolver<{ setDefaultBankAccount: Maybe<WithTypename<StripeBankAccount>> }, MutationSetDefaultBankAccountArgs>,
    deleteVenue?: GraphCacheUpdateResolver<{ deleteVenue: WithTypename<Venue> }, MutationDeleteVenueArgs>,
    linkAccountExec?: GraphCacheUpdateResolver<{ linkAccountExec: WithTypename<Venue> }, MutationLinkAccountExecArgs>,
    changePlaceId?: GraphCacheUpdateResolver<{ changePlaceId: WithTypename<Venue> }, MutationChangePlaceIdArgs>,
    setDevice?: GraphCacheUpdateResolver<{ setDevice: Scalars['Boolean'] }, MutationSetDeviceArgs>,
    unsetDevice?: GraphCacheUpdateResolver<{ unsetDevice: Scalars['Boolean'] }, MutationUnsetDeviceArgs>,
    trackPushNotificationEvent?: GraphCacheUpdateResolver<{ trackPushNotificationEvent: Scalars['Boolean'] }, MutationTrackPushNotificationEventArgs>,
    textUserLink?: GraphCacheUpdateResolver<{ textUserLink: Scalars['Boolean'] }, MutationTextUserLinkArgs>,
    createArtist?: GraphCacheUpdateResolver<{ createArtist: WithTypename<Artist> }, MutationCreateArtistArgs>,
    updateArtist?: GraphCacheUpdateResolver<{ updateArtist: WithTypename<Artist> }, MutationUpdateArtistArgs>,
    updateArtistSongs?: GraphCacheUpdateResolver<{ updateArtistSongs: WithTypename<Artist> }, MutationUpdateArtistSongsArgs>,
    updateArtistVideos?: GraphCacheUpdateResolver<{ updateArtistVideos: WithTypename<Artist> }, MutationUpdateArtistVideosArgs>,
    updateArtistImages?: GraphCacheUpdateResolver<{ updateArtistImages: WithTypename<Artist> }, MutationUpdateArtistImagesArgs>,
    updateSpotifyId?: GraphCacheUpdateResolver<{ updateSpotifyId: WithTypename<Artist> }, MutationUpdateSpotifyIdArgs>,
    deleteArtist?: GraphCacheUpdateResolver<{ deleteArtist: WithTypename<Artist> }, MutationDeleteArtistArgs>,
    publishArtist?: GraphCacheUpdateResolver<{ publishArtist: WithTypename<Artist> }, MutationPublishArtistArgs>,
    updateAdminDetails?: GraphCacheUpdateResolver<{ updateAdminDetails: WithTypename<Artist> }, MutationUpdateAdminDetailsArgs>,
    createExternalBooking?: GraphCacheUpdateResolver<{ createExternalBooking: WithTypename<ExternalBooking> }, MutationCreateExternalBookingArgs>,
    updateExternalBooking?: GraphCacheUpdateResolver<{ updateExternalBooking: WithTypename<ExternalBooking> }, MutationUpdateExternalBookingArgs>,
    deleteExternalBooking?: GraphCacheUpdateResolver<{ deleteExternalBooking: WithTypename<ExternalBooking> }, MutationDeleteExternalBookingArgs>,
    createBookingsBuyer?: GraphCacheUpdateResolver<{ createBookingsBuyer: Array<WithTypename<Booking>> }, MutationCreateBookingsBuyerArgs>,
    createBookingsAdmin?: GraphCacheUpdateResolver<{ createBookingsAdmin: Array<WithTypename<Booking>> }, MutationCreateBookingsAdminArgs>,
    updateBookings?: GraphCacheUpdateResolver<{ updateBookings: Array<WithTypename<Booking>> }, MutationUpdateBookingsArgs>,
    publishBooking?: GraphCacheUpdateResolver<{ publishBooking: WithTypename<Booking> }, MutationPublishBookingArgs>,
    replaceVenue?: GraphCacheUpdateResolver<{ replaceVenue: WithTypename<Booking> }, MutationReplaceVenueArgs>,
    updateBuyerPrice?: GraphCacheUpdateResolver<{ updateBuyerPrice: WithTypename<Booking> }, MutationUpdateBuyerPriceArgs>,
    updateSellerPrice?: GraphCacheUpdateResolver<{ updateSellerPrice: WithTypename<Booking> }, MutationUpdateSellerPriceArgs>,
    updateLastOfferAmount?: GraphCacheUpdateResolver<{ updateLastOfferAmount: WithTypename<Booking> }, MutationUpdateLastOfferAmountArgs>,
    assignAccountExecToBooking?: GraphCacheUpdateResolver<{ assignAccountExecToBooking: WithTypename<Booking> }, MutationAssignAccountExecToBookingArgs>,
    advanceBooking?: GraphCacheUpdateResolver<{ advanceBooking: WithTypename<Booking> }, MutationAdvanceBookingArgs>,
    duplicateBooking?: GraphCacheUpdateResolver<{ duplicateBooking: WithTypename<Booking> }, MutationDuplicateBookingArgs>,
    replaceArtistOnBooking?: GraphCacheUpdateResolver<{ replaceArtistOnBooking: WithTypename<Booking> }, MutationReplaceArtistOnBookingArgs>,
    acceptBookingBuyer?: GraphCacheUpdateResolver<{ acceptBookingBuyer: WithTypename<Booking> }, MutationAcceptBookingBuyerArgs>,
    acceptBookingSeller?: GraphCacheUpdateResolver<{ acceptBookingSeller: WithTypename<Booking> }, MutationAcceptBookingSellerArgs>,
    acceptBookingAdmin?: GraphCacheUpdateResolver<{ acceptBookingAdmin: WithTypename<Booking> }, MutationAcceptBookingAdminArgs>,
    counterBookingBuyer?: GraphCacheUpdateResolver<{ counterBookingBuyer: WithTypename<Booking> }, MutationCounterBookingBuyerArgs>,
    counterBookingSeller?: GraphCacheUpdateResolver<{ counterBookingSeller: WithTypename<Booking> }, MutationCounterBookingSellerArgs>,
    counterBookingAdmin?: GraphCacheUpdateResolver<{ counterBookingAdmin: WithTypename<Booking> }, MutationCounterBookingAdminArgs>,
    declineBooking?: GraphCacheUpdateResolver<{ declineBooking: WithTypename<Booking> }, MutationDeclineBookingArgs>,
    declineBookingAdmin?: GraphCacheUpdateResolver<{ declineBookingAdmin: WithTypename<Booking> }, MutationDeclineBookingAdminArgs>,
    cancelBooking?: GraphCacheUpdateResolver<{ cancelBooking: WithTypename<Booking> }, MutationCancelBookingArgs>,
    cancelBookingAdmin?: GraphCacheUpdateResolver<{ cancelBookingAdmin: WithTypename<Booking> }, MutationCancelBookingAdminArgs>,
    createBookingRequestsBuyer?: GraphCacheUpdateResolver<{ createBookingRequestsBuyer: Array<WithTypename<BookingRequest>> }, MutationCreateBookingRequestsBuyerArgs>,
    updateBookingRequests?: GraphCacheUpdateResolver<{ updateBookingRequests: Array<WithTypename<BookingRequest>> }, MutationUpdateBookingRequestsArgs>,
    cancelBookingRequests?: GraphCacheUpdateResolver<{ cancelBookingRequests: Array<WithTypename<BookingRequest>> }, MutationCancelBookingRequestsArgs>,
    createBookingRequestsAdmin?: GraphCacheUpdateResolver<{ createBookingRequestsAdmin: Array<WithTypename<BookingRequest>> }, MutationCreateBookingRequestsAdminArgs>,
    addArtistsToBookingRequests?: GraphCacheUpdateResolver<{ addArtistsToBookingRequests: Array<WithTypename<BookingRequest>> }, MutationAddArtistsToBookingRequestsArgs>,
    removeArtistsFromBookingRequests?: GraphCacheUpdateResolver<{ removeArtistsFromBookingRequests: Array<WithTypename<BookingRequest>> }, MutationRemoveArtistsFromBookingRequestsArgs>,
    assignAccountExecToBookingRequest?: GraphCacheUpdateResolver<{ assignAccountExecToBookingRequest: WithTypename<BookingRequest> }, MutationAssignAccountExecToBookingRequestArgs>,
    updateBid?: GraphCacheUpdateResolver<{ updateBid: WithTypename<Bid> }, MutationUpdateBidArgs>,
    withdrawBid?: GraphCacheUpdateResolver<{ withdrawBid: WithTypename<Bid> }, MutationWithdrawBidArgs>,
    updateSellerPriceOnBid?: GraphCacheUpdateResolver<{ updateSellerPriceOnBid: WithTypename<Bid> }, MutationUpdateSellerPriceOnBidArgs>,
    createBidAdmin?: GraphCacheUpdateResolver<{ createBidAdmin: WithTypename<Bid> }, MutationCreateBidAdminArgs>,
    setCustomBuyerPriceOnBid?: GraphCacheUpdateResolver<{ setCustomBuyerPriceOnBid: WithTypename<Bid> }, MutationSetCustomBuyerPriceOnBidArgs>,
    createBidSeller?: GraphCacheUpdateResolver<{ createBidSeller: WithTypename<Bid> }, MutationCreateBidSellerArgs>,
    rejectBid?: GraphCacheUpdateResolver<{ rejectBid: WithTypename<Bid> }, MutationRejectBidArgs>,
    acceptBidBuyer?: GraphCacheUpdateResolver<{ acceptBidBuyer: WithTypename<Bid> }, MutationAcceptBidBuyerArgs>,
    acceptBidAdmin?: GraphCacheUpdateResolver<{ acceptBidAdmin: WithTypename<Bid> }, MutationAcceptBidAdminArgs>,
    likeArtist?: GraphCacheUpdateResolver<{ likeArtist: Scalars['Boolean'] }, MutationLikeArtistArgs>,
    viewArtist?: GraphCacheUpdateResolver<{ viewArtist: Scalars['Int'] }, MutationViewArtistArgs>,
    exchangeAuthCodeGoogle?: GraphCacheUpdateResolver<{ exchangeAuthCodeGoogle: Scalars['Boolean'] }, MutationExchangeAuthCodeGoogleArgs>,
    removeCalendar?: GraphCacheUpdateResolver<{ removeCalendar: Scalars['Boolean'] }, Record<string, never>>,
    updateArtistPerformanceDataSongs?: GraphCacheUpdateResolver<{ updateArtistPerformanceDataSongs: WithTypename<ArtistPerformanceData> }, MutationUpdateArtistPerformanceDataSongsArgs>,
    resolveCancellationRequest?: GraphCacheUpdateResolver<{ resolveCancellationRequest: WithTypename<CancellationRequest> }, MutationResolveCancellationRequestArgs>,
    setPlaidAccessToken?: GraphCacheUpdateResolver<{ setPlaidAccessToken: Maybe<WithTypename<SetPlaidAccessTokenResponse>> }, MutationSetPlaidAccessTokenArgs>,
    propagateUser?: GraphCacheUpdateResolver<{ propagateUser: Scalars['JSON'] }, MutationPropagateUserArgs>,
    propagateArtist?: GraphCacheUpdateResolver<{ propagateArtist: Scalars['JSON'] }, MutationPropagateArtistArgs>,
    propagateBooking?: GraphCacheUpdateResolver<{ propagateBooking: Scalars['JSON'] }, MutationPropagateBookingArgs>,
    createArtistReview?: GraphCacheUpdateResolver<{ createArtistReview: WithTypename<ArtistReview> }, MutationCreateArtistReviewArgs>,
    updateArtistReview?: GraphCacheUpdateResolver<{ updateArtistReview: WithTypename<ArtistReview> }, MutationUpdateArtistReviewArgs>,
    deleteArtistReview?: GraphCacheUpdateResolver<{ deleteArtistReview: WithTypename<ArtistReview> }, MutationDeleteArtistReviewArgs>,
    publishArtistReview?: GraphCacheUpdateResolver<{ publishArtistReview: WithTypename<ArtistReview> }, MutationPublishArtistReviewArgs>,
    disputeBooking?: GraphCacheUpdateResolver<{ disputeBooking: WithTypename<BookingDispute> }, MutationDisputeBookingArgs>,
    resolveBookingDispute?: GraphCacheUpdateResolver<{ resolveBookingDispute: WithTypename<BookingDispute> }, MutationResolveBookingDisputeArgs>,
    createExtraArtistInfo?: GraphCacheUpdateResolver<{ createExtraArtistInfo: WithTypename<ExtraArtistInfo> }, MutationCreateExtraArtistInfoArgs>,
    updateExtraArtistInfo?: GraphCacheUpdateResolver<{ updateExtraArtistInfo: WithTypename<ExtraArtistInfo> }, MutationUpdateExtraArtistInfoArgs>,
    deleteExtraArtistInfo?: GraphCacheUpdateResolver<{ deleteExtraArtistInfo: WithTypename<ExtraArtistInfo> }, MutationDeleteExtraArtistInfoArgs>,
    declineBookingRequest?: GraphCacheUpdateResolver<{ declineBookingRequest: WithTypename<BookingRequestDecline> }, MutationDeclineBookingRequestArgs>,
    undoDeclineBookingRequest?: GraphCacheUpdateResolver<{ undoDeclineBookingRequest: WithTypename<BookingRequestDecline> }, MutationUndoDeclineBookingRequestArgs>,
    uploadImage?: GraphCacheUpdateResolver<{ uploadImage: WithTypename<Image> }, MutationUploadImageArgs>,
    sendPromoImageToEmail?: GraphCacheUpdateResolver<{ sendPromoImageToEmail: WithTypename<SendImageToEmailResponse> }, MutationSendPromoImageToEmailArgs>,
    sendPromoImageToPhone?: GraphCacheUpdateResolver<{ sendPromoImageToPhone: WithTypename<SendImageToPhoneResponse> }, MutationSendPromoImageToPhoneArgs>,
    trackPromoExport?: GraphCacheUpdateResolver<{ trackPromoExport: Scalars['Boolean'] }, MutationTrackPromoExportArgs>,
    createArtistVenueApplication?: GraphCacheUpdateResolver<{ createArtistVenueApplication: WithTypename<ArtistVenueApplicationStraw> }, MutationCreateArtistVenueApplicationArgs>,
    propagateVenue?: GraphCacheUpdateResolver<{ propagateVenue: Scalars['JSON'] }, MutationPropagateVenueArgs>,
    refreshDiscoverPage?: GraphCacheUpdateResolver<{ refreshDiscoverPage: Scalars['Boolean'] }, MutationRefreshDiscoverPageArgs>,
    deleteUserForTesting?: GraphCacheUpdateResolver<{ deleteUserForTesting: Scalars['Boolean'] }, MutationDeleteUserForTestingArgs>,
    getCodeTestUser?: GraphCacheUpdateResolver<{ getCodeTestUser: Scalars['Boolean'] }, MutationGetCodeTestUserArgs>,
    createCustomToken?: GraphCacheUpdateResolver<{ createCustomToken: Scalars['String'] }, MutationCreateCustomTokenArgs>,
    createArtistAvailability?: GraphCacheUpdateResolver<{ createArtistAvailability: WithTypename<ArtistAvailability> }, MutationCreateArtistAvailabilityArgs>,
    createArtistAvailabilityCheck?: GraphCacheUpdateResolver<{ createArtistAvailabilityCheck: WithTypename<ArtistAvailabilityCheck> }, MutationCreateArtistAvailabilityCheckArgs>,
    resendCheck?: GraphCacheUpdateResolver<{ resendCheck: WithTypename<ArtistAvailabilityCheck> }, MutationResendCheckArgs>,
    giveArtistAvailability?: GraphCacheUpdateResolver<{ giveArtistAvailability: WithTypename<ArtistAvailabilityCheck> }, MutationGiveArtistAvailabilityArgs>,
    setArtistAvailabilityStatus?: GraphCacheUpdateResolver<{ setArtistAvailabilityStatus: WithTypename<ArtistAvailability> }, MutationSetArtistAvailabilityStatusArgs>,
    requestArtistAvailabilityForBooking?: GraphCacheUpdateResolver<{ requestArtistAvailabilityForBooking: WithTypename<ArtistAvailability> }, MutationRequestArtistAvailabilityForBookingArgs>,
    switchBuyerToSeller?: GraphCacheUpdateResolver<{ switchBuyerToSeller: WithTypename<User> }, MutationSwitchBuyerToSellerArgs>,
    switchSellerToBuyer?: GraphCacheUpdateResolver<{ switchSellerToBuyer: WithTypename<User> }, MutationSwitchSellerToBuyerArgs>,
    updateBookingPreferences?: GraphCacheUpdateResolver<{ updateBookingPreferences: Array<WithTypename<Question>> }, MutationUpdateBookingPreferencesArgs>,
    updateBookingPreference?: GraphCacheUpdateResolver<{ updateBookingPreference: Array<WithTypename<Question>> }, MutationUpdateBookingPreferenceArgs>,
    markBookingAsCharged?: GraphCacheUpdateResolver<{ markBookingAsCharged: WithTypename<Booking> }, MutationMarkBookingAsChargedArgs>,
    markBookingAsPaidOut?: GraphCacheUpdateResolver<{ markBookingAsPaidOut: WithTypename<Booking> }, MutationMarkBookingAsPaidOutArgs>,
    chargeBooking?: GraphCacheUpdateResolver<{ chargeBooking: WithTypename<Booking> }, MutationChargeBookingArgs>,
    payoutBooking?: GraphCacheUpdateResolver<{ payoutBooking: WithTypename<Booking> }, MutationPayoutBookingArgs>,
    confirmBooking?: GraphCacheUpdateResolver<{ confirmBooking: WithTypename<BookingConfirmation> }, MutationConfirmBookingArgs>
  },
  Subscription?: {},
};

export type GraphCacheConfig = {
  schema?: IntrospectionData,
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
  storage?: GraphCacheStorageAdapter
};